import { AgeGateModal } from '../AgeGateModal';
import { AGE_GATE_LEAVE_URL, hasAgeGateVerification, setAgeGateVerification } from '../age-gate';
import { navigateTo, showToast } from '../platform/devvit-client';
import { LegalFooter } from '../components/LegalFooter';
import {
  getFirebaseIdToken,
  isFirebaseAuthConfigured,
  isGoogleIdentityConfigured,
  registerWithEmailPassword,
  renderGoogleIdentityButton,
  sendPasswordReset,
  signInWithEmailPassword,
  signInWithGoogle,
  signOutFirebase,
  subscribeFirebaseUser,
} from '../auth/firebase-auth';
import { clsx } from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type React from 'react';
import { GooMiniGame } from './goo/GooMiniGame';

const fBg = new URL('../../../assets/f.webp', import.meta.url).href;
const marryBg = new URL('../../../assets/marry.webp', import.meta.url).href;
const killBg = new URL('../../../assets/kill.webp', import.meta.url).href;
const killGalleryBg = new URL('../../../assets/killBG.webp', import.meta.url).href;
const crtScreen = new URL('../../../assets/crtScreen.webp', import.meta.url).href;
const heartAsset = new URL('../../../assets/heart.webp', import.meta.url).href;
const healerIcon = new URL('../../../assets/healerIcon.webp', import.meta.url).href;
const rangerIcon = new URL('../../../assets/rangerIcon.webp', import.meta.url).href;
const warriorIcon = new URL('../../../assets/warriorIcon.webp', import.meta.url).href;
const commonRarityIcon = new URL('../../../assets/commonRarity.webp', import.meta.url).href;
const uncommonRarityIcon = new URL('../../../assets/uncommonRarity.webp', import.meta.url).href;
const rareRarityIcon = new URL('../../../assets/rareRarity.webp', import.meta.url).href;
const epicRarityIcon = new URL('../../../assets/epicRarity.webp', import.meta.url).href;
const legendaryRarityIcon = new URL('../../../assets/legendaryRarity.webp', import.meta.url).href;
const cardOpeningVideo = new URL('../../../assets/cardOpeningFinal.webm', import.meta.url).href;
const cardPackTransparent = new URL('../../../assets/cardPackTransparent.webp', import.meta.url)
  .href;
const gemsIcon = new URL('../../../assets/gems.webp', import.meta.url).href;
const pileOfGemsAsset = new URL('../../../assets/pileOfGems.webp', import.meta.url).href;
const bagOfGemsAsset = new URL('../../../assets/bagOfGems.webp', import.meta.url).href;
const chestOfGemsAsset = new URL('../../../assets/chestOfGems.webp', import.meta.url).href;
const ringAsset = new URL('../../../assets/ring.webp', import.meta.url).href;
const knifeAsset = new URL('../../../assets/knife.webp', import.meta.url).href;
const confettiSprite = new URL('../../../assets/Confetti.webp', import.meta.url).href;
const curtainSprite = new URL('../../../assets/curtainOpen.webp', import.meta.url).href;
const curtainVideo = new URL('../../../assets/Curtain Swing Open Animation.webm', import.meta.url)
  .href;
const bulletAsset = new URL('../../../assets/bullet.webp', import.meta.url).href;
const gunAsset = new URL('../../../assets/gun.webp', import.meta.url).href;
const muzzleFlashSprite = new URL('../../../assets/muzzelFlash.webp', import.meta.url).href;
const soldierWalkSprite = new URL('../../../assets/SoldierWalkingSpriteSheet.webp', import.meta.url)
  .href;
const soldierDeadSprite = new URL('../../../assets/soldierDead.webp', import.meta.url).href;
const pollVotingSound = new URL('../../../assets/sounds/pollvoting.mp3', import.meta.url).href;
const resultsDisplaySound = new URL('../../../assets/sounds/resultsdisplay.mp3', import.meta.url)
  .href;
const fireworksSound = new URL('../../../assets/sounds/Fireworks Sound Effect.mp3', import.meta.url)
  .href;
const drumRollSound = new URL('../../../assets/sounds/DrumRoll.mp3', import.meta.url).href;
const funSound = new URL('../../../assets/sounds/YeahFunSoundEffect.mp3', import.meta.url).href;
const marrySound = new URL('../../../assets/sounds/MarriageSoundEffect.mp3', import.meta.url).href;
const killSound = new URL('../../../assets/sounds/DeathSoundEffect.mp3', import.meta.url).href;
const gunshotSound = new URL('../../../assets/sounds/gunshot.mp3', import.meta.url).href;
const airRaidSound = new URL('../../../assets/sounds/AirRaidSound.mp3', import.meta.url).href;
const funGalleryTrack = new URL('../../../assets/sounds/Night Shift Circuit.mp3', import.meta.url)
  .href;
const marryGalleryTrack = new URL(
  '../../../assets/sounds/Garden Champagne Waltz.mp3',
  import.meta.url
).href;
const titleImage = new URL('../../../assets/title.webp', import.meta.url).href;
const femaleBase = new URL('../../../assets/Female1.png', import.meta.url).href;
const femaleFunBase = new URL('../../../assets/female2.png', import.meta.url).href;
const outfitBlack = new URL('../../../assets/Customize/marry/black.png', import.meta.url).href;
const outfitRainbow = new URL('../../../assets/Customize/marry/rainbow.png', import.meta.url).href;
const outfitGold = new URL('../../../assets/Customize/marry/gold.png', import.meta.url).href;
const funOutfitBlack = new URL('../../../assets/Customize/fun/black.png', import.meta.url).href;
const funOutfitRainbow = new URL('../../../assets/Customize/fun/rainbow.png', import.meta.url).href;
const funOutfitGold = new URL('../../../assets/Customize/fun/gold.png', import.meta.url).href;
const chatBubbleAsset = new URL('../../../assets/chatbubblePixel.webp', import.meta.url).href;
const exclamationAsset = new URL('../../../assets/exclamation.png', import.meta.url).href;
const chapelBg = new URL('../../../assets/chapel.png', import.meta.url).href;
const funBg = new URL('../../../assets/nightClub.png', import.meta.url).href;
const leaderboardIcon = new URL('../../../assets/fmkLeaderboard.webp', import.meta.url).href;
const homeIcon = new URL('../../../assets/home.webp', import.meta.url).href;
const fmkGalleryIcon = new URL('../../../assets/FMKGallery.webp', import.meta.url).href;
const settingsIcon = new URL('../../../assets/settings.webp', import.meta.url).href;
const chatIcon = new URL('../../../assets/chatIcon.webp', import.meta.url).href;
const shopIcon = new URL('../../../assets/shopIcon.webp', import.meta.url).href;
const modifyDeckIcon = new URL('../../../assets/modifyDeck.webp', import.meta.url).href;
const uploadIcon = new URL('../../../assets/upload.webp', import.meta.url).href;
const vsAsset = new URL('../../../assets/vs.webp', import.meta.url).href;
const playButtonAsset = new URL('../../../assets/playbutton.webp', import.meta.url).href;
const coinsIcon = new URL('../../../assets/coins.webp', import.meta.url).href;
const pileOfCoinsAsset = new URL('../../../assets/pileOfCoins.webp', import.meta.url).href;
const bagOfCoinsAsset = new URL('../../../assets/bagOfCoins.webp', import.meta.url).href;
const chestOfCoinsAsset = new URL('../../../assets/chestOfCoins.webp', import.meta.url).href;
const rank1Icon = new URL('../../../assets/rankIcons/rank1.webp', import.meta.url).href;
const rank2Icon = new URL('../../../assets/rankIcons/rank2.webp', import.meta.url).href;
const rank3Icon = new URL('../../../assets/rankIcons/rank3.webp', import.meta.url).href;
const rank4Icon = new URL('../../../assets/rankIcons/rank4.webp', import.meta.url).href;
const rank5Icon = new URL('../../../assets/rankIcons/rank5.webp', import.meta.url).href;
const rank6Icon = new URL('../../../assets/rankIcons/rank6.webp', import.meta.url).href;
const rank7Icon = new URL('../../../assets/rankIcons/rank7.webp', import.meta.url).href;
const rankLevelIcon = new URL('../../../assets/rankIcons/rankLevelIcon.webp', import.meta.url).href;
const cardShopMenuIcon = new URL('../../../assets/cardshopIcon.webp', import.meta.url).href;
const questMenuIcon = new URL('../../../assets/questIcon.webp', import.meta.url).href;
const battleMenuIcon = new URL('../../../assets/battleIcon.webp', import.meta.url).href;
const battleBackground = new URL('../../../assets/battlebackground.webp', import.meta.url).href;
const cardOpeningMenuIcon = new URL('../../../assets/cardOpeningIcon.webp', import.meta.url).href;
const collectionMenuIcon = new URL('../../../assets/collectionIcon.webp', import.meta.url).href;
const REVEAL_AUTO_MS = 7500;
const ROLE_SOUND_LEAD_MS = 3000;
const TOURNAMENT_RESTART_DELAY_MS = 21 * 60 * 60 * 1000;
const MUTE_KEY = 'fmk_audio_muted';
const ADMIN_TOKEN_KEY = 'fmk_admin_token';
const ANALYTICS_DAY_OPTIONS = [1, 7, 30, 90] as const;
const GUEST_USER_ID_KEY = 'fmk_guest_user_id';
const GUEST_USER_ID_PATTERN = /^guest_[a-f0-9]{24,64}$/;
const FACE_CROP_SIZE = 220;
const assignmentStorageKey = (postId: string) => `fmk_assignment_${postId}`;
const galleryDisplayLimit = 12;
const MAX_CREATE_PAYLOAD_BYTES = 3_500_000;
const MAX_SLOT_IMAGE_PAYLOAD_BYTES = 1_300_000;
const MAX_IMAGE_DIMENSION = 1600;
const MIN_IMAGE_QUALITY = 0.55;
const MAX_IMAGE_QUALITY_ATTEMPTS = 4;
const MAX_RESIZE_ATTEMPTS = 3;
const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').trim().replace(/\/+$/, '');
const PUBLIC_BASE_URL = (import.meta.env.VITE_PUBLIC_BASE_URL ?? '').trim().replace(/\/+$/, '');
const INITIAL_GAME_ID = new URL(window.location.href).searchParams.get('gameId')?.trim() ?? '';
const INITIAL_TENANT = new URL(window.location.href).searchParams.get('tenantId')?.trim() ?? '';
const INITIAL_VIEW_PARAM =
  new URL(window.location.href).searchParams.get('view')?.trim().toLowerCase() ?? '';
const INITIAL_CHECKOUT_PARAM =
  new URL(window.location.href).searchParams.get('checkout')?.trim() ?? '';
const INITIAL_DECK_EDIT_PARAM = new URL(window.location.href).searchParams.get('deck') === '1';
const SHOW_AI_PORN_BUTTON = false;
const EMPTY_GALLERY: MarryGalleryItem[] = [];

const CurrencyIcon = ({
  kind,
  className = 'h-4 w-4',
}: {
  kind: 'coin' | 'gem';
  className?: string;
}) => (
  <img
    src={kind === 'coin' ? coinsIcon : gemsIcon}
    alt=""
    aria-hidden="true"
    className={clsx('inline-block shrink-0 object-contain align-middle', className)}
  />
);

const CardCurrencyWindow = ({
  currency,
  className,
}: {
  currency: { gold: number; gems: number };
  className?: string;
}) => (
  <div
    className={clsx(
      'aura-chip inline-flex items-center gap-3 rounded-xl bg-black/25 px-3 py-2 text-sm font-black',
      className
    )}
    aria-label={`${currency.gold.toLocaleString()} coins, ${currency.gems.toLocaleString()} gems`}
  >
    <span className="inline-flex items-center gap-1.5 text-[#ffd84a]">
      <CurrencyIcon kind="coin" className="h-5 w-5" />
      <span>{currency.gold.toLocaleString()}</span>
    </span>
    <span className="inline-flex items-center gap-1.5 text-cyan-100">
      <CurrencyIcon kind="gem" className="h-5 w-5" />
      <span>{currency.gems.toLocaleString()}</span>
    </span>
  </div>
);
const POSTS_PAGE_SIZE = 15;
const POST_COMMENTS_PAGE_SIZE = 10;
const POST_COMMENT_MAX_LENGTH = 400;
const ADMIN_REPORTS_PAGE_SIZE = 20;
const BROWSE_AD_EVERY_NTH_SLOT = 4;
const BROWSE_AD_SCRIPT_SRC = 'https://eruptpriority.com/44b34279f623f7a01a23c28219059ce3/invoke.js';
const BROWSE_AD_CONTAINER_ID = 'container-44b34279f623f7a01a23c28219059ce3';
const MAGSRV_PROVIDER_SCRIPT_ID = 'fmk-magsrv-ad-provider';
const MAGSRV_PROVIDER_SCRIPT_SRC = 'https://a.magsrv.com/ad-provider.js';
const POLL_BANNER_MOBILE_CLASS = 'eas6a97888e10';
const POLL_BANNER_MOBILE_ZONE_ID = '5893692';
const POLL_BANNER_DESKTOP_CLASS = 'eas6a97888e2';
const POLL_BANNER_DESKTOP_ZONE_ID = '5893698';
const SLIDING_VIDEO_AD_CLASS = 'eas6a97888e31';
const SLIDING_VIDEO_AD_ZONE_ID = '5928732';
const SLIDING_VIDEO_AD_BLOCKED_TYPES = '45';
const SLIDING_VIDEO_AD_LOAD_TIMEOUT_MS = 12_000;
const SLIDING_VIDEO_AD_STALE_MS = 90_000;
const SHOP_REWARDED_AD_CLASS = 'eas6a97888e37';
const SHOP_REWARDED_AD_ZONE_ID = '5957794';
const SHOP_REWARDED_AD_BLOCKED_TYPES = '45';
const SHOP_REWARDED_AD_VAST_DEFAULT_SRC = 'https://s.magsrv.com/v1/vast.php?idz=5957796';
const SHOP_REWARDED_AD_VAST_GAY_SRC = 'https://s.magsrv.com/v1/vast.php?idz=5957798';
const SHOP_REWARDED_AD_WATCH_MS = 8_000;
const SHOP_REWARDED_AD_LOAD_TIMEOUT_MS = 12_000;
const SHOP_REWARDED_AD_VAST_TIMEOUT_MS = 10_000;
const SHOP_REWARDED_AD_VAST_MAX_WRAPPERS = 3;
const NOWPAYMENTS_BUTTON_SRC = 'https://nowpayments.io/images/embeds/payments-button-black.svg';
const BROWSE_POPUNDER_ADS_ENABLED = import.meta.env.VITE_BROWSE_POPUNDER_ADS_ENABLED === 'true';
const MOBILE_POPUNDER_PROVIDER_SCRIPT_ID = 'fmk-mobile-popunder-provider';
const MOBILE_POPUNDER_PROVIDER_SCRIPT_SRC = '/fmk-mobile-popunder-provider.js?v=20260321h';
const MOBILE_POPUNDER_ZONE_ID = 5876886;
const DESKTOP_POPUNDER_PROVIDER_SCRIPT_ID = 'fmk-desktop-popunder-provider';
const DESKTOP_POPUNDER_PROVIDER_SCRIPT_SRC = '/fmk-desktop-popunder-provider.js?v=20260321h';
const DESKTOP_POPUNDER_ZONE_ID = 5876888;
const BROWSE_NAV_INTENT_KEY = 'fmk_browse_nav_intent';
const BROWSE_NAV_INTENT_TTL_MS = 15_000;
const BROWSE_LOCATION_KEY = 'fmk_browse_location';
const BROWSE_GAY_VISITED_SESSION_KEY = 'fmk_browse_gay_visited_session';
const SHOW_TOP_NAV_CARD_BATTLE_BUTTON = true;
const CARD_TUTORIAL_STEP_KEY = 'fmk_card_tutorial_step';
const CARD_TUTORIAL_REQUIRED_DECK_CARDS = 6;
const MOBILE_BROWSE_AD_COOLDOWN_KEY = 'fmk_mobile_browse_ad_cooldown_until';
const MOBILE_BROWSE_AD_COOLDOWN_MS = 120_000;
const GOO_EXIT_XP_REASON = 'XP for cum shot mini game';
const POPUNDER_DEBUG = true;
const BATTLE_MATCHMAKING_LAND_MS = 2200;
const BATTLE_MATCHMAKING_LOCKED_MS = 2250;
const BATTLE_MATCHMAKING_NAME_TICK_MS = 180;
const BATTLE_ATTACK_ANIMATION_MS = 620;
const BATTLE_ATTACK_SETTLE_MS = 80;
const BATTLE_DRAW_ANIMATION_MS = 440;
const BATTLE_DRAW_REVEAL_MS = 170;
const BATTLE_DRAW_SETTLE_MS = 40;
const BATTLE_HEAL_ANIMATION_MS = 540;
const BATTLE_HEAL_SETTLE_MS = 60;
const BATTLE_HEAL_BETWEEN_MS = 150;
const BATTLE_RANK_ANIMATION_MS = 1250;
const PACK_CARD_FLY_MS = 460;
const GOLD_PACK_COST = 100;
const BATTLE_MATCHMAKING_MIN_PREVIEW_NAMES = 8;
const BATTLE_MATCHMAKING_FAKE_NAMES = [
  'PixelQueen',
  'CardShark88',
  'NeonDuelist',
  'ManaMaven',
  'CritOracle',
  'DeckDaddy',
  'AuraBandit',
  'LuckyLefty',
  'StarrySlayer',
  'ComboCrafter',
  'GoldRushGia',
  'VelvetViper',
];

type GameView =
  | 'create'
  | 'poll'
  | 'settings'
  | 'gallery'
  | 'browse'
  | 'cards'
  | 'packs'
  | 'pack'
  | 'battle'
  | 'quests'
  | 'shop'
  | 'tournament'
  | 'gooGame';
type UrlSyncedView =
  | 'browse'
  | 'create'
  | 'gallery'
  | 'cards'
  | 'packs'
  | 'pack'
  | 'battle'
  | 'quests'
  | 'shop'
  | 'settings'
  | 'tournament';
type MainView =
  | 'poll'
  | 'create'
  | 'browse'
  | 'cards'
  | 'packs'
  | 'pack'
  | 'battle'
  | 'quests'
  | 'shop'
  | 'tournament'
  | 'gooGame';
type GalleryReturnView = Exclude<GameView, 'gallery'>;
type BrowseLocation = {
  sort: FMKPostSort;
  type: FMKPostType;
  page: number;
};

type BattleMotionRect = {
  left: number;
  top: number;
  width: number;
  height: number;
};

type BattleAttackAnimationState = {
  side: 'player' | 'opponent';
  attackerInstanceId: string;
  targetInstanceId: string;
  targetDamage: number;
  card: BattleCard;
  fromRect: BattleMotionRect;
  offsetX: number;
  offsetY: number;
  inPlace: boolean;
};

type BattleDrawAnimationState = {
  id: string;
  side: 'player' | 'opponent';
  slotIndex: number;
  card: BattleCard;
  fromRect: BattleMotionRect;
  toRect: BattleMotionRect;
};

type BattleHealAnimationState = {
  id: string;
  side: 'player' | 'opponent';
  healerInstanceId: string;
  targetInstanceId: string;
  targetSlotIndex: number;
  amount: number;
  fromRect: BattleMotionRect;
  toRect: BattleMotionRect;
};

type BattleDrawRevealState = {
  side: 'player' | 'opponent';
  slotIndex: number;
  instanceId: string;
};

type BattleDeckCountOverrides = Partial<Record<'player' | 'opponent', number>>;

type BattleRankDisplayState = ReturnType<typeof getBattleRankDisplay>;
type BattleRankAnimationKind = 'level' | 'rank';
type BattleRankAnimationState = {
  previousRank: BattleRankDisplayState;
  currentRank: BattleRankDisplayState;
  animationKind: BattleRankAnimationKind;
};
type BattleResultState = {
  outcome: BattleStatus;
  reward: BattleReward;
  previousRank: BattleRankDisplayState;
  nextRank: BattleRankDisplayState;
  previousUserLevel: UserLevelState;
  nextUserLevel: UserLevelState;
  previousCurrency: GalleryCurrencyState;
  nextCurrency: GalleryCurrencyState;
};

type CardPreviewModalCard = {
  displayName: string;
  image: string;
  faceValue?: string;
  rarity: CardRarity;
  ability: CardAbility;
  power: number;
};

type PackOpeningPhase = 'idle' | 'playing' | 'opening' | 'revealing' | 'complete' | 'error';

type CardTutorialStep =
  | 'go_to_first_pack'
  | 'intro_open_first_pack'
  | 'opening_first_pack'
  | 'first_card_power'
  | 'first_card_ability'
  | 'finish_first_pack'
  | 'return_after_first_pack'
  | 'go_to_second_pack'
  | 'open_second_pack'
  | 'opening_second_pack'
  | 'return_after_second_pack'
  | 'go_to_battle'
  | 'open_modify_deck'
  | 'build_deck'
  | 'go_to_battle_after_save'
  | 'start_first_battle'
  | 'waiting_first_battle'
  | 'battle_goal'
  | 'select_attacker'
  | 'select_target'
  | 'attack_rules'
  | 'battle_good_luck'
  | 'free_play_first_battle'
  | 'completed';

type CardTutorialAction =
  | 'open-pack'
  | 'shop'
  | 'return-collection'
  | 'menu-shop'
  | 'menu-quests'
  | 'menu-battle'
  | 'menu-packs'
  | 'menu-cards'
  | 'modify-deck'
  | 'select-deck-card'
  | 'save-deck'
  | 'start-battle'
  | 'select-attacker'
  | 'select-target';

type CardTutorialAbilityTip = CardAbility | null;

const DEFAULT_BROWSE_LOCATION: BrowseLocation = {
  sort: 'popular',
  type: FMK_DEFAULT_POST_TYPE,
  page: 1,
};

const isConstrainedMobileDevice = (): boolean => {
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
  const coarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches ?? false;
  const narrowScreen = window.matchMedia?.('(max-width: 640px)')?.matches ?? false;
  const rawDeviceMemory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  const lowMemory =
    typeof rawDeviceMemory === 'number' && rawDeviceMemory > 0 && rawDeviceMemory <= 3;
  // Safari/mobile often omits deviceMemory; coarse + narrow is a safer fallback for heavy effects.
  const unknownMemoryLikelyMobile = rawDeviceMemory == null && coarsePointer && narrowScreen;
  return reduceMotion || lowMemory || unknownMemoryLikelyMobile;
};

const withApiBase = (path: string): string => {
  if (!API_BASE_URL || (!path.startsWith('/api') && !path.startsWith('/internal'))) return path;
  return `${API_BASE_URL}${path}`;
};

const getPublicBaseUrl = (): string => {
  if (!PUBLIC_BASE_URL) return window.location.origin;
  try {
    return new URL(PUBLIC_BASE_URL).toString();
  } catch {
    return window.location.origin;
  }
};

const buildCanonicalGameUrl = (params: { gameId: string; tenantId?: string }): string => {
  const base = new URL('/game', getPublicBaseUrl());
  base.searchParams.set('gameId', params.gameId);
  if (params.tenantId) {
    base.searchParams.set('tenantId', params.tenantId);
  }
  return base.toString();
};

const buildGameViewUrl = (
  view: UrlSyncedView,
  tenantId?: string,
  options?: { deckEditor?: boolean }
): string => {
  const base = new URL('/game', window.location.origin);
  if (tenantId) {
    base.searchParams.set('tenantId', tenantId);
  }
  if (view !== 'browse') {
    base.searchParams.set('view', view);
  }
  if (view === 'cards' && options?.deckEditor) {
    base.searchParams.set('deck', '1');
  }
  return base.toString();
};

const persistBrowseNavIntent = (): void => {
  try {
    window.sessionStorage.setItem(BROWSE_NAV_INTENT_KEY, String(Date.now()));
  } catch {
    // Ignore storage write failures; the normal in-memory browse transition can still succeed.
  }
};

const clearBrowseNavIntent = (): void => {
  try {
    window.sessionStorage.removeItem(BROWSE_NAV_INTENT_KEY);
  } catch {
    // Ignore storage failures.
  }
};

const hasFreshBrowseNavIntent = (): boolean => {
  try {
    const raw = window.sessionStorage.getItem(BROWSE_NAV_INTENT_KEY);
    const timestamp = raw ? Number.parseInt(raw, 10) : 0;
    if (!Number.isFinite(timestamp) || timestamp <= 0) return false;
    return Date.now() - timestamp <= BROWSE_NAV_INTENT_TTL_MS;
  } catch {
    return false;
  }
};

const isBrowseSort = (value: unknown): value is FMKPostSort =>
  value === 'new' || value === 'popular';

const parseBrowseLocation = (value: unknown): BrowseLocation => {
  if (!value || typeof value !== 'object') return DEFAULT_BROWSE_LOCATION;
  const raw = value as Partial<Record<keyof BrowseLocation, unknown>>;
  const rawPage =
    typeof raw.page === 'number'
      ? raw.page
      : typeof raw.page === 'string'
        ? Number.parseInt(raw.page, 10)
        : Number.NaN;
  const type = normalizeFMKPostType(raw.type);
  if (!isBrowseSort(raw.sort) || type !== raw.type || !Number.isFinite(rawPage) || rawPage <= 0) {
    return DEFAULT_BROWSE_LOCATION;
  }
  return {
    sort: raw.sort,
    type,
    page: Math.floor(rawPage),
  };
};

const getStoredBrowseLocation = (): BrowseLocation => {
  try {
    const raw = window.sessionStorage.getItem(BROWSE_LOCATION_KEY);
    if (!raw) return DEFAULT_BROWSE_LOCATION;
    return parseBrowseLocation(JSON.parse(raw));
  } catch {
    return DEFAULT_BROWSE_LOCATION;
  }
};

const persistBrowseLocation = (location: BrowseLocation): void => {
  try {
    window.sessionStorage.setItem(BROWSE_LOCATION_KEY, JSON.stringify(location));
  } catch {
    // Browse still works with in-memory state when sessionStorage is unavailable.
  }
};

const markGayBrowseVisitedThisSession = (): void => {
  try {
    window.sessionStorage.setItem(BROWSE_GAY_VISITED_SESSION_KEY, '1');
  } catch {
    // Ad category fallback can still use current in-memory state when storage is unavailable.
  }
};

const hasGayBrowseVisitedThisSession = (): boolean => {
  try {
    return window.sessionStorage.getItem(BROWSE_GAY_VISITED_SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

const CARD_TUTORIAL_STEPS: CardTutorialStep[] = [
  'go_to_first_pack',
  'intro_open_first_pack',
  'opening_first_pack',
  'first_card_power',
  'first_card_ability',
  'finish_first_pack',
  'return_after_first_pack',
  'go_to_second_pack',
  'open_second_pack',
  'opening_second_pack',
  'return_after_second_pack',
  'go_to_battle',
  'open_modify_deck',
  'build_deck',
  'go_to_battle_after_save',
  'start_first_battle',
  'waiting_first_battle',
  'battle_goal',
  'select_attacker',
  'select_target',
  'attack_rules',
  'battle_good_luck',
  'free_play_first_battle',
  'completed',
];

const isCardTutorialStep = (value: unknown): value is CardTutorialStep =>
  typeof value === 'string' && CARD_TUTORIAL_STEPS.includes(value as CardTutorialStep);

const CARD_TUTORIAL_FIRST_PACK_INTERRUPTED_STEPS: CardTutorialStep[] = [
  'opening_first_pack',
  'first_card_power',
  'first_card_ability',
  'finish_first_pack',
];
const CARD_TUTORIAL_SECOND_PACK_INTERRUPTED_STEPS: CardTutorialStep[] = ['opening_second_pack'];
const CARD_TUTORIAL_BATTLE_INTERRUPTED_STEPS: CardTutorialStep[] = ['waiting_first_battle'];

const isInterruptedCardTutorialStep = (step: CardTutorialStep): boolean =>
  CARD_TUTORIAL_FIRST_PACK_INTERRUPTED_STEPS.includes(step) ||
  CARD_TUTORIAL_SECOND_PACK_INTERRUPTED_STEPS.includes(step);

const getSafeStoredCardTutorialStep = (
  step: CardTutorialStep,
  entryView: 'battle' | 'packs' = 'packs'
): CardTutorialStep => {
  if (CARD_TUTORIAL_FIRST_PACK_INTERRUPTED_STEPS.includes(step)) {
    return entryView === 'packs' ? 'intro_open_first_pack' : 'go_to_first_pack';
  }
  if (CARD_TUTORIAL_SECOND_PACK_INTERRUPTED_STEPS.includes(step)) {
    return entryView === 'packs' ? 'open_second_pack' : 'go_to_second_pack';
  }
  if (CARD_TUTORIAL_BATTLE_INTERRUPTED_STEPS.includes(step)) {
    return 'start_first_battle';
  }
  return step;
};

const getStoredCardTutorialStep = (): CardTutorialStep | null => {
  try {
    const raw = window.localStorage.getItem(CARD_TUTORIAL_STEP_KEY);
    return isCardTutorialStep(raw) ? raw : null;
  } catch {
    return null;
  }
};

const persistCardTutorialStep = (step: CardTutorialStep): void => {
  try {
    window.localStorage.setItem(CARD_TUTORIAL_STEP_KEY, step);
  } catch {
    // Tutorial can still continue in memory if storage is unavailable.
  }
};

const clearStoredCardTutorialStep = (): void => {
  try {
    window.localStorage.removeItem(CARD_TUTORIAL_STEP_KEY);
  } catch {
    // Ignore storage failures.
  }
};

const buildGuestRandomHex = (length: number): string => {
  const clamped = Math.max(8, Math.min(64, length));
  if (window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(Math.ceil(clamped / 2));
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
      .join('')
      .slice(0, clamped);
  }
  let out = '';
  while (out.length < clamped) {
    out += Math.floor(Math.random() * 16).toString(16);
  }
  return out.slice(0, clamped);
};

const getOrCreateGuestUserId = (): string => {
  try {
    const existing = window.localStorage.getItem(GUEST_USER_ID_KEY)?.trim() ?? '';
    if (GUEST_USER_ID_PATTERN.test(existing)) {
      return existing;
    }
    const created = `guest_${buildGuestRandomHex(32)}`;
    window.localStorage.setItem(GUEST_USER_ID_KEY, created);
    return created;
  } catch {
    // localStorage can be unavailable in strict browsing contexts.
    return `guest_${buildGuestRandomHex(32)}`;
  }
};

const apiFetch = async (
  path: string,
  init?: RequestInit,
  options?: {
    gameId?: string | null;
    tenantId?: string | null;
    adminToken?: string | null;
    authToken?: string | null;
  }
): Promise<Response> => {
  const headers = new Headers(init?.headers ?? undefined);
  const gameId = options?.gameId?.trim() ?? '';
  const tenantId = options?.tenantId?.trim() ?? INITIAL_TENANT;
  const adminToken = options?.adminToken?.trim() ?? '';
  const authToken = options?.authToken?.trim() ?? (await getFirebaseIdToken()) ?? '';
  if (gameId) headers.set('x-fmk-game-id', gameId);
  if (tenantId) headers.set('x-fmk-tenant', tenantId);
  if (adminToken) headers.set('x-fmk-admin-token', adminToken);
  headers.set('x-fmk-user-id', getOrCreateGuestUserId());
  if (authToken) {
    headers.set('authorization', `Bearer ${authToken}`);
  }
  return await fetch(withApiBase(path), {
    ...init,
    headers,
    credentials: init?.credentials ?? 'include',
  });
};

const hashString = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const positionFromId = (id: string) => {
  const hash = hashString(id);
  const left = 10 + (hash % 65);
  const minTop = 35; // the highest the character can spawn (closest to top of the gallery).
  const maxTop = 100; // the lowest the character can spawn (closest to bottom).
  const topRange = maxTop - minTop + 1;
  const top = minTop + ((hash >> 3) % topRange);
  const topRatio = (top - minTop) / topRange;
  const minScale = 0.85;
  const maxScale = 1.45;
  const scale = minScale + topRatio * (maxScale - minScale);
  return { left, top, scale };
};

const randomFrom = <T,>(items: T[]): T => items[Math.floor(Math.random() * items.length)]!;

const funPhrases = [
  'Morals were considered. Briefly.',
  'HR would not approve of this one.',
  'Look, nobody said this was about love.',
  'Thinking with the wrong brain, collectively.',
  'Curiosity won. Consequences later.',
  'This choice was made at 2:37 AM.',
  'Fun now, regret never (probably).',
];

const marryPhrases = [
  "The internet said: 'I can fix them.'",
  'Red flags? Those are just decorations.',
  'Till death do us part… allegedly.',
  'This one gets a toothbrush at my place.',
  'Surprisingly responsible behavior.',
  'Love wins. Somehow.',
  'Lifetime subscription unlocked.',
  'They gave meeting the parents energy.',
];

const killPhrases = [
  'The council has decided.',
  'No hesitation. None.',
  "The internet said 'absolutely not.'",
  'Yeeted into the void.',
  'This was personal.',
  'Everybody disliked that.',
  'Rest in pixels.',
  "They didn't even think about it.",
  'Straight to the shadow realm.',
  'Sometimes peace is not an option.',
];

const marryChatPhrases = [
  'I’m not yelling...this is my inside marriage voice.',
  'I was promised ‘for better or worse,’ not ‘for whatever this is.’',
  'I already know how this ends and I don’t like it.',
  'I know your manipulative patterns. Don’t lie to me.',
  'You said you’d marry me ‘later.’ I didn’t realize later meant never.',
  'I married you knowing you’re like this, and yet here I am, surprised every time.',
  'You and I are being married here together, not me, you, and your twelve maids.',
  'This isn’t a museum. You don’t have to leave everything exactly where you used it.',
  'Why did you leave the toilet seat up again?',
  'You said you’d marry me ‘later.’ I didn’t realize later meant never.',
  'If forgetting were an Olympic sport, you’d finally have gold.',
  'You remember your Reddit password but not our anniversary. Fascinating.',
  'Do you think dishes clean themselves?',
];

const funChatPhrases = [
  '1 dance for $10 2 for $25',
  'I’m smiling because I’m professional.',
  'I get paid to dance, not to babysit you.',
  'Less talking, more tipping—see how that works?',
  'Your opinion is appreciated… in the form of cash.',
  'Clapping is encouraged. Commentary is not.',
  'If you yell one more time, I’m charging extra for emotional damage.',
  'I promise the pole isn’t going anywhere—relax.',
  'I hate EDM. Why doesn’t anyone listen to techno anymore?',
  'WH-WHAT?? I CAN’T HEAR YOU. THE MUSIC ISTOO LOUD!!!',
  'This is a show, not a group project',
];

const marryOutfitCatalog: Array<{ id: GalleryOutfitId; src: string; price: number }> = [
  { id: 'default', src: femaleBase, price: 0 },
  { id: 'black', src: outfitBlack, price: 100 },
  { id: 'rainbow', src: outfitRainbow, price: 300 },
  { id: 'gold', src: outfitGold, price: 1000 },
];

const funOutfitCatalog: Array<{ id: GalleryOutfitId; src: string; price: number }> = [
  { id: 'default', src: femaleFunBase, price: 0 },
  { id: 'black', src: funOutfitBlack, price: 100 },
  { id: 'rainbow', src: funOutfitRainbow, price: 300 },
  { id: 'gold', src: funOutfitGold, price: 1000 },
];

const marryOutfitSources: Record<GalleryOutfitId, string> = {
  default: femaleBase,
  black: outfitBlack,
  rainbow: outfitRainbow,
  gold: outfitGold,
};

const funOutfitSources: Record<GalleryOutfitId, string> = {
  default: femaleFunBase,
  black: funOutfitBlack,
  rainbow: funOutfitRainbow,
  gold: funOutfitGold,
};
import type {
  AdminAnalyticsSummaryResponse,
  AdminDismissPostReportsResponse,
  AdminListReportedPostsResponse,
  AdminRemovePostResponse,
  AdminUpdatePostTypeResponse,
  AnalyticsEventName,
  AnalyticsEventPayload,
  CardAbility,
  CardCollectionResponse,
  CardTutorialCompleteResponse,
  CardTutorialStartResponse,
  CardTutorialState,
  CardDeckState,
  CardRarity,
  CreateFMKResponse,
  ErrorResponse,
  FMKAssignment,
  FMKEntry,
  FMKPostComment,
  FMKPostType,
  FMKPercentages,
  FMKSlot,
  MarryGalleryItem,
  GetFMKResponse,
  LeaderboardEntry,
  LeaderboardResponse,
  VoteResponse,
  GooExitRewardResponse,
  PostActor,
  UserLevelState,
  GalleryCurrencyState,
  GalleryActionResponse,
  GalleryOutfitId,
  GalleryOutfitState,
  GalleryOutfitActionResponse,
  GallerySlotUnlockResponse,
  GalleryGiftResponse,
  GetFMKPostsResponse,
  FMKPostSort,
  FMKPostSummary,
  GallerySelectableResponse,
  KillWaveState,
  KillWaveStateResponse,
  KillWaveStartResponse,
  KillWaveCompleteResponse,
  PostVoteRequest,
  PostVoteResponse,
  ReportPostRequest,
  ReportPostResponse,
  ReportReason,
  GetPostCommentsResponse,
  CreatePostCommentRequest,
  CreatePostCommentResponse,
  UploadShareImageResponse,
  AuthProfileResponse,
  ClaimUsernameRequest,
  ClaimUsernameResponse,
  GetCurrentTournamentResponse,
  TournamentBracket,
  TournamentBracketWindow,
  GetTournamentResultsResponse,
  GetTournamentRoundResponse,
  TournamentCategory,
  TournamentCategoryWinner,
  TournamentEntrant,
  TournamentSummary,
  TournamentVoteRequest,
  TournamentVoteResponse,
  TournamentWindowResult,
  GooExitRewardRequest,
  OpenCardPackResponse,
  OpenCardPackRequest,
  OwnedCard,
  BattleActionResponse,
  BattleAnimationStep,
  BattleAttackRequest,
  BattleCard,
  BattleMatchState,
  BattleRankProfile,
  BattleReward,
  BattleStatus,
  ClaimQuestRequest,
  ClaimQuestResponse,
  DailyQuestState,
  DebugGrantCurrencyRequest,
  DebugGrantCurrencyResponse,
  GetActiveBattleResponse,
  GetCardDeckResponse,
  SaveCardDeckRequest,
  SaveCardDeckResponse,
  ShopAdRewardKind,
  ShopClaimAdRewardRequest,
  ShopClaimAdRewardResponse,
  ShopCheckoutOrderStatus,
  ShopCheckoutResponse,
  ShopCheckoutStatusResponse,
  ShopDailyGiftResponse,
  ShopPaidOffer,
  PurchaseGoldPackResponse,
  QuestsStateResponse,
  ShopPurchasePacksRequest,
  ShopPurchasePacksResponse,
  ShopStateResponse,
  StartBattleResponse,
  StartBattleRequest,
  TrackAnalyticsEventsRequest,
} from '../../shared/types/api';
import {
  FMK_DEFAULT_POST_TYPE,
  REPORT_COMMENT_MAX_LENGTH,
  REPORT_REASON_LABELS,
  REPORT_REASONS,
  TOURNAMENT_CATEGORIES,
  isCompleteAssignment,
  normalizeFMKPostType,
} from '../../shared/types/api';
import { getLevelProgress } from '../../shared/leveling';
import { getBattleRankDisplay } from '../../shared/battle-ranks';

type SlotInput = {
  kind: 'image' | 'text';
  value: string;
  label: string;
  sizeBytes?: number;
  faceValue?: string;
};

type BrowseDisplayItem = { kind: 'post'; post: FMKPostSummary } | { kind: 'ad'; slotIndex: number };

const utf8ByteLength = (value: string): number => new TextEncoder().encode(value).length;

const formatMb = (bytes: number): string => `${(bytes / (1024 * 1024)).toFixed(2)}MB`;

const POST_TYPE_OPTIONS: Array<{ value: FMKPostType; label: string }> = [
  { value: 'straight', label: 'Straight' },
  { value: 'trans', label: 'Trans' },
  { value: 'gay', label: 'Gay' },
];

const POST_TYPE_LABELS: Record<FMKPostType, string> = {
  straight: 'Straight',
  trans: 'Trans',
  gay: 'Gay',
};

const CARD_RARITY_LABELS: Record<CardRarity, string> = {
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
};

const CARD_RARITY_ICONS: Record<CardRarity, string> = {
  common: commonRarityIcon,
  uncommon: uncommonRarityIcon,
  rare: rareRarityIcon,
  epic: epicRarityIcon,
  legendary: legendaryRarityIcon,
};

const CARD_ABILITY_LABELS: Record<CardAbility, string> = {
  healer: 'Healer',
  tank: 'Tank',
  ranger: 'Ranger',
};

const CARD_ABILITY_DESCRIPTIONS: Record<CardAbility, string> = {
  tank: 'Tank: Granted power on play depending on rarity level.',
  ranger: 'Ranger: Does not take damage when attacking.',
  healer: 'Healer: Grants other allied cards on the field power depending on rarity level.',
};

const CARD_ABILITY_ICONS: Record<CardAbility, string> = {
  healer: healerIcon,
  tank: warriorIcon,
  ranger: rangerIcon,
};

type ShopSpecialBundle = {
  id: string;
  price: string;
  gold: number;
  gems: number;
  packs: number;
  guaranteedLegendaryCards?: number;
};

type ShopGemBundle = {
  id: string;
  price: string;
  gems: number;
};

type ShopPackBundle = {
  id: string;
  packs: number;
  gems: number;
};

type ShopCheckoutModalState = {
  offer: ShopPaidOffer | null;
  orderId: string | null;
  invoiceId: string | null;
  invoiceUrl: string | null;
  orderStatus: ShopCheckoutOrderStatus | null;
  loading: boolean;
  refreshing: boolean;
  paymentStarted: boolean;
  error: string | null;
};

const SHOP_SPECIAL_BUNDLES: ShopSpecialBundle[] = [
  { id: 'special-499', price: '$4.99', gold: 500, gems: 25, packs: 1 },
  { id: 'special-999', price: '$9.99', gold: 1200, gems: 60, packs: 3 },
  { id: 'special-1999', price: '$19.99', gold: 2800, gems: 150, packs: 7 },
  { id: 'special-4999', price: '$49.99', gold: 8000, gems: 450, packs: 20 },
  { id: 'special-9999', price: '$99.99', gold: 18000, gems: 1100, packs: 55 },
];

const SHOP_GEM_BUNDLES: ShopGemBundle[] = [
  { id: 'gems-199', price: '$1.99', gems: 20 },
  { id: 'gems-499', price: '$4.99', gems: 60 },
  { id: 'gems-999', price: '$9.99', gems: 135 },
  { id: 'gems-1999', price: '$19.99', gems: 300 },
  { id: 'gems-4999', price: '$49.99', gems: 850 },
  { id: 'gems-9999', price: '$99.99', gems: 1900 },
];

const SHOP_PACK_BUNDLES: ShopPackBundle[] = [
  { id: 'packs-1', packs: 1, gems: 20 },
  { id: 'packs-3', packs: 3, gems: 55 },
  { id: 'packs-7', packs: 7, gems: 120 },
  { id: 'packs-15', packs: 15, gems: 240 },
];

const BATTLE_LEGENDARY_DEAL_DEBUG_ALWAYS_SHOW = false;
const BATTLE_LEGENDARY_DEAL_BATTLE_INTERVAL = 10;
const BATTLE_LEGENDARY_DEAL_DURATION_MS = 15 * 60 * 1000;
const BATTLE_LEGENDARY_DEAL_BUNDLE: ShopSpecialBundle = {
  id: 'battle-legendary-1999',
  price: '$19.99',
  gold: 3000,
  gems: 150,
  packs: 10,
  guaranteedLegendaryCards: 1,
};

const parseShopPriceCents = (price: string): number =>
  Math.round(Number(price.replace(/[^0-9.]/g, '')) * 100);

const buildSpecialPaidOffer = (bundle: ShopSpecialBundle): ShopPaidOffer => ({
  id: bundle.id,
  kind: 'special',
  label: `${bundle.gold.toLocaleString()} Gold + ${bundle.gems.toLocaleString()} Gems + ${bundle.packs} ${
    bundle.packs === 1 ? 'Pack' : 'Packs'
  }${bundle.guaranteedLegendaryCards ? ` + ${bundle.guaranteedLegendaryCards} Guaranteed Legendary` : ''}`,
  priceCents: parseShopPriceCents(bundle.price),
  currency: 'USD',
  reward: {
    gold: bundle.gold,
    gems: bundle.gems,
    packs: bundle.packs,
    ...(bundle.guaranteedLegendaryCards
      ? { guaranteedLegendaryCards: bundle.guaranteedLegendaryCards }
      : {}),
  },
});

const BATTLE_LEGENDARY_DEAL_OFFER = buildSpecialPaidOffer(BATTLE_LEGENDARY_DEAL_BUNDLE);

const buildGemPaidOffer = (bundle: ShopGemBundle): ShopPaidOffer => ({
  id: bundle.id,
  kind: 'gems',
  label: `${bundle.gems.toLocaleString()} Gems`,
  priceCents: parseShopPriceCents(bundle.price),
  currency: 'USD',
  reward: { gold: 0, gems: bundle.gems, packs: 0 },
});

const formatShopPaidPrice = (offer: ShopPaidOffer): string =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: offer.currency,
  }).format(offer.priceCents / 100);

const getShopCoinBundleArt = (gold: number): string => {
  if (gold >= 8000) return chestOfCoinsAsset;
  if (gold >= 1200) return bagOfCoinsAsset;
  return pileOfCoinsAsset;
};

const getShopGemBundleArt = (gems: number): string => {
  if (gems >= 850) return chestOfGemsAsset;
  if (gems >= 135) return bagOfGemsAsset;
  return pileOfGemsAsset;
};

const isRepeatableShopCurrencyArt = (src: string): boolean =>
  src === bagOfCoinsAsset ||
  src === chestOfCoinsAsset ||
  src === bagOfGemsAsset ||
  src === chestOfGemsAsset;

const getShopCurrencyArtRepeatCount = <T,>(
  items: T[],
  index: number,
  getArt: (item: T) => string
): number => {
  const item = items[index];
  if (!item) return 1;
  const art = getArt(item);
  if (!isRepeatableShopCurrencyArt(art)) return 1;
  const occurrenceCount = items
    .slice(0, index + 1)
    .filter((candidate) => getArt(candidate) === art).length;
  return Math.min(2, Math.max(1, occurrenceCount));
};

const ShopCurrencyArt = ({
  src,
  count,
  className = '',
}: {
  src: string;
  count: number;
  className?: string;
}) => {
  const visibleCount = Math.min(2, Math.max(1, count));
  if (visibleCount === 1) {
    return (
      <div className={clsx('flex items-center justify-center', className)} aria-hidden="true">
        <img src={src} alt="" className="h-full w-full object-contain drop-shadow-lg" />
      </div>
    );
  }
  return (
    <div className={clsx('relative mx-auto', className)} aria-hidden="true">
      <img
        src={src}
        alt=""
        className="absolute left-1/2 top-1/2 z-0 h-full w-[78%] object-contain opacity-95 drop-shadow-lg"
        style={{ transform: 'translate(-30%, -58%) scale(0.9)' }}
      />
      <img
        src={src}
        alt=""
        className="absolute left-1/2 top-1/2 z-10 h-full w-[78%] object-contain drop-shadow-lg"
        style={{ transform: 'translate(-64%, -42%)' }}
      />
    </div>
  );
};

const getShopPackStackCount = (packs: number): number => {
  if (packs >= 15) return 5;
  if (packs >= 7) return 4;
  if (packs >= 3) return 3;
  return 1;
};

const ShopPackStack = ({ packs, className = '' }: { packs: number; className?: string }) => {
  const stackCount = getShopPackStackCount(packs);
  return (
    <div className={clsx('relative mx-auto h-32 w-36', className)} aria-hidden="true">
      {Array.from({ length: stackCount }).map((_, index) => {
        const centered = index - (stackCount - 1) / 2;
        return (
          <img
            key={index}
            src={cardPackTransparent}
            alt=""
            className="absolute left-1/2 top-1/2 h-[78%] w-[78%] object-contain drop-shadow-lg"
            style={{
              zIndex: index + 1,
              transform: `translate(-50%, -50%) translate(${centered * 14}px, ${
                Math.abs(centered) * 4
              }px) rotate(${centered * 8}deg)`,
            }}
          />
        );
      })}
    </div>
  );
};

const getShopBundleRibbon = (
  index: number,
  total: number
): 'Most Popular' | 'Best Value' | null => {
  if (total <= 1) return null;
  if (index === total - 1) return 'Best Value';
  if (index === Math.floor(total / 2)) return 'Most Popular';
  return null;
};

const ShopOfferRibbon = ({ label }: { label: 'Most Popular' | 'Best Value' }) => (
  <div className="pointer-events-none absolute -left-11 top-5 z-10 w-40 -rotate-45 bg-red-600 py-1 text-center text-[10px] font-black tracking-wide text-yellow-300 shadow-lg">
    {label}
  </div>
);

const formatDealCountdown = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

const BattleLegendaryDealModal = ({
  offer,
  expiresAt,
  onClose,
  onPurchase,
}: {
  offer: ShopPaidOffer;
  expiresAt: number;
  onClose: () => void;
  onPurchase: () => void;
}) => {
  const [nowMs, setNowMs] = useState(() => Date.now());
  const remainingMs = expiresAt - nowMs;
  const expired = remainingMs <= 0;
  const legendaryCount = offer.reward.guaranteedLegendaryCards ?? 0;

  useEffect(() => {
    const timer = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div
      className="fixed inset-0 z-[85] flex items-center justify-center bg-black/80 px-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="aura-panel relative w-full max-w-lg overflow-hidden rounded-2xl bg-[#5c0099] p-4 text-white shadow-2xl">
        <div className="absolute right-4 top-4 rounded-full bg-red-600 px-3 py-1 text-[10px] font-black uppercase tracking-wide text-yellow-200 shadow-lg">
          {expired ? 'Expired' : `${formatDealCountdown(remainingMs)} left`}
        </div>

        <div className="pr-24">
          <p className="text-xs font-black uppercase tracking-wide text-[#ffd84a]">
            Limited Battle Deal
          </p>
          <h3 className="mt-1 text-2xl font-black leading-tight text-white">
            Legendary Pack Rush
          </h3>
          <p className="mt-2 text-sm font-semibold text-white/75">
            Load up for your next run with a guaranteed legendary card in your next pack opening.
          </p>
        </div>

        <div className="mt-5 grid grid-cols-3 items-end gap-2 rounded-xl border border-white/15 bg-black/20 p-3">
          <ShopCurrencyArt
            src={getShopCoinBundleArt(offer.reward.gold)}
            count={1}
            className="mx-auto h-24 w-full"
          />
          <ShopCurrencyArt
            src={getShopGemBundleArt(offer.reward.gems)}
            count={1}
            className="mx-auto h-24 w-full"
          />
          <div className="relative">
            <ShopPackStack packs={offer.reward.packs} className="h-24 w-full" />
            {legendaryCount > 0 ? (
              <div className="absolute left-1/2 top-2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#fdc500] px-2 py-1 text-[10px] font-black uppercase text-white shadow">
                {legendaryCount} legendary
              </div>
            ) : null}
          </div>
        </div>

        <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs font-black text-white/85">
          <span>{offer.reward.gold.toLocaleString()} GOLD</span>
          <span>{offer.reward.gems.toLocaleString()} GEMS</span>
          <span>{offer.reward.packs.toLocaleString()} PACKS</span>
        </div>

        <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <button
            type="button"
            className="rounded-full px-6 py-3 text-sm font-black text-white btn-3d-gold disabled:opacity-50"
            disabled={expired}
            onClick={onPurchase}
          >
            Get Deal - {formatShopPaidPrice(offer)}
          </button>
          <button
            type="button"
            className="rounded-full bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
            onClick={onClose}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

const CardTutorialOverlay = ({
  message,
  targetSelector,
  showContinue = false,
  onContinue,
}: {
  message: string;
  targetSelector?: string | null;
  showContinue?: boolean;
  onContinue?: () => void;
}) => {
  const [targetRect, setTargetRect] = useState<DOMRect | null>(null);
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    setShowArrow(false);
    const updateRect = () => {
      const element = targetSelector
        ? (document.querySelector(targetSelector) as HTMLElement | null)
        : null;
      setTargetRect(element?.getBoundingClientRect() ?? null);
    };
    updateRect();
    setShowArrow(Boolean(targetSelector));
    window.addEventListener('resize', updateRect);
    window.addEventListener('scroll', updateRect, true);
    return () => {
      window.removeEventListener('resize', updateRect);
      window.removeEventListener('scroll', updateRect, true);
    };
  }, [targetSelector, message]);

  const arrowStyle =
    targetRect && showArrow
      ? ({
          left: `${targetRect.left + targetRect.width / 2}px`,
          top: `${Math.max(18, targetRect.top - 58)}px`,
        } as React.CSSProperties)
      : undefined;

  return (
    <div className="fmk-card-tutorial-layer" aria-live="polite">
      <div className="fmk-card-tutorial-popover aura-panel">
        <p>{message}</p>
        {showContinue ? (
          <button
            type="button"
            className="mt-3 rounded-full px-4 py-2 text-xs font-black text-white btn-3d-gold"
            onClick={onContinue}
          >
            Continue
          </button>
        ) : null}
      </div>
      {arrowStyle ? (
        <div className="fmk-card-tutorial-arrow" style={arrowStyle} aria-hidden="true">
          ↓
        </div>
      ) : null}
    </div>
  );
};

const SHOP_TABS = [
  { id: 'special', label: 'Special' },
  { id: 'daily-gift', label: 'Daily Gift' },
  { id: 'gems', label: 'Gems' },
  { id: 'packs', label: 'Packs' },
] as const;

const BATTLE_RANK_ICONS = [
  rank1Icon,
  rank2Icon,
  rank3Icon,
  rank4Icon,
  rank5Icon,
  rank6Icon,
  rank7Icon,
];

const CardAbilityIcon = ({ ability }: { ability: CardAbility }) => {
  return (
    <img
      src={CARD_ABILITY_ICONS[ability]}
      alt=""
      aria-hidden="true"
      className="fmk-card-ability-icon"
    />
  );
};

const CardRarityIcon = ({ rarity }: { rarity: CardRarity }) => (
  <img src={CARD_RARITY_ICONS[rarity]} alt="" aria-hidden="true" className="fmk-card-rarity-icon" />
);

const CollectionCard = ({
  card,
  highlight = false,
  selected = false,
  onSelect,
}: {
  card: OwnedCard;
  highlight?: boolean;
  selected?: boolean;
  onSelect?: (card: OwnedCard) => void;
}) => {
  const imageSrc = card.image || card.faceValue;
  const content = (
    <>
      <div
        className={clsx(
          'fmk-card-type-badge',
          card.ability === 'tank' && 'fmk-card-type-badge-tank'
        )}
        title={CARD_ABILITY_LABELS[card.ability]}
        aria-label={CARD_ABILITY_LABELS[card.ability]}
      >
        <CardAbilityIcon ability={card.ability} />
      </div>
      <div className="fmk-card-power" aria-label={`Power ${card.power}`}>
        {card.power}
      </div>
      <div className="fmk-card-image-frame">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={card.displayName}
            className="h-full w-full object-cover object-top"
          />
        ) : null}
      </div>
      <div className="fmk-card-name">
        <span>{card.displayName}</span>
      </div>
      <div className="fmk-card-footer fmk-card-footer-rarity-only">
        <div className="fmk-card-rarity-badge" title={CARD_RARITY_LABELS[card.rarity]}>
          <CardRarityIcon rarity={card.rarity} />
        </div>
      </div>
    </>
  );
  const cardClassName = clsx(
    'fmk-collection-card',
    onSelect && 'fmk-collection-card-button',
    `fmk-collection-card-${card.rarity}`,
    highlight && 'fmk-collection-card-new',
    selected && 'fmk-collection-card-selected'
  );
  if (onSelect) {
    return (
      <button type="button" className={cardClassName} onClick={() => onSelect(card)}>
        {content}
      </button>
    );
  }
  return <article className={cardClassName}>{content}</article>;
};

const waitForMs = (durationMs: number): Promise<void> =>
  new Promise((resolve) => {
    window.setTimeout(resolve, durationMs);
  });

const waitForNextFrame = (): Promise<void> =>
  new Promise((resolve) => {
    window.requestAnimationFrame(() => resolve());
  });

const waitForPaint = async (): Promise<void> => {
  await waitForNextFrame();
  await waitForNextFrame();
};

const prefersReducedBattleMotion = (): boolean =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;

const getBattleMotionRect = (element: HTMLElement | null | undefined): BattleMotionRect | null => {
  if (!element) return null;
  const rect = element.getBoundingClientRect();
  return {
    left: rect.left,
    top: rect.top,
    width: rect.width,
    height: rect.height,
  };
};

const preloadBattleCardImage = async (src: string): Promise<void> => {
  if (!src) return;
  const image = new Image();
  image.decoding = 'async';
  image.src = src;
  try {
    await image.decode();
  } catch {
    // The source is already visible in the board; a failed decode hint should not block play.
  }
};

const findBattleCardByInstanceId = (
  battleState: BattleMatchState,
  side: 'player' | 'opponent',
  instanceId: string
): BattleCard | null => {
  const owner = side === 'player' ? battleState.player : battleState.opponent;
  return owner.active.find((card) => card?.instanceId === instanceId) ?? null;
};

const getBattleOwner = (battleState: BattleMatchState, side: 'player' | 'opponent') =>
  side === 'player' ? battleState.player : battleState.opponent;

const cloneBattleMatchForAnimation = (battleState: BattleMatchState): BattleMatchState =>
  JSON.parse(JSON.stringify(battleState)) as BattleMatchState;

const buildBattleOpeningDrawState = (battleState: BattleMatchState): BattleMatchState => {
  const openingState = cloneBattleMatchForAnimation(battleState);
  for (const side of ['opponent', 'player'] as const) {
    const owner = getBattleOwner(openingState, side);
    const activeCards = owner.active.filter((card): card is BattleCard => Boolean(card));
    owner.active = owner.active.map(() => null);
    owner.deck = [...activeCards, ...owner.deck];
  }
  return openingState;
};

const getBattleDrawTransitions = (
  before: BattleMatchState,
  after: BattleMatchState
): Array<{ side: 'player' | 'opponent'; slotIndex: number; card: BattleCard }> => {
  return (['opponent', 'player'] as const).flatMap((side) => {
    const beforeOwner = getBattleOwner(before, side);
    const afterOwner = getBattleOwner(after, side);
    if (beforeOwner.deck.length <= afterOwner.deck.length) return [];
    return afterOwner.active.flatMap((card, slotIndex) => {
      const previousCard = beforeOwner.active[slotIndex] ?? null;
      if (!card || previousCard?.instanceId === card.instanceId) return [];
      return [{ side, slotIndex, card }];
    });
  });
};

const getBattleHealTransitions = (
  before: BattleMatchState,
  after: BattleMatchState
): Array<{
  side: 'player' | 'opponent';
  healerInstanceId: string;
  targetInstanceId: string;
  targetSlotIndex: number;
  amount: number;
}> => {
  return (['opponent', 'player'] as const).flatMap((side) => {
    const beforeOwner = getBattleOwner(before, side);
    const afterOwner = getBattleOwner(after, side);
    const simulatedActive = beforeOwner.active.map((card) => (card ? { ...card } : card));
    const transitions: Array<{
      side: 'player' | 'opponent';
      healerInstanceId: string;
      targetInstanceId: string;
      targetSlotIndex: number;
      amount: number;
    }> = [];

    for (const healer of beforeOwner.active) {
      if (!healer || healer.destroyed || healer.ability !== 'healer') continue;
      if (healer.drawnTurn >= after.turnNumber) continue;
      const healAmount = Math.ceil(healer.currentPower * 0.3);
      if (healAmount <= 0) continue;
      simulatedActive.forEach((card, targetSlotIndex) => {
        if (!card || card.destroyed || card.instanceId === healer.instanceId) return;
        const afterCard = afterOwner.active[targetSlotIndex] ?? null;
        if (!afterCard || afterCard.instanceId !== card.instanceId) return;
        const nextPower = card.currentPower + healAmount;
        if (afterCard.currentPower < nextPower) return;
        transitions.push({
          side,
          healerInstanceId: healer.instanceId,
          targetInstanceId: card.instanceId,
          targetSlotIndex,
          amount: healAmount,
        });
        simulatedActive[targetSlotIndex] = {
          ...card,
          currentPower: nextPower,
          maxPower: Math.max(card.maxPower, nextPower),
        };
      });
    }

    return transitions;
  });
};

const buildBattleHealedState = (
  before: BattleMatchState,
  after: BattleMatchState
): BattleMatchState => {
  const healedState = cloneBattleMatchForAnimation(before);
  for (const side of ['opponent', 'player'] as const) {
    const healedOwner = getBattleOwner(healedState, side);
    const afterOwner = getBattleOwner(after, side);
    healedOwner.active = healedOwner.active.map((beforeCard, slotIndex) => {
      if (!beforeCard) return beforeCard;
      const afterCard = afterOwner.active[slotIndex] ?? null;
      if (!afterCard || afterCard.instanceId !== beforeCard.instanceId) return beforeCard;
      return {
        ...beforeCard,
        currentPower: afterCard.currentPower,
        maxPower: afterCard.maxPower,
      };
    });
  }
  healedState.turn = after.turn;
  healedState.turnNumber = after.turnNumber;
  healedState.events = after.events;
  healedState.updatedAt = after.updatedAt;
  return healedState;
};

const BattleRankDisplay = ({
  rating,
  animation = null,
}: {
  rating: number;
  animation?: BattleRankAnimationState | null;
}) => {
  const rank = animation?.currentRank ?? getBattleRankDisplay(rating);
  const rankIcon = BATTLE_RANK_ICONS[rank.rankNumber - 1] ?? rank1Icon;
  const previousRankIcon = animation
    ? (BATTLE_RANK_ICONS[animation.previousRank.rankNumber - 1] ?? rank1Icon)
    : null;

  return (
    <div
      className={clsx(
        'fmk-battle-rank-display',
        animation?.animationKind === 'rank' && 'fmk-battle-rank-display-rank-up'
      )}
      aria-label={`Rank ${rank.rankNumber}, level ${rank.level}`}
    >
      <div className="fmk-battle-rank-levels" aria-hidden="true">
        {Array.from({ length: rank.levelsPerRank }, (_, index) => {
          const earned = index < rank.earnedLevels;
          const newlyEarned =
            animation?.animationKind === 'level' &&
            index >= animation.previousRank.earnedLevels &&
            index < animation.currentRank.earnedLevels;
          return (
            <img
              key={index}
              src={rankLevelIcon}
              alt=""
              className={clsx(
                'fmk-battle-rank-level-icon',
                !earned && 'fmk-battle-rank-level-icon-empty',
                newlyEarned && 'fmk-battle-rank-level-icon-new'
              )}
            />
          );
        })}
      </div>
      {animation?.animationKind === 'rank' && previousRankIcon ? (
        <div className="fmk-battle-rank-shatter" aria-hidden="true">
          {Array.from({ length: 4 }, (_, index) => (
            <img
              key={index}
              src={previousRankIcon}
              alt=""
              className={`fmk-battle-rank-shard fmk-battle-rank-shard-${index + 1}`}
            />
          ))}
        </div>
      ) : null}
      <img
        src={rankIcon}
        alt={`Battle rank ${rank.rankNumber}`}
        className={clsx(
          'fmk-battle-rank-image',
          animation?.animationKind === 'rank' && 'fmk-battle-rank-image-drop'
        )}
      />
    </div>
  );
};

const BattleResultScreen = ({
  result,
  onContinue,
}: {
  result: BattleResultState;
  onContinue: () => void;
}) => {
  const title =
    result.outcome === 'won' ? 'Victory' : result.outcome === 'forfeited' ? 'Forfeited' : 'Defeat';
  const ratingDelta = result.reward.ratingDelta;
  const [displayXp, setDisplayXp] = useState(result.previousUserLevel.xp);
  const [displayGold, setDisplayGold] = useState(result.previousCurrency.gold);
  const [activeRewardIndex, setActiveRewardIndex] = useState(-1);
  const displayLevel = getLevelProgress(displayXp);
  const xpInLevel = Math.max(0, displayLevel.xp - displayLevel.currentLevelMin);
  const xpLevelSpan = Math.max(1, displayLevel.nextLevelMin - displayLevel.currentLevelMin);
  const xpProgressPct = Math.round(displayLevel.progress * 100);
  const rewardItems = [
    ...(result.reward.gold > 0
      ? [{ kind: 'gold' as const, label: 'Gold', amount: result.reward.gold }]
      : []),
    ...(result.reward.xp > 0
      ? [{ kind: 'xp' as const, label: 'XP', amount: result.reward.xp }]
      : []),
  ];
  const activeReward = activeRewardIndex >= 0 ? rewardItems[activeRewardIndex] : null;

  useEffect(() => {
    setDisplayXp(result.previousUserLevel.xp);
    setDisplayGold(result.previousCurrency.gold);
    setActiveRewardIndex(-1);
    if (prefersReducedBattleMotion() || rewardItems.length === 0) {
      setDisplayXp(result.nextUserLevel.xp);
      setDisplayGold(result.nextCurrency.gold);
      setActiveRewardIndex(rewardItems.length - 1);
      return;
    }

    const timers: number[] = [];
    const frames = new Set<number>();
    const animateValue = (
      from: number,
      to: number,
      setter: (value: number) => void,
      durationMs: number
    ) => {
      const startedAt = performance.now();
      const tick = (now: number) => {
        const progress = Math.min(1, (now - startedAt) / durationMs);
        const eased = 1 - (1 - progress) ** 3;
        setter(Math.round(from + (to - from) * eased));
        if (progress < 1) {
          const nextFrame = window.requestAnimationFrame(tick);
          frames.add(nextFrame);
        }
      };
      const firstFrame = window.requestAnimationFrame(tick);
      frames.add(firstFrame);
    };

    rewardItems.forEach((item, index) => {
      const revealAt = 180 + index * 1250;
      timers.push(
        window.setTimeout(() => {
          setActiveRewardIndex(index);
        }, revealAt)
      );
      timers.push(
        window.setTimeout(() => {
          if (item.kind === 'gold') {
            animateValue(
              result.previousCurrency.gold,
              result.nextCurrency.gold,
              setDisplayGold,
              900
            );
          } else {
            animateValue(result.previousUserLevel.xp, result.nextUserLevel.xp, setDisplayXp, 900);
          }
        }, revealAt + 420)
      );
    });

    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
      frames.forEach((frame) => window.cancelAnimationFrame(frame));
    };
  }, [result]);

  return (
    <section className="fmk-battle-result-screen mt-4 rounded-xl border border-[#ffe27a]/35 bg-black/25 p-5 text-center text-white">
      <div className="fmk-victory-summary-grid">
        <div className="fmk-victory-summary-panel fmk-victory-exp-panel">
          <div className="flex items-center justify-between gap-3">
            <div className="text-left">
              <p className="text-lg font-black text-white">Level {displayLevel.level}</p>
            </div>
            <div className="fmk-victory-xp-token">XP</div>
          </div>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/35">
            <div
              className="h-full rounded-full bg-[#90f7ff]"
              style={{ width: `${xpProgressPct}%` }}
            />
          </div>
          <p className="mt-2 text-xs font-bold text-white/70">
            {xpInLevel.toLocaleString()} / {xpLevelSpan.toLocaleString()} XP
          </p>
        </div>
        <div className="fmk-victory-summary-panel">
          <div className="grid grid-cols-2 gap-2">
            <div className="fmk-victory-currency-readout">
              <img src={coinsIcon} alt="" className="h-8 w-8 object-contain" />
              <div>
                <p className="text-[10px] font-black uppercase text-white/60">Gold</p>
                <p className="text-lg font-black text-[#ffd84a]">{displayGold.toLocaleString()}</p>
              </div>
            </div>
            <div className="fmk-victory-currency-readout">
              <img src={gemsIcon} alt="" className="h-8 w-8 object-contain" />
              <div>
                <p className="text-[10px] font-black uppercase text-white/60">Gems</p>
                <p className="text-lg font-black text-[#90f7ff]">
                  {result.nextCurrency.gems.toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="text-xs font-black uppercase tracking-wide text-[#ffd84a]">Battle Complete</p>
      <h3 className="mt-2 text-4xl font-black text-white">{title}</h3>
      <div className="fmk-victory-reward-stage">
        {activeReward ? (
          <div
            key={`${activeReward.kind}-${activeRewardIndex}`}
            className={clsx(
              'fmk-battle-result-reward fmk-victory-reward-card fmk-victory-reward-card-active rounded-xl bg-black/25 p-4',
              activeReward.kind === 'xp' && 'fmk-victory-reward-card-xp'
            )}
          >
            {activeReward.kind === 'gold' ? (
              <img src={coinsIcon} alt="" aria-hidden="true" className="h-10 w-10 object-contain" />
            ) : (
              <div className="fmk-battle-result-xp-badge">XP</div>
            )}
            <div>
              <div
                className={clsx(
                  'text-3xl font-black',
                  activeReward.kind === 'gold' ? 'text-[#ffd84a]' : 'text-[#90f7ff]'
                )}
              >
                +{activeReward.amount}
              </div>
              <div className="text-xs font-bold uppercase tracking-wide text-white/65">
                {activeReward.label}
              </div>
            </div>
            <div className="fmk-victory-token-burst" aria-hidden="true">
              {Array.from({ length: 14 }, (_, particleIndex) => (
                <span
                  key={particleIndex}
                  className={clsx(
                    'fmk-victory-token-particle',
                    activeReward.kind === 'gold' ? 'fmk-victory-token-coin' : 'fmk-victory-token-xp'
                  )}
                  style={
                    {
                      '--fmk-victory-token-index': particleIndex,
                      '--fmk-victory-token-x': `${((particleIndex % 7) - 3) * 18}px`,
                      '--fmk-victory-token-y': `${-34 - Math.floor(particleIndex / 7) * 24}px`,
                    } as React.CSSProperties
                  }
                >
                  {activeReward.kind === 'gold' ? <img src={coinsIcon} alt="" /> : 'XP'}
                </span>
              ))}
            </div>
          </div>
        ) : (
          <div className="fmk-victory-reward-placeholder">Rewards incoming...</div>
        )}
      </div>
      <div className="fmk-victory-reward-history">
        {rewardItems.map((item, index) => (
          <div
            key={item.kind}
            className={clsx(
              'fmk-victory-reward-chip',
              index <= activeRewardIndex && 'fmk-victory-reward-chip-visible'
            )}
          >
            {item.kind === 'gold' ? (
              <img src={coinsIcon} alt="" aria-hidden="true" />
            ) : (
              <span>XP</span>
            )}
            +{item.amount}
          </div>
        ))}
      </div>
      <p className="mt-4 text-sm font-semibold text-white/75">
        {ratingDelta > 0 ? '+' : ''}
        {ratingDelta} rating
      </p>
      <button
        type="button"
        className="mt-6 rounded-full px-6 py-3 text-sm font-black text-white btn-3d-gold"
        onClick={onContinue}
      >
        Continue
      </button>
    </section>
  );
};

const BattleCardFace = ({ card }: { card: BattleCard }) => (
  <>
    <div
      className={clsx('fmk-card-type-badge', card.ability === 'tank' && 'fmk-card-type-badge-tank')}
      title={CARD_ABILITY_LABELS[card.ability]}
      aria-label={CARD_ABILITY_LABELS[card.ability]}
    >
      <CardAbilityIcon ability={card.ability} />
    </div>
    <div className="fmk-card-power" aria-label={`Power ${card.currentPower}`}>
      {card.currentPower}
    </div>
    <div className="fmk-card-image-frame">
      {card.image ? (
        <img
          src={card.image}
          alt={card.displayName}
          className="h-full w-full object-cover object-top"
        />
      ) : null}
    </div>
    <div className="fmk-card-name">
      <span>{card.displayName}</span>
    </div>
    <div className="fmk-card-footer fmk-card-footer-rarity-only">
      <div className="fmk-card-rarity-badge" title={CARD_RARITY_LABELS[card.rarity]}>
        <CardRarityIcon rarity={card.rarity} />
      </div>
    </div>
  </>
);

const battleCardToPreviewCard = (card: BattleCard): CardPreviewModalCard => ({
  displayName: card.displayName,
  image: card.image,
  rarity: card.rarity,
  ability: card.ability,
  power: card.currentPower,
});

const BattleMotionLayer = ({
  attackAnimation,
  drawAnimation,
  healAnimations,
}: {
  attackAnimation: BattleAttackAnimationState | null;
  drawAnimation: BattleDrawAnimationState | null;
  healAnimations: BattleHealAnimationState[];
}) => {
  if (!attackAnimation && !drawAnimation && healAnimations.length === 0) return null;
  return (
    <div className="fmk-battle-motion-layer" aria-hidden="true">
      {healAnimations.flatMap((animation) =>
        [0, 1].map((orbIndex) => (
          <span
            key={`${animation.id}-orb-${orbIndex}`}
            className="fmk-battle-heal-orb"
            style={
              {
                left: `${animation.fromRect.left + animation.fromRect.width / 2}px`,
                top: `${animation.fromRect.top + animation.fromRect.height / 2}px`,
                '--fmk-battle-heal-x': `${
                  animation.toRect.left +
                  animation.toRect.width / 2 -
                  (animation.fromRect.left + animation.fromRect.width / 2)
                }px`,
                '--fmk-battle-heal-y': `${
                  animation.toRect.top +
                  animation.toRect.height / 2 -
                  (animation.fromRect.top + animation.fromRect.height / 2)
                }px`,
                '--fmk-battle-heal-drift': orbIndex === 0 ? '-10px' : '10px',
                animationDelay: `${orbIndex * 90}ms`,
              } as React.CSSProperties
            }
          />
        ))
      )}
      {healAnimations.map((animation) => (
        <span
          key={`${animation.id}-splash`}
          className="fmk-battle-heal-splash"
          style={{
            left: `${animation.toRect.left + animation.toRect.width / 2}px`,
            top: `${animation.toRect.top + animation.toRect.height / 2}px`,
          }}
        />
      ))}
      {attackAnimation ? (
        <article
          className={clsx(
            'fmk-collection-card',
            `fmk-collection-card-${attackAnimation.card.rarity}`,
            'fmk-battle-motion-card',
            'fmk-battle-card-compact',
            attackAnimation.inPlace
              ? 'fmk-battle-motion-card-attack-ranger'
              : 'fmk-battle-motion-card-attack'
          )}
          style={
            {
              left: `${attackAnimation.fromRect.left}px`,
              top: `${attackAnimation.fromRect.top}px`,
              width: `${attackAnimation.fromRect.width}px`,
              height: `${attackAnimation.fromRect.height}px`,
              '--fmk-battle-attack-x': `${attackAnimation.offsetX}px`,
              '--fmk-battle-attack-y': `${attackAnimation.offsetY}px`,
              '--fmk-battle-attack-prep-x': `${attackAnimation.offsetX * 0.1}px`,
              '--fmk-battle-attack-prep-y': `${attackAnimation.offsetY * 0.1 - 14}px`,
              '--fmk-battle-attack-recoil-x': `${attackAnimation.offsetX * 0.92}px`,
              '--fmk-battle-attack-recoil-y': `${attackAnimation.offsetY * 0.92}px`,
              '--fmk-battle-attack-tilt': attackAnimation.side === 'player' ? '-1.2deg' : '1.2deg',
              '--fmk-battle-attack-recoil-tilt':
                attackAnimation.side === 'player' ? '0.42deg' : '-0.42deg',
            } as React.CSSProperties
          }
        >
          <BattleCardFace card={attackAnimation.card} />
        </article>
      ) : null}
      {drawAnimation ? (
        <div
          className={clsx(
            'fmk-battle-motion-card',
            'fmk-battle-motion-card-draw',
            `fmk-battle-motion-card-draw-${drawAnimation.side}`
          )}
          style={
            {
              left: `${drawAnimation.toRect.left}px`,
              top: `${drawAnimation.toRect.top}px`,
              width: `${drawAnimation.toRect.width}px`,
              height: `${drawAnimation.toRect.height}px`,
              '--fmk-battle-draw-x': `${
                drawAnimation.fromRect.left +
                drawAnimation.fromRect.width / 2 -
                (drawAnimation.toRect.left + drawAnimation.toRect.width / 2)
              }px`,
              '--fmk-battle-draw-y': `${
                drawAnimation.fromRect.top +
                drawAnimation.fromRect.height / 2 -
                (drawAnimation.toRect.top + drawAnimation.toRect.height / 2)
              }px`,
            } as React.CSSProperties
          }
        >
          <div className="fmk-battle-card-back-face" />
        </div>
      ) : null}
    </div>
  );
};

const BattleDeckStack = ({
  side,
  count,
  displayName,
  registerBattleDeck,
}: {
  side: 'player' | 'opponent';
  count: number;
  displayName: string;
  registerBattleDeck?: (side: 'player' | 'opponent', element: HTMLElement | null) => void;
}) => {
  const visibleLayers = count > 0 ? Math.min(5, count) : 0;
  const nameLabel = (
    <div className="fmk-battle-deck-name" title={displayName}>
      {displayName}
    </div>
  );
  return (
    <div className={clsx('fmk-battle-deck-station', `fmk-battle-deck-station-${side}`)}>
      {side === 'opponent' ? nameLabel : null}
      <div
        ref={(element) => registerBattleDeck?.(side, element)}
        className={clsx(
          'fmk-battle-deck-stack',
          `fmk-battle-deck-stack-${side}`,
          count <= 0 && 'fmk-battle-deck-stack-empty'
        )}
        aria-label={`${displayName} deck: ${count} cards`}
      >
        {Array.from({ length: visibleLayers }).map((_, index) => (
          <span
            key={index}
            className="fmk-battle-deck-card"
            style={{
              zIndex: index + 1,
              transform: `translate(${index * 2}px, ${index * -3}px) rotate(${
                (index - 2) * 1.2
              }deg)`,
            }}
          />
        ))}
        <span className="fmk-battle-deck-count">{count}</span>
      </div>
      {side === 'player' ? nameLabel : null}
    </div>
  );
};

const CARD_ECONOMY_MENU_ITEMS: Array<{
  view: 'shop' | 'quests' | 'battle' | 'packs' | 'cards';
  label: string;
  icon: string;
}> = [
  { view: 'shop', label: 'Shop', icon: cardShopMenuIcon },
  { view: 'quests', label: 'Quest', icon: questMenuIcon },
  { view: 'battle', label: 'Battle', icon: battleMenuIcon },
  { view: 'packs', label: 'Packs', icon: cardOpeningMenuIcon },
  { view: 'cards', label: 'Collection', icon: collectionMenuIcon },
];

const BattleCardSlot = ({
  card,
  side,
  slotIndex,
  selected = false,
  disabled = false,
  attackAnimation = null,
  drawReveal = null,
  damageAmount = null,
  healAmount = null,
  registerBattleCard,
  registerBattleSlot,
  onClick,
  onInspect,
}: {
  card: BattleCard | null;
  side: 'player' | 'opponent';
  slotIndex: number;
  selected?: boolean;
  disabled?: boolean;
  attackAnimation?: BattleAttackAnimationState | null;
  drawReveal?: BattleDrawRevealState | null;
  damageAmount?: number | null;
  healAmount?: number | null;
  registerBattleCard?: (instanceId: string, element: HTMLElement | null) => void;
  registerBattleSlot?: (
    side: 'player' | 'opponent',
    slotIndex: number,
    element: HTMLElement | null
  ) => void;
  onClick?: (card: BattleCard) => void;
  onInspect?: (card: BattleCard) => void;
}) => {
  const clickTimeoutRef = useRef<number | null>(null);
  useEffect(
    () => () => {
      if (clickTimeoutRef.current != null) {
        window.clearTimeout(clickTimeoutRef.current);
      }
    },
    []
  );
  const registerElement = (element: HTMLElement | null) => {
    registerBattleSlot?.(side, slotIndex, element);
    if (card) {
      registerBattleCard?.(card.instanceId, element);
    }
  };
  if (!card) {
    return (
      <div
        ref={registerElement}
        className="fmk-battle-empty-slot flex aspect-[5/7] min-h-44 items-center justify-center rounded-lg border border-dashed border-white/25 bg-black/20"
        aria-label="Empty battle slot"
      />
    );
  }
  const isAnimatedAttacker =
    attackAnimation?.side === side && attackAnimation.attackerInstanceId === card.instanceId;
  const isDrawReveal =
    drawReveal?.side === side &&
    drawReveal.slotIndex === slotIndex &&
    drawReveal.instanceId === card.instanceId;
  const className = clsx(
    'fmk-collection-card',
    'fmk-collection-card-button',
    'fmk-battle-card-compact',
    `fmk-collection-card-${card.rarity}`,
    selected && 'fmk-collection-card-selected',
    side === 'opponent' && 'fmk-battle-card-opponent',
    disabled && 'fmk-battle-card-disabled',
    isAnimatedAttacker && 'fmk-battle-card-motion-hidden',
    isDrawReveal && 'fmk-battle-card-draw-reveal',
    damageAmount != null && 'fmk-battle-card-damage-target',
    healAmount != null && 'fmk-battle-card-heal-target'
  );
  const wrappedContent = (
    <>
      <BattleCardFace card={card} />
      {damageAmount != null ? (
        <div className="fmk-battle-damage-number" aria-hidden="true">
          -{damageAmount}
        </div>
      ) : null}
      {healAmount != null ? (
        <>
          <div className="fmk-battle-card-heal-splash" aria-hidden="true" />
          <div className="fmk-battle-heal-number" aria-hidden="true">
            +{healAmount}
          </div>
        </>
      ) : null}
    </>
  );
  const handleInspect = (event: React.MouseEvent<HTMLElement>) => {
    if (!onInspect) return;
    event.preventDefault();
    event.stopPropagation();
    if (clickTimeoutRef.current != null) {
      window.clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }
    onInspect(card);
  };
  if (!onClick) {
    return (
      <article ref={registerElement} className={className} onDoubleClick={handleInspect}>
        {wrappedContent}
      </article>
    );
  }
  const handleClick = () => {
    if (disabled) return;
    if (!onInspect) {
      onClick(card);
      return;
    }
    if (clickTimeoutRef.current != null) {
      window.clearTimeout(clickTimeoutRef.current);
    }
    clickTimeoutRef.current = window.setTimeout(() => {
      clickTimeoutRef.current = null;
      onClick(card);
    }, 220);
  };
  return (
    <button
      ref={registerElement}
      type="button"
      className={className}
      aria-disabled={disabled}
      onClick={handleClick}
      onDoubleClick={handleInspect}
    >
      {wrappedContent}
    </button>
  );
};

const REDDIT_TARGET_SUBREDDITS: Record<FMKPostType, string> = {
  straight: 'F_M_K',
  trans: 'F_M_K_Trans',
  gay: 'F_M_K_Gay',
};

const toPostTypeLabel = (type: FMKPostType): string => POST_TYPE_LABELS[type];
const DEFAULT_REPORT_REASON: ReportReason = 'violent_illegal';
const STORED_ASSIGNMENT_RECOVERY_TTL_MS = 2 * 60 * 60 * 1000;

const toAnalyticsMetricLabel = (name: string): string =>
  name
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

const getRedditTargetSubreddit = (type: unknown): string =>
  REDDIT_TARGET_SUBREDDITS[normalizeFMKPostType(type)];

const readStoredAssignment = (postId: string, slots: FMKSlot[]): FMKAssignment | null => {
  try {
    const raw = window.localStorage.getItem(assignmentStorageKey(postId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { assignment?: FMKAssignment; votedAt?: number };
    if (
      typeof parsed.votedAt !== 'number' ||
      !Number.isFinite(parsed.votedAt) ||
      Date.now() - parsed.votedAt > STORED_ASSIGNMENT_RECOVERY_TTL_MS
    ) {
      return null;
    }
    const assignment = parsed.assignment;
    return assignment && isCompleteAssignment(assignment, slots) ? assignment : null;
  } catch {
    return null;
  }
};

const buildCreatePayload = (slots: SlotInput[], title: string, type: FMKPostType) => ({
  title,
  type,
  slots: slots.map((slot) => ({
    kind: slot.kind,
    value: slot.value,
    label: slot.label,
    ...(slot.faceValue ? { faceValue: slot.faceValue } : {}),
  })),
});

const buildBrowseAdSrcDoc = (): string => `<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: transparent;
      }
      #${BROWSE_AD_CONTAINER_ID} {
        width: 100%;
        height: 100%;
      }
    </style>
  </head>
  <body>
    <script async="async" data-cfasync="false" src="${BROWSE_AD_SCRIPT_SRC}"></script>
    <div id="${BROWSE_AD_CONTAINER_ID}"></div>
  </body>
</html>`;

type AdProviderHostWindow = Window & {
  AdProvider?: Array<{ serve: Record<string, never> }>;
};

const queueMagsrvAdServe = (): void => {
  if (typeof window === 'undefined') return;
  const adHost = window as AdProviderHostWindow;
  adHost.AdProvider = adHost.AdProvider ?? [];
  adHost.AdProvider.push({ serve: {} });
};

const queuePollBannerServe = queueMagsrvAdServe;

const ensureMagsrvProviderLoaded = async (): Promise<void> => {
  if (typeof document === 'undefined') return;
  const existingById = document.getElementById(MAGSRV_PROVIDER_SCRIPT_ID);
  if (existingById) return;
  const existingBySrc = Array.from(document.scripts).some(
    (script) => script.src === MAGSRV_PROVIDER_SCRIPT_SRC
  );
  if (existingBySrc) return;
  await new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = MAGSRV_PROVIDER_SCRIPT_ID;
    script.type = 'application/javascript';
    script.src = MAGSRV_PROVIDER_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Magsrv provider script'));
    document.head.appendChild(script);
  });
};

const ensurePollBannerProviderLoaded = ensureMagsrvProviderLoaded;

type SlidingVideoAdProps = {
  blockedAdTypes: string;
};

const hasRenderedAdContent = (
  element: HTMLElement | null,
  adClass = SLIDING_VIDEO_AD_CLASS
): boolean => {
  if (!element) return false;
  const adSlot = element.querySelector(`ins.${adClass}`);
  const contentRoot = adSlot ?? element;
  const renderedElement = element.querySelector('iframe, video, embed, object');
  if (renderedElement) return true;
  return contentRoot.textContent?.trim().length ? true : contentRoot.childElementCount > 0;
};

const SlidingVideoAd = ({ blockedAdTypes }: SlidingVideoAdProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const adSeenRef = useRef(false);
  const [active, setActive] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let cancelled = false;
    adSeenRef.current = false;
    setActive(false);
    setHidden(false);
    void ensureMagsrvProviderLoaded()
      .catch((error) => {
        console.warn('Failed to load sliding video ad provider', error);
      })
      .finally(() => {
        if (!cancelled) queueMagsrvAdServe();
      });
    return () => {
      cancelled = true;
    };
  }, [blockedAdTypes]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let emptyCheckCount = 0;
    let staleTimer: number | null = null;
    const inspectAd = () => {
      const hasContent = hasRenderedAdContent(container);
      if (hasContent) {
        adSeenRef.current = true;
        setActive(true);
        emptyCheckCount = 0;
        staleTimer ??= window.setTimeout(() => setHidden(true), SLIDING_VIDEO_AD_STALE_MS);
        return;
      }
      if (!adSeenRef.current) return;
      emptyCheckCount += 1;
      if (emptyCheckCount >= 2) setHidden(true);
    };

    const observer = new MutationObserver(inspectAd);
    observer.observe(container, { childList: true, subtree: true });
    const interval = window.setInterval(inspectAd, 1500);
    const noFillTimer = window.setTimeout(() => {
      inspectAd();
      if (!adSeenRef.current) setHidden(true);
    }, SLIDING_VIDEO_AD_LOAD_TIMEOUT_MS);
    return () => {
      observer.disconnect();
      window.clearInterval(interval);
      window.clearTimeout(noFillTimer);
      if (staleTimer != null) window.clearTimeout(staleTimer);
    };
  }, [blockedAdTypes]);

  if (hidden) return null;

  return (
    <div
      ref={containerRef}
      className={clsx('fmk-sliding-video-ad', active && 'fmk-sliding-video-ad-active')}
      aria-label="Sponsored video"
    >
      <ins
        key={blockedAdTypes}
        className={SLIDING_VIDEO_AD_CLASS}
        data-zoneid={SLIDING_VIDEO_AD_ZONE_ID}
        data-block-ad-types={blockedAdTypes}
      ></ins>
    </div>
  );
};

type ShopRewardedAdProps = {
  rewardKind: ShopAdRewardKind;
  vastSrc: string;
  blockedAdTypes: string | null;
  claimLoading: boolean;
  claimError: string | null;
  onClaim: (rewardKind: ShopAdRewardKind) => void;
  onClose: () => void;
};

type ShopAdRewardCelebrationState = {
  rewardKind: ShopAdRewardKind;
  rewardedGold: number;
  rewardedGems: number;
  previousCurrency: GalleryCurrencyState;
  nextCurrency: GalleryCurrencyState;
  eyebrow?: string;
  headline?: string;
};

const formatShopAdSeconds = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  return `${totalSeconds}s`;
};

type VastVideoAd = {
  mediaUrl: string;
  impressions: string[];
  startTrackers: string[];
  completeTrackers: string[];
};

const getVastNodeText = (element: Element | null): string => element?.textContent?.trim() ?? '';

const getVastTrackingUrls = (doc: XMLDocument, eventName: string): string[] =>
  Array.from(doc.querySelectorAll(`Tracking[event="${eventName}"]`))
    .map((node) => getVastNodeText(node))
    .filter(Boolean);

const getVastImpressionUrls = (doc: XMLDocument): string[] =>
  Array.from(doc.querySelectorAll('Impression'))
    .map((node) => getVastNodeText(node))
    .filter(Boolean);

const pickVastMediaUrl = (doc: XMLDocument): string => {
  const mediaFiles = Array.from(doc.querySelectorAll('MediaFile'));
  const playable = mediaFiles.find((node) => {
    const type = node.getAttribute('type')?.toLowerCase() ?? '';
    const delivery = node.getAttribute('delivery')?.toLowerCase() ?? '';
    return type.startsWith('video/') && (!delivery || delivery === 'progressive');
  });
  return getVastNodeText(playable ?? mediaFiles[0] ?? null);
};

const fetchVastVideoAd = async (
  vastSrc: string,
  signal: AbortSignal,
  wrapperDepth = 0
): Promise<VastVideoAd> => {
  const response = await fetch(vastSrc, { signal, credentials: 'omit' });
  if (!response.ok) throw new Error(`VAST request failed: HTTP ${response.status}`);
  const xml = await response.text();
  const doc = new DOMParser().parseFromString(xml, 'application/xml');
  if (doc.querySelector('parsererror')) throw new Error('VAST response was not valid XML.');

  const mediaUrl = pickVastMediaUrl(doc);
  const wrapperUrl = getVastNodeText(doc.querySelector('Wrapper VASTAdTagURI'));
  const impressions = getVastImpressionUrls(doc);
  const startTrackers = getVastTrackingUrls(doc, 'start');
  const completeTrackers = getVastTrackingUrls(doc, 'complete');

  if (mediaUrl) {
    return { mediaUrl, impressions, startTrackers, completeTrackers };
  }
  if (wrapperUrl && wrapperDepth < SHOP_REWARDED_AD_VAST_MAX_WRAPPERS) {
    const wrapped = await fetchVastVideoAd(wrapperUrl, signal, wrapperDepth + 1);
    return {
      mediaUrl: wrapped.mediaUrl,
      impressions: [...impressions, ...wrapped.impressions],
      startTrackers: [...startTrackers, ...wrapped.startTrackers],
      completeTrackers: [...completeTrackers, ...wrapped.completeTrackers],
    };
  }
  throw new Error('VAST response did not include a playable video.');
};

const fireVastTrackingUrls = (urls: string[]): void => {
  urls.forEach((url) => {
    try {
      const image = new Image();
      image.referrerPolicy = 'no-referrer-when-downgrade';
      image.src = url;
    } catch {
      // Tracking pixels are best-effort; ad playback and fallback should keep working.
    }
  });
};

const ShopRewardedAd = ({
  rewardKind,
  vastSrc,
  blockedAdTypes,
  claimLoading,
  claimError,
  onClaim,
  onClose,
}: ShopRewardedAdProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const contentSeenRef = useRef(false);
  const vastStartTrackedRef = useRef(false);
  const vastCompleteTrackedRef = useRef(false);
  const [vastAd, setVastAd] = useState<VastVideoAd | null>(null);
  const [usingFallback, setUsingFallback] = useState(false);
  const [providerError, setProviderError] = useState<string | null>(null);
  const [contentSeen, setContentSeen] = useState(false);
  const [claimReady, setClaimReady] = useState(false);
  const [loadTimedOut, setLoadTimedOut] = useState(false);
  const [remainingMs, setRemainingMs] = useState(SHOP_REWARDED_AD_WATCH_MS);
  const rewardLabel = rewardKind === 'gold' ? 'Video Coins' : 'Video Gems';

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), SHOP_REWARDED_AD_VAST_TIMEOUT_MS);
    contentSeenRef.current = false;
    vastStartTrackedRef.current = false;
    vastCompleteTrackedRef.current = false;
    setVastAd(null);
    setUsingFallback(false);
    setProviderError(null);
    setContentSeen(false);
    setClaimReady(false);
    setLoadTimedOut(false);
    setRemainingMs(SHOP_REWARDED_AD_WATCH_MS);
    void fetchVastVideoAd(vastSrc, controller.signal)
      .then((ad) => {
        if (cancelled) return;
        setVastAd(ad);
        fireVastTrackingUrls(ad.impressions);
      })
      .catch((error) => {
        if (cancelled) return;
        const message = error instanceof Error ? error.message : String(error);
        if (message.includes('VAST response did not include a playable video')) {
          console.info('No playable shop rewarded VAST ad was returned; using inline fallback.');
        } else {
          console.warn('Failed to load shop rewarded VAST ad; using inline fallback.', error);
        }
        setUsingFallback(true);
      });
    return () => {
      cancelled = true;
      window.clearTimeout(timeout);
      controller.abort();
    };
  }, [rewardKind, vastSrc]);

  useEffect(() => {
    if (!usingFallback) return;
    let cancelled = false;
    void ensureMagsrvProviderLoaded()
      .catch((error) => {
        console.warn('Failed to load shop rewarded ad provider', error);
        if (!cancelled) setProviderError('Ad failed to load. Please try again.');
      })
      .finally(() => {
        if (!cancelled) queueMagsrvAdServe();
      });
    return () => {
      cancelled = true;
    };
  }, [blockedAdTypes, rewardKind, usingFallback]);

  useEffect(() => {
    if (!usingFallback) return;
    const container = containerRef.current;
    if (!container) return;

    let readyTimer: number | null = null;
    let countdownTimer: number | null = null;
    const markContentSeen = () => {
      if (contentSeenRef.current) return;
      contentSeenRef.current = true;
      setContentSeen(true);
      const readyAt = Date.now() + SHOP_REWARDED_AD_WATCH_MS;
      countdownTimer = window.setInterval(() => {
        setRemainingMs(Math.max(0, readyAt - Date.now()));
      }, 250);
      readyTimer = window.setTimeout(() => {
        setRemainingMs(0);
        setClaimReady(true);
      }, SHOP_REWARDED_AD_WATCH_MS);
    };
    const inspectAd = () => {
      if (hasRenderedAdContent(container, SHOP_REWARDED_AD_CLASS)) {
        markContentSeen();
      }
    };

    const observer = new MutationObserver(inspectAd);
    observer.observe(container, { childList: true, subtree: true });
    const interval = window.setInterval(inspectAd, 1000);
    const noFillTimer = window.setTimeout(() => {
      inspectAd();
      if (!contentSeenRef.current) setLoadTimedOut(true);
    }, SHOP_REWARDED_AD_LOAD_TIMEOUT_MS);
    inspectAd();
    return () => {
      observer.disconnect();
      window.clearInterval(interval);
      window.clearTimeout(noFillTimer);
      if (readyTimer != null) window.clearTimeout(readyTimer);
      if (countdownTimer != null) window.clearInterval(countdownTimer);
    };
  }, [blockedAdTypes, rewardKind, usingFallback]);

  const trackVastStart = (): void => {
    if (!vastAd || vastStartTrackedRef.current) return;
    vastStartTrackedRef.current = true;
    fireVastTrackingUrls(vastAd.startTrackers);
  };

  const completeVastAd = (): void => {
    if (!vastAd) return;
    if (!vastCompleteTrackedRef.current) {
      vastCompleteTrackedRef.current = true;
      fireVastTrackingUrls(vastAd.completeTrackers);
    }
    setClaimReady(true);
    setRemainingMs(0);
  };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/75 px-4">
      <div className="aura-panel w-full max-w-lg rounded-2xl bg-[#5c0099] p-4 text-white shadow-lg">
        <div className="flex items-center justify-between gap-3">
          <h3 className="text-base font-black text-white">{rewardLabel}</h3>
          <button
            type="button"
            className="rounded-full px-3 py-1 text-xs font-black text-white btn-3d-purple disabled:opacity-60"
            disabled={claimLoading}
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <div
          ref={containerRef}
          className="fmk-shop-rewarded-ad-frame mt-4 flex min-h-[260px] items-center justify-center overflow-hidden rounded-xl border border-white/15 bg-black/30 p-2"
        >
          {vastAd && !usingFallback ? (
            <video
              key={vastAd.mediaUrl}
              src={vastAd.mediaUrl}
              className="max-h-[52vh] w-full rounded-lg bg-black"
              controls
              autoPlay
              playsInline
              onPlay={trackVastStart}
              onEnded={completeVastAd}
              onError={() => {
                console.warn('Shop rewarded VAST media failed to play; using inline fallback.');
                setUsingFallback(true);
                setVastAd(null);
                setClaimReady(false);
              }}
            />
          ) : usingFallback ? (
            <ins
              key={`${rewardKind}-${blockedAdTypes ?? 'unblocked'}`}
              className={SHOP_REWARDED_AD_CLASS}
              data-zoneid={SHOP_REWARDED_AD_ZONE_ID}
              {...(blockedAdTypes ? { 'data-block-ad-types': blockedAdTypes } : {})}
            ></ins>
          ) : (
            <div className="text-sm font-semibold text-white/75">Loading video ad...</div>
          )}
        </div>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
          <p className="text-xs font-semibold text-white/75">
            {providerError
              ? providerError
              : vastAd && !usingFallback && claimReady
                ? 'Reward ready.'
                : vastAd && !usingFallback
                  ? 'Watch the video to unlock your reward.'
                  : loadTimedOut && !contentSeen
                    ? 'No ad is available right now.'
                    : claimReady
                      ? 'Reward ready.'
                      : contentSeen
                        ? `Reward ready in ${formatShopAdSeconds(remainingMs)}`
                        : 'Loading ad...'}
          </p>
          <button
            type="button"
            className="rounded-full px-4 py-2 text-sm font-black text-white btn-3d-gold disabled:opacity-50"
            disabled={!claimReady || claimLoading}
            onClick={() => onClaim(rewardKind)}
          >
            {claimLoading ? 'Claiming...' : 'Claim Reward'}
          </button>
        </div>
        {claimError ? (
          <p className="mt-2 text-xs font-semibold text-red-200">{claimError}</p>
        ) : null}
      </div>
    </div>
  );
};

const ShopAdRewardCelebration = ({
  reward,
  onClose,
}: {
  reward: ShopAdRewardCelebrationState;
  onClose: () => void;
}) => {
  const [displayGold, setDisplayGold] = useState(reward.previousCurrency.gold);
  const [displayGems, setDisplayGems] = useState(reward.previousCurrency.gems);
  const isGoldReward = reward.rewardKind === 'gold';
  const rewardAmount = isGoldReward ? reward.rewardedGold : reward.rewardedGems;
  const rewardName = isGoldReward ? 'Coins' : 'Gems';
  const rewardIcon = isGoldReward ? coinsIcon : gemsIcon;
  const rewardTextColor = isGoldReward ? 'text-[#ffd84a]' : 'text-[#90f7ff]';
  const bonusGems = isGoldReward ? reward.rewardedGems : 0;

  useEffect(() => {
    let animationFrame = 0;
    const startedAt = performance.now();
    const duration = 1200;
    const animate = (now: number): void => {
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayGold(
        Math.round(
          reward.previousCurrency.gold +
            (reward.nextCurrency.gold - reward.previousCurrency.gold) * eased
        )
      );
      setDisplayGems(
        Math.round(
          reward.previousCurrency.gems +
            (reward.nextCurrency.gems - reward.previousCurrency.gems) * eased
        )
      );
      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(animate);
      }
    };
    animationFrame = window.requestAnimationFrame(animate);
    return () => window.cancelAnimationFrame(animationFrame);
  }, [reward]);

  const balanceRows = [
    ...(isGoldReward
      ? [
          {
            kind: 'coin' as const,
            label: 'Coins',
            value: displayGold,
            gained: reward.rewardedGold,
            textClass: 'text-[#ffd84a]',
          },
        ]
      : []),
    ...(!isGoldReward || reward.rewardedGems > 0
      ? [
          {
            kind: 'gem' as const,
            label: 'Gems',
            value: displayGems,
            gained: reward.rewardedGems,
            textClass: 'text-[#90f7ff]',
          },
        ]
      : []),
  ].filter((row) => row.gained > 0);
  const rewardTokens = Array.from({ length: 28 }, (_, index) => {
    const column = (index % 7) - 3;
    const lane = Math.floor(index / 7);
    return {
      index,
      style: {
        '--token-index': index,
        '--token-x': `${column * 18}px`,
        '--token-y': `${118 + lane * 10}px`,
        '--token-arc': `${-42 - (index % 5) * 9}px`,
        '--token-scale': `${0.72 + (index % 4) * 0.08}`,
      } as React.CSSProperties,
    };
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 px-4">
      <div className="aura-panel fmk-shop-ad-reward-modal w-full max-w-md rounded-2xl bg-[#5c0099] p-5 text-white shadow-lg">
        <div className="text-center">
          <p className="text-xs font-black uppercase tracking-wide text-[#ffe27a]">
            {reward.eyebrow ?? 'Reward Claimed'}
          </p>
          <h3 className="mt-1 text-2xl font-black text-white">
            {reward.headline ?? `You earned ${rewardName}!`}
          </h3>
        </div>

        <div className="fmk-shop-ad-reward-stage" aria-hidden="true">
          <div className="fmk-shop-ad-reward-orb">
            <img src={rewardIcon} alt="" />
          </div>
          {rewardTokens.map((token) => (
            <span key={token.index} className="fmk-shop-ad-reward-token" style={token.style}>
              <img src={rewardIcon} alt="" />
            </span>
          ))}
        </div>

        <div className={clsx('text-center text-3xl font-black', rewardTextColor)}>
          +{rewardAmount.toLocaleString()} {rewardName}
        </div>
        {bonusGems > 0 ? (
          <div className="mt-1 text-center text-sm font-black text-[#90f7ff]">
            +{bonusGems.toLocaleString()} Gems bonus
          </div>
        ) : null}

        <div className="mt-5 space-y-2" aria-label="Current shop currency balances">
          {balanceRows.map((balanceRow) => (
            <div
              key={balanceRow.kind}
              className="fmk-shop-ad-balance-row fmk-shop-ad-balance-row-active aura-chip relative overflow-hidden rounded-xl bg-black/25 px-4 py-3"
            >
              <span className="fmk-shop-ad-balance-fill" aria-hidden="true" />
              <div className="relative z-10 flex items-center justify-between gap-3">
                <span className="inline-flex items-center gap-2 text-sm font-black uppercase text-white/75">
                  <CurrencyIcon kind={balanceRow.kind} className="h-7 w-7" />
                  {balanceRow.label}
                </span>
                <span className={clsx('text-2xl font-black', balanceRow.textClass)}>
                  {balanceRow.value.toLocaleString()}
                </span>
              </div>
              <div className="relative z-10 mt-1 text-right text-xs font-black text-white/75">
                +{balanceRow.gained.toLocaleString()} added
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="mt-5 w-full rounded-full px-4 py-3 text-sm font-black text-white btn-3d-gold"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

const ensureMobilePopunderProviderLoaded = async (): Promise<void> => {
  if (typeof document === 'undefined') return;
  const existingScript = document.getElementById(MOBILE_POPUNDER_PROVIDER_SCRIPT_ID);
  if (existingScript) {
    if (POPUNDER_DEBUG)
      console.info('[POPUNDER DEBUG] Mobile provider script already present - rebinding');
    existingScript.remove();
    document.getElementById('popmagicldr')?.remove();
  }
  const script = document.createElement('script');
  script.id = MOBILE_POPUNDER_PROVIDER_SCRIPT_ID;
  script.setAttribute('data-cfasync', 'false');
  script.src = MOBILE_POPUNDER_PROVIDER_SCRIPT_SRC;
  script.async = true;
  script.onload = () => {
    if (POPUNDER_DEBUG) {
      console.info('[POPUNDER DEBUG] Mobile provider loaded', { src: script.src });
      window.setTimeout(() => {
        const hostedLoader = document.getElementById('popmagicldr');
        const hostedScripts = Array.from(document.scripts)
          .map((s) => s.src)
          .filter((src) => src.includes('pemsrv.com'));
        console.info('[POPUNDER DEBUG] Mobile provider post-load check', {
          popmagicldrPresent: Boolean(hostedLoader),
          pemsrvScripts: hostedScripts,
          mobileTriggerCount: document.querySelectorAll('.fmk-popunder-trigger-browse-mobile')
            .length,
        });
      }, 900);
    }
  };
  script.onerror = () => {
    console.warn('[POPUNDER DEBUG] Mobile provider failed to load', { src: script.src });
  };
  document.head.appendChild(script);
};

const ensureDesktopPopunderProviderLoaded = async (): Promise<void> => {
  if (typeof document === 'undefined') return;
  const existingScript = document.getElementById(DESKTOP_POPUNDER_PROVIDER_SCRIPT_ID);
  if (existingScript) {
    if (POPUNDER_DEBUG)
      console.info('[POPUNDER DEBUG] Desktop provider script already present - rebinding');
    existingScript.remove();
    document.getElementById('popmagicldr')?.remove();
  }
  const script = document.createElement('script');
  script.id = DESKTOP_POPUNDER_PROVIDER_SCRIPT_ID;
  script.setAttribute('data-cfasync', 'false');
  script.src = DESKTOP_POPUNDER_PROVIDER_SCRIPT_SRC;
  script.async = true;
  script.onload = () => {
    if (POPUNDER_DEBUG) {
      console.info('[POPUNDER DEBUG] Desktop provider loaded', { src: script.src });
      window.setTimeout(() => {
        const hostedLoader = document.getElementById('popmagicldr');
        const hostedScripts = Array.from(document.scripts)
          .map((s) => s.src)
          .filter((src) => src.includes('pemsrv.com'));
        console.info('[POPUNDER DEBUG] Desktop provider post-load check', {
          popmagicldrPresent: Boolean(hostedLoader),
          pemsrvScripts: hostedScripts,
          desktopTriggerCount: document.querySelectorAll('.fmk-popunder-trigger-browse-desktop')
            .length,
        });
      }, 900);
    }
  };
  script.onerror = () => {
    console.warn('[POPUNDER DEBUG] Desktop provider failed to load', { src: script.src });
  };
  document.head.appendChild(script);
};

const estimateCreatePayloadBytes = (slots: SlotInput[], title: string, type: FMKPostType): number =>
  utf8ByteLength(JSON.stringify(buildCreatePayload(slots, title, type)));

const loadImageElement = async (file: File): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Unable to load selected image.'));
    };
    image.src = objectUrl;
  });

const SHARE_CANVAS_WIDTH = 1536;
const SHARE_CANVAS_HEIGHT = 896;
const SHARE_OUTER_PADDING = 48;
const SHARE_HEADER_HEIGHT = 90;
const SHARE_ROW_GAP = 16;
const SHARE_CARD_BORDER = 8;
const SHARE_CARD_LABEL_HEIGHT = 66;
const SHARE_VS_SCALE = 0.82;
const SHARE_VS_MAX_WIDTH = 320;
const SHARE_FOOTER_TEXT = 'Cast your vote at fmk-game.com';
const SHARE_FOOTER_FONT_SIZE = 26;
const SHARE_FOOTER_PADDING_X = 24;
const SHARE_FOOTER_PADDING_Y = 12;
const TOURNAMENT_SHARE_CANVAS_WIDTH = 2800;
const TOURNAMENT_SHARE_OUTER_PADDING = 72;
const TOURNAMENT_SHARE_CARD_WIDTH = 680;
const TOURNAMENT_SHARE_CARD_HEIGHT = 612;
const TOURNAMENT_SHARE_CARD_GAP_Y = 56;
const TOURNAMENT_SHARE_CONNECTOR_WIDTH = 120;
const TOURNAMENT_SHARE_SLOT_HEIGHT = 68;
const TOURNAMENT_SHARE_WATERMARK = 'fmk-game.com';

const loadImageFromUrl = async (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Unable to load image: ${src}`));
    const cacheBust = `fmkShareTs=${Date.now().toString(36)}`;
    image.src = src.includes('?') ? `${src}&${cacheBust}` : `${src}?${cacheBust}`;
  });

const drawImageCover = (
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement,
  x: number,
  y: number,
  width: number,
  height: number
) => {
  const scale = Math.max(width / image.width, height / image.height);
  const drawWidth = image.width * scale;
  const drawHeight = image.height * scale;
  const drawX = x + (width - drawWidth) / 2;
  // Top-anchor the vertical crop to keep faces near the top in frame.
  const drawY = y;
  ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
};

const drawImageContain = (
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement,
  x: number,
  y: number,
  width: number,
  height: number
) => {
  const scale = Math.min(width / image.width, height / image.height);
  const drawWidth = image.width * scale;
  const drawHeight = image.height * scale;
  const drawX = x + (width - drawWidth) / 2;
  const drawY = y + (height - drawHeight) / 2;
  ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
};

const drawShareFallbackCard = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  label: string
) => {
  ctx.fillStyle = '#3a0b59';
  ctx.fillRect(x, y, width, height);
  ctx.fillStyle = 'rgba(253, 197, 0, 0.25)';
  ctx.fillRect(x, y, width, height);
  ctx.strokeStyle = '#fdc500';
  ctx.lineWidth = 3;
  ctx.strokeRect(x + 1.5, y + 1.5, width - 3, height - 3);
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 36px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('Image Unavailable', x + width / 2, y + height / 2 - 14, Math.max(40, width - 20));
  ctx.font = '600 26px sans-serif';
  ctx.fillText(label, x + width / 2, y + height / 2 + 34, Math.max(40, width - 20));
};

const emptySlots: SlotInput[] = [
  { kind: 'image', value: '', label: 'Option 1' },
  { kind: 'image', value: '', label: 'Option 2' },
  { kind: 'image', value: '', label: 'Option 3' },
];

const initialAssignment: FMKAssignment = { f: '', m: '', k: '' };

const emptyPercentages = (): FMKPercentages => ({
  f: {},
  m: {},
  k: {},
});

const roleLabels: Record<keyof FMKAssignment, string> = {
  f: '"Fun"',
  m: 'Marry',
  k: 'Kill',
};

const tournamentCategoryLabels: Record<TournamentCategory, string> = {
  f: 'Fun',
  m: 'Marry',
  k: 'Kill',
};

const roleOrder: Array<keyof FMKAssignment> = ['f', 'm', 'k'];

const TOURNAMENT_STAGE_LABELS: Record<TournamentSummary['progress'][number]['stage'], string> = {
  round1: 'Quarterfinal',
  round2: 'Round 2',
  round3: 'Semifinal',
  round4: 'Final',
};

const formatCountdown = (remainingMs: number): string => {
  const clamped = Math.max(0, remainingMs);
  const totalSeconds = Math.floor(clamped / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
  return `${minutes}m ${seconds}s`;
};

const getTournamentCountdownMs = (tournament: TournamentSummary | null, nowMs: number): number => {
  if (!tournament) return 0;
  const nextTournamentStartsAt = tournament.endsAt + TOURNAMENT_RESTART_DELAY_MS;
  const endsAt = tournament.status === 'completed' ? nextTournamentStartsAt : tournament.endsAt;
  return Math.max(0, endsAt - nowMs);
};

const getTournamentRoundCountdownMs = (
  tournament: TournamentSummary | null,
  nowMs: number
): number => {
  const endsAt = tournament?.activeWindow?.phaseEndsAt ?? tournament?.activeWindow?.endsAt ?? 0;
  return Math.max(0, endsAt - nowMs);
};

const getTournamentEntrantLabel = (entrant: TournamentEntrant): string =>
  entrant.label?.trim() || entrant.sourcePostTitle?.trim() || `Seed ${entrant.seed}`;

const buildTournamentEntrantMap = (
  entrants: TournamentEntrant[]
): Record<string, TournamentEntrant> =>
  Object.fromEntries(entrants.map((entrant) => [entrant.entrantId, entrant]));

const TournamentProgressGraph = ({ tournament }: { tournament: TournamentSummary }) => (
  <div className="flex flex-wrap justify-center gap-2">
    {tournament.progress.map((step) => {
      const progress =
        step.totalWindows > 0 ? Math.round((step.completedWindows / step.totalWindows) * 100) : 0;
      return (
        <div
          key={step.stage}
          className="tournament-stage-card w-full rounded-xl bg-[#3d0066] px-3 py-2 text-white sm:w-56"
        >
          <div className="flex items-center justify-between gap-2 text-[11px] font-semibold uppercase tracking-wide text-[#ffd84a]">
            <span>{TOURNAMENT_STAGE_LABELS[step.stage]}</span>
            <span>
              {step.completedWindows}/{step.totalWindows}
            </span>
          </div>
          <div className="mt-2 tournament-stage-track h-2 rounded-full bg-white/15">
            <div
              className="tournament-stage-fill h-2 rounded-full bg-[#fdc500]"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      );
    })}
  </div>
);

const TournamentStandings = ({
  result,
  entrantMap,
}: {
  result: TournamentWindowResult;
  entrantMap: Record<string, TournamentEntrant>;
}) => (
  <div className="grid gap-3 sm:grid-cols-3">
    {TOURNAMENT_CATEGORIES.map((category) => {
      const categoryStandings = result.standings[category];
      const hasCategoryVotes = categoryStandings.some((standing) => standing.score > 0);
      const winnerId = hasCategoryVotes ? (categoryStandings[0]?.entrantId ?? '') : '';
      const winner = winnerId ? entrantMap[winnerId] : undefined;
      return (
        <div key={category} className="rounded-xl border border-white/15 bg-white/8 p-3">
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-sm font-bold text-white">{tournamentCategoryLabels[category]}</h4>
            <span className="text-[11px] font-semibold uppercase tracking-wide text-[#ffd84a]">
              {winner ? `Current Winner: ${getTournamentEntrantLabel(winner)}` : 'TBD'}
            </span>
          </div>
          <div className="mt-3 space-y-2">
            {!hasCategoryVotes ? (
              <div className="rounded-lg bg-black/15 px-2 py-4 text-center text-sm font-bold text-white/80">
                TBD
              </div>
            ) : null}
            {hasCategoryVotes
              ? categoryStandings.slice(0, 3).map((standing) => {
                  const entrant = entrantMap[standing.entrantId];
                  return (
                    <div
                      key={`${category}-${standing.entrantId}`}
                      className="flex items-center gap-3 rounded-lg bg-black/15 px-2 py-2"
                    >
                      <div className="w-5 text-center text-xs font-bold text-[#ffd84a]">
                        #{standing.rank}
                      </div>
                      {entrant?.kind === 'image' && entrant.value ? (
                        <img
                          src={entrant.value}
                          alt={getTournamentEntrantLabel(entrant)}
                          className="h-10 w-10 rounded object-cover"
                        />
                      ) : (
                        <div className="flex h-10 w-10 items-center justify-center rounded bg-white/10 text-[10px] text-white/70">
                          TXT
                        </div>
                      )}
                      <div className="min-w-0 flex-1">
                        <div className="truncate text-sm font-semibold text-white">
                          {entrant ? getTournamentEntrantLabel(entrant) : 'Unknown entrant'}
                        </div>
                        <div className="text-xs text-white/70">{standing.score} votes</div>
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      );
    })}
  </div>
);

const getTournamentBracketWindowStatusLabel = (
  status: 'completed' | 'active' | 'upcoming'
): string => {
  switch (status) {
    case 'completed':
      return 'Completed';
    case 'active':
      return 'Live';
    default:
      return 'Upcoming';
  }
};

const TournamentBracketGraph = ({
  bracket,
  entrantMap,
  onPreview,
}: {
  bracket: TournamentBracket;
  entrantMap: Record<string, TournamentEntrant>;
  onPreview: (entrant: TournamentEntrant) => void;
}) => {
  const [zoom, setZoom] = useState(1);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const pointerRef = useRef(new Map<number, { x: number; y: number }>());
  const dragRef = useRef({
    active: false,
    moved: false,
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  });
  const pinchRef = useRef({
    active: false,
    startDistance: 0,
    startZoom: 1,
  });
  const clampBracketZoom = (nextZoom: number): number => Math.min(1.5, Math.max(0.65, nextZoom));
  const setBracketZoom = (nextZoom: number): void => {
    setZoom(clampBracketZoom(nextZoom));
  };
  const getPointerDistance = (): number => {
    const points = [...pointerRef.current.values()];
    const first = points[0];
    const second = points[1];
    if (!first || !second) return 0;
    return Math.hypot(second.x - first.x, second.y - first.y);
  };
  const handlePointerDown = (event: React.PointerEvent<HTMLDivElement>): void => {
    const target = scrollRef.current;
    if (!target) return;
    pointerRef.current.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointerRef.current.size >= 2) {
      pinchRef.current = {
        active: true,
        startDistance: getPointerDistance(),
        startZoom: zoom,
      };
      dragRef.current.active = false;
      return;
    }
    dragRef.current = {
      active: true,
      moved: false,
      startX: event.clientX,
      startY: event.clientY,
      scrollLeft: target.scrollLeft,
      scrollTop: target.scrollTop,
    };
  };
  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>): void => {
    const target = scrollRef.current;
    if (!target) return;
    if (pointerRef.current.has(event.pointerId)) {
      pointerRef.current.set(event.pointerId, { x: event.clientX, y: event.clientY });
    }
    if (pinchRef.current.active && pointerRef.current.size >= 2) {
      event.preventDefault();
      const nextDistance = getPointerDistance();
      if (pinchRef.current.startDistance > 0 && nextDistance > 0) {
        setZoom(
          clampBracketZoom(
            pinchRef.current.startZoom * (nextDistance / pinchRef.current.startDistance)
          )
        );
        dragRef.current.moved = true;
      }
      return;
    }
    if (!dragRef.current.active) return;
    const deltaX = event.clientX - dragRef.current.startX;
    const deltaY = event.clientY - dragRef.current.startY;
    if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) {
      dragRef.current.moved = true;
    }
    target.scrollLeft = dragRef.current.scrollLeft - deltaX;
    target.scrollTop = dragRef.current.scrollTop - deltaY;
  };
  const handlePointerEnd = (event: React.PointerEvent<HTMLDivElement>): void => {
    pointerRef.current.delete(event.pointerId);
    if (pointerRef.current.size < 2) {
      pinchRef.current.active = false;
    }
    const remainingPointer = [...pointerRef.current.values()][0];
    if (remainingPointer && scrollRef.current) {
      dragRef.current = {
        active: true,
        moved: dragRef.current.moved,
        startX: remainingPointer.x,
        startY: remainingPointer.y,
        scrollLeft: scrollRef.current.scrollLeft,
        scrollTop: scrollRef.current.scrollTop,
      };
    } else {
      dragRef.current.active = false;
    }
  };
  const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (!dragRef.current.moved) return;
    event.preventDefault();
    event.stopPropagation();
    dragRef.current.moved = false;
  };
  const zoomPercent = Math.round(zoom * 100);

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-white/70">
          Drag to pan, pinch or tap to zoom
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
            onClick={() => setBracketZoom(zoom - 0.15)}
          >
            -
          </button>
          <button
            type="button"
            className="min-w-14 rounded-full bg-black/20 px-3 py-1 text-xs font-semibold text-white"
            onClick={() => setBracketZoom(1)}
          >
            {zoomPercent}%
          </button>
          <button
            type="button"
            className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
            onClick={() => setBracketZoom(zoom + 0.15)}
          >
            +
          </button>
        </div>
      </div>
      <div
        ref={scrollRef}
        className="tournament-bracket-scroll overflow-auto pb-2"
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerEnd}
        onPointerCancel={handlePointerEnd}
        onClickCapture={handleClickCapture}
        style={{ touchAction: 'none' }}
      >
        <div
          className="tournament-bracket min-w-max"
          style={{
            zoom,
          }}
        >
          {bracket.rounds.map((round, roundIndex) => (
            <div key={round.stage} className="tournament-bracket-stage flex items-stretch">
              <div
                className={clsx(
                  'tournament-bracket-round flex min-w-[280px] flex-col gap-4',
                  `tournament-bracket-round-count-${round.windows.length}`
                )}
              >
                <div className="sticky left-0 z-10 rounded-xl bg-[#280043] px-3 py-2 text-center shadow-[0_10px_24px_rgba(0,0,0,0.24)]">
                  <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#ffd84a]">
                    {round.label}
                  </p>
                </div>
                {Array.from({ length: Math.ceil(round.windows.length / 2) }, (_, pairIndex) => {
                  const pairWindows = round.windows.slice(pairIndex * 2, pairIndex * 2 + 2);
                  const hasSecondNode = pairWindows.length > 1;
                  return (
                    <div
                      key={`${round.stage}-pair-${pairIndex}`}
                      className="tournament-bracket-pair-group flex items-stretch"
                    >
                      <div className="tournament-bracket-window-stack flex min-w-[280px] flex-col gap-4">
                        {pairWindows.map((window) => (
                          <div
                            key={window.battleId}
                            className="tournament-bracket-window aura-card relative rounded-2xl bg-[#4a0079] p-3 text-white"
                          >
                            <div className="flex items-start justify-between gap-3">
                              <div>
                                <p className="text-sm font-bold text-white">{window.label}</p>
                                <p className="text-[11px] text-white/65">
                                  {window.totalBallots} votes
                                </p>
                              </div>
                              <span
                                className={clsx(
                                  'rounded-full px-2 py-1 text-[10px] font-semibold uppercase tracking-wide',
                                  window.status === 'active'
                                    ? 'bg-[#ffd84a] text-[#3d0066]'
                                    : window.status === 'completed'
                                      ? 'bg-white/15 text-white'
                                      : 'bg-black/20 text-white/75'
                                )}
                              >
                                {getTournamentBracketWindowStatusLabel(window.status)}
                              </span>
                            </div>

                            {window.activeCategory ? (
                              <div className="mt-2 text-[11px] font-semibold uppercase tracking-wide text-[#ffd84a]">
                                {tournamentCategoryLabels[window.activeCategory]} phase live
                              </div>
                            ) : null}

                            <div className="mt-3 space-y-2">
                              {window.slots.map((slot) => {
                                const entrant = slot.entrantId
                                  ? entrantMap[slot.entrantId]
                                  : undefined;
                                const previewable = Boolean(
                                  entrant && entrant.kind === 'image' && entrant.value
                                );
                                const content = (
                                  <>
                                    {slot.thumbnailUrl ? (
                                      <img
                                        src={slot.thumbnailUrl}
                                        alt={slot.label}
                                        className="h-8 w-8 shrink-0 rounded-md object-cover object-top"
                                      />
                                    ) : (
                                      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-white/10 text-[10px] font-bold text-white/70">
                                        TBD
                                      </div>
                                    )}
                                    <div className="min-w-0 flex-1">
                                      <div className="flex items-center gap-2">
                                        <span className="truncate text-sm font-semibold text-white">
                                          {slot.label}
                                        </span>
                                        {slot.category ? (
                                          <span className="rounded-full bg-[#ffd84a]/20 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#ffd84a]">
                                            {tournamentCategoryLabels[slot.category]}
                                          </span>
                                        ) : null}
                                        {slot.status === 'current' ? (
                                          <span className="rounded-full bg-cyan-300/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-cyan-200">
                                            Current
                                          </span>
                                        ) : null}
                                      </div>
                                      {slot.status === 'tbd' ? (
                                        <div className="text-[11px] text-white/60">
                                          Waiting for winners
                                        </div>
                                      ) : null}
                                    </div>
                                  </>
                                );

                                return previewable ? (
                                  <button
                                    key={slot.slotId}
                                    type="button"
                                    className={clsx(
                                      'tournament-bracket-slot flex w-full items-center gap-3 rounded-xl border px-2 py-2 text-left transition',
                                      slot.status === 'winner'
                                        ? 'border-[#ffd84a]/60 bg-[#ffd84a]/12'
                                        : slot.status === 'current'
                                          ? 'border-cyan-300/50 bg-cyan-300/10'
                                          : 'border-white/10 bg-black/15 hover:border-white/25 hover:bg-black/25'
                                    )}
                                    onClick={() => entrant && onPreview(entrant)}
                                  >
                                    {content}
                                  </button>
                                ) : (
                                  <div
                                    key={slot.slotId}
                                    className={clsx(
                                      'tournament-bracket-slot flex items-center gap-3 rounded-xl border px-2 py-2',
                                      slot.status === 'winner'
                                        ? 'border-[#ffd84a]/50 bg-[#ffd84a]/10'
                                        : slot.status === 'current'
                                          ? 'border-cyan-300/45 bg-cyan-300/10'
                                          : slot.status === 'tbd'
                                            ? 'border-dashed border-white/15 bg-black/10'
                                            : 'border-white/10 bg-black/15'
                                    )}
                                  >
                                    {content}
                                  </div>
                                );
                              })}
                            </div>

                            {window.winners.length > 0 ? (
                              <div className="mt-3 flex flex-wrap gap-2">
                                {window.winners.map((winner) => (
                                  <span
                                    key={`${window.battleId}-${winner.category}`}
                                    className="rounded-full bg-white/10 px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/85"
                                  >
                                    {tournamentCategoryLabels[winner.category]}
                                  </span>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                      {roundIndex < bracket.rounds.length - 1 ? (
                        <div
                          className={clsx(
                            'tournament-bracket-join-group',
                            !hasSecondNode && 'tournament-bracket-join-group-single'
                          )}
                          aria-hidden="true"
                        >
                          <div className="tournament-bracket-join-arm tournament-bracket-join-arm-top" />
                          {hasSecondNode ? (
                            <div className="tournament-bracket-join-arm tournament-bracket-join-arm-bottom" />
                          ) : null}
                          {hasSecondNode ? (
                            <div className="tournament-bracket-join-vertical" />
                          ) : null}
                          <div className="tournament-bracket-join-out" />
                          <div className="tournament-bracket-join-node" />
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const drawCanvasRoundRect = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
) => {
  const clampedRadius = Math.min(radius, width / 2, height / 2);
  ctx.beginPath();
  ctx.moveTo(x + clampedRadius, y);
  ctx.lineTo(x + width - clampedRadius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + clampedRadius);
  ctx.lineTo(x + width, y + height - clampedRadius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - clampedRadius, y + height);
  ctx.lineTo(x + clampedRadius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - clampedRadius);
  ctx.lineTo(x, y + clampedRadius);
  ctx.quadraticCurveTo(x, y, x + clampedRadius, y);
  ctx.closePath();
};

const fillCanvasRoundRect = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  fillStyle: string | CanvasGradient
) => {
  drawCanvasRoundRect(ctx, x, y, width, height, radius);
  ctx.fillStyle = fillStyle;
  ctx.fill();
};

const strokeCanvasRoundRect = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  strokeStyle: string,
  lineWidth: number
) => {
  drawCanvasRoundRect(ctx, x, y, width, height, radius);
  ctx.strokeStyle = strokeStyle;
  ctx.lineWidth = lineWidth;
  ctx.stroke();
};

const truncateCanvasText = (
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number
): string => {
  const normalized = text.trim();
  if (!normalized || ctx.measureText(normalized).width <= maxWidth) return normalized;
  let truncated = normalized;
  while (truncated.length > 1 && ctx.measureText(`${truncated}...`).width > maxWidth) {
    truncated = truncated.slice(0, -1);
  }
  return `${truncated.trim()}...`;
};

const drawWrappedCanvasText = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  maxWidth: number,
  lineHeight: number,
  maxLines: number
): number => {
  const words = text.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return y;
  const lines: string[] = [];
  let currentLine = '';
  words.forEach((word) => {
    const candidate = currentLine ? `${currentLine} ${word}` : word;
    if (ctx.measureText(candidate).width <= maxWidth || !currentLine) {
      currentLine = candidate;
      return;
    }
    lines.push(currentLine);
    currentLine = word;
  });
  if (currentLine) lines.push(currentLine);

  const visibleLines = lines.slice(0, maxLines);
  if (lines.length > maxLines && visibleLines.length > 0) {
    visibleLines[visibleLines.length - 1] = truncateCanvasText(
      ctx,
      visibleLines[visibleLines.length - 1] ?? '',
      maxWidth
    );
  }
  visibleLines.forEach((line, index) => {
    ctx.fillText(line, x, y + index * lineHeight, maxWidth);
  });
  return y + visibleLines.length * lineHeight;
};

const getTournamentSlotWinner = (
  window: TournamentBracketWindow,
  entrantId: string | undefined
): TournamentCategoryWinner | null =>
  entrantId ? (window.winners.find((winner) => winner.entrantId === entrantId) ?? null) : null;

const getTournamentShareStatusFill = (status: TournamentBracketWindow['status']): string => {
  if (status === 'active') return '#ffd84a';
  if (status === 'completed') return '#70508c';
  return '#2a1840';
};

const getTournamentShareStatusText = (status: TournamentBracketWindow['status']): string => {
  if (status === 'active') return '#26003d';
  if (status === 'completed') return '#ffffff';
  return '#d7c6e8';
};

const composeTournamentBracketShareImage = async ({
  tournament,
  bracket,
  finalWinners,
  entrantMap,
}: {
  tournament: TournamentSummary;
  bracket: TournamentBracket;
  finalWinners: TournamentCategoryWinner[];
  entrantMap: Record<string, TournamentEntrant>;
}): Promise<string> => {
  const completed = tournament.status === 'completed';
  const maxWindows = Math.max(1, ...bracket.rounds.map((round) => round.windows.length));
  const winnerPanelHeight = completed ? 430 : 0;
  const bracketTop =
    TOURNAMENT_SHARE_OUTER_PADDING + 168 + (completed ? winnerPanelHeight + 48 : 24);
  const bracketHeight =
    maxWindows * TOURNAMENT_SHARE_CARD_HEIGHT +
    Math.max(0, maxWindows - 1) * TOURNAMENT_SHARE_CARD_GAP_Y;
  const canvasHeight = Math.max(1500, bracketTop + bracketHeight + 132);
  const canvas = document.createElement('canvas');
  canvas.width = TOURNAMENT_SHARE_CANVAS_WIDTH;
  canvas.height = canvasHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Image generation is not supported in this browser.');
  }

  const imageUrls = new Set<string>();
  bracket.rounds.forEach((round) => {
    round.windows.forEach((window) => {
      window.slots.forEach((slot) => {
        if (slot.thumbnailUrl) imageUrls.add(slot.thumbnailUrl);
      });
    });
  });
  finalWinners.forEach((winner) => {
    const entrant = entrantMap[winner.entrantId];
    if (entrant?.kind === 'image' && entrant.value) imageUrls.add(entrant.value);
  });
  const images = new Map<string, HTMLImageElement | null>();
  await Promise.all(
    [...imageUrls].map(async (url) => {
      try {
        images.set(url, await loadImageFromUrl(url));
      } catch {
        images.set(url, null);
      }
    })
  );

  const background = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
  background.addColorStop(0, '#150021');
  background.addColorStop(0.55, '#3f0069');
  background.addColorStop(1, '#080010');
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = 'rgba(253, 197, 0, 0.08)';
  ctx.beginPath();
  ctx.arc(canvas.width - 420, 230, 520, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = 'rgba(0, 198, 255, 0.07)';
  ctx.beginPath();
  ctx.arc(260, canvas.height - 420, 620, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#ffd84a';
  ctx.font = '900 78px sans-serif';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.fillText('Weekly Tournament Bracket', TOURNAMENT_SHARE_OUTER_PADDING, 58);
  ctx.fillStyle = '#ffffff';
  ctx.font = '700 34px sans-serif';
  const statusText = tournament.status === 'completed' ? 'Final results' : 'Current results';
  ctx.fillText(statusText, TOURNAMENT_SHARE_OUTER_PADDING, 142);

  if (completed) {
    const panelGap = 32;
    const panelWidth = (canvas.width - TOURNAMENT_SHARE_OUTER_PADDING * 2 - panelGap * 2) / 3;
    const panelY = 216;
    TOURNAMENT_CATEGORIES.forEach((category, index) => {
      const winner = finalWinners.find((item) => item.category === category);
      const entrant = winner ? entrantMap[winner.entrantId] : undefined;
      const panelX = TOURNAMENT_SHARE_OUTER_PADDING + index * (panelWidth + panelGap);
      fillCanvasRoundRect(ctx, panelX, panelY, panelWidth, winnerPanelHeight, 28, '#3d0066');
      strokeCanvasRoundRect(ctx, panelX, panelY, panelWidth, winnerPanelHeight, 28, '#ffd84a', 5);

      ctx.fillStyle = '#ffd84a';
      ctx.font = '900 96px sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(category.toUpperCase(), panelX + 28, panelY + 18);
      ctx.fillStyle = '#ffffff';
      ctx.font = '900 34px sans-serif';
      ctx.fillText(tournamentCategoryLabels[category], panelX + 116, panelY + 48);

      const imageX = panelX + 28;
      const imageY = panelY + 136;
      const imageWidth = 204;
      const imageHeight = 244;
      fillCanvasRoundRect(ctx, imageX, imageY, imageWidth, imageHeight, 18, '#12001d');
      const image =
        entrant?.kind === 'image' && entrant.value ? (images.get(entrant.value) ?? null) : null;
      if (image) {
        ctx.save();
        drawCanvasRoundRect(ctx, imageX, imageY, imageWidth, imageHeight, 18);
        ctx.clip();
        drawImageCover(ctx, image, imageX, imageY, imageWidth, imageHeight);
        ctx.restore();
      } else {
        ctx.fillStyle = '#ffffff';
        ctx.font = '800 30px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('TBD', imageX + imageWidth / 2, imageY + imageHeight / 2);
      }

      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillStyle = '#ffffff';
      ctx.font = '900 36px sans-serif';
      drawWrappedCanvasText(
        ctx,
        entrant ? getTournamentEntrantLabel(entrant) : 'Winner',
        panelX + 256,
        panelY + 156,
        panelWidth - 292,
        42,
        3
      );
      ctx.fillStyle = 'rgba(255, 255, 255, 0.76)';
      ctx.font = '700 26px sans-serif';
      ctx.fillText(`${winner?.score ?? 0} final votes`, panelX + 256, panelY + 302);
    });
  }

  const roundCount = Math.max(1, bracket.rounds.length);
  const usedBracketWidth =
    roundCount * TOURNAMENT_SHARE_CARD_WIDTH +
    Math.max(0, roundCount - 1) * TOURNAMENT_SHARE_CONNECTOR_WIDTH;
  const bracketLeft = (canvas.width - usedBracketWidth) / 2;
  const windowRects = new Map<string, { x: number; y: number; width: number; height: number }>();

  const getWindowY = (roundWindowCount: number, windowIndex: number): number => {
    if (roundWindowCount >= maxWindows) {
      return (
        bracketTop + windowIndex * (TOURNAMENT_SHARE_CARD_HEIGHT + TOURNAMENT_SHARE_CARD_GAP_Y)
      );
    }
    const groupSize = maxWindows / Math.max(1, roundWindowCount);
    const start = windowIndex * groupSize;
    const end = start + groupSize - 1;
    const centerIndex = (start + end) / 2;
    const center =
      bracketTop +
      centerIndex * (TOURNAMENT_SHARE_CARD_HEIGHT + TOURNAMENT_SHARE_CARD_GAP_Y) +
      TOURNAMENT_SHARE_CARD_HEIGHT / 2;
    return center - TOURNAMENT_SHARE_CARD_HEIGHT / 2;
  };

  const drawSlot = (
    window: TournamentBracketWindow,
    slot: TournamentBracketWindow['slots'][number],
    x: number,
    y: number,
    width: number
  ) => {
    const entrant = slot.entrantId ? entrantMap[slot.entrantId] : undefined;
    const winner = getTournamentSlotWinner(window, slot.entrantId);
    const slotFill =
      slot.status === 'winner'
        ? '#5f3b08'
        : slot.status === 'current'
          ? '#06445c'
          : slot.status === 'tbd'
            ? '#21102f'
            : '#220036';
    fillCanvasRoundRect(ctx, x, y, width, TOURNAMENT_SHARE_SLOT_HEIGHT, 16, slotFill);
    strokeCanvasRoundRect(
      ctx,
      x,
      y,
      width,
      TOURNAMENT_SHARE_SLOT_HEIGHT,
      16,
      slot.status === 'winner'
        ? '#ffd84a'
        : slot.status === 'current'
          ? '#7ee7ff'
          : 'rgba(255, 255, 255, 0.16)',
      2
    );

    const thumbSize = 60;
    const thumbX = x + 12;
    const thumbY = y + (TOURNAMENT_SHARE_SLOT_HEIGHT - thumbSize) / 2;
    fillCanvasRoundRect(ctx, thumbX, thumbY, thumbSize, thumbSize, 12, '#0f0018');
    const image = slot.thumbnailUrl ? (images.get(slot.thumbnailUrl) ?? null) : null;
    if (image) {
      ctx.save();
      drawCanvasRoundRect(ctx, thumbX, thumbY, thumbSize, thumbSize, 12);
      ctx.clip();
      drawImageCover(ctx, image, thumbX, thumbY, thumbSize, thumbSize);
      ctx.restore();
    } else {
      ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
      ctx.font = '800 14px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(slot.status === 'tbd' ? 'TBD' : 'TXT', thumbX + thumbSize / 2, thumbY + 27);
    }

    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = '#ffffff';
    ctx.font = '800 24px sans-serif';
    const label = entrant ? getTournamentEntrantLabel(entrant) : slot.label;
    ctx.fillText(truncateCanvasText(ctx, label, width - 192), x + 88, y + 12);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.68)';
    ctx.font = '700 17px sans-serif';
    const detailParts = [
      slot.status === 'current' ? 'Current leader' : '',
      slot.status === 'tbd' ? 'Waiting for winners' : '',
    ].filter(Boolean);
    const detailText = detailParts.join(' - ');
    if (detailText) {
      ctx.fillText(detailText, x + 88, y + 42, width - 194);
    }

    if (winner || slot.category) {
      const chipLabel = (winner?.category ?? slot.category ?? 'f').toUpperCase();
      fillCanvasRoundRect(ctx, x + width - 76, y + 17, 48, 34, 17, '#ffd84a');
      ctx.fillStyle = '#2d0048';
      ctx.font = '900 20px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(chipLabel, x + width - 52, y + 34);
    }
  };

  bracket.rounds.forEach((round, roundIndex) => {
    const roundX =
      bracketLeft + roundIndex * (TOURNAMENT_SHARE_CARD_WIDTH + TOURNAMENT_SHARE_CONNECTOR_WIDTH);
    ctx.fillStyle = '#ffd84a';
    ctx.font = '900 34px sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    ctx.fillText(
      round.label,
      roundX + TOURNAMENT_SHARE_CARD_WIDTH / 2,
      Math.max(36, bracketTop - 26),
      TOURNAMENT_SHARE_CARD_WIDTH
    );

    round.windows.forEach((window, windowIndex) => {
      const windowY = getWindowY(round.windows.length, windowIndex);
      windowRects.set(window.battleId, {
        x: roundX,
        y: windowY,
        width: TOURNAMENT_SHARE_CARD_WIDTH,
        height: TOURNAMENT_SHARE_CARD_HEIGHT,
      });
      fillCanvasRoundRect(
        ctx,
        roundX,
        windowY,
        TOURNAMENT_SHARE_CARD_WIDTH,
        TOURNAMENT_SHARE_CARD_HEIGHT,
        26,
        '#3d0066'
      );
      strokeCanvasRoundRect(
        ctx,
        roundX,
        windowY,
        TOURNAMENT_SHARE_CARD_WIDTH,
        TOURNAMENT_SHARE_CARD_HEIGHT,
        26,
        window.status === 'active' ? '#7ee7ff' : '#ffd84a',
        window.status === 'active' ? 5 : 3
      );

      ctx.fillStyle = '#ffffff';
      ctx.font = '900 28px sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(truncateCanvasText(ctx, window.label, 390), roundX + 28, windowY + 24);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.72)';
      ctx.font = '700 20px sans-serif';
      ctx.fillText(`${window.totalBallots} votes`, roundX + 28, windowY + 62);

      const statusLabel = getTournamentBracketWindowStatusLabel(window.status);
      ctx.font = '900 18px sans-serif';
      const statusWidth = Math.max(112, ctx.measureText(statusLabel).width + 36);
      fillCanvasRoundRect(
        ctx,
        roundX + TOURNAMENT_SHARE_CARD_WIDTH - statusWidth - 24,
        windowY + 24,
        statusWidth,
        40,
        20,
        getTournamentShareStatusFill(window.status)
      );
      ctx.fillStyle = getTournamentShareStatusText(window.status);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(
        statusLabel,
        roundX + TOURNAMENT_SHARE_CARD_WIDTH - statusWidth / 2 - 24,
        windowY + 44
      );

      const slotStartY = windowY + 112;
      window.slots.slice(0, 6).forEach((slot, slotIndex) => {
        drawSlot(
          window,
          slot,
          roundX + 24,
          slotStartY + slotIndex * (TOURNAMENT_SHARE_SLOT_HEIGHT + 10),
          TOURNAMENT_SHARE_CARD_WIDTH - 48
        );
      });

      const winnerY = windowY + TOURNAMENT_SHARE_CARD_HEIGHT - 54;
      if (window.winners.length === 0) {
        ctx.fillStyle = 'rgba(255, 255, 255, 0.48)';
        ctx.font = '700 18px sans-serif';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText('Category winners TBD', roundX + 28, winnerY + 16);
      }
    });
  });

  ctx.strokeStyle = '#ffd84a';
  ctx.lineWidth = 8;
  ctx.lineCap = 'round';
  bracket.rounds.slice(0, -1).forEach((round, roundIndex) => {
    const nextRound = bracket.rounds[roundIndex + 1];
    if (!nextRound) return;
    const groupSize = Math.max(1, round.windows.length / Math.max(1, nextRound.windows.length));
    nextRound.windows.forEach((nextWindow, nextIndex) => {
      const target = windowRects.get(nextWindow.battleId);
      if (!target) return;
      const sourceStart = Math.floor(nextIndex * groupSize);
      const sourceEnd = Math.min(
        round.windows.length - 1,
        Math.ceil((nextIndex + 1) * groupSize) - 1
      );
      const sourceRects = round.windows
        .slice(sourceStart, sourceEnd + 1)
        .map((window) => windowRects.get(window.battleId))
        .filter((rect): rect is { x: number; y: number; width: number; height: number } =>
          Boolean(rect)
        );
      if (sourceRects.length === 0) return;
      const firstSource = sourceRects[0];
      if (!firstSource) return;
      const sourceX = firstSource.x + firstSource.width;
      const targetX = target.x;
      const joinX = sourceX + (targetX - sourceX) / 2;
      const targetCenterY = target.y + target.height / 2;
      const sourceCenters = sourceRects.map((rect) => rect.y + rect.height / 2);
      const topSourceY = Math.min(...sourceCenters);
      const bottomSourceY = Math.max(...sourceCenters);

      ctx.beginPath();
      sourceCenters.forEach((sourceY) => {
        ctx.moveTo(sourceX, sourceY);
        ctx.lineTo(joinX, sourceY);
      });
      if (sourceCenters.length > 1) {
        ctx.moveTo(joinX, topSourceY);
        ctx.lineTo(joinX, bottomSourceY);
      }
      ctx.moveTo(joinX, targetCenterY);
      ctx.lineTo(targetX, targetCenterY);
      ctx.stroke();
      ctx.fillStyle = '#ffd84a';
      ctx.beginPath();
      ctx.arc(joinX, targetCenterY, 12, 0, Math.PI * 2);
      ctx.fill();
    });
  });

  ctx.fillStyle = '#ffd84a';
  ctx.font = '900 36px sans-serif';
  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';
  ctx.shadowColor = 'rgba(0, 0, 0, 0.55)';
  ctx.shadowBlur = 4;
  ctx.fillText(
    TOURNAMENT_SHARE_WATERMARK,
    canvas.width - TOURNAMENT_SHARE_OUTER_PADDING,
    canvas.height - 36
  );
  ctx.shadowColor = 'transparent';
  ctx.shadowBlur = 0;

  try {
    return canvas.toDataURL('image/jpeg', 0.92);
  } catch {
    throw new Error('Could not export image. One of the tournament images blocks sharing.');
  }
};

type SlotParticle = {
  id: number;
  image: string;
  duration: number;
  left: number;
};

type EmojiParticle = {
  id: number;
  x: number;
  y: number;
  duration: number;
  delay: number;
};

type CoinParticle = {
  id: number;
  startX: number;
  startY: number;
  deltaX: number;
  deltaY: number;
  duration: number;
  delay: number;
};

type KillEnemy = {
  id: number;
  x: number;
  y: number;
  speed: number;
  faceSrc: string | null;
  alive: boolean;
  deadAt: number | null;
};

type KillBullet = {
  id: number;
  x: number;
  y: number;
  speed: number;
};

const roleParticles: Record<keyof FMKAssignment, string> = {
  f: heartAsset,
  m: ringAsset,
  k: knifeAsset,
};

type LevelEvent = {
  previous: UserLevelState | null;
  current: UserLevelState;
  gainedXp: number;
  leveledUp: boolean;
  xpReason?: string;
};

type GalleryMotion = 'left' | 'right' | 'jump';

const defaultLevel = getLevelProgress(0);

type SpriteOnceProps = {
  src: string;
  cols: number;
  rows: number;
  frameCount: number;
  fps: number;
  width: number;
  height?: number;
  onComplete?: () => void;
  className?: string;
};

const SpriteOnce = ({
  src,
  cols,
  rows,
  frameCount,
  fps,
  width,
  height,
  onComplete,
  className,
}: SpriteOnceProps) => {
  const spriteRef = useRef<HTMLDivElement | null>(null);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const el = spriteRef.current;
    if (!el) return undefined;
    const lowEndDevice = isConstrainedMobileDevice();
    const frameStep = lowEndDevice ? 2 : 1;
    const effectiveFps = Math.max(10, Math.round(fps * (lowEndDevice ? 0.45 : 1)));
    const frameDuration = 1000 / Math.max(1, effectiveFps);
    let current = 0;
    let lastTime = performance.now();
    let elapsed = 0;

    const applyFrame = (frame: number) => {
      const col = frame % cols;
      const row = Math.floor(frame / cols);
      const bgPosX = cols > 1 ? (col / (cols - 1)) * 100 : 0;
      const bgPosY = rows > 1 ? (row / (rows - 1)) * 100 : 0;
      el.style.backgroundPosition = `${bgPosX}% ${bgPosY}%`;
    };

    applyFrame(0);
    const tick = (now: number) => {
      elapsed += now - lastTime;
      lastTime = now;
      while (elapsed >= frameDuration) {
        elapsed -= frameDuration;
        current += frameStep;
        if (current >= frameCount) {
          applyFrame(frameCount - 1);
          if (onComplete) onComplete();
          return;
        }
        applyFrame(current);
      }
      rafRef.current = window.requestAnimationFrame(tick);
    };
    rafRef.current = window.requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
      rafRef.current = null;
    };
  }, [cols, rows, frameCount, fps, onComplete, src]);

  const bgSize = `${cols * 100}% ${rows * 100}%`;

  return (
    <div
      ref={spriteRef}
      className={className}
      style={{
        width,
        height: height ?? width,
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: bgSize,
        backgroundPosition: '0% 0%',
        imageRendering: 'pixelated',
      }}
    />
  );
};

type CurtainRevealProps = {
  videoSrc: string;
  fallbackSrc: string;
  width: number;
  height: number;
  onComplete: () => void;
};

const CurtainReveal = ({
  videoSrc,
  fallbackSrc,
  width,
  height,
  onComplete,
}: CurtainRevealProps) => {
  const [useFallback, setUseFallback] = useState(() => {
    if (typeof document === 'undefined') return false;
    const probe = document.createElement('video');
    return probe.canPlayType('video/webm; codecs="vp9"') === '';
  });

  if (useFallback) {
    return (
      <SpriteOnce
        src={fallbackSrc}
        cols={8}
        rows={22}
        frameCount={176}
        fps={40}
        width={width}
        height={height}
        onComplete={onComplete}
      />
    );
  }

  return (
    <video
      className="block object-cover"
      src={videoSrc}
      muted
      autoPlay
      playsInline
      preload="auto"
      width={width}
      height={height}
      style={{ width, height }}
      onEnded={onComplete}
      onError={() => setUseFallback(true)}
    />
  );
};

type SpriteLoopProps = {
  src: string;
  cols: number;
  rows: number;
  frameCount: number;
  fps: number;
  width: number;
  height: number;
  className?: string;
};

const SpriteLoop = ({
  src,
  cols,
  rows,
  frameCount,
  fps,
  width,
  height,
  className,
}: SpriteLoopProps) => {
  const spriteRef = useRef<HTMLDivElement | null>(null);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const el = spriteRef.current;
    if (!el) return undefined;
    const lowEndDevice = isConstrainedMobileDevice();
    const frameStep = lowEndDevice ? 2 : 1;
    const effectiveFps = Math.max(10, Math.round(fps * (lowEndDevice ? 0.45 : 1)));
    const frameDuration = 1000 / Math.max(1, effectiveFps);
    let current = 0;
    let lastTime = performance.now();
    let elapsed = 0;

    const applyFrame = (frame: number) => {
      const col = frame % cols;
      const row = Math.floor(frame / cols);
      const bgPosX = cols > 1 ? (col / (cols - 1)) * 100 : 0;
      const bgPosY = rows > 1 ? (row / (rows - 1)) * 100 : 0;
      el.style.backgroundPosition = `${bgPosX}% ${bgPosY}%`;
    };

    applyFrame(0);
    const tick = (now: number) => {
      elapsed += now - lastTime;
      lastTime = now;
      while (elapsed >= frameDuration) {
        elapsed -= frameDuration;
        current += frameStep;
        if (current >= frameCount) {
          current = 0;
        }
        applyFrame(current);
      }
      rafRef.current = window.requestAnimationFrame(tick);
    };
    rafRef.current = window.requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
      rafRef.current = null;
    };
  }, [cols, rows, frameCount, fps, src]);

  const bgSize = `${cols * 100}% ${rows * 100}%`;

  return (
    <div
      ref={spriteRef}
      className={className}
      style={{
        width,
        height,
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: bgSize,
        backgroundPosition: '0% 0%',
        imageRendering: 'pixelated',
      }}
    />
  );
};

const getSlotById = (slots: FMKSlot[], id: string | null | undefined) =>
  slots.find((slot) => slot.id === id);

const getAssignedFunImageSlot = (
  entry: FMKEntry | null,
  assignment: FMKAssignment
): FMKSlot | null => {
  if (!entry) return null;
  const slot = getSlotById(entry.slots, assignment.f);
  if (!slot || slot.kind !== 'image' || !slot.value) return null;
  return slot;
};

const slotPreview = (slot: FMKSlot | SlotInput) => {
  if (slot.kind === 'text') return slot.value || slot.label || 'Text option';
  if (slot.value) return slot.label || '';
  return 'No content';
};

const percentFor = (percentages: FMKPercentages, role: keyof FMKAssignment, slotId: string) =>
  percentages[role]?.[slotId] ?? 0;

const roleBackgrounds: Record<keyof FMKAssignment, string> = {
  f: fBg,
  m: marryBg,
  k: killBg,
};

const DropZone = ({
  role,
  entry,
  assignment,
  isActive,
  onUnassign,
  isDragInProgress,
  onClickEmpty,
  particles,
}: {
  role: keyof FMKAssignment;
  entry: FMKEntry;
  assignment: FMKAssignment;
  isActive: boolean;
  onUnassign: (role: keyof FMKAssignment) => void;
  isDragInProgress: boolean;
  onClickEmpty: (role: keyof FMKAssignment) => void;
  particles: SlotParticle[];
}) => {
  const slot = getSlotById(entry.slots, assignment[role]);
  return (
    <div
      className={clsx(
        'aura-card fmk-poll-drop-zone relative flex aspect-[11/8] min-h-[96px] w-full max-w-[220px] flex-col items-center justify-center overflow-hidden rounded-xl bg-[#510087] p-0 transition-all shadow-[inset_0_6px_10px_rgba(0,0,0,0.8),inset_0_-6px_10px_rgba(0,0,0,0.6)]',
        `fmk-poll-drop-zone-${role}`,
        isActive ? 'ring-2 ring-[#510087]/40' : ''
      )}
      style={{
        backgroundImage: `url(${roleBackgrounds[role]})`,
        backgroundSize: 'var(--fmk-poll-role-image-size, contain)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="pointer-events-none absolute inset-0">
        {particles.map((p) => (
          <img
            key={p.id}
            src={p.image}
            alt="particle"
            className="slot-particle"
            style={{ left: `${p.left}%`, animationDuration: `${p.duration}s` }}
          />
        ))}
      </div>
      {slot ? (
        <button
          type="button"
          onClick={() => {
            if (!isDragInProgress) onUnassign(role);
          }}
          className="flex h-full w-full items-center justify-center overflow-hidden rounded-lg border border-white/40 bg-white/20 p-0 opacity-70 transition-opacity hover:bg-white/30 hover:opacity-100"
        >
          {slot.kind === 'image' && slot.value ? (
            <img
              src={slot.value}
              alt={slot.label ?? 'slot'}
              className="block h-full w-full object-contain object-center"
            />
          ) : (
            <span className="px-2 text-sm font-semibold text-white">{slotPreview(slot)}</span>
          )}
        </button>
      ) : (
        <div
          className={clsx(
            'flex h-full w-full items-center justify-center rounded-lg transition-colors',
            isActive
              ? 'border border-dashed border-white/80 bg-white/10'
              : 'border border-transparent'
          )}
          onClick={() => onClickEmpty(role)}
        >
          {isActive ? <span className="text-xs font-semibold text-white/80">Drop here</span> : null}
        </div>
      )}
    </div>
  );
};

const PercentBar = ({
  slot,
  percent,
  highlight,
}: {
  slot: FMKSlot;
  percent: number;
  highlight: boolean;
}) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center justify-between text-xs text-white">
      <span className={clsx('flex items-center gap-2', highlight && 'font-semibold text-white')}>
        {slot.kind === 'image' && slot.value ? (
          <img
            src={slot.value}
            alt={slot.label ?? 'option'}
            className="h-6 w-6 flex-shrink-0 rounded object-cover"
          />
        ) : null}
        <span className="truncate">
          {slot.kind === 'text'
            ? slot.value || slot.label || 'Text option'
            : (slot.label ?? 'Image option')}
        </span>
      </span>
      <span className={clsx(highlight && 'font-semibold text-white')}>{percent}%</span>
    </div>
    <div
      className={clsx(
        'h-2 rounded-full bg-white/30',
        highlight && 'ring-2 ring-[#fdc500] ring-offset-2 ring-offset-[#5c0099]'
      )}
    >
      <div
        className={clsx('h-2 rounded-full', highlight ? 'bg-[#fdc500]' : 'bg-[#fdc500]')}
        style={{ width: `${percent}%` }}
      />
    </div>
  </div>
);

const SlotCard = ({
  slot,
  onDragStart,
  onDragEnd,
  isDragging,
  isAssigned,
  onSelect,
  isSelected,
}: {
  slot: FMKSlot;
  onDragStart: (slot: FMKSlot, event: React.DragEvent<HTMLDivElement>) => void;
  onDragEnd: () => void;
  isDragging: boolean;
  isAssigned: boolean;
  onSelect: (slot: FMKSlot) => void;
  isSelected: boolean;
}) => {
  return (
    <div
      draggable={!isAssigned}
      onDragStart={(e) => {
        if (isAssigned) return;
        onDragStart(slot, e);
      }}
      onDragEnd={onDragEnd}
      className={clsx(
        'fmk-poll-slot-card flex aspect-[11/8] min-h-[96px] w-full max-w-[220px] cursor-grab flex-col gap-1 overflow-hidden rounded-xl border-2 border-[#3b0a5e] bg-[#510087] p-1.5 text-white shadow-[0_6px_0_#3b0a5e,0_20px_30px_rgba(0,0,0,0.35)] transition-all duration-150 ease-out sm:gap-2 sm:p-3',
        isDragging
          ? 'scale-105 shadow-lg shadow-purple-200 rotate-1 border-[#6b21a8]'
          : isAssigned
            ? 'shadow-none'
            : 'shadow-[0_3px_0_#3b0a5e,0_12px_22px_rgba(0,0,0,0.28)] hover:shadow-sm',
        isAssigned && 'cursor-default',
        isSelected && !isAssigned && 'ring-2 ring-[#fdc500]'
      )}
      onClick={() => {
        if (isAssigned) return;
        onSelect(slot);
      }}
    >
      <div
        className={clsx(
          'flex flex-1 w-full flex-col items-center text-center transition-opacity',
          isAssigned && 'opacity-0'
        )}
      >
        <span className="text-sm font-semibold text-white">{slot.label ?? 'Slot'}</span>
        {slot.kind === 'text' ? (
          <span className="text-xs text-white/80 truncate">{slotPreview(slot)}</span>
        ) : null}
        {slot.kind === 'image' && slot.value ? (
          <div className="mt-1 flex min-h-0 w-full flex-1 items-center justify-center overflow-hidden rounded-lg sm:mt-2">
            <img
              src={slot.value}
              alt={slot.label ?? 'slot'}
              className="h-full w-full object-contain"
            />
          </div>
        ) : (
          <div className="mt-2 flex flex-1 w-full items-center justify-center rounded-lg bg-white/10 px-2 text-center text-xs text-white">
            {slotPreview(slot)}
          </div>
        )}
      </div>
      {isAssigned ? <div className="pointer-events-none absolute inset-0 rounded-xl" /> : null}
    </div>
  );
};

const FunPromptModal = ({
  slot,
  onAccept,
  onDecline,
}: {
  slot: FMKSlot;
  onAccept: () => void;
  onDecline: () => void;
}) => (
  <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 px-4">
    <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-5 text-white shadow-2xl">
      <div className="space-y-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-[#fdc500]">
            Bonus mini game
          </p>
          <h3 className="mt-1 text-2xl font-black">
            {' '}
            {slot.label ?? 'your Fun pick'} loves that you picked them to fuck. Want to give them a
            cum shot?
          </h3>
          <p className="mt-2 text-sm text-white/80">
            Open the cum shot game using the character you placed in the Fuck category.
          </p>
        </div>
        <div className="overflow-hidden rounded-2xl bg-black/30">
          <img
            src={slot.value}
            alt={slot.label ?? 'Fun pick'}
            className="max-h-72 w-full object-contain"
          />
        </div>
        <div className="flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onDecline}
            className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
          >
            No thanks
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
          >
            Yes, play
          </button>
        </div>
      </div>
    </div>
  </div>
);

const CardPackUnlockModal = ({
  onOpen,
  onClose,
}: {
  onOpen: () => void;
  onClose: () => void;
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
    <div className="aura-panel relative w-full max-w-sm rounded-2xl bg-[#5c0099] p-5 text-center text-white shadow-2xl">
      <button
        type="button"
        aria-label="Close free pack popup"
        className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full text-sm font-black text-white btn-3d-purple"
        onClick={onClose}
      >
        X
      </button>
      <div className="mx-auto flex h-44 w-44 items-center justify-center">
        <img
          src={cardPackTransparent}
          alt=""
          aria-hidden="true"
          className="h-full w-full object-contain"
        />
      </div>
      <h3 className="mt-2 text-2xl font-black leading-tight">
        Congrats! You unlock a free pack!
      </h3>
      <button
        type="button"
        className="mt-5 w-full rounded-full px-5 py-3 text-base font-black text-white btn-3d-gold"
        onClick={onOpen}
      >
        Open
      </button>
    </div>
  </div>
);

const LevelUpModal = ({
  event,
  onClose,
  isMuted,
}: {
  event: LevelEvent | null;
  onClose: () => void;
  isMuted: boolean;
}) => {
  const [fill, setFill] = useState(0);
  const fireworksRef = useRef<HTMLAudioElement | null>(null);
  const [confettiBursts, setConfettiBursts] = useState<
    { id: number; left: number; top: number; width: number; flip: boolean }[]
  >([]);

  useEffect(() => {
    if (!event) return;
    const start =
      event.previous && event.previous.level === event.current.level
        ? Math.round(event.previous.progress * 100)
        : 0;
    const target = Math.round(event.current.progress * 100);
    const steps: number[] = [start];
    if (event.leveledUp) {
      steps.push(100, 0);
    }
    steps.push(target);

    const timeouts: number[] = [];
    const schedule = (idx: number) => {
      if (idx >= steps.length) return;
      const value = steps[idx] ?? 0;
      setFill(value);
      const delay = idx === 0 ? 60 : event.leveledUp && (value === 100 || value === 0) ? 420 : 520;
      timeouts.push(window.setTimeout(() => schedule(idx + 1), delay));
    };
    schedule(0);

    return () => {
      timeouts.forEach((t) => window.clearTimeout(t));
    };
  }, [event]);

  useEffect(() => {
    if (!event || !event.leveledUp) return;
    if (isMuted) return;
    if (!fireworksRef.current) {
      fireworksRef.current = new Audio(fireworksSound);
      fireworksRef.current.loop = false;
    }
    fireworksRef.current.currentTime = 0;
    void fireworksRef.current.play().catch(() => {
      /* autoplay might be blocked */
    });
  }, [event, isMuted]);

  useEffect(() => {
    if (fireworksRef.current) {
      fireworksRef.current.muted = isMuted;
    }
  }, [isMuted]);

  useEffect(() => {
    if (!event || !event.leveledUp) return;
    setConfettiBursts([]);
    const timers: number[] = [];
    let count = 0;
    const launch = () => {
      const largeScreen = window.innerWidth >= 1024;
      const mediumScreen = window.innerWidth >= 640;
      const minWidth = largeScreen ? 300 : mediumScreen ? 240 : 180;
      const widthRange = largeScreen ? 220 : mediumScreen ? 160 : 140;
      setConfettiBursts((prev) => [
        ...prev,
        {
          id: Date.now() + count,
          left: 5 + Math.random() * 90, // 5% to 95%
          top: 10 + Math.random() * 80, // 10% to 90%
          width: minWidth + Math.random() * widthRange,
          flip: Math.random() > 0.5,
        },
      ]);
      count += 1;
      if (count < 5) {
        timers.push(window.setTimeout(launch, 420));
      }
    };
    launch();
    return () => {
      timers.forEach((t) => window.clearTimeout(t));
    };
  }, [event]);

  if (!event) return null;

  const levelText = `Level ${event.current.level}`;
  const reasonText = event.xpReason ?? 'XP gained';

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 px-4">
      {event.leveledUp ? (
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          {confettiBursts.map((burst) => (
            <div
              key={burst.id}
              className="absolute"
              style={{
                left: `${burst.left}%`,
                top: `${burst.top}%`,
                transform: `translate(-50%, -50%) ${burst.flip ? 'scaleX(-1)' : ''}`,
              }}
            >
              <SpriteOnce
                src={confettiSprite}
                cols={8}
                rows={8}
                frameCount={64}
                fps={46}
                width={burst.width}
              />
            </div>
          ))}
        </div>
      ) : null}
      <div className="aura-panel relative z-10 w-full max-w-lg overflow-hidden rounded-2xl bg-[#5c0099] p-5 shadow-2xl">
        <div className="relative z-10 space-y-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#fdc500]">
                {event.leveledUp ? 'Level up!' : 'XP gained'}
              </p>
              <h3 className="text-2xl font-bold text-white">{levelText}</h3>
              <p className="text-sm font-semibold text-white/80">
                +{event.gainedXp} XP · {reasonText}
              </p>
            </div>
            <div className="rounded-xl bg-white/10 px-3 py-2 text-right">
              <p className="text-xs font-semibold text-white/70">Next</p>
              <p className="text-sm font-bold text-white">Lv {event.current.level + 1}</p>
              <p className="text-[11px] text-white/70">{event.current.remaining} XP to go</p>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs text-white/80">
              <span>Progress to Lv {event.current.level + 1}</span>
              <span>{Math.round(fill)}%</span>
            </div>
            <div className="h-3 overflow-hidden rounded-full bg-white/20">
              <div
                className="h-full rounded-full bg-[#fdc500] shadow-[0_0_12px_rgba(253,197,0,0.6)] transition-[width] duration-700 ease-out"
                style={{ width: `${fill}%` }}
              />
            </div>
            <div className="flex items-center justify-between text-xs text-white/80">
              <span>{event.current.remaining} XP to next</span>
              <span>{event.current.xp} XP total</span>
            </div>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const App = () => {
  const battleCardRefs = useRef<Map<string, HTMLElement>>(new Map());
  const battleSlotRefs = useRef<Map<string, HTMLElement>>(new Map());
  const battleDeckRefs = useRef<Map<'player' | 'opponent', HTMLElement>>(new Map());
  const battleRankAnimationTimeoutRef = useRef<number | null>(null);
  const pendingBrowseAfterAdRef = useRef(false);
  const pendingBrowseAfterAdTimerRef = useRef<number | null>(null);
  const pendingBrowseAfterAdReadyAtRef = useRef(0);
  const lastBrowsePrimeAtRef = useRef(0);
  const lastGooExitPrimeAtRef = useRef(0);

  const leaderboardEnabled = true;
  const [slots, setSlots] = useState<SlotInput[]>(emptySlots);
  const [createTitle, setCreateTitle] = useState('');
  const [createPostType, setCreatePostType] = useState<FMKPostType>(FMK_DEFAULT_POST_TYPE);
  const [createTitleTouched, setCreateTitleTouched] = useState(false);
  const [entry, setEntry] = useState<FMKEntry | null>(null);
  const [percentages, setPercentages] = useState<FMKPercentages>(() => emptyPercentages());
  const [assignment, setAssignment] = useState<FMKAssignment>(initialAssignment);
  const [marryGallery, setMarryGallery] = useState<MarryGalleryItem[]>([]);
  const [funGallery, setFunGallery] = useState<MarryGalleryItem[]>([]);
  const [killGallery, setKillGallery] = useState<MarryGalleryItem[]>([]);
  const [currency, setCurrency] = useState<GalleryCurrencyState>({
    gold: 0,
    gems: 0,
    affection: {},
  });
  const [funCurrency, setFunCurrency] = useState<GalleryCurrencyState>({
    gold: 0,
    gems: 0,
    affection: {},
  });
  const [outfits, setOutfits] = useState<GalleryOutfitState>({ unlocked: {}, selected: {} });
  const [funOutfits, setFunOutfits] = useState<GalleryOutfitState>({ unlocked: {}, selected: {} });
  const [displayGold, setDisplayGold] = useState(0);
  const [pendingGoldTarget, setPendingGoldTarget] = useState<number | null>(null);
  const [availableSlots, setAvailableSlots] = useState(2);
  const [funAvailableSlots, setFunAvailableSlots] = useState(2);
  const [galleryMotion, setGalleryMotion] = useState<Record<string, GalleryMotion | null>>({});
  const galleryTimerRef = useRef<number | null>(null);
  const [selectableMarryIds, setSelectableMarryIds] = useState<Set<string>>(() => new Set());
  const [selectableFunIds, setSelectableFunIds] = useState<Set<string>>(() => new Set());
  const selectableMarryIdsRef = useRef<Set<string>>(new Set());
  const selectableFunIdsRef = useRef<Set<string>>(new Set());
  const [selectedGalleryItem, setSelectedGalleryItem] = useState<MarryGalleryItem | null>(null);
  const [activeBubbleId, setActiveBubbleId] = useState<string | null>(null);
  const [chatBubbleText, setChatBubbleText] = useState<string | null>(null);
  const [chatBubbleVisible, setChatBubbleVisible] = useState(false);
  const chatBubbleVisibleRef = useRef(false);
  const chatBubbleIntervalRef = useRef<number | null>(null);
  const chatBubbleTimeoutRef = useRef<number | null>(null);
  const selectablesPollRef = useRef<number | null>(null);
  const bubbleIndexRef = useRef(0);
  const [divorceConfirmOpen, setDivorceConfirmOpen] = useState(false);
  const [galleryActionLoading, setGalleryActionLoading] = useState(false);
  const [footRubUsed, setFootRubUsed] = useState(false);
  const [heartParticles, setHeartParticles] = useState<EmojiParticle[]>([]);
  const [coinParticles, setCoinParticles] = useState<CoinParticle[]>([]);
  const galleryItemRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const goldBadgeRef = useRef<HTMLDivElement | null>(null);
  const goldIncrementTimerRef = useRef<number | null>(null);
  const killRewardRef = useRef<HTMLDivElement | null>(null);
  const [shopOpen, setShopOpen] = useState(false);
  const [shopPage, setShopPage] = useState(0);
  const [outfitConfirm, setOutfitConfirm] = useState<{
    open: boolean;
    outfitId: GalleryOutfitId | null;
  }>({
    open: false,
    outfitId: null,
  });
  const [slotUnlockOpen, setSlotUnlockOpen] = useState(false);
  const [galleryType, setGalleryType] = useState<'marry' | 'fun' | 'kill'>('marry');
  const [killWaveState, setKillWaveState] = useState<KillWaveState>({
    waveNumber: 1,
    nextWaveAt: 0,
  });
  const [killWaveActive, setKillWaveActive] = useState(false);
  const [killWaveEndsAt, setKillWaveEndsAt] = useState<number | null>(null);
  const [killWavePopupOpen, setKillWavePopupOpen] = useState(true);
  const [killTimeRemainingMs, setKillTimeRemainingMs] = useState(0);
  const [killEnemies, setKillEnemies] = useState<KillEnemy[]>([]);
  const [killBullets, setKillBullets] = useState<KillBullet[]>([]);
  const [killMisses, setKillMisses] = useState(0);
  const [killGunX, setKillGunX] = useState(50);
  const [killFlashKey, setKillFlashKey] = useState(0);
  const [killFlashVisible, setKillFlashVisible] = useState(false);
  const [killRewardOpen, setKillRewardOpen] = useState(false);
  const [killRewardAmount, setKillRewardAmount] = useState(0);
  const [hasVoted, setHasVoted] = useState(false);
  const [totalVotes, setTotalVotes] = useState(0);
  const [loading, setLoading] = useState(() => Boolean(INITIAL_GAME_ID));
  const [showLoadingRecovery, setShowLoadingRecovery] = useState(false);
  const [ageGateOpen, setAgeGateOpen] = useState(() => !hasAgeGateVerification());
  const [creating, setCreating] = useState(false);
  const [voting, setVoting] = useState(false);
  const [award, setAward] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [shareError, setShareError] = useState<string | null>(null);
  const [sharePreviewImage, setSharePreviewImage] = useState<string | null>(null);
  const [sharePreviewUrl, setSharePreviewUrl] = useState<string | null>(null);
  const [sharePosting, setSharePosting] = useState(false);
  const [postedAs, setPostedAs] = useState<PostActor | null>(null);
  const [postedAsReason, setPostedAsReason] = useState<string | null>(null);
  const [shareGenerating, setShareGenerating] = useState(false);
  const [tournamentShareImage, setTournamentShareImage] = useState<string | null>(null);
  const [tournamentShareGenerating, setTournamentShareGenerating] = useState(false);
  const [tournamentShareError, setTournamentShareError] = useState<string | null>(null);
  const [view, setView] = useState<GameView>(() => {
    if (INITIAL_GAME_ID) return 'poll';
    if (INITIAL_VIEW_PARAM === 'create') return 'create';
    if (INITIAL_VIEW_PARAM === 'gallery') return 'gallery';
    if (INITIAL_VIEW_PARAM === 'cards') return 'cards';
    if (INITIAL_VIEW_PARAM === 'packs') return 'packs';
    if (INITIAL_VIEW_PARAM === 'pack') return 'pack';
    if (INITIAL_VIEW_PARAM === 'battle') return 'battle';
    if (INITIAL_VIEW_PARAM === 'quests') return 'quests';
    if (INITIAL_VIEW_PARAM === 'shop') return 'shop';
    if (INITIAL_VIEW_PARAM === 'settings') return 'settings';
    if (INITIAL_VIEW_PARAM === 'tournament') return 'tournament';
    return 'browse';
  });
  const [cardDeckEditorOpen, setCardDeckEditorOpen] = useState(
    () => INITIAL_VIEW_PARAM === 'cards' && INITIAL_DECK_EDIT_PARAM
  );
  const [isSlidingAdMobileViewport, setIsSlidingAdMobileViewport] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia('(max-width: 639px)').matches
  );
  const [mobileBrowseAdCooldownUntil, setMobileBrowseAdCooldownUntil] = useState(() => {
    if (typeof window === 'undefined') return 0;
    const raw = window.localStorage.getItem(MOBILE_BROWSE_AD_COOLDOWN_KEY);
    const parsed = raw ? Number.parseInt(raw, 10) : 0;
    return Number.isFinite(parsed) ? parsed : 0;
  });
  const isMobileBrowseAdEligible =
    BROWSE_POPUNDER_ADS_ENABLED && Date.now() >= mobileBrowseAdCooldownUntil;
  const browseHref = buildGameViewUrl('browse', INITIAL_TENANT || undefined);
  const armMobileBrowseAdCooldown = useCallback(() => {
    const until = Date.now() + MOBILE_BROWSE_AD_COOLDOWN_MS;
    setMobileBrowseAdCooldownUntil(until);
    try {
      window.localStorage.setItem(MOBILE_BROWSE_AD_COOLDOWN_KEY, String(until));
    } catch {
      // Ignore storage write failures; in-memory cooldown still applies this session.
    }
  }, []);
  const syncUrlToView = useCallback(
    (nextView: UrlSyncedView) => {
      const nextUrl = buildGameViewUrl(nextView, INITIAL_TENANT || undefined, {
        deckEditor: nextView === 'cards' && cardDeckEditorOpen,
      });
      if (window.location.href !== nextUrl) {
        window.history.replaceState(null, '', nextUrl);
      }
    },
    [cardDeckEditorOpen]
  );
  const openBrowseView = useCallback(
    (reason: string) => {
      if (POPUNDER_DEBUG) {
        console.info('[POPUNDER DEBUG] Opening browse view', {
          reason,
          href: window.location.href,
          visibilityState: document.visibilityState,
          pendingBrowseAfterAd: pendingBrowseAfterAdRef.current,
        });
      }
      clearBrowseNavIntent();
      syncUrlToView('browse');
      setLoading(false);
      setView('browse');
    },
    [syncUrlToView]
  );
  const flushPendingBrowseAfterAd = useCallback(() => {
    if (!pendingBrowseAfterAdRef.current) return;
    if (pendingBrowseAfterAdTimerRef.current != null) {
      window.clearTimeout(pendingBrowseAfterAdTimerRef.current);
      pendingBrowseAfterAdTimerRef.current = null;
    }
    pendingBrowseAfterAdReadyAtRef.current = 0;
    pendingBrowseAfterAdRef.current = false;
    openBrowseView('pending-browse-flush');
  }, [openBrowseView]);
  const queueBrowseAfterAd = useCallback(() => {
    persistBrowseNavIntent();
    syncUrlToView('browse');
    pendingBrowseAfterAdRef.current = true;
    pendingBrowseAfterAdReadyAtRef.current = Date.now() + 300;
    if (POPUNDER_DEBUG) {
      console.info('[POPUNDER DEBUG] Browse queued after ad', {
        href: window.location.href,
        visibilityState: document.visibilityState,
        readyAt: pendingBrowseAfterAdReadyAtRef.current,
      });
    }
    if (pendingBrowseAfterAdTimerRef.current != null) {
      window.clearTimeout(pendingBrowseAfterAdTimerRef.current);
    }
    pendingBrowseAfterAdTimerRef.current = window.setTimeout(() => {
      pendingBrowseAfterAdTimerRef.current = null;
      flushPendingBrowseAfterAd();
    }, 300);
  }, [flushPendingBrowseAfterAd, syncUrlToView]);
  const primeBrowseAfterAd = useCallback(
    (source: string, isMobileTrigger: boolean) => {
      if (!BROWSE_POPUNDER_ADS_ENABLED) return;
      const now = Date.now();
      if (now - lastBrowsePrimeAtRef.current < 200) return;
      lastBrowsePrimeAtRef.current = now;
      if (POPUNDER_DEBUG) {
        console.info('[POPUNDER DEBUG] Priming browse trigger', {
          source,
          isMobileTrigger,
          href: window.location.href,
          visibilityState: document.visibilityState,
        });
      }
      if (isMobileTrigger && isMobileBrowseAdEligible) armMobileBrowseAdCooldown();
      queueBrowseAfterAd();
    },
    [armMobileBrowseAdCooldown, isMobileBrowseAdEligible, queueBrowseAfterAd]
  );
  const primeMobileBrowseAfterAd = useCallback(() => {
    primeBrowseAfterAd('react-mobile', true);
  }, [primeBrowseAfterAd]);
  const primeDesktopBrowseAfterAd = useCallback(() => {
    primeBrowseAfterAd('react-desktop', false);
  }, [primeBrowseAfterAd]);
  const primeGooExitAfterAd = useCallback(() => {
    if (!BROWSE_POPUNDER_ADS_ENABLED) return;
    const now = Date.now();
    if (now - lastGooExitPrimeAtRef.current < 200) return;
    lastGooExitPrimeAtRef.current = now;
    const isMobileTrigger = window.matchMedia('(max-width: 639px)').matches;
    if (POPUNDER_DEBUG) {
      console.info('[POPUNDER DEBUG] Priming goo exit trigger', {
        isMobileTrigger,
        href: window.location.href,
        visibilityState: document.visibilityState,
      });
    }
    if (isMobileTrigger && isMobileBrowseAdEligible) {
      armMobileBrowseAdCooldown();
    }
  }, [armMobileBrowseAdCooldown, isMobileBrowseAdEligible]);
  const primeMobileGooExitAfterAd = useCallback(() => {
    primeGooExitAfterAd();
  }, [primeGooExitAfterAd]);
  const primeDesktopGooExitAfterAd = useCallback(() => {
    primeGooExitAfterAd();
  }, [primeGooExitAfterAd]);
  const [previousView, setPreviousView] = useState<GalleryReturnView>('browse');
  const [lastMainView, setLastMainView] = useState<MainView>('browse');
  const [selectedGameId, setSelectedGameId] = useState<string>(INITIAL_GAME_ID);
  const analyticsQueueRef = useRef<AnalyticsEventPayload[]>([]);
  const analyticsFlushTimerRef = useRef<number | null>(null);
  const flushAnalytics = useCallback(
    (preferBeacon = false) => {
      if (!analyticsQueueRef.current.length) return;
      const events = analyticsQueueRef.current.splice(0, analyticsQueueRef.current.length);
      const payload: TrackAnalyticsEventsRequest = {
        events,
        ...(INITIAL_TENANT ? { tenantId: INITIAL_TENANT } : {}),
        ...(selectedGameId || entry?.id ? { gameId: selectedGameId || entry?.id || '' } : {}),
      };
      const body = JSON.stringify(payload);
      if (
        preferBeacon &&
        typeof navigator !== 'undefined' &&
        typeof navigator.sendBeacon === 'function'
      ) {
        try {
          const sent = navigator.sendBeacon(
            withApiBase('/api/analytics/events'),
            new Blob([body], { type: 'application/json' })
          );
          if (sent) return;
        } catch {
          // Fall back to fetch below.
        }
      }
      void apiFetch(
        '/api/analytics/events',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: events.length <= 10,
        },
        { gameId: selectedGameId || entry?.id || null, tenantId: INITIAL_TENANT }
      ).catch((error) => {
        console.warn('Analytics flush failed', error);
      });
    },
    [entry?.id, selectedGameId]
  );
  const trackAnalyticsEvent = useCallback(
    (
      name: AnalyticsEventName,
      properties?: AnalyticsEventPayload['properties'],
      options?: { flush?: boolean; preferBeacon?: boolean }
    ) => {
      analyticsQueueRef.current.push({
        name,
        ...(properties ? { properties } : {}),
        occurredAt: Date.now(),
      });
      if (analyticsFlushTimerRef.current) {
        window.clearTimeout(analyticsFlushTimerRef.current);
        analyticsFlushTimerRef.current = null;
      }
      if (options?.flush) {
        flushAnalytics(Boolean(options.preferBeacon));
        return;
      }
      analyticsFlushTimerRef.current = window.setTimeout(() => {
        analyticsFlushTimerRef.current = null;
        flushAnalytics(false);
      }, 1500);
    },
    [flushAnalytics]
  );
  const initialBrowseLocation = useMemo(() => getStoredBrowseLocation(), []);
  const [browseSort, setBrowseSort] = useState<FMKPostSort>(initialBrowseLocation.sort);
  const [browseType, setBrowseType] = useState<FMKPostType>(initialBrowseLocation.type);
  const [browsePage, setBrowsePage] = useState(initialBrowseLocation.page);
  const [browsePosts, setBrowsePosts] = useState<FMKPostSummary[]>([]);
  const [browseHasMore, setBrowseHasMore] = useState(false);
  const [browseLoading, setBrowseLoading] = useState(false);
  const [browseError, setBrowseError] = useState<string | null>(null);
  const [cardCollection, setCardCollection] = useState<CardCollectionResponse | null>(null);
  const [cardsLoading, setCardsLoading] = useState(false);
  const [cardsOpening, setCardsOpening] = useState(false);
  const [cardsGrantingPack, setCardsGrantingPack] = useState(false);
  const [cardsGrantingCurrency, setCardsGrantingCurrency] = useState<'gold' | 'gems' | null>(null);
  const [cardsError, setCardsError] = useState<string | null>(null);
  const [pulledCards, setPulledCards] = useState<OwnedCard[]>([]);
  const [packOpeningPhase, setPackOpeningPhase] = useState<PackOpeningPhase>('idle');
  const [packRevealIndex, setPackRevealIndex] = useState(0);
  const [packCardFlying, setPackCardFlying] = useState(false);
  const [packVideoReady, setPackVideoReady] = useState(false);
  const [cardTutorial, setCardTutorial] = useState<CardTutorialState | null>(null);
  const [cardTutorialStep, setCardTutorialStepState] = useState<CardTutorialStep | null>(null);
  const [cardTutorialStarting, setCardTutorialStarting] = useState(false);
  const [cardTutorialCompleting, setCardTutorialCompleting] = useState(false);
  const [cardTutorialSeenAbilities, setCardTutorialSeenAbilities] = useState<CardAbility[]>([]);
  const [cardTutorialAbilityTip, setCardTutorialAbilityTip] =
    useState<CardTutorialAbilityTip>(null);
  const [completedTutorialNoticeOpen, setCompletedTutorialNoticeOpen] = useState(false);
  const packVideoRef = useRef<HTMLVideoElement | null>(null);
  const packSwipeStartRef = useRef<{ x: number; y: number } | null>(null);
  const packSwipeConsumedRef = useRef(false);
  const initialInterruptedPackRecoveryCheckedRef = useRef(false);
  const [selectedCard, setSelectedCard] = useState<CardPreviewModalCard | null>(null);
  const [cardDeck, setCardDeck] = useState<CardDeckState | null>(null);
  const [deckSelection, setDeckSelection] = useState<string[]>([]);
  const [deckSaving, setDeckSaving] = useState(false);
  const [deckError, setDeckError] = useState<string | null>(null);
  const [battleRank, setBattleRank] = useState<BattleRankProfile | null>(null);
  const [battleDeck, setBattleDeck] = useState<CardDeckState | null>(null);
  const [battle, setBattle] = useState<BattleMatchState | null>(null);
  const [battleLoading, setBattleLoading] = useState(false);
  const [battleStarting, setBattleStarting] = useState(false);
  const [battleActionLoading, setBattleActionLoading] = useState(false);
  const [battleAnimating, setBattleAnimating] = useState(false);
  const [battleAttackAnimation, setBattleAttackAnimation] =
    useState<BattleAttackAnimationState | null>(null);
  const [battleDrawAnimation, setBattleDrawAnimation] = useState<BattleDrawAnimationState | null>(
    null
  );
  const [battleHealAnimations, setBattleHealAnimations] = useState<BattleHealAnimationState[]>([]);
  const [battleDrawReveal, setBattleDrawReveal] = useState<BattleDrawRevealState | null>(null);
  const [battleDeckCountOverrides, setBattleDeckCountOverrides] =
    useState<BattleDeckCountOverrides>({});
  const [battleResult, setBattleResult] = useState<BattleResultState | null>(null);
  const [battleRankAnimation, setBattleRankAnimation] = useState<BattleRankAnimationState | null>(
    null
  );
  const [battleError, setBattleError] = useState<string | null>(null);
  const [shopState, setShopState] = useState<ShopStateResponse | null>(null);
  const [shopLoading, setShopLoading] = useState(false);
  const [shopActionLoading, setShopActionLoading] = useState<string | null>(null);
  const [shopError, setShopError] = useState<string | null>(null);
  const [shopCheckout, setShopCheckout] = useState<ShopCheckoutModalState | null>(null);
  const [battleLegendaryDealExpiresAt, setBattleLegendaryDealExpiresAt] = useState<number | null>(
    null
  );
  const completedBattlesSinceLegendaryDealRef = useRef(0);
  const [questsState, setQuestsState] = useState<QuestsStateResponse | null>(null);
  const [questsLoading, setQuestsLoading] = useState(false);
  const [questActionLoading, setQuestActionLoading] = useState<string | null>(null);
  const [questsError, setQuestsError] = useState<string | null>(null);
  const [shopRewardedAdKind, setShopRewardedAdKind] = useState<ShopAdRewardKind | null>(null);
  const [shopRewardedAdError, setShopRewardedAdError] = useState<string | null>(null);
  const [shopAdRewardCelebration, setShopAdRewardCelebration] =
    useState<ShopAdRewardCelebrationState | null>(null);
  const [shopDailyGiftCelebration, setShopDailyGiftCelebration] =
    useState<ShopAdRewardCelebrationState | null>(null);
  const [selectedBattleAttacker, setSelectedBattleAttacker] = useState<string | null>(null);
  const [matchmakingActive, setMatchmakingActive] = useState(false);
  const [matchmakingNames, setMatchmakingNames] = useState<string[]>([]);
  const [matchmakingNameIndex, setMatchmakingNameIndex] = useState(0);
  const [matchmakingLocked, setMatchmakingLocked] = useState(false);
  const [pendingBattleStart, setPendingBattleStart] = useState<StartBattleResponse | null>(null);
  const updateBrowseLocation = useCallback((location: BrowseLocation): void => {
    const nextLocation = parseBrowseLocation(location);
    if (nextLocation.type === 'gay') {
      markGayBrowseVisitedThisSession();
    }
    setBrowseSort(nextLocation.sort);
    setBrowseType(nextLocation.type);
    setBrowsePage(nextLocation.page);
    persistBrowseLocation(nextLocation);
  }, []);
  const [tournamentSummary, setTournamentSummary] = useState<TournamentSummary | null>(null);
  const [tournamentLoading, setTournamentLoading] = useState(false);
  const [tournamentError, setTournamentError] = useState<string | null>(null);
  const [tournamentPageLoading, setTournamentPageLoading] = useState(false);
  const [tournamentRound, setTournamentRound] = useState<GetTournamentRoundResponse['round']>(null);
  const [tournamentRoundResults, setTournamentRoundResults] =
    useState<TournamentWindowResult | null>(null);
  const [tournamentBracket, setTournamentBracket] = useState<TournamentBracket | null>(null);
  const [tournamentFinalWinners, setTournamentFinalWinners] = useState<TournamentCategoryWinner[]>(
    []
  );
  const [tournamentHasVoted, setTournamentHasVoted] = useState(false);
  const [tournamentVoteSelections, setTournamentVoteSelections] = useState<Record<string, string>>(
    {}
  );
  const [tournamentPendingChoice, setTournamentPendingChoice] = useState<{
    pairKey: string;
    entrantId: string;
  } | null>(null);
  const [tournamentSubmitting, setTournamentSubmitting] = useState(false);
  const [pendingTournamentVoteResult, setPendingTournamentVoteResult] =
    useState<TournamentVoteResponse | null>(null);
  const [tournamentPreviewEntrant, setTournamentPreviewEntrant] =
    useState<TournamentEntrant | null>(null);
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const [browseVotePendingByPost, setBrowseVotePendingByPost] = useState<Record<string, boolean>>(
    {}
  );
  const [browseReportPendingByPost, setBrowseReportPendingByPost] = useState<
    Record<string, boolean>
  >({});
  const [browseCommentsExpandedByPost, setBrowseCommentsExpandedByPost] = useState<
    Record<string, boolean>
  >({});
  const [browseCommentsByPost, setBrowseCommentsByPost] = useState<
    Record<string, FMKPostComment[]>
  >({});
  const [browseCommentsPageByPost, setBrowseCommentsPageByPost] = useState<Record<string, number>>(
    {}
  );
  const [browseCommentsHasMoreByPost, setBrowseCommentsHasMoreByPost] = useState<
    Record<string, boolean>
  >({});
  const [browseCommentsLoadingByPost, setBrowseCommentsLoadingByPost] = useState<
    Record<string, boolean>
  >({});
  const [browseCommentsErrorByPost, setBrowseCommentsErrorByPost] = useState<
    Record<string, string | null>
  >({});
  const [browseCommentDraftByPost, setBrowseCommentDraftByPost] = useState<Record<string, string>>(
    {}
  );
  const [browseCommentSubmitPendingByPost, setBrowseCommentSubmitPendingByPost] = useState<
    Record<string, boolean>
  >({});
  const [reportModalPostId, setReportModalPostId] = useState<string | null>(null);
  const [reportReason, setReportReason] = useState<ReportReason>(DEFAULT_REPORT_REASON);
  const [reportComment, setReportComment] = useState('');
  const [reportModalError, setReportModalError] = useState<string | null>(null);
  const [reportThanksModalOpen, setReportThanksModalOpen] = useState(false);
  const [reportThanksMessage, setReportThanksMessage] = useState(
    'Thank you for reporting this post and helping keep the community safe.'
  );
  const [adminToken, setAdminToken] = useState(() => {
    if (typeof window === 'undefined') return '';
    return window.localStorage.getItem(ADMIN_TOKEN_KEY) ?? '';
  });
  const [adminReports, setAdminReports] = useState<AdminListReportedPostsResponse['items']>([]);
  const [adminReportsPage, setAdminReportsPage] = useState(1);
  const [adminReportsHasMore, setAdminReportsHasMore] = useState(false);
  const [adminReportsLoading, setAdminReportsLoading] = useState(false);
  const [adminReportsError, setAdminReportsError] = useState<string | null>(null);
  const [adminRemovePendingByPost, setAdminRemovePendingByPost] = useState<Record<string, boolean>>(
    {}
  );
  const [adminDismissPendingByPost, setAdminDismissPendingByPost] = useState<
    Record<string, boolean>
  >({});
  const [adminTypeByPost, setAdminTypeByPost] = useState<Record<string, FMKPostType>>({});
  const [adminTypePendingByPost, setAdminTypePendingByPost] = useState<Record<string, boolean>>({});
  const [adminHardDelete, setAdminHardDelete] = useState(false);
  const [adminAnalyticsDays, setAdminAnalyticsDays] = useState<1 | 7 | 30 | 90>(7);
  const [adminAnalyticsSummary, setAdminAnalyticsSummary] =
    useState<AdminAnalyticsSummaryResponse | null>(null);
  const [adminAnalyticsLoading, setAdminAnalyticsLoading] = useState(false);
  const [adminAnalyticsError, setAdminAnalyticsError] = useState<string | null>(null);
  const [moderationToolsOpen, setModerationToolsOpen] = useState(false);
  const [dragging, setDragging] = useState<string | null>(null);
  const [dragOverRole, setDragOverRole] = useState<keyof FMKAssignment | null>(null);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [leaderboardUserId, setLeaderboardUserId] = useState<string | null>(null);
  const [currentResultRole, setCurrentResultRole] = useState<keyof FMKAssignment>('f');
  const [currentCreateSlot, setCurrentCreateSlot] = useState(0);
  const [createFacePromptOpen, setCreateFacePromptOpen] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState<string | null>(null);
  const [slotParticles, setSlotParticles] = useState<Record<keyof FMKAssignment, SlotParticle[]>>({
    f: [],
    m: [],
    k: [],
  });
  const [userLevel, setUserLevel] = useState<UserLevelState | null>(null);
  const [levelEvent, setLevelEvent] = useState<LevelEvent | null>(null);
  const [pendingFunSlot, setPendingFunSlot] = useState<FMKSlot | null>(null);
  const [funPromptOpen, setFunPromptOpen] = useState(false);
  const [cardPackUnlockPrompt, setCardPackUnlockPrompt] = useState<
    VoteResponse['cardPackUnlockPrompt'] | null
  >(null);
  const [pendingCardPackUnlockPrompt, setPendingCardPackUnlockPrompt] = useState<
    VoteResponse['cardPackUnlockPrompt'] | null
  >(null);
  const [gooGameSlot, setGooGameSlot] = useState<FMKSlot | null>(null);
  const [gooRewardPostId, setGooRewardPostId] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authUsername, setAuthUsername] = useState('');
  const [authMode, setAuthMode] = useState<'sign_in' | 'register' | 'reset'>('sign_in');
  const [authOpen, setAuthOpen] = useState(false);
  const [authSubmitting, setAuthSubmitting] = useState(false);
  const [authError, setAuthError] = useState<string | null>(null);
  const [authMessage, setAuthMessage] = useState<string | null>(null);
  const [accountUsername, setAccountUsername] = useState<string | null>(null);
  const [usernameClaimOpen, setUsernameClaimOpen] = useState(false);
  const [usernameClaimSubmitting, setUsernameClaimSubmitting] = useState(false);
  const [usernameClaimError, setUsernameClaimError] = useState<string | null>(null);
  const [revealActive, setRevealActive] = useState(false);
  const [revealStep, setRevealStep] = useState(0);
  const [revealTextVisible, setRevealTextVisible] = useState(false);
  const [revealImageVisible, setRevealImageVisible] = useState(false);
  const [revealPhrases, setRevealPhrases] = useState<Partial<Record<keyof FMKAssignment, string>>>(
    {}
  );
  const [curtainPlaying, setCurtainPlaying] = useState(true);
  const [curtainWidth, setCurtainWidth] = useState(360);
  const [curtainHeight, setCurtainHeight] = useState(203);
  const [revealSoundsPlayed, setRevealSoundsPlayed] = useState<
    Partial<Record<keyof FMKAssignment, boolean>>
  >({});
  const [isPageVisible, setIsPageVisible] = useState(true);
  const viewRef = useRef<GameView>('browse');
  const [isMuted, setIsMuted] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem(MUTE_KEY);
    if (stored === '1') return true;
    return false;
  });
  const [muteReady, setMuteReady] = useState(false);
  const [faceCropSlotIndex, setFaceCropSlotIndex] = useState<number | null>(null);
  const [faceCropSrc, setFaceCropSrc] = useState<string | null>(null);
  const [faceCropImage, setFaceCropImage] = useState<HTMLImageElement | null>(null);
  const [faceCropScale, setFaceCropScale] = useState(1);
  const [faceCropOffset, setFaceCropOffset] = useState({ x: 0, y: 0 });
  const faceCropDragRef = useRef<{
    startX: number;
    startY: number;
    originX: number;
    originY: number;
  } | null>(null);
  const pollAudioRef = useRef<HTMLAudioElement | null>(null);
  const resultsAudioRef = useRef<HTMLAudioElement | null>(null);
  const activeAudioRef = useRef<HTMLAudioElement | null>(null);
  const drumRollRef = useRef<HTMLAudioElement | null>(null);
  const funGalleryTrackRef = useRef<HTMLAudioElement | null>(null);
  const marryGalleryTrackRef = useRef<HTMLAudioElement | null>(null);
  const funSoundRef = useRef<HTMLAudioElement | null>(null);
  const marrySoundRef = useRef<HTMLAudioElement | null>(null);
  const killSoundRef = useRef<HTMLAudioElement | null>(null);
  const gunshotSoundRef = useRef<HTMLAudioElement | null>(null);
  const airRaidSoundRef = useRef<HTMLAudioElement | null>(null);
  const revealSoundStepRef = useRef<number | null>(null);
  const audioCtxRef = useRef<AudioContext | null>(null);
  const marryBufferRef = useRef<AudioBuffer | null>(null);
  const killBufferRef = useRef<AudioBuffer | null>(null);
  const particleIdRef = useRef(0);
  const revealImageContainerRef = useRef<HTMLDivElement | null>(null);
  const killGameRef = useRef<HTMLDivElement | null>(null);
  const fmkInFlightRef = useRef<Promise<void> | null>(null);
  const resumeCardFlowAfterAuthRef = useRef<(() => Promise<void>) | null>(null);
  const freePackAuthResumePendingRef = useRef(false);
  const isMountedRef = useRef(true);
  const killGameSizeRef = useRef({ width: 1, height: 1 });
  const killEnemiesRef = useRef<KillEnemy[]>([]);
  const killBulletsRef = useRef<KillBullet[]>([]);
  const killWaveActiveRef = useRef(false);
  const killMissesRef = useRef(0);
  const killWaveEndsAtRef = useRef<number | null>(null);
  const killSpawnAccumulatorRef = useRef(0);
  const killRafRef = useRef<number | null>(null);
  const killIdRef = useRef(0);
  const tournamentChoiceAdvanceTimerRef = useRef<number | null>(null);
  const authConfigured = isFirebaseAuthConfigured();
  const googleIdentityConfigured = isGoogleIdentityConfigured();
  const googleButtonRef = useRef<HTMLDivElement | null>(null);
  const [googleButtonReady, setGoogleButtonReady] = useState(false);
  const hasProfileUsername = Boolean(accountUsername?.trim());
  const simplifyRevealAnimation = useMemo(() => isConstrainedMobileDevice(), []);

  const loadAuthProfile = useCallback(async (options: { force?: boolean } = {}) => {
    if (!isAuthenticated && !options.force) {
      setAccountUsername(null);
      return;
    }
    try {
      const res = await apiFetch('/api/auth/profile');
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as AuthProfileResponse;
      const username = data.currentUser?.username?.trim() ?? '';
      setAccountUsername(username || null);
      if (!username) {
        setUsernameClaimOpen(true);
      }
    } catch (err) {
      console.error('Failed to load auth profile', err);
      setAccountUsername(null);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const unsubscribe = subscribeFirebaseUser((user) => {
      setIsAuthenticated(Boolean(user));
      if (user?.email) {
        setAuthEmail(user.email);
      }
      if (!user) {
        setAccountUsername(null);
        setAuthUsername('');
        setUsernameClaimOpen(false);
        setUsernameClaimError(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    void loadAuthProfile();
  }, [loadAuthProfile]);

  const claimUsernameForAccount = useCallback(async (candidate: string): Promise<void> => {
    const username = candidate.trim();
    if (!username) {
      throw new Error('Username is required.');
    }
    const payload: ClaimUsernameRequest = { username };
    const res = await apiFetch('/api/auth/username', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = (await res.json().catch(() => null)) as ErrorResponse | null;
      throw new Error(data?.message ?? `HTTP ${res.status}`);
    }
    const data = (await res.json()) as ClaimUsernameResponse;
    const claimed = data.currentUser.username?.trim() ?? username;
    setAccountUsername(claimed);
    setAuthUsername(claimed);
    setUsernameClaimOpen(false);
    setUsernameClaimError(null);
  }, []);

  const handleClaimUsernameSubmit = useCallback(async () => {
    setUsernameClaimSubmitting(true);
    setUsernameClaimError(null);
    try {
      await claimUsernameForAccount(authUsername);
      showToast({ text: 'Username set', appearance: 'success' });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Could not set username.';
      setUsernameClaimError(message);
    } finally {
      setUsernameClaimSubmitting(false);
    }
  }, [authUsername, claimUsernameForAccount]);

  const requireCreateOrLeaderboardAuth = useCallback(
    (actionLabel: string): boolean => {
      if (isAuthenticated) return true;
      setAuthOpen(true);
      setAuthError(`Please sign in to ${actionLabel}.`);
      setAuthMessage(null);
      showToast({ text: `Sign in required to ${actionLabel}.` });
      return false;
    },
    [isAuthenticated]
  );

  const requireReadyUserAction = useCallback(
    (actionLabel: string): boolean => {
      if (!requireCreateOrLeaderboardAuth(actionLabel)) return false;
      if (hasProfileUsername) return true;
      setUsernameClaimOpen(true);
      setUsernameClaimError(`Set your username to ${actionLabel}.`);
      return false;
    },
    [hasProfileUsername, requireCreateOrLeaderboardAuth]
  );

  const requireParticipantIdentity = useCallback((_actionLabel: string): boolean => true, []);

  const handleGoogleSignIn = useCallback(async () => {
    if (!authConfigured) {
      setAuthError('Login is not configured yet. Add Firebase web env values first.');
      return;
    }
    setAuthSubmitting(true);
    setAuthError(null);
    setAuthMessage(null);
    try {
      await signInWithGoogle();
      setAuthOpen(false);
      showToast({ text: 'Signed in with Google', appearance: 'success' });
      await loadAuthProfile({ force: true });
      await resumeCardFlowAfterAuthRef.current?.();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Google sign-in failed.';
      setAuthError(message);
    } finally {
      setAuthSubmitting(false);
    }
  }, [authConfigured, loadAuthProfile]);

  useEffect(() => {
    if (!authOpen || authMode === 'reset' || !authConfigured || !googleIdentityConfigured) {
      setGoogleButtonReady(false);
      return;
    }
    const container = googleButtonRef.current;
    if (!container) return;
    let cancelled = false;
    void renderGoogleIdentityButton(container, {
      onSuccess: async () => {
        if (cancelled) return;
        setAuthOpen(false);
        setAuthError(null);
        setAuthMessage(null);
        showToast({ text: 'Signed in with Google', appearance: 'success' });
        await loadAuthProfile({ force: true });
        await resumeCardFlowAfterAuthRef.current?.();
      },
      onError: (message) => {
        if (cancelled) return;
        setAuthError(message);
      },
    })
      .then(() => {
        if (cancelled) return;
        setGoogleButtonReady(true);
      })
      .catch((error) => {
        if (cancelled) return;
        const message = error instanceof Error ? error.message : 'Google sign-in unavailable.';
        setAuthError(message);
        setGoogleButtonReady(false);
      });
    return () => {
      cancelled = true;
      container.innerHTML = '';
    };
  }, [authConfigured, authMode, authOpen, googleIdentityConfigured, loadAuthProfile]);

  const handleAuthSubmit = useCallback(async () => {
    if (!authConfigured) {
      setAuthError('Login is not configured yet. Add Firebase web env values first.');
      return;
    }
    const email = authEmail.trim();
    const password = authPassword;
    if (!email) {
      setAuthError('Email is required.');
      return;
    }
    if (authMode === 'register' && !authUsername.trim()) {
      setAuthError('Username is required for registration.');
      return;
    }
    if (authMode !== 'reset' && password.length < 6) {
      setAuthError('Password must be at least 6 characters.');
      return;
    }
    setAuthSubmitting(true);
    setAuthError(null);
    setAuthMessage(null);
    try {
      if (authMode === 'register') {
        await registerWithEmailPassword(email, password);
        await claimUsernameForAccount(authUsername);
        setAuthOpen(false);
        setAuthPassword('');
        setAuthUsername('');
        showToast({ text: 'Account created', appearance: 'success' });
        await resumeCardFlowAfterAuthRef.current?.();
      } else if (authMode === 'sign_in') {
        await signInWithEmailPassword(email, password);
        setAuthOpen(false);
        setAuthPassword('');
        await loadAuthProfile({ force: true });
        showToast({ text: 'Signed in', appearance: 'success' });
        await resumeCardFlowAfterAuthRef.current?.();
      } else {
        await sendPasswordReset(email);
        setAuthMessage('Password reset email sent. Check your inbox.');
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Authentication failed.';
      setAuthError(message);
    } finally {
      setAuthSubmitting(false);
    }
  }, [
    authConfigured,
    authEmail,
    authMode,
    authPassword,
    authUsername,
    claimUsernameForAccount,
    loadAuthProfile,
  ]);

  const handleAuthSignOut = useCallback(async () => {
    setAuthSubmitting(true);
    setAuthError(null);
    setAuthMessage(null);
    try {
      await signOutFirebase();
      setAuthPassword('');
      setAuthUsername('');
      setAccountUsername(null);
      showToast({ text: 'Signed out', appearance: 'success' });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Could not sign out.';
      setAuthError(message);
    } finally {
      setAuthSubmitting(false);
    }
  }, []);

  const pickPhraseForRole = (role: keyof FMKAssignment) => {
    const pools: Record<keyof FMKAssignment, string[]> = {
      f: funPhrases,
      m: marryPhrases,
      k: killPhrases,
    };
    const pool = pools[role] ?? [];
    return pool[Math.floor(Math.random() * pool.length)] ?? '';
  };

  const getTopSlotForRole = (
    role: keyof FMKAssignment
  ): { slot: FMKSlot; percent: number } | null => {
    if (!entry) return null;
    let bestSlot: FMKSlot | null = null;
    let bestPercent = -1;
    entry.slots.forEach((slot, idx) => {
      const percent = percentFor(percentages, role, slot.id);
      if (percent > bestPercent || (percent === bestPercent && bestSlot === null && idx === 0)) {
        bestSlot = slot;
        bestPercent = percent;
      }
    });
    if (!bestSlot) return null;
    return { slot: bestSlot, percent: Math.max(0, bestPercent) };
  };

  const playPollAudio = () => {
    if (isMuted) return;
    if (!pollAudioRef.current) return;
    if (activeAudioRef.current && activeAudioRef.current !== pollAudioRef.current) {
      activeAudioRef.current.pause();
      activeAudioRef.current.currentTime = 0;
    }
    activeAudioRef.current = pollAudioRef.current;
    void pollAudioRef.current.play().catch(() => {
      /* autoplay may be blocked; user gesture already occurred */
    });
  };

  const playRoleSound = (role: keyof FMKAssignment) => {
    if (isMuted) return false;
    const refMap: Partial<Record<keyof FMKAssignment, React.RefObject<HTMLAudioElement | null>>> = {
      f: funSoundRef,
      m: marrySoundRef,
      k: killSoundRef,
    };
    let played = false;
    if (role === 'm' || role === 'k') {
      played = playRoleBuffer(role);
    }
    if (!played) {
      const targetRef = refMap[role];
      if (targetRef?.current) {
        targetRef.current.currentTime = 0;
        void targetRef.current.play().catch(() => {
          /* autoplay may be blocked */
        });
        played = true;
      }
    }
    return played;
  };

  const ensureAudioContext = () => {
    if (audioCtxRef.current) return audioCtxRef.current;
    const Ctor = (window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext) as
      | typeof AudioContext
      | undefined;
    if (!Ctor) return null;
    audioCtxRef.current = new Ctor();
    return audioCtxRef.current;
  };

  const handleCurtainComplete = useCallback(() => {
    setCurtainPlaying(false);
  }, []);

  const loadBuffer = async (url: string) => {
    const ctx = ensureAudioContext();
    if (!ctx) return null;
    const res = await fetch(url);
    const arr = await res.arrayBuffer();
    return await ctx.decodeAudioData(arr);
  };

  const playRoleBuffer = (role: keyof FMKAssignment) => {
    const ctx = ensureAudioContext();
    if (!ctx) return false;
    const buffer =
      role === 'm' ? marryBufferRef.current : role === 'k' ? killBufferRef.current : null;
    if (!buffer) return false;
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    const gain = ctx.createGain();
    gain.gain.value = role === 'm' || role === 'k' ? 1.6 : 1;
    source.connect(gain).connect(ctx.destination);
    source.start(0);
    return true;
  };

  const openSettings = () => {
    if (view !== 'settings') {
      if (
        view === 'create' ||
        view === 'browse' ||
        view === 'cards' ||
        view === 'packs' ||
        view === 'pack' ||
        view === 'battle' ||
        view === 'quests' ||
        view === 'shop' ||
        view === 'tournament' ||
        view === 'gooGame'
      ) {
        setLastMainView(view);
      } else {
        setLastMainView('poll');
      }
    }
    setView('settings');
  };

  const closeSettings = () => {
    setView(lastMainView ?? 'poll');
  };

  const refreshSelectables = async (reason: string): Promise<void> => {
    try {
      const res = await apiFetch('/api/gallery/selectables');
      if (!res.ok) {
        console.warn('[FMK] /api/gallery/selectables failed', { reason, status: res.status });
        return;
      }
      const data = (await res.json()) as GallerySelectableResponse;
      if (data.marryGallery) {
        setMarryGallery(data.marryGallery);
      }
      if (data.funGallery) {
        setFunGallery(data.funGallery);
      }
      setSelectableMarryIds(new Set(data.selectableMarryIds ?? []));
      setSelectableFunIds(new Set(data.selectableFunIds ?? []));
      console.info('[FMK] selectables refreshed', {
        reason,
        marryGalleryCount: data.marryGallery?.length ?? marryGallery.length,
        funGalleryCount: data.funGallery?.length ?? funGallery.length,
        marryCount: data.selectableMarryIds?.length ?? 0,
        funCount: data.selectableFunIds?.length ?? 0,
      });
    } catch (err) {
      console.warn('[FMK] /api/gallery/selectables fetch error', { reason, error: err });
    }
  };

  const openGallery = async () => {
    const nextGalleryType = galleryType;
    setPreviousView(view === 'gallery' ? 'poll' : (view as GalleryReturnView));
    setView('gallery');
    trackAnalyticsEvent('gallery_open', { galleryType: nextGalleryType });
    await refreshSelectables('open-gallery');
  };

  const closeGallery = () => {
    trackAnalyticsEvent('gallery_close', { galleryType });
    setView(previousView);
  };

  const loadKillState = async () => {
    try {
      const res = await apiFetch('/api/kill/state');
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json()) as KillWaveStateResponse;
      setKillGallery(data.killGallery ?? []);
      setKillWaveState(data.waveState ?? { waveNumber: 1, nextWaveAt: 0 });
      if (data.currency) {
        setCurrency(data.currency);
        setDisplayGold(data.currency.gold);
        setPendingGoldTarget(null);
      }
    } catch (err) {
      console.error('Failed to load kill state', err);
      setError('Could not load kill gallery right now.');
    }
  };

  const closeSelectableModal = () => {
    setSelectedGalleryItem(null);
    setChatBubbleVisible(false);
    setChatBubbleText(null);
    setActiveBubbleId(null);
    setDivorceConfirmOpen(false);
    setFootRubUsed(false);
  };

  const startGoldIncrement = () => {
    if (pendingGoldTarget === null) return;
    if (goldIncrementTimerRef.current) {
      window.clearInterval(goldIncrementTimerRef.current);
    }
    goldIncrementTimerRef.current = window.setInterval(() => {
      setDisplayGold((prev) => {
        if (prev >= pendingGoldTarget) {
          if (goldIncrementTimerRef.current) {
            window.clearInterval(goldIncrementTimerRef.current);
            goldIncrementTimerRef.current = null;
          }
          setPendingGoldTarget(null);
          return pendingGoldTarget;
        }
        return Math.min(pendingGoldTarget, prev + 1);
      });
    }, 50);
  };

  const spawnHeartParticles = () => {
    const now = Date.now();
    const particles = Array.from({ length: 10 }).map((_, idx) => ({
      id: now + idx,
      x: Math.random() * 60 - 30,
      y: Math.random() * 20 - 10,
      duration: 1200 + Math.random() * 300,
      delay: Math.random() * 120,
    }));
    setHeartParticles((prev) => [...prev, ...particles]);
    particles.forEach((particle) => {
      window.setTimeout(
        () => {
          setHeartParticles((prev) => prev.filter((p) => p.id !== particle.id));
        },
        particle.duration + particle.delay + 50
      );
    });
  };

  const spawnCoinParticles = () => {
    if (!selectedGalleryItem) return;
    const origin = galleryItemRefs.current[selectedGalleryItem.id];
    const badge = goldBadgeRef.current;
    if (!origin || !badge) return;
    const originRect = origin.getBoundingClientRect();
    const badgeRect = badge.getBoundingClientRect();
    const startX = originRect.left + originRect.width / 2;
    const startY = originRect.top + originRect.height / 2;
    const endX = badgeRect.left + badgeRect.width / 2;
    const endY = badgeRect.top + badgeRect.height / 2;
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const now = Date.now();
    const particles = Array.from({ length: 10 }).map((_, idx) => ({
      id: now + idx,
      startX,
      startY,
      deltaX: deltaX + (Math.random() * 40 - 20),
      deltaY: deltaY + (Math.random() * 30 - 15),
      duration: 1200 + Math.random() * 300,
      delay: Math.random() * 120,
    }));
    setCoinParticles((prev) => [...prev, ...particles]);
    particles.forEach((particle) => {
      window.setTimeout(
        () => {
          setCoinParticles((prev) => prev.filter((p) => p.id !== particle.id));
        },
        particle.duration + particle.delay + 50
      );
    });
  };

  const spawnCoinParticlesFrom = useCallback((originRect: DOMRect, particleCount = 10) => {
    const badge = goldBadgeRef.current;
    if (!badge) return;
    const badgeRect = badge.getBoundingClientRect();
    const startX = originRect.left + originRect.width / 2;
    const startY = originRect.top + originRect.height / 2;
    const endX = badgeRect.left + badgeRect.width / 2;
    const endY = badgeRect.top + badgeRect.height / 2;
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const now = Date.now();
    const particles = Array.from({ length: particleCount }).map((_, idx) => ({
      id: now + idx,
      startX,
      startY,
      deltaX: deltaX + (Math.random() * 40 - 20),
      deltaY: deltaY + (Math.random() * 30 - 15),
      duration: 1200 + Math.random() * 300,
      delay: Math.random() * 120,
    }));
    setCoinParticles((prev) => [...prev, ...particles]);
    particles.forEach((particle) => {
      window.setTimeout(
        () => {
          setCoinParticles((prev) => prev.filter((p) => p.id !== particle.id));
        },
        particle.duration + particle.delay + 50
      );
    });
  }, []);

  const handleFootRub = async () => {
    if (!selectedGalleryItem) return;
    if (footRubUsed) return;
    if (isFunGallery && !isMuted) {
      if (!funSoundRef.current) {
        funSoundRef.current = new Audio(funSound);
        funSoundRef.current.loop = false;
      }
      funSoundRef.current.currentTime = 0;
      void funSoundRef.current.play().catch(() => {});
    }
    spawnHeartParticles();
    setFootRubUsed(true);
    setGalleryActionLoading(true);
    setError(null);
    try {
      const res = await apiFetch(isFunGallery ? '/api/fun/foot-rub' : '/api/gallery/foot-rub', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ characterId: selectedGalleryItem.id }),
      });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as
        | GalleryActionResponse
        | { currency: GalleryCurrencyState; funGallery: MarryGalleryItem[] };
      const nextCurrency = data.currency ?? { gold: 0, gems: 0, affection: {} };
      setCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? prev.affection : nextCurrency.affection,
      }));
      setFunCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? nextCurrency.affection : prev.affection,
      }));
      setPendingGoldTarget(nextCurrency.gold);
      if (isFunGallery && 'funGallery' in data) {
        setFunGallery(data.funGallery ?? []);
      } else if (!isFunGallery && 'marryGallery' in data) {
        setMarryGallery(data.marryGallery ?? []);
      }
      trackAnalyticsEvent(isFunGallery ? 'gallery_back_rub' : 'gallery_foot_rub', {
        galleryType: isFunGallery ? 'fun' : 'marry',
      });
      await refreshSelectables('after-foot-rub');
    } catch (err) {
      console.error('Foot rub failed', err);
      setError(err instanceof Error ? err.message : 'Could not give a foot rub right now.');
      setFootRubUsed(false);
    } finally {
      setGalleryActionLoading(false);
    }
  };

  const handleDivorce = async () => {
    if (!selectedGalleryItem) return;
    if (!canAffordDivorce) {
      setError('Not enough gold to divorce.');
      return;
    }
    setGalleryActionLoading(true);
    setError(null);
    try {
      const res = await apiFetch(isFunGallery ? '/api/fun/divorce' : '/api/gallery/divorce', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ characterId: selectedGalleryItem.id }),
      });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as
        | GalleryActionResponse
        | { currency: GalleryCurrencyState; funGallery: MarryGalleryItem[] };
      const nextCurrency = data.currency ?? { gold: 0, gems: 0, affection: {} };
      setCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? prev.affection : nextCurrency.affection,
      }));
      setFunCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? nextCurrency.affection : prev.affection,
      }));
      setDisplayGold(nextCurrency.gold);
      setPendingGoldTarget(null);
      if (isFunGallery && 'funGallery' in data) {
        setFunGallery(data.funGallery ?? []);
      } else if (!isFunGallery && 'marryGallery' in data) {
        setMarryGallery(data.marryGallery ?? []);
      }
      trackAnalyticsEvent('gallery_divorce', { galleryType: isFunGallery ? 'fun' : 'marry' });
      closeSelectableModal();
    } catch (err) {
      console.error('Divorce failed', err);
      setError('Could not divorce right now.');
    } finally {
      setGalleryActionLoading(false);
      setDivorceConfirmOpen(false);
    }
  };

  const handleUnlockOutfit = async (outfitId: GalleryOutfitId) => {
    if (!selectedGalleryItem) return;
    setGalleryActionLoading(true);
    setError(null);
    try {
      const res = await apiFetch(
        isFunGallery ? '/api/fun/outfits/unlock' : '/api/gallery/outfits/unlock',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ characterId: selectedGalleryItem.id, outfitId }),
        }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GalleryOutfitActionResponse;
      setCurrency((prev) => ({ ...prev, gold: data.currency.gold, gems: data.currency.gems }));
      setFunCurrency((prev) => ({ ...prev, gold: data.currency.gold, gems: data.currency.gems }));
      setDisplayGold(data.currency.gold);
      setPendingGoldTarget(null);
      if (isFunGallery) {
        setFunOutfits(data.outfits);
      } else {
        setOutfits(data.outfits);
      }
      trackAnalyticsEvent('gallery_outfit_unlock', {
        galleryType: isFunGallery ? 'fun' : 'marry',
        outfitId,
      });
      setOutfitConfirm({ open: false, outfitId: null });
    } catch (err) {
      console.error('Outfit unlock failed', err);
      setError(err instanceof Error ? err.message : 'Could not unlock outfit.');
    } finally {
      setGalleryActionLoading(false);
    }
  };

  const handleSelectOutfit = async (outfitId: GalleryOutfitId) => {
    if (!selectedGalleryItem) return;
    setGalleryActionLoading(true);
    setError(null);
    try {
      const res = await apiFetch(
        isFunGallery ? '/api/fun/outfits/select' : '/api/gallery/outfits/select',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ characterId: selectedGalleryItem.id, outfitId }),
        }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GalleryOutfitActionResponse;
      setCurrency((prev) => ({ ...prev, gold: data.currency.gold, gems: data.currency.gems }));
      setFunCurrency((prev) => ({ ...prev, gold: data.currency.gold, gems: data.currency.gems }));
      if (isFunGallery) {
        setFunOutfits(data.outfits);
      } else {
        setOutfits(data.outfits);
      }
      trackAnalyticsEvent('gallery_outfit_select', {
        galleryType: isFunGallery ? 'fun' : 'marry',
        outfitId,
      });
    } catch (err) {
      console.error('Outfit select failed', err);
      setError(err instanceof Error ? err.message : 'Could not select outfit.');
    } finally {
      setGalleryActionLoading(false);
    }
  };

  const handleUnlockSlot = async () => {
    if (!canUnlockSlot) return;
    setGalleryActionLoading(true);
    setError(null);
    try {
      const currentSlots = isFunGallery ? funAvailableSlots : availableSlots;
      const res = await apiFetch(
        isFunGallery ? '/api/fun/slots/unlock' : '/api/gallery/slots/unlock',
        { method: 'POST' }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GallerySlotUnlockResponse;
      if (isFunGallery) {
        setFunAvailableSlots(data.availableSlots);
        setFunCurrency({
          gold: data.currency.gold,
          gems: data.currency.gems,
          affection: data.currency.affection,
        });
        setCurrency({ ...currency, gold: data.currency.gold, gems: data.currency.gems });
      } else {
        setAvailableSlots(data.availableSlots);
        setCurrency({
          gold: data.currency.gold,
          gems: data.currency.gems,
          affection: data.currency.affection,
        });
        setFunCurrency({ ...funCurrency, gold: data.currency.gold, gems: data.currency.gems });
      }
      setDisplayGold(data.currency.gold);
      if (data.availableSlots === currentSlots) {
        setError('Not enough affection to unlock a new slot.');
        return;
      }
      trackAnalyticsEvent('gallery_slot_unlock', { galleryType: isFunGallery ? 'fun' : 'marry' });
      setSlotUnlockOpen(false);
    } catch (err) {
      console.error('Unlock slot failed', err);
      setError(err instanceof Error ? err.message : 'Could not unlock slot.');
    } finally {
      setGalleryActionLoading(false);
    }
  };

  const handleGift = async () => {
    if (!selectedGalleryItem) return;
    if (!canAffordGift) return;
    spawnHeartParticles();
    setGalleryActionLoading(true);
    setError(null);
    try {
      const res = await apiFetch(isFunGallery ? '/api/fun/gift' : '/api/gallery/gift', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ characterId: selectedGalleryItem.id }),
      });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GalleryGiftResponse | { currency: GalleryCurrencyState };
      const nextCurrency = data.currency ?? { gold: 0, gems: 0, affection: {} };
      setCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? prev.affection : nextCurrency.affection,
      }));
      setFunCurrency((prev) => ({
        gold: nextCurrency.gold,
        gems: nextCurrency.gems,
        affection: isFunGallery ? nextCurrency.affection : prev.affection,
      }));
      setDisplayGold(nextCurrency.gold);
      setPendingGoldTarget(null);
      trackAnalyticsEvent('gallery_gift', { galleryType: isFunGallery ? 'fun' : 'marry' });
    } catch (err) {
      console.error('Gift failed', err);
      setError(err instanceof Error ? err.message : 'Could not send gift.');
    } finally {
      setGalleryActionLoading(false);
    }
  };

  const resetAssignment = () => setAssignment(initialAssignment);

  const spawnParticles = (role: keyof FMKAssignment) => {
    const count = Math.floor(Math.random() * 3) + 3; // 3-5 particles
    const image = roleParticles[role];
    const newParticles: SlotParticle[] = Array.from({ length: count }).map((_, idx) => {
      const id = particleIdRef.current++;
      const base = ((idx + 1) / (count + 1)) * 100;
      const jitter = (Math.random() - 0.5) * 16; // +-8%
      const left = Math.min(95, Math.max(5, base + jitter));
      return {
        id,
        image,
        duration: 2.6 + Math.random() * 0.6,
        left,
      };
    });
    setSlotParticles((prev) => ({
      ...prev,
      [role]: [...prev[role], ...newParticles],
    }));
    newParticles.forEach((p) => {
      setTimeout(
        () => {
          setSlotParticles((prev) => ({
            ...prev,
            [role]: prev[role].filter((part) => part.id !== p.id),
          }));
        },
        p.duration * 1000 + 50
      );
    });
  };

  const handleLevelUpdate = (gainedXp: number, next: UserLevelState, xpReason?: string) => {
    setLevelEvent({
      previous: userLevel,
      current: next,
      gainedXp,
      leveledUp: (userLevel?.level ?? 1) < next.level,
      xpReason: xpReason ?? 'XP gained',
    });
    setUserLevel(next);
  };

  const updateAudioPreference = async (muted: boolean) => {
    try {
      const res = await apiFetch('/api/audio', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ muted }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
    } catch (err) {
      console.error('Failed to update audio preference', err);
    }
  };

  const fetchFMK = async (signal?: AbortSignal, retriesLeft = 2, explicitGameId?: string) => {
    if (fmkInFlightRef.current != null) {
      try {
        await fmkInFlightRef.current;
      } catch {
        // First caller handles error state; coalesced caller just waits
      }
      const gameId = explicitGameId ?? selectedGameId;
      if (
        !signal?.aborted &&
        fmkInFlightRef.current == null &&
        gameId &&
        viewRef.current === 'poll'
      ) {
        if (POPUNDER_DEBUG) {
          console.info(
            '[POPUNDER DEBUG] Retrying coalesced poll load after prior in-flight settled',
            {
              gameId,
              retriesLeft,
              visibilityState: document.visibilityState,
            }
          );
        }
        return fetchFMK(signal, retriesLeft, explicitGameId);
      }
      return;
    }

    const run = async (): Promise<void> => {
      if (!isMountedRef.current || signal?.aborted) return;
      let clientRequestId = 'fmk-load-unknown';
      let serverRequestId = 'server-unknown';
      setLoading(true);
      setError(null);
      setAward(null);
      setPostedAs(null);
      setPostedAsReason(null);
      setFunPromptOpen(false);
      setPendingFunSlot(null);
      setGooGameSlot(null);
      try {
        clientRequestId = `fmk-load-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        const startedAt = Date.now();
        const gameId = explicitGameId ?? selectedGameId;
        const fmkPath = gameId ? `/api/fmk?gameId=${encodeURIComponent(gameId)}` : '/api/fmk';
        const res = await apiFetch(fmkPath, signal != null ? { signal } : {}, {
          gameId,
          tenantId: INITIAL_TENANT,
        });
        serverRequestId = res.headers.get('x-fmk-request-id') ?? 'server-unknown';
        const retriable5xx = res.status === 502 || res.status === 503 || res.status === 504;
        const retryable500 = res.status === 500 && retriesLeft === 2;
        const retryable400 = res.status === 400 && retriesLeft > 0;
        const retryable401 = res.status === 401 && retriesLeft > 0;
        const shouldRetry =
          (retriable5xx || retryable401 || retryable500 || retryable400) &&
          retriesLeft > 0 &&
          !signal?.aborted &&
          document.visibilityState === 'visible';

        if (shouldRetry) {
          const delayMs = retriable5xx
            ? retriesLeft === 2
              ? 800
              : 2000
            : retryable500
              ? 1500
              : retryable400
                ? 700
                : retriesLeft === 2
                  ? 400
                  : 1000;
          console.warn('[FMK] GET /api/fmk retry scheduled', {
            clientRequestId,
            serverRequestId,
            status: res.status,
            retriesLeft,
            delayMs,
          });
          await new Promise<void>((resolve, reject) => {
            const onAbort = () => {
              clearTimeout(t);
              signal?.removeEventListener('abort', onAbort);
              reject(new DOMException('Aborted', 'AbortError'));
            };
            const t = setTimeout(() => {
              signal?.removeEventListener('abort', onAbort);
              resolve();
            }, delayMs);
            signal?.addEventListener('abort', onAbort);
          }).catch((e: unknown) => {
            if (e instanceof Error && e.name === 'AbortError') throw e;
          });
          if (signal?.aborted || document.visibilityState !== 'visible') return;
          return fetchFMK(signal, retryable500 ? 0 : retriesLeft - 1, explicitGameId);
        }
        if (!res.ok) {
          let serverMessage = `HTTP ${res.status}`;
          let responseBody: unknown = null;
          try {
            const body = (await res.json().catch(() => null)) as { message?: string } | null;
            responseBody = body;
            if (typeof body?.message === 'string' && body.message.trim()) {
              serverMessage = body.message;
            }
          } catch {
            // keep default message
          }
          console.error('[FMK] GET /api/fmk failed', {
            clientRequestId,
            serverRequestId,
            status: res.status,
            durationMs: Date.now() - startedAt,
            responseBody,
          });
          throw new Error(serverMessage);
        }
        const data: GetFMKResponse = await res.json();
        console.info('[FMK] GET /api/fmk success', {
          clientRequestId,
          serverRequestId,
          durationMs: Date.now() - startedAt,
          hasEntry: data.entry != null,
          hasVoted: data.hasVoted,
        });
        if (!isMountedRef.current || signal?.aborted) return;
        const recoveredAssignment =
          data.entry && !data.hasVoted
            ? readStoredAssignment(data.entry.id, data.entry.slots)
            : null;
        const recoveredHasVoted = data.hasVoted || recoveredAssignment != null;
        if (recoveredAssignment) {
          console.info('[FMK] Recovered recent local vote state after poll load', {
            clientRequestId,
            serverRequestId,
            postId: data.entry?.id,
          });
        }
        setEntry(data.entry);
        setPercentages(data.percentages ?? emptyPercentages());
        setHasVoted(recoveredHasVoted);
        if (!recoveredHasVoted) {
          setAward(null);
        }
        if (typeof data.currentUser?.authenticated === 'boolean') {
          setIsAuthenticated(data.currentUser.authenticated);
        }
        if (typeof data.currentUser?.username === 'string') {
          const nextUsername = data.currentUser.username.trim();
          setAccountUsername(nextUsername || null);
        } else if (data.currentUser?.authenticated) {
          setAccountUsername(null);
          setUsernameClaimOpen(true);
        }
        setTotalVotes(data.totalVotes ?? 0);
        setUserLevel(data.userLevel ?? defaultLevel);
        if (typeof data.audioMuted === 'boolean') {
          setIsMuted(data.audioMuted);
        }
        setMarryGallery(data.marryGallery ?? []);
        setFunGallery(data.funGallery ?? []);
        setKillGallery(data.killGallery ?? []);
        const nextCurrency = data.currency ?? { gold: 0, gems: 0, affection: {} };
        setCurrency(nextCurrency);
        const nextFunCurrency = data.funCurrency ?? {
          gold: nextCurrency.gold,
          gems: nextCurrency.gems,
          affection: {},
        };
        setFunCurrency(nextFunCurrency);
        setDisplayGold(nextCurrency.gold);
        setPendingGoldTarget(null);
        setOutfits(data.outfits ?? { unlocked: {}, selected: {} });
        setFunOutfits(data.funOutfits ?? { unlocked: {}, selected: {} });
        setAvailableSlots(data.slots?.availableSlots ?? 2);
        setFunAvailableSlots(data.funSlots?.availableSlots ?? 2);
        setSelectableMarryIds(new Set(data.selectableMarryIds ?? []));
        setSelectableFunIds(new Set(data.selectableFunIds ?? []));
        setRevealActive(false);
        setRevealStep(0);
        setRevealTextVisible(false);
        setRevealImageVisible(false);
        setCardPackUnlockPrompt(null);
        setPendingCardPackUnlockPrompt(null);
        if (data.entry) {
          setSelectedGameId(data.entry.id);
          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('gameId', data.entry.id);
          if (INITIAL_TENANT) {
            nextUrl.searchParams.set('tenantId', INITIAL_TENANT);
          }
          window.history.replaceState(null, '', nextUrl.toString());
          // Always clear carry-over slot placement when opening/loading a poll.
          resetAssignment();
          const serverAssignment = data.assignment ?? null;
          if (
            data.hasVoted &&
            serverAssignment &&
            isCompleteAssignment(serverAssignment, data.entry.slots)
          ) {
            setAssignment(serverAssignment);
          } else if (recoveredAssignment) {
            setAssignment(recoveredAssignment);
          }
          const currentView = viewRef.current;
          if (currentView === 'poll' || explicitGameId) {
            setView('poll');
          }
        } else {
          resetAssignment();
        }
        if (recoveredHasVoted) setCurrentResultRole('f');
      } catch (err) {
        if (err instanceof Error && err.name === 'AbortError') return;
        const message = err instanceof Error ? err.message : 'Failed to load. Try again.';
        console.warn('F.M.K load failed:', {
          message,
          retriesLeft,
          location: window.location.href,
          visibilityState: document.visibilityState,
        });
        if (!isMountedRef.current || signal?.aborted) return;
        setError(message.startsWith('HTTP ') ? 'Failed to load. Try again.' : message);
      } finally {
        if (isMountedRef.current && !signal?.aborted) {
          setLoading(false);
        }
      }
    };

    const currentRun = run();
    fmkInFlightRef.current = currentRun;
    try {
      await currentRun;
    } finally {
      if (fmkInFlightRef.current === currentRun) {
        fmkInFlightRef.current = null;
      }
    }
  };

  const fetchBrowsePosts = useCallback(
    async (page: number, sort: FMKPostSort, type: FMKPostType): Promise<void> => {
      setBrowseLoading(true);
      setBrowseError(null);
      try {
        const res = await apiFetch(
          `/api/fmk/posts?sort=${encodeURIComponent(sort)}&type=${encodeURIComponent(type)}&page=${page}&pageSize=${POSTS_PAGE_SIZE}`,
          undefined,
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as GetFMKPostsResponse;
        setBrowsePosts(data.items ?? []);
        setBrowseHasMore(Boolean(data.hasMore));
      } catch (err) {
        console.error('Failed to load browse posts', err);
        setBrowseError(err instanceof Error ? err.message : 'Could not load posts right now.');
      } finally {
        setBrowseLoading(false);
      }
    },
    []
  );

  const setCardTutorialStep = useCallback((step: CardTutorialStep | null): void => {
    setCardTutorialStepState(step);
    if (!step || step === 'completed') {
      clearStoredCardTutorialStep();
      return;
    }
    persistCardTutorialStep(step);
  }, []);

  const isCardTutorialActive =
    cardTutorial?.status === 'active' &&
    cardTutorialStep !== null &&
    cardTutorialStep !== 'completed';
  const shouldShowCardTutorialUi = isCardTutorialActive && view !== 'settings';
  const shouldEnforceCardTutorialActions = isCardTutorialActive && view !== 'settings';

  const isCardTutorialActionAllowed = useCallback(
    (action: CardTutorialAction): boolean => {
      if (!shouldEnforceCardTutorialActions || !cardTutorialStep) return true;
      switch (cardTutorialStep) {
        case 'go_to_first_pack':
          return action === 'menu-packs';
        case 'intro_open_first_pack':
        case 'open_second_pack':
          return action === 'open-pack';
        case 'opening_first_pack':
        case 'opening_second_pack':
        case 'waiting_first_battle':
          return false;
        case 'first_card_power':
        case 'first_card_ability':
          return false;
        case 'finish_first_pack':
          return action === 'return-collection';
        case 'return_after_first_pack':
        case 'return_after_second_pack':
          return action === 'return-collection';
        case 'go_to_second_pack':
          return action === 'menu-packs' || action === 'menu-cards';
        case 'go_to_battle':
        case 'go_to_battle_after_save':
          return action === 'menu-battle' || action === 'menu-cards';
        case 'open_modify_deck':
          return action === 'modify-deck' || action === 'menu-battle';
        case 'build_deck':
          return action === 'select-deck-card' || action === 'save-deck';
        case 'start_first_battle':
          return action === 'start-battle' || action === 'menu-battle';
        case 'battle_goal':
        case 'attack_rules':
        case 'battle_good_luck':
          return false;
        case 'select_attacker':
          return action === 'select-attacker';
        case 'select_target':
          return action === 'select-target';
        case 'free_play_first_battle':
          return true;
        default:
          return true;
      }
    },
    [cardTutorialStep, shouldEnforceCardTutorialActions]
  );

  const resetPackOpeningState = useCallback((): void => {
    setPulledCards([]);
    setPackRevealIndex(0);
    setPackCardFlying(false);
    setPackVideoReady(false);
    setPackOpeningPhase('idle');
  }, []);

  const fetchCardCollection = useCallback(async (): Promise<void> => {
    setCardsLoading(true);
    setCardsError(null);
    setDeckError(null);
    try {
      const res = await apiFetch('/api/cards/deck', undefined, { tenantId: INITIAL_TENANT });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GetCardDeckResponse;
      setCardCollection(data.collection);
      setCardDeck(data.deck);
      setDeckSelection(data.deck.cardIds);
    } catch (err) {
      console.error('Failed to load card collection', err);
      setCardsError(err instanceof Error ? err.message : 'Could not load cards right now.');
    } finally {
      setCardsLoading(false);
    }
  }, []);

  const handleOpenCardPack = useCallback(
    async (options: { tutorial?: boolean } = {}): Promise<void> => {
      if (!requireReadyUserAction('open card packs')) return;
      setCardsOpening(true);
      setCardsError(null);
      try {
        const payload: OpenCardPackRequest = { tutorial: Boolean(options.tutorial) };
        const res = await apiFetch(
          '/api/cards/open-pack',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as OpenCardPackResponse;
        setCardCollection({
          cards: data.cards,
          unopenedPacks: data.unopenedPacks,
          openedPacks: data.openedPacks,
          updatedAt: data.updatedAt,
        });
        setPulledCards(data.pulledCards ?? []);
        setPackRevealIndex(0);
        setPackCardFlying(false);
        setPackOpeningPhase('idle');
        if (options.tutorial && cardTutorialStep === 'intro_open_first_pack') {
          setCardTutorialStep('opening_first_pack');
        } else if (options.tutorial && cardTutorialStep === 'open_second_pack') {
          setCardTutorialStep('opening_second_pack');
        }
        syncUrlToView('pack');
        setView('pack');
      } catch (err) {
        console.error('Failed to open card pack', err);
        setCardsError(err instanceof Error ? err.message : 'Could not open a card pack right now.');
      } finally {
        setCardsOpening(false);
      }
    },
    [cardTutorialStep, requireReadyUserAction, setCardTutorialStep, syncUrlToView]
  );

  const handleGrantTemporaryCardPack = useCallback(async (): Promise<void> => {
    if (!moderationToolsOpen || !adminToken.trim()) {
      setCardsError(
        'Open moderation tools in Settings and enter the admin token to use debug grants.'
      );
      return;
    }
    if (!requireReadyUserAction('grant a temporary card pack')) return;
    setCardsGrantingPack(true);
    setCardsError(null);
    try {
      const res = await apiFetch(
        '/api/cards/grant-pack',
        { method: 'POST' },
        { tenantId: INITIAL_TENANT, adminToken }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as CardCollectionResponse;
      setCardCollection(data);
      showToast({ text: 'Temporary pack granted', appearance: 'success' });
    } catch (err) {
      console.error('Failed to grant temporary card pack', err);
      setCardsError(err instanceof Error ? err.message : 'Could not grant a pack right now.');
    } finally {
      setCardsGrantingPack(false);
    }
  }, [adminToken, moderationToolsOpen, requireReadyUserAction]);

  const handleGrantDebugCurrency = useCallback(
    async (payload: DebugGrantCurrencyRequest): Promise<void> => {
      if (!moderationToolsOpen || !adminToken.trim()) {
        setCardsError(
          'Open moderation tools in Settings and enter the admin token to use debug grants.'
        );
        return;
      }
      if (!requireReadyUserAction('grant debug currency')) return;
      const grantKind = payload.gold && payload.gold > 0 ? 'gold' : 'gems';
      setCardsGrantingCurrency(grantKind);
      setCardsError(null);
      try {
        const res = await apiFetch(
          '/api/cards/grant-currency',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT, adminToken }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as DebugGrantCurrencyResponse;
        setCurrency(data.currency);
        setFunCurrency((prev) => ({
          ...prev,
          gold: data.currency.gold,
          gems: data.currency.gems,
        }));
        setDisplayGold(data.currency.gold);
        setShopState(data);
        const grantText =
          data.grantedGold > 0
            ? `+${data.grantedGold.toLocaleString()} gold`
            : `+${data.grantedGems.toLocaleString()} gems`;
        showToast({ text: `Debug grant: ${grantText}`, appearance: 'success' });
      } catch (err) {
        console.error('Failed to grant debug currency', err);
        setCardsError(err instanceof Error ? err.message : 'Could not grant debug currency.');
      } finally {
        setCardsGrantingCurrency(null);
      }
    },
    [adminToken, moderationToolsOpen, requireReadyUserAction]
  );

  const consumeCardPackForReveal = useCallback(
    async (options: { tutorial?: boolean } = {}): Promise<void> => {
      if (cardCollection && cardCollection.unopenedPacks <= 0) {
        setCardsError('No unopened card packs are available.');
        setPackOpeningPhase('error');
        syncUrlToView('packs');
        setView('packs');
        return;
      }
      setCardsOpening(true);
      setPackOpeningPhase('opening');
      setCardsError(null);
      try {
        const payload: OpenCardPackRequest = { tutorial: Boolean(options.tutorial) };
        const res = await apiFetch(
          '/api/cards/open-pack',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as OpenCardPackResponse;
        setCardCollection({
          cards: data.cards,
          unopenedPacks: data.unopenedPacks,
          openedPacks: data.openedPacks,
          updatedAt: data.updatedAt,
        });
        setPulledCards(data.pulledCards ?? []);
        setPackRevealIndex(0);
        setPackCardFlying(false);
        setPackVideoReady(false);
        setPackOpeningPhase((data.pulledCards ?? []).length > 0 ? 'revealing' : 'complete');
      } catch (err) {
        console.error('Failed to open card pack', err);
        setCardsError(err instanceof Error ? err.message : 'Could not open a card pack right now.');
        setPackOpeningPhase('error');
      } finally {
        setCardsOpening(false);
      }
    },
    [cardCollection, syncUrlToView]
  );

  const finishPackOpeningAnimation = useCallback(async (): Promise<void> => {
    if (pulledCards.length > 0) {
      setPackRevealIndex(0);
      setPackCardFlying(false);
      setPackOpeningPhase('revealing');
      return;
    }
    await consumeCardPackForReveal();
  }, [consumeCardPackForReveal, pulledCards.length]);

  const startPackOpeningAnimation = useCallback(async (): Promise<void> => {
    if (!requireReadyUserAction('open card packs')) return;
    if (pulledCards.length === 0 && cardCollection && cardCollection.unopenedPacks <= 0) {
      setCardsError('No unopened card packs are available.');
      syncUrlToView('packs');
      setView('packs');
      return;
    }
    setCardsError(null);
    setPackRevealIndex(0);
    setPackCardFlying(false);
    setPackVideoReady(false);
    setPackOpeningPhase('playing');
    await waitForNextFrame();
    const video = packVideoRef.current;
    if (!video) {
      await finishPackOpeningAnimation();
      return;
    }
    try {
      video.currentTime = 0;
      await video.play();
    } catch (err) {
      console.warn('Pack opening video could not play; opening pack immediately.', err);
      await finishPackOpeningAnimation();
    }
  }, [
    cardCollection,
    finishPackOpeningAnimation,
    pulledCards.length,
    requireReadyUserAction,
    syncUrlToView,
  ]);

  const returnToCardCollection = useCallback((): void => {
    if (!isCardTutorialActionAllowed('return-collection')) return;
    const nextTutorialStep =
      cardTutorialStep === 'return_after_first_pack'
        ? 'go_to_second_pack'
        : cardTutorialStep === 'return_after_second_pack'
          ? 'go_to_battle'
          : null;
    setPackOpeningPhase('idle');
    setPackRevealIndex(0);
    setPackCardFlying(false);
    setPackVideoReady(false);
    setCardsError(null);
    syncUrlToView('cards');
    setView('cards');
    if (nextTutorialStep) setCardTutorialStep(nextTutorialStep);
  }, [cardTutorialStep, isCardTutorialActionAllowed, setCardTutorialStep, syncUrlToView]);

  const dismissCurrentPackCard = useCallback((): void => {
    if (cardTutorialStep === 'first_card_power' || cardTutorialStep === 'first_card_ability') {
      return;
    }
    if (packOpeningPhase !== 'revealing' || packCardFlying || pulledCards.length === 0) return;
    setPackCardFlying(true);
    window.setTimeout(() => {
      setPackRevealIndex((currentIndex) => {
        const nextIndex = currentIndex + 1;
        if (nextIndex >= pulledCards.length) {
          setPackOpeningPhase('complete');
          setPackCardFlying(false);
          showToast({ text: 'Card pack opened', appearance: 'success' });
          return currentIndex;
        }
        setPackCardFlying(false);
        return nextIndex;
      });
    }, PACK_CARD_FLY_MS);
  }, [cardTutorialStep, packCardFlying, packOpeningPhase, pulledCards.length]);

  const handlePackCardPointerDown = useCallback((event: React.PointerEvent): void => {
    packSwipeStartRef.current = { x: event.clientX, y: event.clientY };
    packSwipeConsumedRef.current = false;
  }, []);

  const handlePackCardPointerUp = useCallback(
    (event: React.PointerEvent): void => {
      const start = packSwipeStartRef.current;
      packSwipeStartRef.current = null;
      if (!start) return;
      const deltaX = event.clientX - start.x;
      const deltaY = event.clientY - start.y;
      if (deltaX < -40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        packSwipeConsumedRef.current = true;
        dismissCurrentPackCard();
      }
    },
    [dismissCurrentPackCard]
  );

  const handlePackCardClick = useCallback((): void => {
    if (packSwipeConsumedRef.current) {
      packSwipeConsumedRef.current = false;
      return;
    }
    dismissCurrentPackCard();
  }, [dismissCurrentPackCard]);

  const toggleDeckCard = useCallback(
    (cardId: string): void => {
      if (!isCardTutorialActionAllowed('select-deck-card')) return;
      setDeckError(null);
      setDeckSelection((prev) => {
        if (prev.includes(cardId)) return prev.filter((id) => id !== cardId);
        if (prev.length >= 6) return prev;
        return [...prev, cardId];
      });
    },
    [isCardTutorialActionAllowed]
  );

  const handleSaveCardDeck = useCallback(async (): Promise<void> => {
    if (!isCardTutorialActionAllowed('save-deck')) return;
    if (!requireReadyUserAction('save your battle deck')) return;
    setDeckSaving(true);
    setDeckError(null);
    try {
      const payload: SaveCardDeckRequest = { cardIds: deckSelection };
      const res = await apiFetch(
        '/api/cards/deck',
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as SaveCardDeckResponse;
      setCardDeck(data.deck);
      setDeckSelection(data.deck.cardIds);
      setBattleRank(data.rank);
      setBattleDeck(data.deck);
      showToast({ text: 'Battle deck saved', appearance: 'success' });
      if (cardTutorialStep === 'build_deck') {
        setCardTutorialStep('go_to_battle_after_save');
        setCardDeckEditorOpen(false);
      }
    } catch (err) {
      console.error('Failed to save card deck', err);
      setDeckError(err instanceof Error ? err.message : 'Could not save your deck right now.');
    } finally {
      setDeckSaving(false);
    }
  }, [
    cardTutorialStep,
    deckSelection,
    isCardTutorialActionAllowed,
    requireReadyUserAction,
    setCardTutorialStep,
  ]);

  const openCardDeckEditor = useCallback((): void => {
    if (!isCardTutorialActionAllowed('modify-deck')) return;
    setCardDeckEditorOpen(true);
    setView('cards');
    if (cardTutorialStep === 'open_modify_deck') {
      setCardTutorialStep('build_deck');
    }
  }, [cardTutorialStep, isCardTutorialActionAllowed, setCardTutorialStep]);

  const openBattleShop = useCallback((): void => {
    if (!isCardTutorialActionAllowed('shop')) return;
    syncUrlToView('shop');
    setView('shop');
  }, [isCardTutorialActionAllowed, syncUrlToView]);

  const openCardEconomyView = useCallback(
    (nextView: 'shop' | 'quests' | 'battle' | 'packs' | 'cards'): void => {
      const action = `menu-${nextView}` as CardTutorialAction;
      if (!isCardTutorialActionAllowed(action)) return;
      setCardDeckEditorOpen(false);
      syncUrlToView(nextView);
      setView(nextView);
      if (cardTutorialStep === 'go_to_first_pack' && nextView === 'packs') {
        setCardTutorialStep('intro_open_first_pack');
      } else if (cardTutorialStep === 'go_to_second_pack' && nextView === 'packs') {
        setCardTutorialStep('open_second_pack');
      } else if (
        (cardTutorialStep === 'go_to_battle' || cardTutorialStep === 'go_to_battle_after_save') &&
        nextView === 'battle'
      ) {
        setCardTutorialStep(
          cardTutorialStep === 'go_to_battle' ? 'open_modify_deck' : 'start_first_battle'
        );
      }
    },
    [cardTutorialStep, isCardTutorialActionAllowed, setCardTutorialStep, syncUrlToView]
  );

  const clearBattleRankAnimationTimer = useCallback((): void => {
    if (battleRankAnimationTimeoutRef.current) {
      window.clearTimeout(battleRankAnimationTimeoutRef.current);
      battleRankAnimationTimeoutRef.current = null;
    }
  }, []);

  const buildBattleResultState = useCallback(
    (
      actionResponse: BattleActionResponse,
      previousRank: BattleRankDisplayState
    ): BattleResultState | null => {
      if (actionResponse.battle.status === 'active' || !actionResponse.battle.reward) return null;
      const nextUserLevel =
        actionResponse.userLevel ??
        getLevelProgress((userLevel?.xp ?? 0) + actionResponse.battle.reward.xp);
      const previousUserLevel =
        userLevel ?? getLevelProgress(Math.max(0, nextUserLevel.xp - actionResponse.gainedXp));
      const previousCurrency = currency;
      const nextCurrency = {
        ...currency,
        gold: currency.gold + actionResponse.battle.reward.gold,
      };
      return {
        outcome: actionResponse.battle.status,
        reward: actionResponse.battle.reward,
        previousRank,
        nextRank: getBattleRankDisplay(actionResponse.rank.rating),
        previousUserLevel,
        nextUserLevel,
        previousCurrency,
        nextCurrency,
      };
    },
    [currency, userLevel]
  );

  const maybeShowBattleLegendaryDeal = useCallback((): void => {
    const nextCompletedCount = completedBattlesSinceLegendaryDealRef.current + 1;
    const shouldShowDeal =
      BATTLE_LEGENDARY_DEAL_DEBUG_ALWAYS_SHOW ||
      nextCompletedCount >= BATTLE_LEGENDARY_DEAL_BATTLE_INTERVAL;
    completedBattlesSinceLegendaryDealRef.current = shouldShowDeal ? 0 : nextCompletedCount;
    if (shouldShowDeal) {
      setBattleLegendaryDealExpiresAt(Date.now() + BATTLE_LEGENDARY_DEAL_DURATION_MS);
    }
  }, []);

  const handleBattleResultContinue = useCallback((): void => {
    if (!battleResult) return;
    const animationKind =
      battleResult.previousRank.rankNumber !== battleResult.nextRank.rankNumber
        ? 'rank'
        : battleResult.nextRank.level > battleResult.previousRank.level
          ? 'level'
          : null;
    setBattleResult(null);
    maybeShowBattleLegendaryDeal();
    clearBattleRankAnimationTimer();
    if (!animationKind) {
      setBattleRankAnimation(null);
      return;
    }
    setBattleRankAnimation({
      previousRank: battleResult.previousRank,
      currentRank: battleResult.nextRank,
      animationKind,
    });
    battleRankAnimationTimeoutRef.current = window.setTimeout(() => {
      setBattleRankAnimation(null);
      battleRankAnimationTimeoutRef.current = null;
    }, BATTLE_RANK_ANIMATION_MS);
  }, [battleResult, clearBattleRankAnimationTimer, maybeShowBattleLegendaryDeal]);

  const applyShopState = useCallback((nextState: ShopStateResponse): void => {
    setShopState(nextState);
    setCurrency(nextState.currency);
    setFunCurrency((prev) => ({
      ...prev,
      gold: nextState.currency.gold,
      gems: nextState.currency.gems,
    }));
    setCardCollection((prev) =>
      prev ? { ...prev, unopenedPacks: nextState.unopenedPacks } : prev
    );
  }, []);

  const fetchShopState = useCallback(async (): Promise<void> => {
    setShopLoading(true);
    setShopError(null);
    try {
      const res = await apiFetch('/api/shop/state', undefined, { tenantId: INITIAL_TENANT });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      applyShopState((await res.json()) as ShopStateResponse);
    } catch (err) {
      console.error('Failed to load shop state', err);
      setShopError(err instanceof Error ? err.message : 'Could not load the shop right now.');
    } finally {
      setShopLoading(false);
    }
  }, [applyShopState]);

  const applyShopCheckoutStatus = useCallback(
    (data: ShopCheckoutStatusResponse): void => {
      if (data.shopState) applyShopState(data.shopState);
      setShopCheckout((prev) => ({
        offer: data.offer,
        orderId: data.orderId,
        invoiceId: data.invoiceId ?? prev?.invoiceId ?? null,
        invoiceUrl: data.invoiceUrl ?? prev?.invoiceUrl ?? null,
        orderStatus: data.orderStatus,
        loading: false,
        refreshing: false,
        paymentStarted: data.orderStatus === 'pending' ? (prev?.paymentStarted ?? false) : false,
        error: null,
      }));
    },
    [applyShopState]
  );

  const refreshShopCheckoutStatus = useCallback(
    async (
      orderId: string,
      options: { showPaidToast?: boolean; paymentStarted?: boolean } = {}
    ): Promise<void> => {
      const trimmedOrderId = orderId.trim();
      if (!trimmedOrderId) return;
      setShopCheckout((prev) =>
        prev
          ? {
              ...prev,
              refreshing: true,
              paymentStarted: options.paymentStarted ?? prev.paymentStarted,
              error: null,
            }
          : {
              offer: null,
              orderId: trimmedOrderId,
              invoiceId: null,
              invoiceUrl: null,
              orderStatus: null,
              loading: true,
              refreshing: true,
              paymentStarted: options.paymentStarted ?? false,
              error: null,
            }
      );
      try {
        const res = await apiFetch(
          `/api/shop/checkout/${encodeURIComponent(trimmedOrderId)}`,
          undefined,
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as ShopCheckoutStatusResponse;
        applyShopCheckoutStatus(data);
        if (data.orderStatus === 'paid' && options.showPaidToast) {
          showToast({ text: 'Purchase added to your shop balance', appearance: 'success' });
        }
      } catch (err) {
        console.error('Failed to refresh shop checkout', err);
        setShopCheckout((prev) =>
          prev
            ? {
                ...prev,
                loading: false,
                refreshing: false,
                error: err instanceof Error ? err.message : 'Could not refresh checkout status.',
              }
            : prev
        );
      }
    },
    [applyShopCheckoutStatus]
  );

  const openShopCheckout = useCallback(
    async (offer: ShopPaidOffer): Promise<void> => {
      if (!isAuthenticated) {
        setShopError('Sign in required to start checkout.');
        setAuthOpen(true);
        return;
      }
      setShopCheckout({
        offer,
        orderId: null,
        invoiceId: null,
        invoiceUrl: null,
        orderStatus: null,
        loading: true,
        refreshing: false,
        paymentStarted: false,
        error: null,
      });
      setShopError(null);
      try {
        const res = await apiFetch(
          '/api/shop/checkout',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ offerId: offer.id }),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as ShopCheckoutResponse;
        setShopCheckout({
          offer: data.offer,
          orderId: data.orderId,
          invoiceId: data.invoiceId,
          invoiceUrl: data.invoiceUrl,
          orderStatus: 'pending',
          loading: false,
          refreshing: false,
          paymentStarted: false,
          error: null,
        });
      } catch (err) {
        console.error('Failed to start shop checkout', err);
        setShopCheckout((prev) =>
          prev
            ? {
                ...prev,
                loading: false,
                refreshing: false,
                error: err instanceof Error ? err.message : 'Could not start checkout right now.',
              }
            : prev
        );
      }
    },
    [isAuthenticated]
  );

  const applyQuestsState = useCallback((nextState: QuestsStateResponse): void => {
    setQuestsState(nextState);
    setCurrency(nextState.currency);
    setFunCurrency((prev) => ({
      ...prev,
      gold: nextState.currency.gold,
      gems: nextState.currency.gems,
    }));
    setDisplayGold(nextState.currency.gold);
  }, []);

  useEffect(() => {
    if (view !== 'shop' || !INITIAL_CHECKOUT_PARAM || !isAuthenticated) return;
    void refreshShopCheckoutStatus(INITIAL_CHECKOUT_PARAM, {
      showPaidToast: true,
      paymentStarted: true,
    });
  }, [isAuthenticated, refreshShopCheckoutStatus, view]);

  useEffect(() => {
    if (
      !shopCheckout?.paymentStarted ||
      !shopCheckout.orderId ||
      shopCheckout.orderStatus !== 'pending'
    ) {
      return;
    }
    const interval = window.setInterval(() => {
      void refreshShopCheckoutStatus(shopCheckout.orderId!, { showPaidToast: true });
    }, 5000);
    return () => window.clearInterval(interval);
  }, [
    refreshShopCheckoutStatus,
    shopCheckout?.orderId,
    shopCheckout?.orderStatus,
    shopCheckout?.paymentStarted,
  ]);

  const startCardTutorialIfNeeded = useCallback(
    async (options: { entryView?: 'battle' | 'packs' } = {}): Promise<CardTutorialState | null> => {
      if (
        cardTutorialStarting ||
        cardTutorial?.status === 'active' ||
        cardTutorial?.status === 'completed'
      ) {
        return cardTutorial;
      }
      setCardTutorialStarting(true);
      try {
        const res = await apiFetch(
          '/api/cards/tutorial/start',
          { method: 'POST' },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as CardTutorialStartResponse;
        applyShopState(data);
        setCardTutorial(data.tutorial);
        if (data.tutorial.status === 'completed') {
          setCardTutorialStep('completed');
          return data.tutorial;
        }
        const storedStep = data.grantedGold > 0 ? null : getStoredCardTutorialStep();
        const safeStoredStep = storedStep
          ? getSafeStoredCardTutorialStep(storedStep, options.entryView)
          : null;
        setCardTutorialStep(
          safeStoredStep && safeStoredStep !== 'completed'
            ? safeStoredStep
            : options.entryView === 'battle'
              ? 'go_to_first_pack'
              : 'intro_open_first_pack'
        );
        if (data.grantedGold > 0) {
          showToast({ text: `+${data.grantedGold} gold`, appearance: 'success' });
        }
        return data.tutorial;
      } catch (err) {
        console.error('Failed to start card tutorial', err);
        return null;
      } finally {
        setCardTutorialStarting(false);
      }
    },
    [applyShopState, cardTutorial?.status, cardTutorialStarting, setCardTutorialStep]
  );

  const resumeCardFlowAfterAuth = useCallback(async (): Promise<void> => {
    const shouldResumeFreePackFlow = freePackAuthResumePendingRef.current;
    freePackAuthResumePendingRef.current = false;
    if (!shouldResumeFreePackFlow) return;
    resetPackOpeningState();
    setCardPackUnlockPrompt(null);
    setPendingCardPackUnlockPrompt(null);
    setCardTutorial(null);
    setCardTutorialAbilityTip(null);
    setCardTutorialStep(null);
    setCardsError(null);
    setShopError(null);
    setCardTutorialStarting(true);
    try {
      const res = await apiFetch(
        '/api/cards/tutorial/start',
        { method: 'POST' },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as CardTutorialStartResponse;
      applyShopState(data);
      setCardTutorial(data.tutorial);
      if (data.tutorial.status === 'completed') {
        setCardTutorialStep('completed');
        setCompletedTutorialNoticeOpen(true);
        syncUrlToView('cards');
        setView('cards');
      } else {
        setCompletedTutorialNoticeOpen(false);
        setCardTutorialStep('intro_open_first_pack');
        syncUrlToView('packs');
        setView('packs');
        if (data.grantedGold > 0) {
          showToast({ text: `+${data.grantedGold} gold`, appearance: 'success' });
        }
      }
      await fetchCardCollection();
    } catch (err) {
      console.error('Failed to resume card tutorial after auth', err);
      setCardsError(err instanceof Error ? err.message : 'Could not refresh cards right now.');
    } finally {
      setCardTutorialStarting(false);
    }
  }, [
    applyShopState,
    fetchCardCollection,
    resetPackOpeningState,
    setCardTutorialStep,
    syncUrlToView,
  ]);

  resumeCardFlowAfterAuthRef.current = resumeCardFlowAfterAuth;

  const handleOpenFreeCardPack = useCallback((): void => {
    if (!isAuthenticated) {
      freePackAuthResumePendingRef.current = true;
    }
    setCardPackUnlockPrompt(null);
    setPendingCardPackUnlockPrompt(null);
    openCardEconomyView('packs');
    void startCardTutorialIfNeeded({ entryView: 'packs' });
  }, [isAuthenticated, openCardEconomyView, startCardTutorialIfNeeded]);

  const handleTopNavCardBattle = useCallback(async (): Promise<void> => {
    if (!requireReadyUserAction('open card battle')) return;
    const tutorialIsKnown =
      cardTutorial?.status === 'active' || cardTutorial?.status === 'completed';
    if (!tutorialIsKnown) {
      const tutorial = await startCardTutorialIfNeeded({ entryView: 'packs' });
      openCardEconomyView(tutorial?.status === 'completed' ? 'battle' : 'packs');
      return;
    }
    if (cardTutorial?.status === 'active' && cardTutorialStep === 'go_to_first_pack') {
      openCardEconomyView('packs');
      return;
    }
    openCardEconomyView('battle');
    void startCardTutorialIfNeeded({ entryView: 'battle' });
  }, [
    cardTutorial?.status,
    cardTutorialStep,
    openCardEconomyView,
    requireReadyUserAction,
    startCardTutorialIfNeeded,
  ]);

  const topNavCardTutorialAction: CardTutorialAction =
    cardTutorial?.status === 'active' && cardTutorialStep === 'go_to_first_pack'
      ? 'menu-packs'
      : 'menu-battle';

  const completeCardTutorialIfNeeded = useCallback(async (): Promise<void> => {
    if (!isCardTutorialActive || cardTutorialCompleting) return;
    setCardTutorialCompleting(true);
    try {
      const res = await apiFetch(
        '/api/cards/tutorial/complete',
        { method: 'POST' },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as CardTutorialCompleteResponse;
      setCardTutorial(data.tutorial);
      setCardTutorialStep('completed');
      setCardTutorialAbilityTip(null);
    } catch (err) {
      console.error('Failed to complete card tutorial', err);
    } finally {
      setCardTutorialCompleting(false);
    }
  }, [cardTutorialCompleting, isCardTutorialActive, setCardTutorialStep]);

  const fetchQuestsState = useCallback(async (): Promise<void> => {
    setQuestsLoading(true);
    setQuestsError(null);
    try {
      const res = await apiFetch('/api/quests/state', undefined, { tenantId: INITIAL_TENANT });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      applyQuestsState((await res.json()) as QuestsStateResponse);
    } catch (err) {
      console.error('Failed to load quests', err);
      setQuestsError(err instanceof Error ? err.message : 'Could not load quests right now.');
    } finally {
      setQuestsLoading(false);
    }
  }, [applyQuestsState]);

  const handleClaimQuest = useCallback(
    async (quest: DailyQuestState, originRect?: DOMRect): Promise<void> => {
      if (!requireReadyUserAction('claim quest rewards')) return;
      setQuestActionLoading(quest.id);
      setQuestsError(null);
      try {
        const payload: ClaimQuestRequest = { questId: quest.id };
        const res = await apiFetch(
          '/api/quests/claim',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as ClaimQuestResponse;
        applyQuestsState(data);
        if (originRect) {
          spawnCoinParticlesFrom(originRect, 18);
        }
        showToast({ text: `+${data.rewardedGold} gold`, appearance: 'success' });
      } catch (err) {
        console.error('Failed to claim quest', err);
        setQuestsError(err instanceof Error ? err.message : 'Could not claim that quest.');
      } finally {
        setQuestActionLoading(null);
      }
    },
    [applyQuestsState, requireReadyUserAction, spawnCoinParticlesFrom]
  );

  const handleClaimDailyGift = useCallback(async (): Promise<void> => {
    if (!requireReadyUserAction('claim your daily gift')) return;
    setShopActionLoading('daily-gift');
    setShopError(null);
    try {
      const previousCurrency = shopState?.currency ?? currency;
      const res = await apiFetch(
        '/api/shop/daily-gift',
        { method: 'POST' },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as ShopDailyGiftResponse;
      applyShopState(data);
      setShopDailyGiftCelebration({
        rewardKind: 'gold',
        rewardedGold: Math.max(0, data.currency.gold - previousCurrency.gold),
        rewardedGems: Math.max(0, data.currency.gems - previousCurrency.gems),
        previousCurrency,
        nextCurrency: data.currency,
        eyebrow: 'Daily Gift Claimed',
        headline: 'Daily gift opened!',
      });
      showToast({ text: 'Daily gift claimed', appearance: 'success' });
    } catch (err) {
      console.error('Failed to claim daily shop gift', err);
      setShopError(err instanceof Error ? err.message : 'Could not claim your daily gift.');
    } finally {
      setShopActionLoading(null);
    }
  }, [applyShopState, currency, requireReadyUserAction, shopState]);

  const handlePurchaseShopPacks = useCallback(
    async (packCount: number): Promise<void> => {
      if (!requireReadyUserAction('buy card packs')) return;
      setShopActionLoading(`packs-${packCount}`);
      setShopError(null);
      try {
        const payload: ShopPurchasePacksRequest = { packCount };
        const res = await apiFetch(
          '/api/shop/packs',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as ShopPurchasePacksResponse;
        applyShopState(data);
        showToast({
          text: `${data.purchasedPacks} pack${data.purchasedPacks === 1 ? '' : 's'} added`,
          appearance: 'success',
        });
      } catch (err) {
        console.error('Failed to purchase shop packs', err);
        setShopError(err instanceof Error ? err.message : 'Could not buy packs right now.');
      } finally {
        setShopActionLoading(null);
      }
    },
    [applyShopState, requireReadyUserAction]
  );

  const handlePurchaseGoldPack = useCallback(
    async (options: { tutorial?: boolean } = {}): Promise<void> => {
      if (!requireReadyUserAction('buy a card pack')) return;
      setShopActionLoading('gold-pack');
      setShopError(null);
      setCardsError(null);
      try {
        const res = await apiFetch(
          '/api/shop/gold-pack',
          { method: 'POST' },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as PurchaseGoldPackResponse;
        applyShopState(data);
        setCardCollection((prev) =>
          prev ? { ...prev, unopenedPacks: data.unopenedPacks, updatedAt: Date.now() } : prev
        );
        showToast({ text: 'Pack purchased', appearance: 'success' });
        await handleOpenCardPack({ tutorial: Boolean(options.tutorial) });
      } catch (err) {
        console.error('Failed to buy gold pack', err);
        const message = err instanceof Error ? err.message : 'Could not buy a pack right now.';
        setShopError(message);
        setCardsError(message);
      } finally {
        setShopActionLoading(null);
      }
    },
    [applyShopState, handleOpenCardPack, requireReadyUserAction]
  );

  const openShopRewardedAd = useCallback(
    (rewardKind: ShopAdRewardKind): void => {
      if (!requireReadyUserAction('watch shop ads')) return;
      const rewardState = shopState?.adRewards[rewardKind] ?? null;
      if (rewardState && !rewardState.available) {
        setShopError('That video reward is not ready yet.');
        return;
      }
      setShopRewardedAdError(null);
      setShopAdRewardCelebration(null);
      setShopRewardedAdKind(rewardKind);
    },
    [requireReadyUserAction, shopState]
  );

  const closeShopAdRewardCelebration = useCallback((): void => {
    setShopAdRewardCelebration(null);
  }, []);

  const closeShopDailyGiftCelebration = useCallback((): void => {
    setShopDailyGiftCelebration(null);
  }, []);

  const closeShopRewardedAd = useCallback((): void => {
    if (shopActionLoading?.startsWith('ad-')) return;
    setShopRewardedAdKind(null);
    setShopRewardedAdError(null);
  }, [shopActionLoading]);

  const handleClaimShopAdReward = useCallback(
    async (rewardKind: ShopAdRewardKind): Promise<void> => {
      setShopActionLoading(`ad-${rewardKind}`);
      setShopRewardedAdError(null);
      setShopError(null);
      try {
        const payload: ShopClaimAdRewardRequest = { rewardKind };
        const res = await apiFetch(
          '/api/shop/ad-reward',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as ShopClaimAdRewardResponse;
        const previousCurrency = shopState?.currency ?? currency;
        applyShopState(data);
        setShopRewardedAdKind(null);
        setShopAdRewardCelebration({
          rewardKind: data.rewardKind,
          rewardedGold: data.rewardedGold,
          rewardedGems: data.rewardedGems,
          previousCurrency,
          nextCurrency: data.currency,
        });
      } catch (err) {
        console.error('Failed to claim shop ad reward', err);
        setShopRewardedAdError(
          err instanceof Error ? err.message : 'Could not claim that video reward.'
        );
      } finally {
        setShopActionLoading(null);
      }
    },
    [applyShopState, currency, shopState]
  );

  const fetchBattleState = useCallback(async (): Promise<void> => {
    setBattleLoading(true);
    setBattleError(null);
    setBattleResult(null);
    setBattleRankAnimation(null);
    clearBattleRankAnimationTimer();
    try {
      const activeRes = await apiFetch('/api/battle/active', undefined, {
        tenantId: INITIAL_TENANT,
      });
      if (!activeRes.ok) {
        const data = (await activeRes.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${activeRes.status}`);
      }
      const activeData = (await activeRes.json()) as GetActiveBattleResponse;
      setBattle(activeData.battle);
      setBattleRank(activeData.rank);
      setBattleDeck(activeData.deck);
      setMatchmakingActive(false);
      setMatchmakingLocked(false);
      setPendingBattleStart(null);
    } catch (err) {
      console.error('Failed to load battle state', err);
      setBattleError(err instanceof Error ? err.message : 'Could not load battle right now.');
    } finally {
      setBattleLoading(false);
    }
  }, [clearBattleRankAnimationTimer]);

  const handleStartBattle = useCallback(async (): Promise<void> => {
    if (!isCardTutorialActionAllowed('start-battle')) return;
    if (!requireReadyUserAction('start a battle')) return;
    setBattleStarting(true);
    setBattleError(null);
    setBattleResult(null);
    setBattleRankAnimation(null);
    clearBattleRankAnimationTimer();
    setSelectedBattleAttacker(null);
    setBattleAttackAnimation(null);
    setBattleHealAnimations([]);
    setBattleAnimating(false);
    setMatchmakingActive(false);
    setMatchmakingLocked(false);
    setPendingBattleStart(null);
    try {
      const payload: StartBattleRequest = { tutorial: cardTutorialStep === 'start_first_battle' };
      const res = await apiFetch(
        '/api/battle/start',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as StartBattleResponse;
      const opponentName = data.battle.opponent.displayName.trim() || 'Opponent';
      const seenNames = new Set<string>();
      const names: string[] = [];
      for (const name of data.matchmakingNames ?? []) {
        const trimmed = name.trim();
        if (!trimmed || trimmed === opponentName || seenNames.has(trimmed)) continue;
        seenNames.add(trimmed);
        names.push(trimmed);
      }
      for (const fakeName of BATTLE_MATCHMAKING_FAKE_NAMES) {
        if (names.length >= BATTLE_MATCHMAKING_MIN_PREVIEW_NAMES - 1) break;
        if (fakeName === opponentName || seenNames.has(fakeName)) continue;
        seenNames.add(fakeName);
        names.push(fakeName);
      }
      names.push(opponentName);
      setBattle(null);
      setPendingBattleStart(data);
      setMatchmakingNames(names);
      setMatchmakingNameIndex(0);
      setMatchmakingLocked(false);
      setMatchmakingActive(true);
      if (cardTutorialStep === 'start_first_battle') {
        setCardTutorialStep('waiting_first_battle');
      }
    } catch (err) {
      console.error('Failed to start battle', err);
      setBattleError(err instanceof Error ? err.message : 'Could not start a battle right now.');
      setBattleStarting(false);
      setMatchmakingActive(false);
      setMatchmakingLocked(false);
      setPendingBattleStart(null);
    }
  }, [
    cardTutorialStep,
    clearBattleRankAnimationTimer,
    isCardTutorialActionAllowed,
    requireReadyUserAction,
    setCardTutorialStep,
  ]);

  useEffect(() => {
    return () => clearBattleRankAnimationTimer();
  }, [clearBattleRankAnimationTimer]);

  const registerBattleCard = useCallback(
    (instanceId: string, element: HTMLElement | null): void => {
      if (element) {
        battleCardRefs.current.set(instanceId, element);
      } else {
        battleCardRefs.current.delete(instanceId);
      }
    },
    []
  );

  const registerBattleSlot = useCallback(
    (side: 'player' | 'opponent', slotIndex: number, element: HTMLElement | null): void => {
      const key = `${side}:${slotIndex}`;
      if (element) {
        battleSlotRefs.current.set(key, element);
      } else {
        battleSlotRefs.current.delete(key);
      }
    },
    []
  );

  const registerBattleDeck = useCallback(
    (side: 'player' | 'opponent', element: HTMLElement | null): void => {
      if (element) {
        battleDeckRefs.current.set(side, element);
      } else {
        battleDeckRefs.current.delete(side);
      }
    },
    []
  );

  const playBattleDrawTransitions = useCallback(
    async (before: BattleMatchState, after: BattleMatchState): Promise<void> => {
      const heals = getBattleHealTransitions(before, after);
      if (
        (heals.length === 0 && getBattleDrawTransitions(before, after).length === 0) ||
        prefersReducedBattleMotion()
      ) {
        setBattle(after);
        await waitForPaint();
        return;
      }
      setBattle(before);
      await waitForPaint();
      let transitionBase = before;
      if (heals.length > 0) {
        const healAnimations = heals.flatMap((heal, sequenceIndex) => {
          const targetRect =
            getBattleMotionRect(battleCardRefs.current.get(heal.targetInstanceId)) ??
            getBattleMotionRect(battleSlotRefs.current.get(`${heal.side}:${heal.targetSlotIndex}`));
          if (!targetRect) return [];
          const healerRect =
            getBattleMotionRect(battleCardRefs.current.get(heal.healerInstanceId)) ?? targetRect;
          return [
            {
              id: `${heal.side}-${sequenceIndex}-${heal.healerInstanceId}-${heal.targetInstanceId}`,
              ...heal,
              fromRect: healerRect,
              toRect: targetRect,
            },
          ];
        });
        if (healAnimations.length > 0) {
          const stagedHealBattle = cloneBattleMatchForAnimation(before);
          for (const healAnimation of healAnimations) {
            setBattleHealAnimations([healAnimation]);
            await waitForMs(BATTLE_HEAL_ANIMATION_MS);
            setBattleHealAnimations([]);
            await waitForPaint();
            const stagedOwner = getBattleOwner(stagedHealBattle, healAnimation.side);
            stagedOwner.active = stagedOwner.active.map((card) => {
              if (!card || card.instanceId !== healAnimation.targetInstanceId) return card;
              const nextPower = card.currentPower + healAnimation.amount;
              return {
                ...card,
                currentPower: nextPower,
                maxPower: Math.max(card.maxPower, nextPower),
              };
            });
            setBattle(cloneBattleMatchForAnimation(stagedHealBattle));
            await waitForPaint();
            await waitForMs(BATTLE_HEAL_SETTLE_MS);
            await waitForMs(BATTLE_HEAL_BETWEEN_MS);
          }
        }
        transitionBase = buildBattleHealedState(before, after);
        setBattle(transitionBase);
        await waitForPaint();
      }
      const draws = getBattleDrawTransitions(transitionBase, after);
      if (draws.length === 0) {
        setBattle(after);
        await waitForPaint();
        return;
      }
      const animatedSides = new Set<'player' | 'opponent'>();
      const drawnBySide: BattleDeckCountOverrides = {};
      const stagedBattle = cloneBattleMatchForAnimation(transitionBase);
      for (const draw of draws) {
        const deckRect = getBattleMotionRect(battleDeckRefs.current.get(draw.side));
        const slotRect = getBattleMotionRect(
          battleSlotRefs.current.get(`${draw.side}:${draw.slotIndex}`)
        );
        if (!deckRect || !slotRect) continue;
        animatedSides.add(draw.side);
        drawnBySide[draw.side] = (drawnBySide[draw.side] ?? 0) + 1;
        const beforeDeckCount = getBattleOwner(transitionBase, draw.side).deck.length;
        setBattleDeckCountOverrides((current) => ({
          ...current,
          [draw.side]: Math.max(0, beforeDeckCount - (drawnBySide[draw.side] ?? 0)),
        }));
        setBattleDrawAnimation({
          id: `${draw.side}-${draw.card.instanceId}-${draw.slotIndex}`,
          side: draw.side,
          slotIndex: draw.slotIndex,
          card: draw.card,
          fromRect: deckRect,
          toRect: slotRect,
        });
        await waitForMs(BATTLE_DRAW_ANIMATION_MS);
        const stagedOwner = getBattleOwner(stagedBattle, draw.side);
        stagedOwner.active = stagedOwner.active.map((card, index) =>
          index === draw.slotIndex ? draw.card : card
        );
        stagedOwner.deck = getBattleOwner(transitionBase, draw.side).deck.slice(
          drawnBySide[draw.side] ?? 0
        );
        stagedBattle.updatedAt = after.updatedAt;
        setBattle(cloneBattleMatchForAnimation(stagedBattle));
        setBattleDrawReveal({
          side: draw.side,
          slotIndex: draw.slotIndex,
          instanceId: draw.card.instanceId,
        });
        setBattleDrawAnimation(null);
        await waitForPaint();
        await waitForMs(BATTLE_DRAW_REVEAL_MS);
        setBattleDrawReveal(null);
        await waitForMs(BATTLE_DRAW_SETTLE_MS);
      }
      setBattleDeckCountOverrides((current) => {
        const next = { ...current };
        for (const side of animatedSides) {
          delete next[side];
        }
        return next;
      });
      setBattle(after);
      await waitForPaint();
    },
    []
  );

  const playBattleAnimationSteps = useCallback(
    async (steps: BattleAnimationStep[], finalBattle?: BattleMatchState): Promise<void> => {
      if (steps.length === 0) {
        if (finalBattle) {
          setBattle(finalBattle);
        }
        return;
      }
      setBattleAnimating(true);
      try {
        let displayedBattle: BattleMatchState | null = null;
        for (const step of steps) {
          if (displayedBattle) {
            await playBattleDrawTransitions(displayedBattle, step.battleBefore);
          }
          const attacker = findBattleCardByInstanceId(
            step.battleBefore,
            step.side,
            step.attackerInstanceId
          );
          setBattle(step.battleBefore);
          await waitForPaint();
          if (!attacker || prefersReducedBattleMotion()) {
            setBattle(step.battleAfter);
            displayedBattle = step.battleAfter;
            await waitForMs(BATTLE_ATTACK_SETTLE_MS);
            continue;
          }
          const attackerElement = battleCardRefs.current.get(step.attackerInstanceId);
          const targetElement = battleCardRefs.current.get(step.targetInstanceId);
          const attackerRect = getBattleMotionRect(attackerElement);
          const targetRect = getBattleMotionRect(targetElement);
          const measuredOffset =
            attackerRect && targetRect
              ? {
                  x:
                    (targetRect.left +
                      targetRect.width / 2 -
                      (attackerRect.left + attackerRect.width / 2)) *
                    0.78,
                  y:
                    (targetRect.top +
                      targetRect.height / 2 -
                      (attackerRect.top + attackerRect.height / 2)) *
                    0.78,
                }
              : { x: 0, y: step.side === 'player' ? -96 : 96 };
          await preloadBattleCardImage(attacker.image);
          setBattleAttackAnimation({
            side: step.side,
            attackerInstanceId: step.attackerInstanceId,
            targetInstanceId: step.targetInstanceId,
            targetDamage: step.targetDamage,
            card: attacker,
            fromRect: attackerRect ?? {
              left: window.innerWidth / 2,
              top: window.innerHeight / 2,
              width: 120,
              height: 168,
            },
            offsetX: measuredOffset.x,
            offsetY: measuredOffset.y,
            inPlace: attacker.ability === 'ranger',
          });
          await waitForMs(BATTLE_ATTACK_ANIMATION_MS);
          setBattle(step.battleAfter);
          displayedBattle = step.battleAfter;
          setBattleAttackAnimation(null);
          await waitForMs(BATTLE_ATTACK_SETTLE_MS);
        }
        if (finalBattle && displayedBattle) {
          await playBattleDrawTransitions(displayedBattle, finalBattle);
        }
      } finally {
        setBattleAttackAnimation(null);
        setBattleDrawAnimation(null);
        setBattleHealAnimations([]);
        setBattleDrawReveal(null);
        setBattleDeckCountOverrides({});
        setBattleAnimating(false);
      }
    },
    [playBattleDrawTransitions]
  );

  const handleBattleAttack = useCallback(
    async (targetInstanceId: string): Promise<void> => {
      if (!isCardTutorialActionAllowed('select-target')) return;
      if (!selectedBattleAttacker || battleAnimating) return;
      const previousRank = getBattleRankDisplay(battleRank?.rating ?? 1000);
      setBattleActionLoading(true);
      setBattleError(null);
      setBattleResult(null);
      setBattleRankAnimation(null);
      clearBattleRankAnimationTimer();
      try {
        const payload: BattleAttackRequest = {
          attackerInstanceId: selectedBattleAttacker,
          targetInstanceId,
        };
        const res = await apiFetch(
          '/api/battle/attack',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as BattleActionResponse;
        if (data.animationSteps?.length) {
          await playBattleAnimationSteps(data.animationSteps, data.battle);
        }
        const nextBattleResult = buildBattleResultState(data, previousRank);
        setBattle(data.battle);
        setBattleRank(data.rank);
        setBattleResult(nextBattleResult);
        if (nextBattleResult) {
          setCurrency(nextBattleResult.nextCurrency);
          setFunCurrency((prev) => ({
            ...prev,
            gold: nextBattleResult.nextCurrency.gold,
            gems: nextBattleResult.nextCurrency.gems,
          }));
        }
        if (data.userLevel) {
          setUserLevel(data.userLevel);
        }
        if (cardTutorialStep === 'select_target') {
          setCardTutorialStep('attack_rules');
        }
      } catch (err) {
        console.error('Failed to submit battle attack', err);
        setBattleError(err instanceof Error ? err.message : 'Could not attack right now.');
      } finally {
        setSelectedBattleAttacker(null);
        setBattleActionLoading(false);
      }
    },
    [
      battleAnimating,
      battleRank?.rating,
      buildBattleResultState,
      cardTutorialStep,
      clearBattleRankAnimationTimer,
      isCardTutorialActionAllowed,
      playBattleAnimationSteps,
      selectedBattleAttacker,
      setCardTutorialStep,
    ]
  );

  const handleForfeitBattle = useCallback(async (): Promise<void> => {
    const previousRank = getBattleRankDisplay(battleRank?.rating ?? 1000);
    setBattleActionLoading(true);
    setBattleAnimating(false);
    setBattleAttackAnimation(null);
    setBattleDrawAnimation(null);
    setBattleDrawReveal(null);
    setBattleDeckCountOverrides({});
    setBattleError(null);
    setBattleResult(null);
    setBattleRankAnimation(null);
    clearBattleRankAnimationTimer();
    try {
      const res = await apiFetch(
        '/api/battle/forfeit',
        { method: 'POST' },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as BattleActionResponse;
      const nextBattleResult = buildBattleResultState(data, previousRank);
      setBattle(data.battle);
      setBattleRank(data.rank);
      setBattleResult(nextBattleResult);
      if (nextBattleResult) {
        setCurrency(nextBattleResult.nextCurrency);
        setFunCurrency((prev) => ({
          ...prev,
          gold: nextBattleResult.nextCurrency.gold,
          gems: nextBattleResult.nextCurrency.gems,
        }));
      }
      if (data.userLevel) {
        setUserLevel(data.userLevel);
      }
    } catch (err) {
      console.error('Failed to forfeit battle', err);
      setBattleError(err instanceof Error ? err.message : 'Could not forfeit right now.');
    } finally {
      setBattleActionLoading(false);
    }
  }, [battleRank?.rating, buildBattleResultState, clearBattleRankAnimationTimer]);

  useEffect(() => {
    if (!matchmakingActive || !pendingBattleStart) return;
    let cancelled = false;
    let revealStarted = false;
    const names = matchmakingNames.length
      ? matchmakingNames
      : [pendingBattleStart.battle.opponent.displayName];
    const interval = window.setInterval(() => {
      setMatchmakingNameIndex((prev) => (prev + 1) % names.length);
    }, BATTLE_MATCHMAKING_NAME_TICK_MS);
    const landTimer = window.setTimeout(() => {
      window.clearInterval(interval);
      setMatchmakingNameIndex(Math.max(0, names.length - 1));
      setMatchmakingLocked(true);
    }, BATTLE_MATCHMAKING_LAND_MS);
    const revealTimer = window.setTimeout(() => {
      revealStarted = true;
      void (async () => {
        const openingBattle = buildBattleOpeningDrawState(pendingBattleStart.battle);
        setBattleRank(pendingBattleStart.rank);
        setBattle(openingBattle);
        setBattleStarting(false);
        setMatchmakingActive(false);
        setMatchmakingLocked(false);
        setMatchmakingNames([]);
        setMatchmakingNameIndex(0);
        setBattleAnimating(true);
        await waitForPaint();
        if (!cancelled) {
          await playBattleDrawTransitions(openingBattle, pendingBattleStart.battle);
        }
        if (!cancelled) {
          setBattleAnimating(false);
          setPendingBattleStart(null);
          showToast({ text: 'Battle started', appearance: 'success' });
        }
      })();
    }, BATTLE_MATCHMAKING_LAND_MS + BATTLE_MATCHMAKING_LOCKED_MS);
    return () => {
      window.clearInterval(interval);
      window.clearTimeout(landTimer);
      window.clearTimeout(revealTimer);
      if (!revealStarted) {
        cancelled = true;
        setBattleAnimating(false);
      }
      setMatchmakingLocked(false);
    };
  }, [matchmakingActive, matchmakingNames, pendingBattleStart, playBattleDrawTransitions]);

  const fetchTournamentSummary = useCallback(async (): Promise<void> => {
    setTournamentLoading(true);
    setTournamentError(null);
    try {
      const res = await apiFetch('/api/tournament/current', undefined, {
        tenantId: INITIAL_TENANT,
      });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as GetCurrentTournamentResponse;
      setTournamentSummary(data.tournament ?? null);
    } catch (err) {
      console.error('Failed to load tournament summary', err);
      setTournamentError(
        err instanceof Error ? err.message : 'Could not load the tournament right now.'
      );
    } finally {
      setTournamentLoading(false);
    }
  }, []);

  const fetchTournamentPageData = useCallback(async (): Promise<void> => {
    setTournamentPageLoading(true);
    setTournamentError(null);
    try {
      const [roundRes, resultsRes] = await Promise.all([
        apiFetch('/api/tournament/current/round', undefined, { tenantId: INITIAL_TENANT }),
        apiFetch('/api/tournament/current/results', undefined, { tenantId: INITIAL_TENANT }),
      ]);
      if (!roundRes.ok) {
        const data = (await roundRes.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${roundRes.status}`);
      }
      if (!resultsRes.ok) {
        const data = (await resultsRes.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${resultsRes.status}`);
      }
      const roundData = (await roundRes.json()) as GetTournamentRoundResponse;
      const resultsData = (await resultsRes.json()) as GetTournamentResultsResponse;
      const nextRound = roundData.round ?? null;
      setTournamentSummary(roundData.tournament ?? resultsData.tournament ?? null);
      if (
        (tournamentRound?.battleId ?? '') !== (nextRound?.battleId ?? '') ||
        (tournamentRound?.category ?? '') !== (nextRound?.category ?? '')
      ) {
        setTournamentVoteSelections({});
        setTournamentPendingChoice(null);
      }
      setTournamentRound(nextRound);
      setTournamentHasVoted(Boolean(roundData.hasVoted));
      setTournamentRoundResults(roundData.results ?? null);
      setTournamentBracket(resultsData.bracket ?? null);
      setTournamentFinalWinners(resultsData.finalWinners ?? []);
    } catch (err) {
      console.error('Failed to load tournament page data', err);
      setTournamentError(
        err instanceof Error ? err.message : 'Could not load the tournament right now.'
      );
    } finally {
      setTournamentPageLoading(false);
    }
  }, [tournamentRound?.battleId]);

  const openTournamentPage = useCallback(async (): Promise<void> => {
    trackAnalyticsEvent('tournament_open', {
      battleId: tournamentSummary?.activeWindow?.battleId ?? '',
      stage: tournamentSummary?.activeWindow?.stage ?? '',
    });
    setView('tournament');
    setLoading(false);
    await fetchTournamentPageData();
  }, [
    fetchTournamentPageData,
    tournamentSummary?.activeWindow?.battleId,
    tournamentSummary?.activeWindow?.stage,
    trackAnalyticsEvent,
  ]);

  const setTournamentSelection = useCallback((pairKey: string, entrantId: string): void => {
    setTournamentVoteSelections((prev) => ({
      ...prev,
      [pairKey]: entrantId,
    }));
  }, []);

  const handleTournamentChoice = useCallback(
    (pairKey: string, entrantId: string): void => {
      if (tournamentPendingChoice != null) return;
      trackAnalyticsEvent('tournament_choice_select', {
        pairKey,
        entrantId,
        category: tournamentRound?.category ?? '',
        battleId: tournamentRound?.battleId ?? '',
      });
      setTournamentPendingChoice({ pairKey, entrantId });
      if (tournamentChoiceAdvanceTimerRef.current != null) {
        window.clearTimeout(tournamentChoiceAdvanceTimerRef.current);
      }
      tournamentChoiceAdvanceTimerRef.current = window.setTimeout(() => {
        setTournamentSelection(pairKey, entrantId);
        setTournamentPendingChoice(null);
        tournamentChoiceAdvanceTimerRef.current = null;
      }, 425);
    },
    [
      setTournamentSelection,
      tournamentPendingChoice,
      tournamentRound?.battleId,
      tournamentRound?.category,
      trackAnalyticsEvent,
    ]
  );

  const handleTournamentVoteSubmit = useCallback(async (): Promise<void> => {
    if (!tournamentRound) return;
    const picks = tournamentRound.pairs.map((pair) => {
      const winnerEntrantId = tournamentVoteSelections[pair.pairKey] ?? '';
      return {
        pairKey: pair.pairKey,
        leftEntrantId: pair.leftEntrantId,
        rightEntrantId: pair.rightEntrantId,
        winnerEntrantId,
      };
    });
    const incomplete = picks.some((pick) => !pick.winnerEntrantId);
    if (incomplete) {
      setTournamentError(
        `Finish every ${tournamentCategoryLabels[tournamentRound.category]} comparison before submitting.`
      );
      return;
    }
    setTournamentSubmitting(true);
    setTournamentError(null);
    try {
      const payload: TournamentVoteRequest = {
        battleId: tournamentRound.battleId,
        category: tournamentRound.category,
        picks,
      };
      const res = await apiFetch(
        '/api/tournament/current/vote',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as TournamentVoteResponse;
      setPendingTournamentVoteResult(data);
      setTournamentPendingChoice(null);
      handleLevelUpdate(data.gainedXp, data.userLevel, data.xpReason);
      trackAnalyticsEvent('tournament_vote_submit', {
        battleId: data.battleId,
        category: data.category,
        picks: picks.length,
      });
      showToast({ text: 'Tournament vote submitted', appearance: 'success' });
    } catch (err) {
      console.error('Failed to submit tournament vote', err);
      setTournamentError(
        err instanceof Error ? err.message : 'Could not submit your tournament vote.'
      );
    } finally {
      setTournamentSubmitting(false);
    }
  }, [handleLevelUpdate, tournamentRound, tournamentVoteSelections, trackAnalyticsEvent]);

  const handleLevelModalClose = useCallback((): void => {
    const pendingTournamentResult = pendingTournamentVoteResult;
    setLevelEvent(null);
    if (!pendingTournamentResult) {
      if (!cardPackUnlockPrompt && pendingFunSlot && viewRef.current === 'poll') {
        setFunPromptOpen(true);
      }
      return;
    }

    setPendingTournamentVoteResult(null);
    setTournamentSummary(pendingTournamentResult.tournament);
    setTournamentHasVoted(true);
    setTournamentRoundResults(pendingTournamentResult.results);
    void (async () => {
      await fetchTournamentPageData();
      await fetchTournamentSummary();
    })();
  }, [
    fetchTournamentPageData,
    fetchTournamentSummary,
    cardPackUnlockPrompt,
    pendingFunSlot,
    pendingTournamentVoteResult,
  ]);

  const handleBrowsePostVote = useCallback(
    async (postId: string, vote: 1 | -1): Promise<void> => {
      if (!requireParticipantIdentity('vote on posts')) return;
      setBrowseVotePendingByPost((prev) => ({ ...prev, [postId]: true }));
      try {
        const payload: PostVoteRequest = { postId, vote };
        const res = await apiFetch(
          '/api/fmk/posts/vote',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as PostVoteResponse;
        setBrowsePosts((prev) =>
          prev.map((post) =>
            post.postId === data.postId
              ? {
                  ...post,
                  userVote: data.userVote,
                  popularScore: data.popularScore,
                }
              : post
          )
        );
        if (browseSort === 'popular') {
          await fetchBrowsePosts(browsePage, browseSort, browseType);
        }
      } catch (err) {
        console.error('Failed to vote on browse post', err);
        setBrowseError(
          err instanceof Error ? err.message : 'Could not vote on this post right now.'
        );
      } finally {
        setBrowseVotePendingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    [browsePage, browseSort, browseType, fetchBrowsePosts, requireParticipantIdentity]
  );

  const openReportModal = useCallback((postId: string): void => {
    if (!postId) {
      setBrowseError('No post is selected to report right now.');
      return;
    }
    setReportModalPostId(postId);
    setReportReason(DEFAULT_REPORT_REASON);
    setReportComment('');
    setReportModalError(null);
  }, []);

  const closeReportModal = useCallback((): void => {
    setReportModalPostId(null);
    setReportComment('');
    setReportModalError(null);
  }, []);

  const submitReport = useCallback(async (): Promise<void> => {
    const postId = reportModalPostId ?? '';
    if (!postId) {
      setReportModalError('No post is selected to report right now.');
      return;
    }
    const comment = reportComment.trim();
    if (comment.length > REPORT_COMMENT_MAX_LENGTH) {
      setReportModalError(`Comment must be ${REPORT_COMMENT_MAX_LENGTH} characters or less.`);
      return;
    }
    setBrowseReportPendingByPost((prev) => ({ ...prev, [postId]: true }));
    setReportModalError(null);
    try {
      const payload: ReportPostRequest = {
        postId,
        reason: reportReason,
        ...(comment ? { comment } : {}),
      };
      const res = await apiFetch(
        '/api/fmk/posts/report',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as ReportPostResponse;
      setReportThanksMessage(
        data.alreadyReported
          ? 'Thanks for looking out. You already reported this post, and we appreciate your help keeping the community safe.'
          : 'Thank you for reporting this post and helping keep the community safe.'
      );
      closeReportModal();
      setReportThanksModalOpen(true);
    } catch (err) {
      console.error('Failed to report post', err);
      setReportModalError(
        err instanceof Error ? err.message : 'Could not report this post right now.'
      );
    } finally {
      setBrowseReportPendingByPost((prev) => {
        const { [postId]: _ignored, ...next } = prev;
        return next;
      });
    }
  }, [closeReportModal, reportComment, reportModalPostId, reportReason]);

  const loadBrowseCommentsPage = useCallback(
    async (postId: string, page: number, append: boolean): Promise<void> => {
      setBrowseCommentsLoadingByPost((prev) => ({ ...prev, [postId]: true }));
      setBrowseCommentsErrorByPost((prev) => ({ ...prev, [postId]: null }));
      try {
        const res = await apiFetch(
          `/api/fmk/posts/comments?postId=${encodeURIComponent(postId)}&page=${page}&pageSize=${POST_COMMENTS_PAGE_SIZE}`,
          undefined,
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as GetPostCommentsResponse;
        const items = data.items ?? [];
        setBrowseCommentsByPost((prev) => ({
          ...prev,
          [postId]: append ? [...(prev[postId] ?? []), ...items] : items,
        }));
        setBrowseCommentsPageByPost((prev) => ({ ...prev, [postId]: page }));
        setBrowseCommentsHasMoreByPost((prev) => ({ ...prev, [postId]: Boolean(data.hasMore) }));
      } catch (err) {
        console.error('Failed to load post comments', err);
        setBrowseCommentsErrorByPost((prev) => ({
          ...prev,
          [postId]: err instanceof Error ? err.message : 'Could not load comments right now.',
        }));
      } finally {
        setBrowseCommentsLoadingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    []
  );

  const toggleBrowseComments = useCallback(
    (postId: string): void => {
      const currentlyExpanded = Boolean(browseCommentsExpandedByPost[postId]);
      if (currentlyExpanded) {
        setBrowseCommentsExpandedByPost((prev) => ({ ...prev, [postId]: false }));
        return;
      }
      setBrowseCommentsExpandedByPost((prev) => ({ ...prev, [postId]: true }));
      const hasLoadedAnyPage = (browseCommentsPageByPost[postId] ?? 0) > 0;
      if (!hasLoadedAnyPage && !browseCommentsLoadingByPost[postId]) {
        void loadBrowseCommentsPage(postId, 1, false);
      }
    },
    [
      browseCommentsExpandedByPost,
      browseCommentsLoadingByPost,
      browseCommentsPageByPost,
      loadBrowseCommentsPage,
    ]
  );

  const loadMoreBrowseComments = useCallback(
    (postId: string): void => {
      const nextPage = (browseCommentsPageByPost[postId] ?? 1) + 1;
      void loadBrowseCommentsPage(postId, nextPage, true);
    },
    [browseCommentsPageByPost, loadBrowseCommentsPage]
  );

  const submitBrowseComment = useCallback(
    async (postId: string): Promise<void> => {
      if (!requireReadyUserAction('comment on posts')) return;
      const body = (browseCommentDraftByPost[postId] ?? '').trim();
      if (!body) {
        setBrowseCommentsErrorByPost((prev) => ({ ...prev, [postId]: 'Comment cannot be empty.' }));
        return;
      }
      if (body.length > POST_COMMENT_MAX_LENGTH) {
        setBrowseCommentsErrorByPost((prev) => ({
          ...prev,
          [postId]: `Comment must be ${POST_COMMENT_MAX_LENGTH} characters or less.`,
        }));
        return;
      }
      setBrowseCommentSubmitPendingByPost((prev) => ({ ...prev, [postId]: true }));
      setBrowseCommentsErrorByPost((prev) => ({ ...prev, [postId]: null }));
      try {
        const payload: CreatePostCommentRequest = { postId, body };
        const res = await apiFetch(
          '/api/fmk/posts/comments',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          },
          { tenantId: INITIAL_TENANT }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as CreatePostCommentResponse;
        setBrowseCommentsByPost((prev) => ({
          ...prev,
          [postId]: [data.comment, ...(prev[postId] ?? [])],
        }));
        setBrowsePosts((prev) =>
          prev.map((post) =>
            post.postId === postId
              ? {
                  ...post,
                  commentCount: Math.max(0, Math.floor(Number(post.commentCount) || 0)) + 1,
                }
              : post
          )
        );
        setBrowseCommentsPageByPost((prev) => ({
          ...prev,
          [postId]: Math.max(prev[postId] ?? 0, 1),
        }));
        setBrowseCommentDraftByPost((prev) => ({ ...prev, [postId]: '' }));
      } catch (err) {
        console.error('Failed to submit comment', err);
        setBrowseCommentsErrorByPost((prev) => ({
          ...prev,
          [postId]: err instanceof Error ? err.message : 'Could not submit comment right now.',
        }));
      } finally {
        setBrowseCommentSubmitPendingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    [browseCommentDraftByPost, requireReadyUserAction]
  );

  const handleReportCurrentPost = useCallback(() => {
    const postId = selectedGameId || entry?.id || '';
    if (!postId) {
      setError('No post is selected to report right now.');
      return;
    }
    openReportModal(postId);
  }, [entry?.id, openReportModal, selectedGameId]);

  const loadAdminReportedPosts = useCallback(
    async (page: number): Promise<void> => {
      const token = adminToken.trim();
      if (!token) {
        setAdminReports([]);
        setAdminTypeByPost({});
        setAdminReportsHasMore(false);
        setAdminReportsError('Enter admin token to review reports.');
        return;
      }
      setAdminReportsLoading(true);
      setAdminReportsError(null);
      try {
        const res = await apiFetch(
          `/internal/admin/fmk/reports?page=${page}&pageSize=${ADMIN_REPORTS_PAGE_SIZE}`,
          undefined,
          { tenantId: INITIAL_TENANT, adminToken: token }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as AdminListReportedPostsResponse;
        const items = (data.items ?? []).map((item) => ({
          ...item,
          type: normalizeFMKPostType(item.type),
        }));
        setAdminReports(items);
        setAdminTypeByPost((prev) => {
          const next: Record<string, FMKPostType> = {};
          for (const item of items) {
            next[item.postId] = prev[item.postId] ?? item.type;
          }
          return next;
        });
        setAdminReportsHasMore(Boolean(data.hasMore));
      } catch (err) {
        console.error('Failed to load admin reports', err);
        setAdminReportsError(
          err instanceof Error ? err.message : 'Could not load reports right now.'
        );
      } finally {
        setAdminReportsLoading(false);
      }
    },
    [adminToken]
  );

  const loadAdminAnalyticsSummary = useCallback(
    async (days: number): Promise<void> => {
      const token = adminToken.trim();
      if (!token) {
        setAdminAnalyticsSummary(null);
        setAdminAnalyticsError('Enter admin token to view analytics.');
        return;
      }
      setAdminAnalyticsLoading(true);
      setAdminAnalyticsError(null);
      try {
        const res = await apiFetch(`/internal/admin/analytics/summary?days=${days}`, undefined, {
          tenantId: INITIAL_TENANT,
          adminToken: token,
        });
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as AdminAnalyticsSummaryResponse;
        setAdminAnalyticsSummary(data);
      } catch (err) {
        console.error('Failed to load analytics summary', err);
        setAdminAnalyticsError(
          err instanceof Error ? err.message : 'Could not load analytics right now.'
        );
      } finally {
        setAdminAnalyticsLoading(false);
      }
    },
    [adminToken]
  );

  const handleAdminRemovePost = useCallback(
    async (postId: string): Promise<void> => {
      const token = adminToken.trim();
      if (!token) {
        setAdminReportsError('Enter admin token to remove posts.');
        return;
      }
      setAdminRemovePendingByPost((prev) => ({ ...prev, [postId]: true }));
      try {
        const res = await apiFetch(
          '/internal/admin/fmk/posts/remove',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ postId, hardDelete: adminHardDelete }),
          },
          { tenantId: INITIAL_TENANT, adminToken: token }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as AdminRemovePostResponse;
        setBrowsePosts((prev) => prev.filter((post) => post.postId !== postId));
        setAdminReports((prev) =>
          prev.map((item) => (item.postId === postId ? { ...item, removed: true } : item))
        );
        showToast({
          text: data.alreadyRemoved
            ? 'Post was already removed.'
            : data.hardDeleted
              ? `Post hard-deleted (${data.deletedKeyCount ?? 0} key(s), ${data.deletedImageCount ?? 0} image(s)).`
              : 'Post removed.',
          appearance: 'success',
        });
        await loadAdminReportedPosts(adminReportsPage);
      } catch (err) {
        console.error('Failed to remove post', err);
        setAdminReportsError(
          err instanceof Error ? err.message : 'Could not remove this post right now.'
        );
      } finally {
        setAdminRemovePendingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    [adminHardDelete, adminReportsPage, adminToken, loadAdminReportedPosts]
  );

  const handleAdminDismissReports = useCallback(
    async (postId: string): Promise<void> => {
      const token = adminToken.trim();
      if (!token) {
        setAdminReportsError('Enter admin token to dismiss reports.');
        return;
      }
      setAdminDismissPendingByPost((prev) => ({ ...prev, [postId]: true }));
      try {
        const res = await apiFetch(
          '/internal/admin/fmk/reports/dismiss',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ postId }),
          },
          { tenantId: INITIAL_TENANT, adminToken: token }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as AdminDismissPostReportsResponse;
        setAdminReports((prev) => prev.filter((item) => item.postId !== postId));
        showToast({
          text: `Dismissed ${data.dismissedReportCount} report(s).`,
          appearance: 'success',
        });
        await loadAdminReportedPosts(adminReportsPage);
      } catch (err) {
        console.error('Failed to dismiss reports', err);
        setAdminReportsError(
          err instanceof Error ? err.message : 'Could not dismiss these reports right now.'
        );
      } finally {
        setAdminDismissPendingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    [adminReportsPage, adminToken, loadAdminReportedPosts]
  );

  const handleAdminUpdatePostType = useCallback(
    async (postId: string): Promise<void> => {
      const token = adminToken.trim();
      if (!token) {
        setAdminReportsError('Enter admin token to update post type.');
        return;
      }
      const requestedType = adminTypeByPost[postId] ?? FMK_DEFAULT_POST_TYPE;
      setAdminTypePendingByPost((prev) => ({ ...prev, [postId]: true }));
      try {
        const res = await apiFetch(
          '/internal/admin/fmk/posts/type',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ postId, type: requestedType }),
          },
          { tenantId: INITIAL_TENANT, adminToken: token }
        );
        if (!res.ok) {
          const data = (await res.json().catch(() => null)) as ErrorResponse | null;
          throw new Error(data?.message ?? `HTTP ${res.status}`);
        }
        const data = (await res.json()) as AdminUpdatePostTypeResponse;
        const normalizedType = normalizeFMKPostType(data.type);
        setAdminReports((prev) =>
          prev.map((item) => (item.postId === postId ? { ...item, type: normalizedType } : item))
        );
        setAdminTypeByPost((prev) => ({ ...prev, [postId]: normalizedType }));
        setBrowsePosts((prev) => {
          const updated = prev.map((post) =>
            post.postId === postId ? { ...post, type: normalizedType } : post
          );
          return browseType === normalizedType
            ? updated
            : updated.filter((post) => post.postId !== postId);
        });
        showToast({
          text: `Post type updated to ${toPostTypeLabel(normalizedType)}.`,
          appearance: 'success',
        });
      } catch (err) {
        console.error('Failed to update post type', err);
        setAdminReportsError(
          err instanceof Error ? err.message : 'Could not update this post type right now.'
        );
      } finally {
        setAdminTypePendingByPost((prev) => {
          const { [postId]: _ignored, ...next } = prev;
          return next;
        });
      }
    },
    [adminToken, adminTypeByPost, browseType]
  );

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      if (tournamentChoiceAdvanceTimerRef.current != null) {
        window.clearTimeout(tournamentChoiceAdvanceTimerRef.current);
        tournamentChoiceAdvanceTimerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    viewRef.current = view;
  }, [view]);

  useEffect(() => {
    if (loading) return;
    trackAnalyticsEvent('page_view', { view });
  }, [loading, trackAnalyticsEvent, view]);

  useEffect(() => {
    const flushBeforeExit = () => flushAnalytics(true);
    const flushWhenHidden = () => {
      if (document.visibilityState === 'hidden') {
        flushAnalytics(true);
      }
    };
    document.addEventListener('visibilitychange', flushWhenHidden);
    window.addEventListener('pagehide', flushBeforeExit);
    return () => {
      document.removeEventListener('visibilitychange', flushWhenHidden);
      window.removeEventListener('pagehide', flushBeforeExit);
      if (analyticsFlushTimerRef.current) {
        window.clearTimeout(analyticsFlushTimerRef.current);
        analyticsFlushTimerRef.current = null;
      }
      flushAnalytics(true);
    };
  }, [flushAnalytics]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mediaQuery = window.matchMedia('(max-width: 639px)');
    const updateSlidingAdViewport = () => setIsSlidingAdMobileViewport(mediaQuery.matches);
    updateSlidingAdViewport();
    mediaQuery.addEventListener('change', updateSlidingAdViewport);
    return () => {
      mediaQuery.removeEventListener('change', updateSlidingAdViewport);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!BROWSE_POPUNDER_ADS_ENABLED) return;
    if (loading) return;
    if (view === 'browse') return;

    // Trigger-method=2 providers attach listeners to existing matching elements.
    // Wait until the interactive UI is rendered so browse trigger buttons exist.
    if (POPUNDER_DEBUG) {
      console.info('[POPUNDER DEBUG] Boot provider load', {
        userAgent: navigator.userAgent,
        width: window.innerWidth,
        loading,
        mobileTriggerCount: document.querySelectorAll('.fmk-popunder-trigger-browse-mobile').length,
        desktopTriggerCount: document.querySelectorAll('.fmk-popunder-trigger-browse-desktop')
          .length,
      });
    }

    const isMobileViewport = window.matchMedia('(max-width: 639px)').matches;
    const loader = isMobileViewport
      ? ensureMobilePopunderProviderLoaded()
      : ensureDesktopPopunderProviderLoaded();
    void loader.catch((error) => {
      console.warn('Failed to load popunder provider', error);
    });
  }, [hasVoted, loading, revealActive, view]);

  useEffect(() => {
    if (!BROWSE_POPUNDER_ADS_ENABLED) return;
    if (typeof document === 'undefined' || !POPUNDER_DEBUG) return;
    const desktopEventName = `creativeDisplayed-${DESKTOP_POPUNDER_ZONE_ID}`;
    const mobileEventName = `creativeDisplayed-${MOBILE_POPUNDER_ZONE_ID}`;
    const onDesktopCreativeDisplayed = () => {
      console.info('[POPUNDER DEBUG] Desktop creativeDisplayed event fired');
      flushPendingBrowseAfterAd();
    };
    const onMobileCreativeDisplayed = () => {
      console.info('[POPUNDER DEBUG] Mobile creativeDisplayed event fired');
      flushPendingBrowseAfterAd();
    };
    document.addEventListener(desktopEventName, onDesktopCreativeDisplayed as EventListener);
    document.addEventListener(mobileEventName, onMobileCreativeDisplayed as EventListener);
    return () => {
      document.removeEventListener(desktopEventName, onDesktopCreativeDisplayed as EventListener);
      document.removeEventListener(mobileEventName, onMobileCreativeDisplayed as EventListener);
    };
  }, [flushPendingBrowseAfterAd]);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const resumePendingBrowse = () => {
      if (!pendingBrowseAfterAdRef.current) return;
      if (POPUNDER_DEBUG) {
        console.info('[POPUNDER DEBUG] Resume pending browse check', {
          visibilityState: document.visibilityState,
          href: window.location.href,
          pendingBrowseAfterAd: pendingBrowseAfterAdRef.current,
        });
      }
      if (document.visibilityState !== 'visible') return;
      const remainingMs = pendingBrowseAfterAdReadyAtRef.current - Date.now();
      if (remainingMs <= 0) {
        flushPendingBrowseAfterAd();
        return;
      }
      if (pendingBrowseAfterAdTimerRef.current != null) {
        window.clearTimeout(pendingBrowseAfterAdTimerRef.current);
      }
      pendingBrowseAfterAdTimerRef.current = window.setTimeout(() => {
        pendingBrowseAfterAdTimerRef.current = null;
        flushPendingBrowseAfterAd();
      }, remainingMs);
    };

    document.addEventListener('visibilitychange', resumePendingBrowse);
    window.addEventListener('focus', resumePendingBrowse);
    window.addEventListener('pageshow', resumePendingBrowse);
    return () => {
      document.removeEventListener('visibilitychange', resumePendingBrowse);
      window.removeEventListener('focus', resumePendingBrowse);
      window.removeEventListener('pageshow', resumePendingBrowse);
      if (pendingBrowseAfterAdTimerRef.current != null) {
        window.clearTimeout(pendingBrowseAfterAdTimerRef.current);
        pendingBrowseAfterAdTimerRef.current = null;
      }
    };
  }, [flushPendingBrowseAfterAd]);

  useEffect(() => {
    if (loading && view === 'poll' && selectedGameId && hasFreshBrowseNavIntent()) {
      if (POPUNDER_DEBUG) {
        console.info('[POPUNDER DEBUG] Restoring browse navigation intent after reload', {
          selectedGameId,
          href: window.location.href,
          visibilityState: document.visibilityState,
        });
      }
      openBrowseView('restored-browse-intent');
      return;
    }
  }, [loading, openBrowseView, selectedGameId, view]);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!BROWSE_POPUNDER_ADS_ENABLED) return;

    const resolveBrowseTrigger = (event: Event): { isMobileTrigger: boolean } | null => {
      const selector = '.fmk-popunder-trigger-browse-mobile, .fmk-popunder-trigger-browse-desktop';
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (const entry of path) {
        if (!(entry instanceof HTMLElement)) continue;
        if (!entry.matches(selector)) continue;
        if (entry.dataset.fmkBrowseNav !== '1') continue;
        return {
          isMobileTrigger: entry.classList.contains('fmk-popunder-trigger-browse-mobile'),
        };
      }

      const rawTarget = event.target;
      const baseElement =
        rawTarget instanceof Element
          ? rawTarget
          : rawTarget instanceof Node
            ? rawTarget.parentElement
            : null;
      if (!(baseElement instanceof Element)) return null;
      const trigger = baseElement.closest(selector);
      if (!(trigger instanceof HTMLElement)) return null;
      if (trigger.dataset.fmkBrowseNav !== '1') return null;
      return {
        isMobileTrigger: trigger.classList.contains('fmk-popunder-trigger-browse-mobile'),
      };
    };

    const onPrime = (event: Event) => {
      const trigger = resolveBrowseTrigger(event);
      if (!trigger) return;
      primeBrowseAfterAd(
        trigger.isMobileTrigger ? 'window-capture-mobile' : 'window-capture-desktop',
        trigger.isMobileTrigger
      );
    };

    const onClick = (event: Event) => {
      const trigger = resolveBrowseTrigger(event);
      if (!trigger) return;
      openBrowseView(
        trigger.isMobileTrigger ? 'window-capture-mobile-click' : 'window-capture-desktop-click'
      );
    };

    window.addEventListener('pointerdown', onPrime, true);
    window.addEventListener('touchstart', onPrime, true);
    window.addEventListener('mousedown', onPrime, true);
    window.addEventListener('click', onClick, true);
    return () => {
      window.removeEventListener('pointerdown', onPrime, true);
      window.removeEventListener('touchstart', onPrime, true);
      window.removeEventListener('mousedown', onPrime, true);
      window.removeEventListener('click', onClick, true);
    };
  }, [openBrowseView, primeBrowseAfterAd]);

  useEffect(() => {
    if (!loading) {
      setShowLoadingRecovery(false);
      return;
    }
    const timer = window.setTimeout(() => {
      setShowLoadingRecovery(true);
      if (POPUNDER_DEBUG) {
        console.warn('[POPUNDER DEBUG] Loading recovery visible', {
          view,
          selectedGameId,
          href: window.location.href,
          visibilityState: document.visibilityState,
          pendingBrowseAfterAd: pendingBrowseAfterAdRef.current,
        });
      }
    }, 2500);
    return () => window.clearTimeout(timer);
  }, [loading, selectedGameId, view]);

  useEffect(() => {
    if (loading) return;
    if (
      view === 'browse' ||
      view === 'create' ||
      view === 'gallery' ||
      view === 'cards' ||
      view === 'packs' ||
      view === 'pack' ||
      view === 'battle' ||
      view === 'quests' ||
      view === 'shop' ||
      view === 'settings' ||
      view === 'tournament'
    ) {
      syncUrlToView(view);
    }
  }, [loading, syncUrlToView, view]);

  const showPollBannerAds = !loading && (view === 'poll' || view === 'tournament' || view === 'gallery');

  useEffect(() => {
    if (!showPollBannerAds) return;
    void ensurePollBannerProviderLoaded()
      .then(() => {
        window.setTimeout(() => {
          queuePollBannerServe();
        }, 0);
      })
      .catch((error) => {
        console.warn('Failed to load poll banner provider', error);
      });
  }, [showPollBannerAds, view]);

  useEffect(() => {
    if (
      view !== 'browse' &&
      view !== 'cards' &&
      view !== 'pack' &&
      view !== 'battle' &&
      view !== 'shop' &&
      view !== 'tournament'
    )
      return;
    setLoading(false);
  }, [view]);

  useEffect(() => {
    if (view !== 'browse') return;
    if (browseType === 'gay') {
      markGayBrowseVisitedThisSession();
    }
    void fetchBrowsePosts(browsePage, browseSort, browseType);
    void fetchTournamentSummary();
  }, [browsePage, browseSort, browseType, fetchBrowsePosts, fetchTournamentSummary, view]);

  useEffect(() => {
    if (view !== 'cards' && view !== 'packs' && view !== 'pack') return;
    void fetchCardCollection();
  }, [fetchCardCollection, view]);

  useEffect(() => {
    if (initialInterruptedPackRecoveryCheckedRef.current) return;
    if (loading) return;
    initialInterruptedPackRecoveryCheckedRef.current = true;
    if (view !== 'pack') return;
    const storedStep = getStoredCardTutorialStep();
    if (!storedStep || !isInterruptedCardTutorialStep(storedStep)) return;
    setPackOpeningPhase('idle');
    setPackRevealIndex(0);
    setPackCardFlying(false);
    setPackVideoReady(false);
    setPulledCards([]);
    syncUrlToView('packs');
    setView('packs');
  }, [loading, syncUrlToView, view]);

  useEffect(() => {
    if (view !== 'packs' || loading) return;
    void startCardTutorialIfNeeded({ entryView: 'packs' });
  }, [loading, startCardTutorialIfNeeded, view]);

  useEffect(() => {
    if (!isCardTutorialActive || !cardTutorialStep || !cardCollection) return;
    if (!isInterruptedCardTutorialStep(cardTutorialStep)) return;
    if (view === 'pack' && pulledCards.length > 0) return;

    setPackOpeningPhase('idle');
    setPackRevealIndex(0);
    setPackCardFlying(false);
    setPackVideoReady(false);
    setPulledCards([]);

    if (CARD_TUTORIAL_FIRST_PACK_INTERRUPTED_STEPS.includes(cardTutorialStep)) {
      if (cardCollection.openedPacks > 0 || cardCollection.cards.length >= 3) {
        syncUrlToView('cards');
        setView('cards');
        setCardTutorialStep('go_to_second_pack');
      } else {
        syncUrlToView('packs');
        setView('packs');
        setCardTutorialStep('intro_open_first_pack');
      }
      return;
    }

    if (CARD_TUTORIAL_SECOND_PACK_INTERRUPTED_STEPS.includes(cardTutorialStep)) {
      if (
        cardCollection.openedPacks > 1 ||
        cardCollection.cards.length >= CARD_TUTORIAL_REQUIRED_DECK_CARDS
      ) {
        syncUrlToView('cards');
        setView('cards');
        setCardTutorialStep('go_to_battle');
      } else {
        syncUrlToView('packs');
        setView('packs');
        setCardTutorialStep('open_second_pack');
      }
      return;
    }

    if (CARD_TUTORIAL_BATTLE_INTERRUPTED_STEPS.includes(cardTutorialStep)) {
      syncUrlToView('battle');
      setView('battle');
      setCardTutorialStep('start_first_battle');
    }
  }, [
    cardCollection,
    cardTutorialStep,
    isCardTutorialActive,
    pulledCards.length,
    setCardTutorialStep,
    syncUrlToView,
    view,
  ]);

  useEffect(() => {
    if (view !== 'battle') return;
    void fetchBattleState();
  }, [fetchBattleState, view]);

  useEffect(() => {
    if (view !== 'battle' || loading) return;
    void startCardTutorialIfNeeded({ entryView: 'battle' });
  }, [loading, startCardTutorialIfNeeded, view]);

  useEffect(() => {
    if (!isCardTutorialActive || view !== 'pack' || packOpeningPhase !== 'revealing') return;
    if (packRevealIndex !== 0) return;
    if (cardTutorialStep === 'opening_first_pack') {
      setCardTutorialStep('first_card_power');
    }
  }, [
    cardTutorialStep,
    isCardTutorialActive,
    packOpeningPhase,
    packRevealIndex,
    setCardTutorialStep,
    view,
  ]);

  useEffect(() => {
    if (!isCardTutorialActive || view !== 'pack' || packOpeningPhase !== 'complete') return;
    if (cardTutorialStep === 'finish_first_pack') {
      setCardTutorialStep('return_after_first_pack');
    } else if (cardTutorialStep === 'opening_second_pack') {
      setCardTutorialStep('return_after_second_pack');
    }
  }, [cardTutorialStep, isCardTutorialActive, packOpeningPhase, setCardTutorialStep, view]);

  useEffect(() => {
    if (
      !isCardTutorialActive ||
      (cardTutorialStep !== 'waiting_first_battle' && cardTutorialStep !== 'start_first_battle') ||
      view !== 'battle' ||
      battle?.status !== 'active' ||
      battleAnimating ||
      matchmakingActive
    ) {
      return;
    }
    setCardTutorialStep('battle_goal');
  }, [
    battle?.status,
    battleAnimating,
    cardTutorialStep,
    isCardTutorialActive,
    matchmakingActive,
    setCardTutorialStep,
    view,
  ]);

  useEffect(() => {
    if (
      !isCardTutorialActive ||
      cardTutorialStep !== 'free_play_first_battle' ||
      !battle ||
      battle.status !== 'active' ||
      cardTutorialAbilityTip
    ) {
      return;
    }
    const visibleAbilities = [...battle.player.active, ...battle.opponent.active]
      .map((card) => card?.ability)
      .filter((ability): ability is CardAbility => Boolean(ability));
    const nextAbility = visibleAbilities.find(
      (ability) => !cardTutorialSeenAbilities.includes(ability)
    );
    if (nextAbility) {
      setCardTutorialAbilityTip(nextAbility);
    }
  }, [
    battle,
    cardTutorialAbilityTip,
    cardTutorialSeenAbilities,
    cardTutorialStep,
    isCardTutorialActive,
  ]);

  useEffect(() => {
    if (!isCardTutorialActive || cardTutorialStep !== 'free_play_first_battle' || !battleResult) {
      return;
    }
    void completeCardTutorialIfNeeded();
  }, [battleResult, cardTutorialStep, completeCardTutorialIfNeeded, isCardTutorialActive]);

  useEffect(() => {
    if (!CARD_ECONOMY_MENU_ITEMS.some((item) => item.view === view)) return;
    void fetchShopState();
  }, [fetchShopState, view]);

  useEffect(() => {
    if (!CARD_ECONOMY_MENU_ITEMS.some((item) => item.view === view)) return;
    void fetchQuestsState();
  }, [fetchQuestsState, view]);

  useEffect(() => {
    if (view !== 'browse' && view !== 'tournament') return;
    const refresh = window.setInterval(() => {
      void fetchTournamentSummary();
      if (view === 'tournament') {
        void fetchTournamentPageData();
      }
    }, 60000);
    return () => window.clearInterval(refresh);
  }, [fetchTournamentPageData, fetchTournamentSummary, view]);

  useEffect(() => {
    if (view !== 'tournament') return;
    void fetchTournamentPageData();
  }, [fetchTournamentPageData, view]);

  useEffect(() => {
    if (view !== 'settings') return;
    if (!adminToken.trim()) return;
    void loadAdminReportedPosts(adminReportsPage);
    void loadAdminAnalyticsSummary(adminAnalyticsDays);
  }, [
    adminAnalyticsDays,
    adminReportsPage,
    adminToken,
    loadAdminAnalyticsSummary,
    loadAdminReportedPosts,
    view,
  ]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const runFetch = () => {
      if (signal.aborted) return;
      if (!selectedGameId) return;
      if (viewRef.current !== 'poll') return;
      if (POPUNDER_DEBUG) {
        console.info('[POPUNDER DEBUG] Boot poll fetch requested', {
          selectedGameId,
          view: viewRef.current,
          hasInFlightRequest: fmkInFlightRef.current != null,
          visibilityState: document.visibilityState,
        });
      }
      void fetchFMK(signal);
    };

    const onVisibility = () => {
      const visible = document.visibilityState === 'visible';
      setIsPageVisible(visible);
    };

    document.addEventListener('visibilitychange', onVisibility);
    setIsPageVisible(document.visibilityState === 'visible');
    // Only auto-load poll data on mount when a post is selected.
    runFetch();

    return () => {
      controller.abort();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [selectedGameId]);

  useEffect(() => {
    if (!funGalleryTrackRef.current) {
      funGalleryTrackRef.current = new Audio(funGalleryTrack);
      funGalleryTrackRef.current.loop = true;
    }
    if (!marryGalleryTrackRef.current) {
      marryGalleryTrackRef.current = new Audio(marryGalleryTrack);
      marryGalleryTrackRef.current.loop = true;
    }

    const funTrack = funGalleryTrackRef.current;
    const marryTrack = marryGalleryTrackRef.current;
    if (!funTrack || !marryTrack) return;

    const stopTracks = () => {
      funTrack.pause();
      marryTrack.pause();
    };

    if (view !== 'gallery' || isMuted || galleryType === 'kill') {
      stopTracks();
      return;
    }

    if (galleryType === 'fun') {
      marryTrack.pause();
      funTrack.currentTime = 0;
      void funTrack.play().catch(() => {});
    } else {
      funTrack.pause();
      marryTrack.currentTime = 0;
      void marryTrack.play().catch(() => {});
    }

    return () => {
      stopTracks();
    };
  }, [galleryType, isMuted, view]);

  useEffect(() => {
    setMuteReady(true);
  }, []);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevPosition = document.body.style.position;
    const prevWidth = document.body.style.width;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.position = prevPosition;
      document.body.style.width = prevWidth;
    };
  }, []);

  useEffect(() => {
    if (typeof Audio === 'undefined') return undefined;

    if (!pollAudioRef.current) {
      pollAudioRef.current = new Audio(pollVotingSound);
      pollAudioRef.current.loop = true;
    }

    if (!resultsAudioRef.current) {
      resultsAudioRef.current = new Audio(resultsDisplaySound);
      resultsAudioRef.current.loop = true;
    }

    if (!drumRollRef.current) {
      drumRollRef.current = new Audio(drumRollSound);
      drumRollRef.current.loop = false;
    }

    if (!funSoundRef.current) {
      funSoundRef.current = new Audio(funSound);
      funSoundRef.current.loop = false;
    }
    if (!marrySoundRef.current) {
      marrySoundRef.current = new Audio(marrySound);
      marrySoundRef.current.loop = false;
      marrySoundRef.current.volume = 1;
    }
    if (!killSoundRef.current) {
      killSoundRef.current = new Audio(killSound);
      killSoundRef.current.loop = false;
      killSoundRef.current.volume = 1;
    }

    void (async () => {
      try {
        if (!marryBufferRef.current) {
          marryBufferRef.current = await loadBuffer(marrySound);
        }
        if (!killBufferRef.current) {
          killBufferRef.current = await loadBuffer(killSound);
        }
      } catch (err) {
        console.warn('Audio decode failed', err);
      }
    })();

    if (!muteReady) return;
    const onPollScreen = view === 'poll' && !hasVoted && !loading && isPageVisible && !isMuted;
    const onRevealSlides = revealActive && hasVoted && !loading && isPageVisible && !isMuted;
    const onResults =
      view === 'poll' && hasVoted && !revealActive && !loading && isPageVisible && !isMuted;

    const nextAudio = onPollScreen
      ? pollAudioRef.current
      : onRevealSlides || onResults
        ? resultsAudioRef.current
        : null;

    if (activeAudioRef.current && activeAudioRef.current !== nextAudio) {
      activeAudioRef.current.pause();
      activeAudioRef.current.currentTime = 0;
    }

    if (nextAudio) {
      activeAudioRef.current = nextAudio;
      void nextAudio.play().catch(() => {
        /* autoplay may be blocked until user interacts */
      });
    } else {
      activeAudioRef.current = null;
    }

    return () => {
      if (activeAudioRef.current) {
        activeAudioRef.current.pause();
        activeAudioRef.current.currentTime = 0;
        activeAudioRef.current = null;
      }
    };
  }, [view, hasVoted, loading, revealActive, isPageVisible, isMuted, muteReady]);

  useEffect(() => {
    if (isMuted && activeAudioRef.current) {
      activeAudioRef.current.pause();
      activeAudioRef.current.currentTime = 0;
      activeAudioRef.current = null;
    }
    const audioEls = [
      pollAudioRef.current,
      resultsAudioRef.current,
      drumRollRef.current,
      funSoundRef.current,
      marrySoundRef.current,
      killSoundRef.current,
    ];
    audioEls.forEach((audio) => {
      if (audio) audio.muted = isMuted;
    });
    window.localStorage.setItem(MUTE_KEY, isMuted ? '1' : '0');
  }, [isMuted]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(ADMIN_TOKEN_KEY, adminToken.trim());
  }, [adminToken]);

  useEffect(() => {
    if (!revealActive) return;
    setRevealTextVisible(false);
    setRevealImageVisible(simplifyRevealAnimation);
    setCurtainPlaying(!simplifyRevealAnimation);
    setRevealSoundsPlayed((prev) => {
      if (Object.keys(prev).length === 0) return prev;
      return {};
    });
    const textTimer = window.setTimeout(
      () => setRevealTextVisible(true),
      simplifyRevealAnimation ? 0 : 80
    );
    const imageTimer = window.setTimeout(
      () => setRevealImageVisible(true),
      simplifyRevealAnimation ? 0 : 900
    );
    const autoAdvanceTimer = window.setTimeout(() => {
      advanceReveal();
    }, REVEAL_AUTO_MS);
    return () => {
      window.clearTimeout(textTimer);
      window.clearTimeout(imageTimer);
      window.clearTimeout(autoAdvanceTimer);
    };
  }, [revealStep, revealActive, simplifyRevealAnimation]);

  useEffect(() => {
    if (!revealActive) return;
    const syncCurtainSize = () => {
      const el = revealImageContainerRef.current;
      if (!el) return;
      setCurtainWidth(Math.max(240, Math.floor(el.clientWidth)));
      setCurtainHeight(Math.max(135, Math.floor(el.clientHeight)));
    };
    syncCurtainSize();
    const onResize = () => {
      syncCurtainSize();
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [revealStep, revealActive]);

  useEffect(() => {
    if (!revealActive) return;
    if (simplifyRevealAnimation) {
      setCurtainPlaying(false);
      return;
    }
    if (!drumRollRef.current) return;
    if (isMuted) return;
    drumRollRef.current.currentTime = 0;
    void drumRollRef.current.play().catch(() => {
      /* autoplay may be blocked */
    });
    setCurtainPlaying(true);
  }, [revealStep, revealActive, simplifyRevealAnimation]);

  useEffect(() => {
    if (!revealActive) return;
    const role = roleOrder[Math.min(revealStep, roleOrder.length - 1)] ?? 'f';
    if (revealSoundStepRef.current === revealStep) return;
    const delay = Math.max(0, REVEAL_AUTO_MS - ROLE_SOUND_LEAD_MS);
    const timer = window.setTimeout(() => {
      if (revealSoundStepRef.current === revealStep) return;
      const played = playRoleSound(role);
      if (played) {
        setRevealSoundsPlayed((prev) => ({ ...prev, [role]: true }));
        revealSoundStepRef.current = revealStep;
      }
    }, delay);
    return () => {
      window.clearTimeout(timer);
    };
  }, [revealStep, revealActive, revealSoundsPlayed]);

  useEffect(() => {
    if (!revealActive) return;
    setRevealPhrases((prev) => {
      const next: Partial<Record<keyof FMKAssignment, string>> = { ...prev };
      let changed = false;
      (roleOrder as Array<keyof FMKAssignment>).forEach((role) => {
        if (!next[role]) {
          next[role] = pickPhraseForRole(role);
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [revealActive]);

  useEffect(() => {
    if (view !== 'poll') return;
    if (!hasVoted || revealActive || levelEvent || cardPackUnlockPrompt) return;
    if (!pendingCardPackUnlockPrompt) return;
    setCardPackUnlockPrompt(pendingCardPackUnlockPrompt);
    setPendingCardPackUnlockPrompt(null);
  }, [cardPackUnlockPrompt, hasVoted, levelEvent, pendingCardPackUnlockPrompt, revealActive, view]);

  useEffect(() => {
    if (!faceCropSrc) {
      setFaceCropImage(null);
      return;
    }
    const image = new Image();
    image.onload = () => setFaceCropImage(image);
    image.src = faceCropSrc;
  }, [faceCropSrc]);

  const getCropMetrics = useCallback((image: HTMLImageElement, scale: number) => {
    const baseScale = Math.max(FACE_CROP_SIZE / image.width, FACE_CROP_SIZE / image.height);
    const displayScale = baseScale * scale;
    const drawWidth = image.width * displayScale;
    const drawHeight = image.height * displayScale;
    return { displayScale, drawWidth, drawHeight };
  }, []);

  const clampCropOffset = useCallback(
    (offset: { x: number; y: number }, image: HTMLImageElement, scale: number) => {
      const { drawWidth, drawHeight } = getCropMetrics(image, scale);
      const maxX = Math.max(0, (drawWidth - FACE_CROP_SIZE) / 2);
      const maxY = Math.max(0, (drawHeight - FACE_CROP_SIZE) / 2);
      return {
        x: Math.min(maxX, Math.max(-maxX, offset.x)),
        y: Math.min(maxY, Math.max(-maxY, offset.y)),
      };
    },
    [getCropMetrics]
  );

  useEffect(() => {
    if (!faceCropImage) return;
    setFaceCropOffset((prev) => clampCropOffset(prev, faceCropImage, faceCropScale));
  }, [faceCropImage, faceCropScale, clampCropOffset]);

  const updateSlot = (index: number, updater: Partial<SlotInput>) => {
    setSlots((prev) => prev.map((slot, i) => (i === index ? { ...slot, ...updater } : slot)));
  };

  const openFaceCrop = (index: number) => {
    const slot = slots[index];
    if (!slot || slot.kind !== 'image' || !slot.value) return;
    setFaceCropSlotIndex(index);
    setFaceCropSrc(slot.value);
    setFaceCropScale(1);
    setFaceCropOffset({ x: 0, y: 0 });
  };

  const closeFaceCrop = () => {
    setFaceCropSlotIndex(null);
    setFaceCropSrc(null);
    setFaceCropImage(null);
    setFaceCropScale(1);
    setFaceCropOffset({ x: 0, y: 0 });
  };

  const saveFaceCrop = () => {
    if (faceCropSlotIndex === null || !faceCropImage) return;
    const { drawWidth, drawHeight } = getCropMetrics(faceCropImage, faceCropScale);
    const canvas = document.createElement('canvas');
    canvas.width = FACE_CROP_SIZE;
    canvas.height = FACE_CROP_SIZE;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const x = FACE_CROP_SIZE / 2 - drawWidth / 2 + faceCropOffset.x;
    const y = FACE_CROP_SIZE / 2 - drawHeight / 2 + faceCropOffset.y;
    ctx.clearRect(0, 0, FACE_CROP_SIZE, FACE_CROP_SIZE);
    ctx.save();
    ctx.beginPath();
    ctx.arc(FACE_CROP_SIZE / 2, FACE_CROP_SIZE / 2, FACE_CROP_SIZE / 2, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(faceCropImage, x, y, drawWidth, drawHeight);
    ctx.restore();
    const faceValue = canvas.toDataURL('image/png');
    updateSlot(faceCropSlotIndex, { faceValue });
    closeFaceCrop();
  };

  const handleCropPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    if (!faceCropImage) return;
    event.preventDefault();
    faceCropDragRef.current = {
      startX: event.clientX,
      startY: event.clientY,
      originX: faceCropOffset.x,
      originY: faceCropOffset.y,
    };
    event.currentTarget.setPointerCapture(event.pointerId);
  };

  const handleCropPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    if (!faceCropImage || !faceCropDragRef.current) return;
    const { startX, startY, originX, originY } = faceCropDragRef.current;
    const next = clampCropOffset(
      { x: originX + (event.clientX - startX), y: originY + (event.clientY - startY) },
      faceCropImage,
      faceCropScale
    );
    setFaceCropOffset(next);
  };

  const handleCropPointerUp = () => {
    faceCropDragRef.current = null;
  };

  const compressImageForCreate = async (
    file: File
  ): Promise<{ value: string; sizeBytes: number }> => {
    const image = await loadImageElement(file);
    const initialScale = Math.min(1, MAX_IMAGE_DIMENSION / Math.max(image.width, image.height));
    let targetWidth = Math.max(1, Math.round(image.width * initialScale));
    let targetHeight = Math.max(1, Math.round(image.height * initialScale));

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Image compression is not available in this browser.');

    let encoded = '';
    for (let resizeAttempt = 0; resizeAttempt < MAX_RESIZE_ATTEMPTS; resizeAttempt += 1) {
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      ctx.clearRect(0, 0, targetWidth, targetHeight);
      ctx.drawImage(image, 0, 0, targetWidth, targetHeight);

      let quality = 0.86;
      encoded = canvas.toDataURL('image/jpeg', quality);
      for (
        let qualityAttempt = 0;
        qualityAttempt < MAX_IMAGE_QUALITY_ATTEMPTS;
        qualityAttempt += 1
      ) {
        const encodedBytes = utf8ByteLength(encoded);
        if (encodedBytes <= MAX_SLOT_IMAGE_PAYLOAD_BYTES) {
          return { value: encoded, sizeBytes: encodedBytes };
        }
        quality = Math.max(MIN_IMAGE_QUALITY, quality - 0.1);
        encoded = canvas.toDataURL('image/jpeg', quality);
      }

      targetWidth = Math.max(1, Math.round(targetWidth * 0.85));
      targetHeight = Math.max(1, Math.round(targetHeight * 0.85));
    }

    const encodedBytes = utf8ByteLength(encoded);
    if (encodedBytes > MAX_SLOT_IMAGE_PAYLOAD_BYTES) {
      throw new Error('Image still too large after compression. Choose a smaller image.');
    }
    return { value: encoded, sizeBytes: encodedBytes };
  };

  const handleFile = async (index: number, file: File) => {
    try {
      const { value, sizeBytes } = await compressImageForCreate(file);
      updateSlot(index, { value, kind: 'image', sizeBytes, faceValue: '' });
      setError(null);
    } catch (err) {
      console.error('Image preparation failed', err);
      setError(err instanceof Error ? err.message : 'Failed to process image.');
    }
  };

  const handleDropFile = (index: number, files: FileList | null) => {
    const file = files?.[0];
    if (file) {
      void handleFile(index, file);
    }
  };

  const triggerFileSelect = (index: number) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => handleDropFile(index, (e.target as HTMLInputElement).files);
    input.click();
  };

  const submitCreate = async () => {
    if (!requireReadyUserAction('create posts')) return;
    setCreateTitleTouched(true);
    if (createTitleInvalid) {
      setError('Title post is required.');
      return;
    }
    setCreating(true);
    setError(null);
    setAward(null);
    setPostedAs(null);
    setPostedAsReason(null);
    try {
      const invalidSlotIndex = slots.findIndex((slot) => {
        if (slot.kind === 'image') {
          return !slot.value.trim() || !slot.faceValue;
        }
        return !slot.value.trim();
      });

      if (invalidSlotIndex !== -1) {
        setCurrentCreateSlot(invalidSlotIndex);
        const invalidSlot = slots[invalidSlotIndex];
        if (invalidSlot && invalidSlot.kind === 'image') {
          setCreateFacePromptOpen(true);
        } else {
          setError('Fill all three slots with an image or text value.');
        }
        setCreating(false);
        return;
      }

      const payload = buildCreatePayload(slots, createTitleTrimmed, createPostType);
      const estimatedPayloadBytes = estimateCreatePayloadBytes(
        slots,
        createTitleTrimmed,
        createPostType
      );
      if (estimatedPayloadBytes > MAX_CREATE_PAYLOAD_BYTES) {
        throw new Error(
          `Create payload too large (${formatMb(estimatedPayloadBytes)}). Keep total under ${formatMb(MAX_CREATE_PAYLOAD_BYTES)}.`
        );
      }
      const res = await apiFetch(
        '/api/fmk',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const serverRequestId = res.headers.get('x-fmk-request-id') ?? 'server-unknown';
        let fallbackMessage = `HTTP ${res.status}`;
        if (res.status === 413) {
          fallbackMessage = `Images are too large for Reddit webview limits. Keep total under ${formatMb(MAX_CREATE_PAYLOAD_BYTES)}.`;
        } else if (res.status >= 500) {
          fallbackMessage = 'Server could not create the post. Please retry with smaller images.';
        }
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        console.error('[FMK] POST /api/fmk failed', {
          serverRequestId,
          status: res.status,
          payloadBytes: estimatedPayloadBytes,
          responseBody: data,
        });
        throw new Error(data?.message ?? fallbackMessage);
      }
      const data: CreateFMKResponse = await res.json();
      setPostedAs(data.postedAs);
      setPostedAsReason(data.postedAsReason ?? null);
      setEntry(data.entry);
      setSelectedGameId(data.entry.id);
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('gameId', data.entry.id);
      if (INITIAL_TENANT) {
        nextUrl.searchParams.set('tenantId', INITIAL_TENANT);
      }
      window.history.replaceState(null, '', nextUrl.toString());
      setPercentages(emptyPercentages());
      setHasVoted(false);
      handleLevelUpdate(data.gainedXp, data.userLevel, data.xpReason);
      resetAssignment();
      setCreateTitle('');
      setCreatePostType(FMK_DEFAULT_POST_TYPE);
      setCreateTitleTouched(false);
      window.localStorage.removeItem(assignmentStorageKey(data.entry.id));
      setFunPromptOpen(false);
      setPendingFunSlot(null);
      setGooGameSlot(null);
      trackAnalyticsEvent('create_submit_success', {
        postId: data.entry.id,
        type: data.entry.type ?? FMK_DEFAULT_POST_TYPE,
      });
      setView('poll');
    } catch (err) {
      console.error('Create failed', err);
      setError(err instanceof Error ? err.message : 'Failed to create poll');
    } finally {
      setCreating(false);
    }
  };

  const handleDrop = (role: keyof FMKAssignment, slotId?: string | null) => {
    if (!slotId) return;
    setAssignment((prev) => {
      const updated: FMKAssignment = { ...prev };
      (['f', 'm', 'k'] as Array<keyof FMKAssignment>).forEach((r) => {
        if (updated[r] === slotId) updated[r] = '';
      });
      updated[role] = slotId;
      return updated;
    });
    setDragOverRole(null);
    setDragging(null);
    setSelectedSlotId(null);
    spawnParticles(role);
    playPollAudio();
  };

  const unassignRole = (role: keyof FMKAssignment) => {
    setAssignment((prev) => ({ ...prev, [role]: '' }));
    setDragOverRole((prev) => (prev === role ? null : prev));
    setSelectedSlotId(null);
  };

  const goToPreviousRole = () => {
    trackAnalyticsEvent('result_role_previous', { role: currentResultRole });
    setCurrentResultRole((prev) => roleOrder[Math.max(0, roleOrder.indexOf(prev) - 1)] ?? prev);
  };

  const goToNextRole = () => {
    trackAnalyticsEvent('result_role_next', { role: currentResultRole });
    setCurrentResultRole(
      (prev) => roleOrder[Math.min(roleOrder.length - 1, roleOrder.indexOf(prev) + 1)] ?? prev
    );
  };

  const startRevealSequence = () => {
    setRevealActive(true);
    setRevealStep(0);
    setRevealPhrases({
      f: pickPhraseForRole('f'),
      m: pickPhraseForRole('m'),
      k: pickPhraseForRole('k'),
    });
    setRevealSoundsPlayed({});
    revealSoundStepRef.current = null;
  };

  const advanceReveal = () => {
    if (revealStep >= roleOrder.length - 1) {
      setRevealActive(false);
      return;
    }
    setRevealStep((prev) => Math.min(roleOrder.length - 1, prev + 1));
  };

  const handleVote = async () => {
    if (!entry) return;
    if (!requireParticipantIdentity('vote')) return;
    if (!isCompleteAssignment(assignment, entry.slots)) {
      setError('Place each option into F, M, and K.');
      return;
    }
    const votedFunSlot = getAssignedFunImageSlot(entry, assignment);
    setVoting(true);
    setError(null);
    setAward(null);
    setCardPackUnlockPrompt(null);
    setPendingCardPackUnlockPrompt(null);
    try {
      const res = await apiFetch(
        '/api/fmk/vote',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ assignment }),
        },
        { gameId: selectedGameId || entry.id, tenantId: INITIAL_TENANT }
      );
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        if (res.status === 409) {
          setHasVoted(true);
        }
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data: VoteResponse = await res.json();
      setPercentages(data.percentages);
      setHasVoted(true);
      setAward(data.award);
      setTotalVotes(data.totalVotes);
      if (data.cardPackUnlockPrompt && data.cardPackUnlockPrompt.unopenedPacks > 0) {
        setPendingFunSlot(null);
        setFunPromptOpen(false);
        setPendingCardPackUnlockPrompt(data.cardPackUnlockPrompt);
      } else {
        setPendingFunSlot(votedFunSlot);
        setFunPromptOpen(false);
      }
      handleLevelUpdate(data.gainedXp, data.userLevel, data.xpReason);
      if (data.marryGallery) {
        setMarryGallery(data.marryGallery);
      }
      if (data.funGallery) {
        setFunGallery(data.funGallery);
      }
      if (data.killGallery) {
        setKillGallery(data.killGallery);
      }
      trackAnalyticsEvent('poll_vote_submit', { postId: entry.id });
      setCurrentResultRole('f');
      startRevealSequence();
      window.localStorage.setItem(
        assignmentStorageKey(entry.id),
        JSON.stringify({ assignment, votedAt: Date.now() })
      );
    } catch (err) {
      console.error('Vote failed', err);
      setError(err instanceof Error ? err.message : 'Failed to submit vote');
    } finally {
      setVoting(false);
    }
  };

  const showReveal = revealActive && hasVoted;
  const canViewPollResults = hasVoted;
  const declineFunPrompt = () => {
    setFunPromptOpen(false);
    setPendingFunSlot(null);
  };
  const acceptFunPrompt = () => {
    if (!pendingFunSlot) {
      declineFunPrompt();
      return;
    }
    const postId = selectedGameId || entry?.id || '';
    setGooRewardPostId(postId || null);
    setGooGameSlot(pendingFunSlot);
    setPendingFunSlot(null);
    setFunPromptOpen(false);
    trackAnalyticsEvent('goo_game_start', { postId });
    setView('gooGame');
  };
  const rewardGooExitXp = useCallback(async (postId: string) => {
    const res = await apiFetch(
      '/api/goo/exit/reward',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postId } satisfies GooExitRewardRequest),
      },
      { tenantId: INITIAL_TENANT }
    );
    if (!res.ok) {
      const data = (await res.json().catch(() => null)) as ErrorResponse | null;
      throw new Error(data?.message ?? `HTTP ${res.status}`);
    }
    return (await res.json()) as GooExitRewardResponse;
  }, []);
  const backToPollResults = useCallback(() => {
    const currentPostId = gooRewardPostId;
    const shouldPrimeMobile = window.matchMedia('(max-width: 639px)').matches;
    if (shouldPrimeMobile) {
      primeMobileGooExitAfterAd();
    } else {
      primeDesktopGooExitAfterAd();
    }

    setView('poll');
    setGooGameSlot(null);
    setGooRewardPostId(null);
    trackAnalyticsEvent(
      'goo_done_press',
      { postId: currentPostId ?? '' },
      { flush: true, preferBeacon: true }
    );

    if (!currentPostId) return;
    void rewardGooExitXp(currentPostId)
      .then((data) => {
        if (data.awarded && data.gainedXp > 0) {
          trackAnalyticsEvent('goo_reward_awarded', { postId: currentPostId }, { flush: true });
          handleLevelUpdate(data.gainedXp, data.userLevel, data.xpReason ?? GOO_EXIT_XP_REASON);
        } else if (data.userLevel) {
          setUserLevel(data.userLevel);
        }
      })
      .catch((error) => {
        console.warn('Failed to award goo mini game xp', error);
      });
  }, [
    gooRewardPostId,
    handleLevelUpdate,
    primeDesktopGooExitAfterAd,
    primeMobileGooExitAfterAd,
    rewardGooExitXp,
    trackAnalyticsEvent,
  ]);
  const createBlocked = !isAuthenticated || !hasProfileUsername;
  const canWriteBrowseComments = isAuthenticated && hasProfileUsername;
  const tournamentEntrantMap = useMemo(
    () => buildTournamentEntrantMap(tournamentSummary?.entrants ?? []),
    [tournamentSummary?.entrants]
  );
  const tournamentCountdown = formatCountdown(getTournamentCountdownMs(tournamentSummary, nowMs));
  const tournamentRoundCountdown = formatCountdown(
    getTournamentRoundCountdownMs(tournamentSummary, nowMs)
  );
  const tournamentDecisionSteps = useMemo(
    () =>
      tournamentRound
        ? tournamentRound.pairs.map((pair, pairIndex) => ({
            category: tournamentRound.category,
            pair,
            pairIndex,
          }))
        : [],
    [tournamentRound]
  );
  const currentTournamentDecisionIndex = tournamentDecisionSteps.findIndex(
    (step) => !tournamentVoteSelections[step.pair.pairKey]
  );
  const currentTournamentDecision =
    currentTournamentDecisionIndex >= 0
      ? tournamentDecisionSteps[currentTournamentDecisionIndex]
      : null;
  const tournamentChoiceInProgress = tournamentPendingChoice != null;
  const tournamentSelectionsComplete =
    tournamentRound != null &&
    tournamentRound.pairs.every((pair) => Boolean(tournamentVoteSelections[pair.pairKey]));
  useEffect(() => {
    if (!tournamentRound) return;
    if (tournamentHasVoted) return;
    if (pendingTournamentVoteResult) return;
    if (!tournamentSelectionsComplete) return;
    if (tournamentChoiceInProgress || tournamentSubmitting) return;
    void handleTournamentVoteSubmit();
  }, [
    handleTournamentVoteSubmit,
    pendingTournamentVoteResult,
    tournamentChoiceInProgress,
    tournamentHasVoted,
    tournamentRound,
    tournamentSelectionsComplete,
    tournamentSubmitting,
  ]);
  const browseAdSrcDoc = useMemo(() => buildBrowseAdSrcDoc(), []);
  const browseDisplayItems = useMemo<BrowseDisplayItem[]>(() => {
    if (browsePosts.length === 0) return [];
    const items: BrowseDisplayItem[] = [];
    let postIndex = 0;
    for (let slotIndex = 1; slotIndex <= browsePosts.length; slotIndex += 1) {
      if (slotIndex % BROWSE_AD_EVERY_NTH_SLOT === 0) {
        items.push({ kind: 'ad', slotIndex });
        continue;
      }
      const post = browsePosts[postIndex];
      if (!post) break;
      items.push({ kind: 'post', post });
      postIndex += 1;
    }
    return items;
  }, [browsePosts]);
  const createTitleTrimmed = createTitle.trim();
  const createTitleInvalid = createTitleTrimmed.length === 0;
  const hasUploadedImage = slots.some((slot) => slot.kind === 'image' && slot.value);
  const currentRevealRole = roleOrder[Math.min(revealStep, roleOrder.length - 1)] ?? 'f';
  const currentWinner = getTopSlotForRole(currentRevealRole);
  const currentWinnerSlot: FMKSlot | null = currentWinner?.slot ?? null;
  const currentWinnerPercent = currentWinner?.percent ?? 0;
  const currentWinnerImage =
    currentWinnerSlot && currentWinnerSlot.kind === 'image' ? currentWinnerSlot.value : '';
  const showSlidingVideoAd =
    view === 'browse' || (view === 'gooGame' && !isSlidingAdMobileViewport);
  const slidingVideoAdBlockedTypes =
    view === 'browse' && (browseType === 'gay' || browseType === 'trans')
      ? '0'
      : SLIDING_VIDEO_AD_BLOCKED_TYPES;
  const currentWinnerLabel = (() => {
    if (!currentWinnerSlot) return 'Top option';
    if (currentWinnerSlot.kind === 'text')
      return currentWinnerSlot.value || currentWinnerSlot.label || 'Top option';
    return currentWinnerSlot.label || 'Top option';
  })();
  const currentPhrase = revealPhrases[currentRevealRole] ?? '';
  const composeShareImage = useCallback(async (currentEntry: FMKEntry): Promise<string> => {
    const canvas = document.createElement('canvas');
    canvas.width = SHARE_CANVAS_WIDTH;
    canvas.height = SHARE_CANVAS_HEIGHT;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Image generation is not supported in this browser.');
    }

    let titleGraphic: HTMLImageElement | null = null;
    let vsGraphic: HTMLImageElement | null = null;
    try {
      titleGraphic = await loadImageFromUrl(titleImage);
    } catch {
      titleGraphic = null;
    }
    try {
      vsGraphic = await loadImageFromUrl(vsAsset);
    } catch {
      vsGraphic = null;
    }

    const slotGraphics = await Promise.all(
      currentEntry.slots.map(async (slot) => {
        if (slot.kind !== 'image' || !slot.value.trim()) return null;
        try {
          return await loadImageFromUrl(slot.value);
        } catch {
          return null;
        }
      })
    );

    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    gradient.addColorStop(0, '#210035');
    gradient.addColorStop(1, '#4f007f');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const titleBounds = {
      x: SHARE_OUTER_PADDING,
      y: SHARE_OUTER_PADDING / 2,
      width: canvas.width - SHARE_OUTER_PADDING * 2,
      height: SHARE_HEADER_HEIGHT,
    };

    if (titleGraphic) {
      drawImageContain(
        ctx,
        titleGraphic,
        titleBounds.x,
        titleBounds.y,
        titleBounds.width,
        titleBounds.height
      );
    } else {
      ctx.fillStyle = '#ffffff';
      ctx.font = '900 84px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('F.M.K', canvas.width / 2, titleBounds.y + titleBounds.height / 2);
    }

    const rowY = titleBounds.y + titleBounds.height + SHARE_ROW_GAP;
    const rowHeight = canvas.height - rowY - SHARE_OUTER_PADDING;
    const cardWidth = Math.floor((canvas.width - SHARE_OUTER_PADDING * 2) / 3);

    currentEntry.slots.forEach((slot, index) => {
      const cardX = SHARE_OUTER_PADDING + index * cardWidth;
      const cardY = rowY;
      const cardHeight = rowHeight;
      const imageAreaX = cardX + SHARE_CARD_BORDER;
      const imageAreaY = cardY + SHARE_CARD_BORDER;
      const imageAreaWidth = cardWidth - SHARE_CARD_BORDER * 2;
      const imageAreaHeight = cardHeight - SHARE_CARD_BORDER * 2 - SHARE_CARD_LABEL_HEIGHT;

      ctx.fillStyle = '#160026';
      ctx.fillRect(cardX, cardY, cardWidth, cardHeight);
      ctx.strokeStyle = '#fdc500';
      ctx.lineWidth = SHARE_CARD_BORDER;
      ctx.strokeRect(
        cardX + SHARE_CARD_BORDER / 2,
        cardY + SHARE_CARD_BORDER / 2,
        cardWidth - SHARE_CARD_BORDER,
        cardHeight - SHARE_CARD_BORDER
      );

      const loadedGraphic = slotGraphics[index];
      if (loadedGraphic) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(imageAreaX, imageAreaY, imageAreaWidth, imageAreaHeight);
        ctx.clip();
        drawImageCover(ctx, loadedGraphic, imageAreaX, imageAreaY, imageAreaWidth, imageAreaHeight);
        ctx.restore();
      } else {
        const fallbackLabel = slot.label?.trim() || `Option ${index + 1}`;
        drawShareFallbackCard(
          ctx,
          imageAreaX,
          imageAreaY,
          imageAreaWidth,
          imageAreaHeight,
          fallbackLabel
        );
      }

      const labelY = imageAreaY + imageAreaHeight;
      ctx.fillStyle = '#510087';
      ctx.fillRect(imageAreaX, labelY, imageAreaWidth, SHARE_CARD_LABEL_HEIGHT);
      ctx.strokeStyle = '#fdc500';
      ctx.lineWidth = 2;
      ctx.strokeRect(imageAreaX + 1, labelY + 1, imageAreaWidth - 2, SHARE_CARD_LABEL_HEIGHT - 2);
      const labelText =
        slot.label?.trim() || (slot.kind === 'text' ? slot.value.trim() : `Option ${index + 1}`);
      ctx.fillStyle = '#ffffff';
      ctx.font = '700 28px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(
        labelText || `Option ${index + 1}`,
        imageAreaX + imageAreaWidth / 2,
        labelY + SHARE_CARD_LABEL_HEIGHT / 2,
        imageAreaWidth - 16
      );
    });

    const seamCenters = [SHARE_OUTER_PADDING + cardWidth, SHARE_OUTER_PADDING + cardWidth * 2];
    seamCenters.forEach((seamX) => {
      if (vsGraphic) {
        const targetWidth = Math.min(SHARE_VS_MAX_WIDTH, Math.round(cardWidth * SHARE_VS_SCALE));
        const targetHeight = Math.round(targetWidth * (vsGraphic.height / vsGraphic.width));
        const drawX = seamX - targetWidth / 2;
        const drawY = rowY + rowHeight / 2 - targetHeight / 2;
        ctx.drawImage(vsGraphic, drawX, drawY, targetWidth, targetHeight);
      } else {
        const radius = 56;
        const centerY = rowY + rowHeight / 2;
        ctx.fillStyle = '#fdc500';
        ctx.beginPath();
        ctx.arc(seamX, centerY, radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#5c0099';
        ctx.font = '900 52px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('VS', seamX, centerY);
      }
    });

    // Add a subtle call-to-action footer for shared images.
    ctx.fillStyle = '#fdc500';
    ctx.font = `700 ${SHARE_FOOTER_FONT_SIZE}px sans-serif`;
    ctx.textAlign = 'right';
    ctx.textBaseline = 'bottom';
    ctx.shadowColor = 'rgba(0, 0, 0, 0.55)';
    ctx.shadowBlur = 2;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 1;
    ctx.fillText(
      SHARE_FOOTER_TEXT,
      canvas.width - SHARE_FOOTER_PADDING_X,
      canvas.height - SHARE_FOOTER_PADDING_Y
    );
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    try {
      return canvas.toDataURL('image/png');
    } catch {
      throw new Error('Could not export image. One of the post images blocks canvas sharing.');
    }
  }, []);

  const closeSharePreview = useCallback(() => {
    setSharePreviewImage(null);
    setSharePreviewUrl(null);
  }, []);

  const handleGenerateShareImage = useCallback(async () => {
    if (!entry) return;
    setShareGenerating(true);
    setShareError(null);
    try {
      const imageDataUrl = await composeShareImage(entry);
      setSharePreviewImage(imageDataUrl);
      setSharePreviewUrl(null);
      showToast({ text: 'Share image generated', appearance: 'success' });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to generate share image.';
      setShareError(message);
      showToast({ text: message });
    } finally {
      setShareGenerating(false);
    }
  }, [composeShareImage, entry]);

  const createSharePreviewLink = useCallback(async (): Promise<string> => {
    if (!sharePreviewImage) throw new Error('Generate a share image first.');
    const shareTitle = entry?.title?.trim() || 'Play F.M.K';
    const gameIdForHeaders = selectedGameId || entry?.id || null;
    if (!gameIdForHeaders) {
      throw new Error('Could not determine game id for sharing.');
    }
    const sourcePostUrl = buildCanonicalGameUrl({
      gameId: gameIdForHeaders,
      ...(INITIAL_TENANT ? { tenantId: INITIAL_TENANT } : {}),
    });
    const uploadRes = await apiFetch(
      '/api/share/upload',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          imageDataUrl: sharePreviewImage,
          sourcePostUrl,
          title: shareTitle,
        }),
      },
      {
        gameId: gameIdForHeaders,
        tenantId: INITIAL_TENANT,
      }
    );
    if (!uploadRes.ok) {
      const errorData = (await uploadRes.json().catch(() => null)) as ErrorResponse | null;
      throw new Error(errorData?.message ?? `HTTP ${uploadRes.status}`);
    }
    const uploadData = (await uploadRes.json()) as UploadShareImageResponse;
    setSharePreviewUrl(uploadData.shareUrl);
    return uploadData.shareUrl;
  }, [entry?.id, entry?.title, selectedGameId, sharePreviewImage]);

  const handleShareToReddit = useCallback(async () => {
    if (!sharePreviewImage) return;
    setSharePosting(true);
    setShareError(null);
    try {
      const shareTitle = entry?.title?.trim() || 'Play F.M.K';
      const shareUrl = sharePreviewUrl || (await createSharePreviewLink());
      const targetSubreddit = getRedditTargetSubreddit(entry?.type);
      const submitUrl = `https://www.reddit.com/r/${targetSubreddit}/submit/?type=LINK&title=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
      void navigator.clipboard?.writeText(shareUrl).catch(() => {});
      const newTab = window.open(submitUrl, '_blank', 'noopener,noreferrer');
      if (!newTab) {
        navigateTo(submitUrl);
      }
      showToast({
        text: 'Reddit submit opened and share preview link copied.',
        appearance: 'success',
      });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to open Reddit submit.';
      setShareError(message);
      showToast({ text: message });
    } finally {
      setSharePosting(false);
    }
  }, [createSharePreviewLink, entry?.title, entry?.type, sharePreviewImage, sharePreviewUrl]);

  const handleCopySourceLink = useCallback(async () => {
    try {
      const shareUrl = sharePreviewUrl || (await createSharePreviewLink());
      await navigator.clipboard.writeText(shareUrl);
      showToast({ text: 'Share preview link copied', appearance: 'success' });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Could not copy link automatically';
      setShareError(message);
      showToast({ text: message });
    }
  }, [createSharePreviewLink, sharePreviewUrl]);

  const closeTournamentSharePreview = useCallback(() => {
    setTournamentShareImage(null);
    setTournamentShareError(null);
  }, []);

  const handleGenerateTournamentShareImage = useCallback(async () => {
    if (!tournamentSummary || !tournamentBracket) return;
    setTournamentShareGenerating(true);
    setTournamentShareError(null);
    try {
      const imageDataUrl = await composeTournamentBracketShareImage({
        tournament: tournamentSummary,
        bracket: tournamentBracket,
        finalWinners: tournamentFinalWinners,
        entrantMap: tournamentEntrantMap,
      });
      setTournamentShareImage(imageDataUrl);
      showToast({ text: 'Tournament bracket image generated', appearance: 'success' });
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Failed to generate tournament bracket image.';
      setTournamentShareError(message);
      showToast({ text: message });
    } finally {
      setTournamentShareGenerating(false);
    }
  }, [tournamentBracket, tournamentEntrantMap, tournamentFinalWinners, tournamentSummary]);

  const handleCopyTournamentLink = useCallback(async () => {
    try {
      const tournamentUrl = buildGameViewUrl('tournament', INITIAL_TENANT || undefined);
      await navigator.clipboard.writeText(tournamentUrl);
      showToast({ text: 'Tournament link copied', appearance: 'success' });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Could not copy tournament link.';
      setTournamentShareError(message);
      showToast({ text: message });
    }
  }, []);

  const fetchLeaderboard = async () => {
    try {
      const res = await apiFetch('/api/leaderboard');
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as ErrorResponse | null;
        throw new Error(data?.message ?? `HTTP ${res.status}`);
      }
      const data = (await res.json()) as LeaderboardResponse;
      setLeaderboard(data.entries);
      setLeaderboardUserId(data.currentUserId);
    } catch (err) {
      console.error('Failed to load leaderboard', err);
      setError('Could not load leaderboard right now.');
    }
  };

  const openPostFromBrowse = async (postId: string) => {
    trackAnalyticsEvent('browse_open_post', { postId });
    setSelectedGameId(postId);
    setLoading(true);
    setFunPromptOpen(false);
    setPendingFunSlot(null);
    setGooGameSlot(null);
    setView('poll');
    await fetchFMK(undefined, 2, postId);
  };

  const createDragImage = (slot: FMKSlot, event: React.DragEvent<HTMLDivElement>) => {
    if (!event.dataTransfer) return;
    const preview = document.createElement('div');
    preview.style.position = 'absolute';
    preview.style.top = '-1000px';
    preview.style.left = '-1000px';
    preview.style.pointerEvents = 'none';
    preview.style.padding = '6px 8px';
    preview.style.border = '1px solid #510087';
    preview.style.borderRadius = '12px';
    preview.style.background = '#fff';
    preview.style.boxShadow = '0 8px 20px rgba(0,0,0,0.12)';
    preview.style.display = 'flex';
    preview.style.alignItems = 'center';
    preview.style.gap = '8px';
    preview.style.fontSize = '12px';
    preview.style.fontWeight = '700';
    preview.style.color = '#3b2f00';

    if (slot.kind === 'image' && slot.value) {
      const img = document.createElement('img');
      img.src = slot.value;
      img.alt = slot.label ?? 'drag preview';
      img.style.width = '40px';
      img.style.height = '40px';
      img.style.objectFit = 'contain';
      img.style.borderRadius = '8px';
      preview.appendChild(img);
    }

    const text = document.createElement('span');
    text.innerText = slot.label ?? 'Option';
    preview.appendChild(text);

    document.body.appendChild(preview);
    event.dataTransfer.setDragImage(preview, 20, 20);

    setTimeout(() => {
      if (preview.parentNode) {
        preview.parentNode.removeChild(preview);
      }
    }, 0);
  };

  const isFunGallery = galleryType === 'fun';
  const isKillGallery = galleryType === 'kill';
  const showStandardGallery = !isKillGallery;
  const activeGallery = showStandardGallery
    ? isFunGallery
      ? funGallery
      : marryGallery
    : EMPTY_GALLERY;
  const activeOutfits = isFunGallery ? funOutfits : outfits;
  const activeAvailableSlots = showStandardGallery
    ? isFunGallery
      ? funAvailableSlots
      : availableSlots
    : 0;
  const activeAffection = isFunGallery ? funCurrency.affection : currency.affection;
  const sharedCardCurrency = shopState?.currency ?? currency;
  const galleryDisplayGold = sharedCardCurrency.gold;
  const galleryDisplayGems = sharedCardCurrency.gems;
  const activeOutfitCatalog = isFunGallery ? funOutfitCatalog : marryOutfitCatalog;
  const activeOutfitSources = isFunGallery ? funOutfitSources : marryOutfitSources;
  const killGalleryItems = useMemo(
    () => killGallery.slice(Math.max(0, killGallery.length - galleryDisplayLimit)),
    [killGallery]
  );

  const formatKillCountdown = (ms: number) => {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const updateKillGameSize = useCallback(() => {
    const rect = killGameRef.current?.getBoundingClientRect();
    if (!rect) return;
    killGameSizeRef.current = { width: rect.width || 1, height: rect.height || 1 };
  }, []);

  const resetKillWaveVisuals = useCallback(() => {
    setKillEnemies([]);
    setKillBullets([]);
    setKillMisses(0);
    killEnemiesRef.current = [];
    killBulletsRef.current = [];
    killMissesRef.current = 0;
    killSpawnAccumulatorRef.current = 0;
  }, []);

  const playGunshot = useCallback(() => {
    if (isMuted) return;
    if (!gunshotSoundRef.current) {
      gunshotSoundRef.current = new Audio(gunshotSound);
    }
    gunshotSoundRef.current.currentTime = 0;
    void gunshotSoundRef.current.play().catch(() => {});
  }, [isMuted]);

  const playDeathSound = useCallback(() => {
    if (isMuted) return;
    if (!killSoundRef.current) {
      killSoundRef.current = new Audio(killSound);
    }
    killSoundRef.current.currentTime = 0;
    void killSoundRef.current.play().catch(() => {});
  }, [isMuted]);

  const startAirRaid = useCallback(() => {
    if (isMuted) return;
    if (!airRaidSoundRef.current) {
      airRaidSoundRef.current = new Audio(airRaidSound);
      airRaidSoundRef.current.loop = true;
    }
    airRaidSoundRef.current.currentTime = 0;
    void airRaidSoundRef.current.play().catch(() => {});
  }, [isMuted]);

  const stopAirRaid = useCallback(() => {
    if (!airRaidSoundRef.current) return;
    airRaidSoundRef.current.pause();
    airRaidSoundRef.current.currentTime = 0;
  }, []);

  const finishKillWave = useCallback(
    async (result: 'win' | 'lose') => {
      setKillWaveActive(false);
      setKillWavePopupOpen(true);
      setKillWaveEndsAt(null);
      setKillFlashVisible(false);
      stopAirRaid();
      resetKillWaveVisuals();
      try {
        const res = await apiFetch('/api/kill/complete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ result }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = (await res.json()) as KillWaveCompleteResponse;
        setKillWaveState(data.waveState ?? { waveNumber: 1, nextWaveAt: 0 });
        if (data.currency) {
          setCurrency(data.currency);
          setFunCurrency((prev) => ({
            ...prev,
            gold: data.currency.gold,
            gems: data.currency.gems,
          }));
          setShopState((prev) => (prev ? { ...prev, currency: data.currency } : prev));
          setQuestsState((prev) => (prev ? { ...prev, currency: data.currency } : prev));
          setDisplayGold(data.currency.gold);
          setPendingGoldTarget(null);
        }
        if (result === 'win') {
          setKillRewardAmount(Math.max(0, Math.floor(Number(data.rewardedGold ?? 0))));
          setKillRewardOpen(true);
        }
        trackAnalyticsEvent('kill_wave_complete', { galleryType: 'kill', result });
      } catch (err) {
        console.error('Failed to complete kill wave', err);
        setError('Could not complete the kill wave.');
      }
    },
    [resetKillWaveVisuals, stopAirRaid, trackAnalyticsEvent]
  );

  const startKillWave = useCallback(async () => {
    if (!killGalleryItems.length) {
      showToast({ text: 'No kill selections yet. Vote to add targets.' });
      return;
    }
    if (killTimeRemainingMs > 0) return;
    try {
      const res = await apiFetch('/api/kill/start', { method: 'POST' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json()) as KillWaveStartResponse;
      const startedAt = data.startedAt ?? Date.now();
      setKillWaveState(data.waveState ?? { waveNumber: 1, nextWaveAt: 0 });
      setKillWaveActive(true);
      setKillWavePopupOpen(false);
      setKillWaveEndsAt(startedAt + 60 * 1000);
      resetKillWaveVisuals();
      updateKillGameSize();
      startAirRaid();
      trackAnalyticsEvent('kill_wave_start', { galleryType: 'kill' });
    } catch (err) {
      console.error('Failed to start kill wave', err);
      setError('Could not start the kill wave.');
    }
  }, [
    killGalleryItems.length,
    killTimeRemainingMs,
    resetKillWaveVisuals,
    startAirRaid,
    trackAnalyticsEvent,
    updateKillGameSize,
  ]);

  const handleKillShot = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (!killWaveActiveRef.current) return;
      const rect = killGameRef.current?.getBoundingClientRect();
      if (!rect) return;
      const xPct = ((event.clientX - rect.left) / rect.width) * 100;
      const clamped = Math.min(94, Math.max(6, xPct));
      setKillGunX(clamped);
      const bullet: KillBullet = {
        id: killIdRef.current++,
        x: clamped,
        y: 92,
        speed: 110,
      };
      setKillBullets((prev) => [...prev, bullet]);
      setKillFlashVisible(true);
      setKillFlashKey((prev) => prev + 1);
      playGunshot();
    },
    [playGunshot]
  );

  const killWaveReady = killTimeRemainingMs <= 0;
  const killCountdownLabel = killWaveReady ? 'Ready' : formatKillCountdown(killTimeRemainingMs);
  const surviveRemainingMs =
    killWaveActive && killWaveEndsAt ? Math.max(0, killWaveEndsAt - Date.now()) : 60 * 1000;
  const surviveTimerLabel = formatKillCountdown(surviveRemainingMs);
  const killHearts = Math.max(0, 3 - killMisses);
  const claimKillReward = () => {
    const origin = killRewardRef.current?.getBoundingClientRect();
    if (origin) {
      spawnCoinParticlesFrom(origin);
    }
    startGoldIncrement();
    setKillRewardOpen(false);
  };

  const galleryItems = useMemo(
    () => activeGallery.slice(0, Math.min(activeAvailableSlots, galleryDisplayLimit)),
    [activeAvailableSlots, activeGallery]
  );
  const galleryPositions = useMemo(
    () => Object.fromEntries(galleryItems.map((item) => [item.id, positionFromId(item.id)])),
    [galleryItems]
  );
  const selectedGalleryFaceSrc = selectedGalleryItem
    ? selectedGalleryItem.faceValue || selectedGalleryItem.image
    : null;
  const selectedOutfitId: GalleryOutfitId = selectedGalleryItem
    ? (activeOutfits.selected[selectedGalleryItem.id] ?? 'default')
    : 'default';
  const selectedBodySrc = activeOutfitSources[selectedOutfitId];
  const selectedFaceClass = isFunGallery
    ? 'absolute left-1/2 top-[30%] h-[34px] w-[34px] -translate-x-1/2 rounded-full object-cover bg-[#3d0066]'
    : 'absolute left-1/2 top-[30%] h-[37px] w-[37px] -translate-x-1/2 rounded-full object-cover bg-[#3d0066]';
  const selectedFaceFallbackClass = isFunGallery
    ? 'absolute left-1/2 top-[18%] h-[36px] w-[36px] -translate-x-1/2 rounded-full bg-[#3d0066] p-2 text-center text-[10px] font-semibold text-white/80'
    : 'absolute left-1/2 top-[18%] h-[42px] w-[42px] -translate-x-1/2 rounded-full bg-[#3d0066] p-2 text-center text-[10px] font-semibold text-white/80';
  const selectedAffection = selectedGalleryItem
    ? (activeAffection[selectedGalleryItem.id] ?? 0)
    : 0;
  const canAffordDivorce = currency.gold >= 300;
  const canAffordGift = currency.gold >= 75;
  const selectedIsSelectable = selectedGalleryItem
    ? (isFunGallery ? selectableFunIds : selectableMarryIds).has(selectedGalleryItem.id)
    : false;
  useEffect(() => {
    if (!selectedGalleryItem || selectedIsSelectable || view !== 'gallery' || isKillGallery) return;
    const selectableIds = Array.from(isFunGallery ? selectableFunIds : selectableMarryIds);
    console.info('[FMK] selected gallery item is not selectable', {
      galleryType: isFunGallery ? 'fun' : 'marry',
      selectedId: selectedGalleryItem.id,
      selectableCount: selectableIds.length,
      selectableIds,
    });
  }, [
    isFunGallery,
    isKillGallery,
    selectedGalleryItem,
    selectedIsSelectable,
    selectableFunIds,
    selectableMarryIds,
    view,
  ]);
  const canUnlockSlot =
    activeAvailableSlots < 12 &&
    galleryItems.length > 0 &&
    galleryItems.every((item) => (activeAffection[item.id] ?? 0) >= 10);
  const unlockedOutfits = selectedGalleryItem
    ? new Set(activeOutfits.unlocked[selectedGalleryItem.id] ?? ['default'])
    : new Set<GalleryOutfitId>(['default']);
  const shopPageSize = 3;
  const shopTotalPages = Math.max(1, Math.ceil(activeOutfitCatalog.length / shopPageSize));
  const shopItems = activeOutfitCatalog.slice(
    shopPage * shopPageSize,
    shopPage * shopPageSize + shopPageSize
  );
  const confirmOutfit = outfitConfirm.open
    ? (activeOutfitCatalog.find((outfit) => outfit.id === outfitConfirm.outfitId) ?? null)
    : null;

  useEffect(() => {
    selectableMarryIdsRef.current = selectableMarryIds;
  }, [selectableMarryIds]);

  useEffect(() => {
    selectableFunIdsRef.current = selectableFunIds;
  }, [selectableFunIds]);

  useEffect(() => {
    if (marryGallery.length === 0) {
      if (selectableMarryIds.size) {
        setSelectableMarryIds(new Set());
      }
      return;
    }
    setSelectableMarryIds((prev) => {
      const validIds = new Set(marryGallery.map((item) => item.id));
      const next = new Set(Array.from(prev).filter((id) => validIds.has(id)));
      return next.size === prev.size ? prev : next;
    });
  }, [marryGallery, selectableMarryIds.size]);

  useEffect(() => {
    if (funGallery.length === 0) {
      if (selectableFunIds.size) {
        setSelectableFunIds(new Set());
      }
      return;
    }
    setSelectableFunIds((prev) => {
      const validIds = new Set(funGallery.map((item) => item.id));
      const next = new Set(Array.from(prev).filter((id) => validIds.has(id)));
      return next.size === prev.size ? prev : next;
    });
  }, [funGallery, selectableFunIds.size]);

  useEffect(() => {
    if (marryGallery.length === 0) {
      if (Object.keys(outfits.unlocked).length || Object.keys(outfits.selected).length) {
        setOutfits({ unlocked: {}, selected: {} });
      }
      return;
    }
    const validIds = new Set(marryGallery.map((item) => item.id));
    const nextUnlocked: Record<string, GalleryOutfitId[]> = {};
    const nextSelected: Record<string, GalleryOutfitId> = {};
    Object.entries(outfits.unlocked).forEach(([id, list]) => {
      if (validIds.has(id)) nextUnlocked[id] = list;
    });
    Object.entries(outfits.selected).forEach(([id, outfitId]) => {
      if (validIds.has(id)) nextSelected[id] = outfitId;
    });
    if (
      Object.keys(nextUnlocked).length !== Object.keys(outfits.unlocked).length ||
      Object.keys(nextSelected).length !== Object.keys(outfits.selected).length
    ) {
      setOutfits({ unlocked: nextUnlocked, selected: nextSelected });
    }
  }, [marryGallery, outfits]);

  useEffect(() => {
    if (funGallery.length === 0) {
      if (Object.keys(funOutfits.unlocked).length || Object.keys(funOutfits.selected).length) {
        setFunOutfits({ unlocked: {}, selected: {} });
      }
      return;
    }
    const validIds = new Set(funGallery.map((item) => item.id));
    const nextUnlocked: Record<string, GalleryOutfitId[]> = {};
    const nextSelected: Record<string, GalleryOutfitId> = {};
    Object.entries(funOutfits.unlocked).forEach(([id, list]) => {
      if (validIds.has(id)) nextUnlocked[id] = list;
    });
    Object.entries(funOutfits.selected).forEach(([id, outfitId]) => {
      if (validIds.has(id)) nextSelected[id] = outfitId;
    });
    if (
      Object.keys(nextUnlocked).length !== Object.keys(funOutfits.unlocked).length ||
      Object.keys(nextSelected).length !== Object.keys(funOutfits.selected).length
    ) {
      setFunOutfits({ unlocked: nextUnlocked, selected: nextSelected });
    }
  }, [funGallery, funOutfits]);

  useEffect(() => {
    if (selectedGalleryItem) {
      setFootRubUsed(false);
      setShopPage(0);
      setOutfitConfirm({ open: false, outfitId: null });
    }
  }, [selectedGalleryItem]);

  useEffect(() => {
    if (!galleryItems.length) {
      setSlotUnlockOpen(false);
    }
  }, [galleryItems.length]);

  useEffect(() => {
    setSelectedGalleryItem(null);
    setShopOpen(false);
    setOutfitConfirm({ open: false, outfitId: null });
  }, [galleryType]);

  useEffect(() => {
    if (shopPage >= shopTotalPages) {
      setShopPage(Math.max(0, shopTotalPages - 1));
    }
  }, [shopPage, shopTotalPages]);

  useEffect(() => {
    if (!selectedGalleryItem) {
      setShopOpen(false);
      setOutfitConfirm({ open: false, outfitId: null });
    }
  }, [selectedGalleryItem]);

  useEffect(() => {
    if (pendingGoldTarget !== null) return;
    if (displayGold !== currency.gold) {
      setDisplayGold(currency.gold);
    }
  }, [currency.gold, displayGold, pendingGoldTarget]);

  useEffect(() => {
    chatBubbleVisibleRef.current = chatBubbleVisible;
  }, [chatBubbleVisible]);

  useEffect(() => {
    if (view !== 'gallery') {
      setSelectedGalleryItem(null);
      setChatBubbleVisible(false);
      setChatBubbleText(null);
      setActiveBubbleId(null);
      return;
    }
  }, [view]);

  useEffect(() => {
    if (view === 'gallery' && isKillGallery) {
      void loadKillState();
      setKillWavePopupOpen(true);
    }
  }, [isKillGallery, view]);

  useEffect(() => {
    if (view !== 'gallery' || !isKillGallery) return;
    const update = () => {
      setKillTimeRemainingMs(Math.max(0, killWaveState.nextWaveAt - Date.now()));
    };
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, [isKillGallery, killWaveState.nextWaveAt, view]);

  useEffect(() => {
    if (!isKillGallery) return;
    const handleResize = () => updateKillGameSize();
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isKillGallery, updateKillGameSize]);

  useEffect(() => {
    killWaveActiveRef.current = killWaveActive;
  }, [killWaveActive]);

  useEffect(() => {
    killMissesRef.current = killMisses;
  }, [killMisses]);

  useEffect(() => {
    killWaveEndsAtRef.current = killWaveEndsAt;
  }, [killWaveEndsAt]);

  useEffect(() => {
    killEnemiesRef.current = killEnemies;
  }, [killEnemies]);

  useEffect(() => {
    killBulletsRef.current = killBullets;
  }, [killBullets]);

  useEffect(() => {
    if (killWaveActive && (view !== 'gallery' || !isKillGallery)) {
      void finishKillWave('lose');
    }
  }, [finishKillWave, isKillGallery, killWaveActive, view]);

  useEffect(() => {
    if (isMuted && killWaveActive) {
      stopAirRaid();
    }
  }, [isMuted, killWaveActive, stopAirRaid]);

  useEffect(() => {
    if (!killWaveActive) {
      if (killRafRef.current) {
        window.cancelAnimationFrame(killRafRef.current);
        killRafRef.current = null;
      }
      return;
    }
    updateKillGameSize();
    const waveNumber = Math.max(1, killWaveState.waveNumber);
    const enemySpeed = Math.min(16, 6 + waveNumber * 1.2);
    const spawnInterval = Math.max(0.4, 1.2 - waveNumber * 0.05);
    const enemyWidth = 12;
    const enemyHeight = 18;
    let lastTime = performance.now();

    const tick = (now: number) => {
      const dt = Math.min(0.05, Math.max(0, (now - lastTime) / 1000));
      lastTime = now;
      const waveEndAt = killWaveEndsAtRef.current;
      if (waveEndAt && Date.now() >= waveEndAt) {
        void finishKillWave('win');
        return;
      }

      const bullets = killBulletsRef.current;
      const enemies = killEnemiesRef.current;
      let misses = killMissesRef.current;

      killSpawnAccumulatorRef.current += dt;
      const spawnedEnemies: KillEnemy[] = [];
      if (killGalleryItems.length) {
        while (killSpawnAccumulatorRef.current >= spawnInterval) {
          killSpawnAccumulatorRef.current -= spawnInterval;
          const pick = killGalleryItems[Math.floor(Math.random() * killGalleryItems.length)];
          const faceSrc = pick?.faceValue || pick?.image || null;
          spawnedEnemies.push({
            id: killIdRef.current++,
            x: 8 + Math.random() * 84,
            y: -enemyHeight,
            speed: enemySpeed,
            faceSrc,
            alive: true,
            deadAt: null,
          });
        }
      } else {
        killSpawnAccumulatorRef.current = 0;
      }

      const nextEnemies: KillEnemy[] = [];
      const nowMs = Date.now();
      for (const enemy of enemies) {
        if (enemy.alive) {
          const nextY = enemy.y + enemy.speed * dt;
          if (nextY >= 100) {
            misses += 1;
            continue;
          }
          nextEnemies.push({ ...enemy, y: nextY });
        } else if (!enemy.deadAt || nowMs - enemy.deadAt < 1200) {
          nextEnemies.push(enemy);
        }
      }
      nextEnemies.push(...spawnedEnemies);

      const nextBullets: KillBullet[] = [];
      for (const bullet of bullets) {
        const nextY = bullet.y - bullet.speed * dt;
        if (nextY < -10) continue;
        let hit = false;
        for (const enemy of nextEnemies) {
          if (!enemy.alive) continue;
          const withinX = Math.abs(bullet.x - enemy.x) <= enemyWidth * 0.5;
          const withinY = nextY >= enemy.y && nextY <= enemy.y + enemyHeight;
          if (withinX && withinY) {
            enemy.alive = false;
            enemy.deadAt = nowMs;
            playDeathSound();
            hit = true;
            break;
          }
        }
        if (!hit) nextBullets.push({ ...bullet, y: nextY });
      }

      if (misses !== killMissesRef.current) {
        setKillMisses(misses);
      }
      if (misses >= 3) {
        void finishKillWave('lose');
        return;
      }

      killEnemiesRef.current = nextEnemies;
      killBulletsRef.current = nextBullets;
      setKillEnemies(nextEnemies);
      setKillBullets(nextBullets);
      killRafRef.current = window.requestAnimationFrame(tick);
    };

    killRafRef.current = window.requestAnimationFrame(tick);
    return () => {
      if (killRafRef.current) {
        window.cancelAnimationFrame(killRafRef.current);
        killRafRef.current = null;
      }
    };
  }, [
    finishKillWave,
    killGalleryItems,
    killWaveActive,
    killWaveState.waveNumber,
    playDeathSound,
    updateKillGameSize,
  ]);

  useEffect(() => {
    const activeSelectableIds = isFunGallery ? selectableFunIds : selectableMarryIds;
    if (activeBubbleId && !activeSelectableIds.has(activeBubbleId)) {
      setActiveBubbleId(null);
      setChatBubbleVisible(false);
      setChatBubbleText(null);
    }
  }, [activeBubbleId, isFunGallery, selectableFunIds, selectableMarryIds]);

  useEffect(() => {
    const activeSelectableIds = isFunGallery ? selectableFunIds : selectableMarryIds;
    const activeSelectableRef = isFunGallery ? selectableFunIdsRef : selectableMarryIdsRef;
    if (view !== 'gallery' || isKillGallery || activeSelectableIds.size === 0) {
      setChatBubbleVisible(false);
      setChatBubbleText(null);
      setActiveBubbleId(null);
      if (chatBubbleIntervalRef.current) {
        window.clearInterval(chatBubbleIntervalRef.current);
        chatBubbleIntervalRef.current = null;
      }
      if (chatBubbleTimeoutRef.current) {
        window.clearTimeout(chatBubbleTimeoutRef.current);
        chatBubbleTimeoutRef.current = null;
      }
      return;
    }
    if (chatBubbleIntervalRef.current) return;
    const showNextBubble = () => {
      if (chatBubbleVisibleRef.current) return;
      const selectableIds = galleryItems
        .filter((item) => activeSelectableRef.current.has(item.id))
        .map((item) => item.id);
      if (selectableIds.length === 0) return;
      const nextIndex = bubbleIndexRef.current % selectableIds.length;
      const nextId = selectableIds[nextIndex] ?? null;
      if (!nextId) return;
      bubbleIndexRef.current = (nextIndex + 1) % selectableIds.length;
      setActiveBubbleId(nextId);
      setChatBubbleText(randomFrom(isFunGallery ? funChatPhrases : marryChatPhrases));
      setChatBubbleVisible(true);
      if (chatBubbleTimeoutRef.current) {
        window.clearTimeout(chatBubbleTimeoutRef.current);
      }
      chatBubbleTimeoutRef.current = window.setTimeout(() => {
        setChatBubbleVisible(false);
      }, 4000);
    };
    chatBubbleTimeoutRef.current = window.setTimeout(showNextBubble, 500);
    chatBubbleIntervalRef.current = window.setInterval(showNextBubble, 3000);
    return () => {
      if (chatBubbleIntervalRef.current) {
        window.clearInterval(chatBubbleIntervalRef.current);
        chatBubbleIntervalRef.current = null;
      }
      if (chatBubbleTimeoutRef.current) {
        window.clearTimeout(chatBubbleTimeoutRef.current);
        chatBubbleTimeoutRef.current = null;
      }
    };
  }, [galleryItems, isFunGallery, isKillGallery, selectableFunIds, selectableMarryIds, view]);

  useEffect(() => {
    if (view !== 'gallery' || isKillGallery) {
      if (selectablesPollRef.current) {
        window.clearInterval(selectablesPollRef.current);
        selectablesPollRef.current = null;
      }
      return;
    }
    const poll = () => {
      void refreshSelectables('gallery-poll');
    };
    poll();
    selectablesPollRef.current = window.setInterval(poll, 75000);
    return () => {
      if (selectablesPollRef.current) {
        window.clearInterval(selectablesPollRef.current);
        selectablesPollRef.current = null;
      }
    };
  }, [view, isKillGallery]);

  useEffect(() => {
    if (galleryItems.length === 0) {
      setGalleryMotion((prev) => (Object.keys(prev).length > 0 ? {} : prev));
      if (galleryTimerRef.current) {
        window.clearInterval(galleryTimerRef.current);
        galleryTimerRef.current = null;
      }
      return;
    }
    setGalleryMotion((prev) => {
      const next: Record<string, GalleryMotion | null> = {};
      galleryItems.forEach((item) => {
        next[item.id] = prev[item.id] ?? null;
      });
      return next;
    });
    if (galleryTimerRef.current) return undefined;
    galleryTimerRef.current = window.setInterval(() => {
      const target = randomFrom(galleryItems);
      if (!target) return;
      setGalleryMotion((prev) => {
        if (prev[target.id]) return prev;
        return { ...prev, [target.id]: randomFrom<GalleryMotion>(['left', 'right', 'jump']) };
      });
    }, 2200);
    return () => {
      if (galleryTimerRef.current) {
        window.clearInterval(galleryTimerRef.current);
        galleryTimerRef.current = null;
      }
    };
  }, [galleryItems]);

  const cropMetrics = faceCropImage ? getCropMetrics(faceCropImage, faceCropScale) : null;
  const analyticsTopEvents = adminAnalyticsSummary?.events.slice(0, 8) ?? [];
  const analyticsTopPages = adminAnalyticsSummary?.pages.slice(0, 6) ?? [];
  const analyticsTopGalleries = adminAnalyticsSummary?.galleries.slice(0, 8) ?? [];
  const analyticsRecentDaily = adminAnalyticsSummary?.daily.slice(-7) ?? [];
  const collectionCards = cardCollection?.cards ?? [];
  const unopenedCardPacks = cardCollection?.unopenedPacks ?? 0;
  const selectedCardFullArt = selectedCard
    ? selectedCard.image || selectedCard.faceValue || ''
    : '';
  const arenaRating = battle?.reward?.rating ?? battleRank?.rating ?? 1000;
  const battleIsActive = battle?.status === 'active';
  const matchmakingPlayerName = pendingBattleStart?.battle.player.displayName ?? 'You';
  const matchmakingOpponentName =
    matchmakingNames[matchmakingNameIndex] ??
    pendingBattleStart?.battle.opponent.displayName ??
    'Opponent';
  const packCurrentCard = pulledCards[packRevealIndex] ?? null;
  const packInteractionActive =
    view === 'pack' &&
    (packOpeningPhase === 'idle' ||
      packOpeningPhase === 'playing' ||
      packOpeningPhase === 'opening' ||
      packOpeningPhase === 'revealing');
  const packShowNav =
    view !== 'pack' || packOpeningPhase === 'complete' || packOpeningPhase === 'error';
  const shopCurrency = shopState?.currency ?? currency;
  const shopUnopenedPacks = shopState?.unopenedPacks ?? unopenedCardPacks;
  const packsCurrency = shopState?.currency ?? currency;
  const packsUnopenedPacks = shopState?.unopenedPacks ?? unopenedCardPacks;
  const canBuyGoldPack = packsCurrency.gold >= GOLD_PACK_COST;
  const showCardEconomyMenu =
    CARD_ECONOMY_MENU_ITEMS.some((item) => item.view === view) &&
    !(view === 'battle' && (battleIsActive || matchmakingActive));
  const shopDailyGift = shopState?.dailyGift ?? null;
  const shopDailyGiftAvailable = Boolean(shopDailyGift?.available);
  const questRewardAvailable = Boolean(
    questsState?.quests.some((quest) => quest.completed && !quest.claimed)
  );
  const shopAdGoldReward = shopState?.adRewards.gold ?? null;
  const shopAdGemsReward = shopState?.adRewards.gems ?? null;
  const shopRewardedAdBlockedTypes = hasGayBrowseVisitedThisSession()
    ? null
    : SHOP_REWARDED_AD_BLOCKED_TYPES;
  const shopRewardedAdVastSrc = hasGayBrowseVisitedThisSession()
    ? SHOP_REWARDED_AD_VAST_GAY_SRC
    : SHOP_REWARDED_AD_VAST_DEFAULT_SRC;
  const shopDailyReadyAt = shopDailyGift?.nextClaimAt
    ? new Date(shopDailyGift.nextClaimAt).toLocaleString()
    : '';
  const getShopAdRewardButtonLabel = (
    rewardKind: ShopAdRewardKind,
    available: boolean,
    nextClaimAt: number
  ): string => {
    if (shopActionLoading === `ad-${rewardKind}`) return 'Claiming...';
    if (available) return 'Watch Ad';
    return `Ready in ${formatCountdown(nextClaimAt - nowMs)}`;
  };
  const scrollToShopSection = (sectionId: string): void => {
    document.getElementById(`shop-${sectionId}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  const openGalleryGemShop = (): void => {
    setCardDeckEditorOpen(false);
    syncUrlToView('shop');
    setView('shop');
    window.setTimeout(() => scrollToShopSection('gems'), 0);
  };
  const continueCardTutorial = (): void => {
    if (cardTutorialAbilityTip) {
      setCardTutorialSeenAbilities((prev) =>
        prev.includes(cardTutorialAbilityTip) ? prev : [...prev, cardTutorialAbilityTip]
      );
      setCardTutorialAbilityTip(null);
      return;
    }
    if (cardTutorialStep === 'first_card_power') {
      setCardTutorialStep('first_card_ability');
    } else if (cardTutorialStep === 'first_card_ability') {
      setCardTutorialStep('finish_first_pack');
    } else if (cardTutorialStep === 'battle_goal') {
      setCardTutorialStep('select_attacker');
    } else if (cardTutorialStep === 'attack_rules') {
      setCardTutorialStep('battle_good_luck');
    } else if (cardTutorialStep === 'battle_good_luck') {
      setCardTutorialStep('free_play_first_battle');
    }
  };
  const cardTutorialAbilityMessages: Record<CardAbility, string> = {
    tank: 'Tank cards gain large amounts of power when revealed, depending on their rarity.',
    ranger: 'This is a ranger card. It takes no damage when attacking.',
    healer:
      'This is a healer card. At the beginning of your turn, healers buff other allied cards on the field.',
  };
  const cardTutorialOverlay =
    shouldShowCardTutorialUi && cardTutorialAbilityTip
      ? {
          message: cardTutorialAbilityMessages[cardTutorialAbilityTip],
          targetSelector: `.fmk-battle-card-grid .fmk-card-type-badge[aria-label="${CARD_ABILITY_LABELS[cardTutorialAbilityTip]}"]`,
          showContinue: true,
        }
      : shouldShowCardTutorialUi && cardTutorialStep
        ? (() => {
            switch (cardTutorialStep) {
              case 'go_to_first_pack':
                return {
                  message: "Let's open a card pack before your first battle.",
                  targetSelector: '[data-card-tutorial-target="menu-packs"]',
                  showContinue: false,
                };
              case 'intro_open_first_pack':
                return {
                  message:
                    "Congratulations! you've earned enough gold to open a pack. Click Open Pack to see your reward.",
                  targetSelector: '[data-card-tutorial-target="open-pack"]',
                  showContinue: false,
                };
              case 'first_card_power':
                return {
                  message: 'Every card has a power level.',
                  targetSelector: '.fmk-pack-reveal-card .fmk-card-power',
                  showContinue: true,
                };
              case 'first_card_ability':
                return {
                  message: 'Every card has an ability.',
                  targetSelector: '.fmk-pack-reveal-card .fmk-card-type-badge',
                  showContinue: true,
                };
              case 'return_after_first_pack':
              case 'return_after_second_pack':
                return {
                  message: 'Return to your collection to keep going.',
                  targetSelector: '[data-card-tutorial-target="return-collection"]',
                  showContinue: false,
                };
              case 'go_to_second_pack':
                return {
                  message:
                    "Every deck used in the game requires six cards to play. Let's open another pack.",
                  targetSelector: '[data-card-tutorial-target="menu-packs"]',
                  showContinue: false,
                };
              case 'open_second_pack':
                return {
                  message: 'Open another pack for 100 gold.',
                  targetSelector: '[data-card-tutorial-target="open-pack"]',
                  showContinue: false,
                };
              case 'go_to_battle':
              case 'go_to_battle_after_save':
                return {
                  message: 'Open the battle menu.',
                  targetSelector: '[data-card-tutorial-target="menu-battle"]',
                  showContinue: false,
                };
              case 'open_modify_deck':
                return {
                  message: 'Open Modify Deck.',
                  targetSelector: '[data-card-tutorial-target="modify-deck"]',
                  showContinue: false,
                };
              case 'build_deck':
                return {
                  message:
                    'Select six cards and press the save deck button to finish building your deck.',
                  targetSelector: '[data-card-tutorial-target="save-deck"]',
                  showContinue: false,
                };
              case 'start_first_battle':
                return {
                  message: 'Press Play to enter your first game.',
                  targetSelector: '[data-card-tutorial-target="start-battle"]',
                  showContinue: false,
                };
              case 'battle_goal':
                return {
                  message:
                    "The goal is to be the last one standing. Whoever's deck is depleted loses.",
                  targetSelector: null,
                  showContinue: true,
                };
              case 'select_attacker':
                return {
                  message: 'Attack with one of your cards.',
                  targetSelector:
                    '.fmk-battle-board-row-player .fmk-collection-card-button:not([aria-disabled="true"])',
                  showContinue: false,
                };
              case 'select_target':
                return {
                  message: 'Choose an opposing card to attack.',
                  targetSelector:
                    '.fmk-battle-board-row-opponent .fmk-collection-card-button:not([aria-disabled="true"])',
                  showContinue: false,
                };
              case 'attack_rules':
                return {
                  message:
                    "In general, unless a card has a special ability, when a card attacks, each card's power is subtracted from each other.",
                  targetSelector: null,
                  showContinue: true,
                };
              case 'battle_good_luck':
                return {
                  message: 'Try to win the battle for a reward. Good luck!',
                  targetSelector: null,
                  showContinue: true,
                };
              default:
                return null;
            }
          })()
        : null;

  return (
    <div className="relative h-screen overflow-x-hidden overflow-y-auto bg-[#3d0066] px-2 py-4 sm:px-4">
      {coinParticles.length ? (
        <div className="pointer-events-none fixed inset-0 z-50">
          {coinParticles.map((particle) => (
            <span
              key={particle.id}
              className="gallery-coin-particle"
              style={{
                left: `${particle.startX}px`,
                top: `${particle.startY}px`,
                ['--coin-dx' as string]: `${particle.deltaX}px`,
                ['--coin-dy' as string]: `${particle.deltaY}px`,
                animationDuration: `${particle.duration}ms`,
                animationDelay: `${particle.delay}ms`,
              }}
            >
              <CurrencyIcon kind="coin" className="h-4 w-4" />
            </span>
          ))}
        </div>
      ) : null}
      <div
        className={clsx(
          'mx-auto flex flex-col gap-3',
          packInteractionActive
            ? 'max-w-none'
            : view === 'tournament' ||
                view === 'cards' ||
                view === 'packs' ||
                view === 'pack' ||
                view === 'battle' ||
                view === 'quests' ||
                view === 'shop'
              ? 'max-w-[72rem]'
              : view === 'gooGame'
                ? 'max-w-[76rem]'
                : 'max-w-5xl'
        )}
      >
        {loading ? (
          <div className="absolute inset-0 z-50 flex items-center justify-center px-4">
            <img
              src={crtScreen}
              alt=""
              className="pointer-events-none absolute inset-0 h-full w-full object-cover"
            />
            <div className="aura-panel -translate-y-[10vh] flex items-center justify-center rounded-2xl bg-[#5c0099] p-10 text-center">
              <div className="flex flex-col items-center gap-4">
                <img
                  src={titleImage}
                  alt="F.M.K title"
                  className="h-20 w-auto object-contain drop-shadow"
                />
                <p className="text-sm font-semibold text-white">Loading...</p>
                {showLoadingRecovery ? (
                  <div className="max-w-sm space-y-3">
                    <p className="text-xs text-white/80">
                      Debug: `view={view}` `gameId={selectedGameId || 'none'}` `pendingBrowse=
                      {String(pendingBrowseAfterAdRef.current)}`
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-2">
                      <button
                        type="button"
                        className="rounded-full px-4 py-2 text-xs font-semibold text-white btn-3d-gold"
                        onClick={() => openBrowseView('loading-recovery-button')}
                      >
                        Open Browse
                      </button>
                      {selectedGameId ? (
                        <button
                          type="button"
                          className="rounded-full px-4 py-2 text-xs font-semibold text-white btn-3d-purple"
                          onClick={() => void fetchFMK(undefined, 2, selectedGameId)}
                        >
                          Retry Poll Load
                        </button>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}

        {!loading && packShowNav ? (
          <div className="aura-panel rounded-2xl bg-[#5c0099] p-3 text-white">
            <div className="flex items-center justify-between gap-2">
              <div className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto pb-1">
                <button
                  type="button"
                  aria-label="Settings"
                  className="flex h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple"
                  onClick={openSettings}
                >
                  <img src={settingsIcon} alt="" className="h-5 w-5 object-contain" />
                </button>
                <a
                  href={browseHref}
                  data-fmk-browse-nav="1"
                  className={clsx(
                    'inline-flex h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple sm:hidden',
                    isMobileBrowseAdEligible ? 'fmk-popunder-trigger-browse-mobile' : null
                  )}
                  onPointerDownCapture={primeMobileBrowseAfterAd}
                  onTouchStartCapture={primeMobileBrowseAfterAd}
                  onMouseDownCapture={primeMobileBrowseAfterAd}
                  onPointerUp={() => {
                    window.setTimeout(() => openBrowseView('top-nav-mobile-pointerup'), 0);
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    if (POPUNDER_DEBUG)
                      console.info('[POPUNDER DEBUG] Mobile top-nav Browse clicked');
                    openBrowseView('top-nav-mobile-click');
                  }}
                  aria-label="Browse"
                >
                  <img src={homeIcon} alt="" className="h-5 w-5 object-contain" />
                </a>
                <a
                  href={browseHref}
                  data-fmk-browse-nav="1"
                  className={clsx(
                    'hidden h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple sm:inline-flex',
                    BROWSE_POPUNDER_ADS_ENABLED ? 'fmk-popunder-trigger-browse-desktop' : null
                  )}
                  onPointerDownCapture={primeDesktopBrowseAfterAd}
                  onTouchStartCapture={primeDesktopBrowseAfterAd}
                  onMouseDownCapture={primeDesktopBrowseAfterAd}
                  onPointerUp={() => {
                    window.setTimeout(() => openBrowseView('top-nav-desktop-pointerup'), 0);
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    if (POPUNDER_DEBUG)
                      console.info('[POPUNDER DEBUG] Desktop top-nav Browse clicked');
                    openBrowseView('top-nav-desktop-click');
                  }}
                  aria-label="Browse"
                >
                  <img src={homeIcon} alt="" className="h-5 w-5 object-contain" />
                </a>
                <button
                  type="button"
                  aria-label="Create"
                  className="flex h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple"
                  onClick={() => {
                    if (!requireReadyUserAction('create posts')) return;
                    setView('create');
                    setCurrentCreateSlot(0);
                    setPostedAs(null);
                  }}
                >
                  <img src={uploadIcon} alt="" className="h-5 w-5 object-contain" />
                </button>
                {SHOW_AI_PORN_BUTTON ? (
                  <button
                    type="button"
                    className="inline-flex h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple"
                    onClick={() =>
                      navigateTo(
                        `/faceswap.html${INITIAL_TENANT ? `?tenantId=${encodeURIComponent(INITIAL_TENANT)}` : ''}`
                      )
                    }
                  >
                    AI Porn
                  </button>
                ) : null}
                {SHOW_TOP_NAV_CARD_BATTLE_BUTTON ? (
                  <button
                    type="button"
                    aria-label="Card battle"
                    className="flex h-9 shrink-0 items-center justify-center rounded-full px-3 text-xs font-semibold text-white btn-3d-purple"
                    data-card-tutorial-target={topNavCardTutorialAction}
                    disabled={!isCardTutorialActionAllowed(topNavCardTutorialAction)}
                    onClick={() => void handleTopNavCardBattle()}
                  >
                    <img src={collectionMenuIcon} alt="" className="h-5 w-5 object-contain" />
                  </button>
                ) : null}
              </div>
              <div className="shrink-0">
                {!isAuthenticated ? (
                  <button
                    type="button"
                    className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                    disabled={!authConfigured}
                    onClick={() => {
                      setAuthMode('sign_in');
                      setAuthOpen(true);
                      setAuthError(null);
                      setAuthMessage(null);
                    }}
                  >
                    {authConfigured ? 'Log in' : 'Login unavailable'}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}

        {!loading && view === 'browse' ? (
          <div className="browse-aura-panel rounded-2xl bg-[#5c0099] p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <h2 className="text-lg font-bold text-white">F.M.K</h2>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className={clsx(
                    'rounded-full px-3 py-1 text-xs font-semibold text-white',
                    browseSort === 'new' ? 'btn-3d-gold' : 'btn-3d-purple'
                  )}
                  onClick={() => {
                    updateBrowseLocation({ sort: 'new', type: browseType, page: 1 });
                  }}
                >
                  New
                </button>
                <button
                  type="button"
                  className={clsx(
                    'rounded-full px-3 py-1 text-xs font-semibold text-white',
                    browseSort === 'popular' ? 'btn-3d-gold' : 'btn-3d-purple'
                  )}
                  onClick={() => {
                    updateBrowseLocation({ sort: 'popular', type: browseType, page: 1 });
                  }}
                >
                  Popular
                </button>
                <label className="sr-only" htmlFor="browse-type-select">
                  Post type
                </label>
                <select
                  id="browse-type-select"
                  className="browse-aura-field rounded-full bg-[#3d0066] px-3 py-1 text-xs font-semibold text-white"
                  value={browseType}
                  onChange={(event) => {
                    updateBrowseLocation({
                      sort: browseSort,
                      type: event.target.value as FMKPostType,
                      page: 1,
                    });
                  }}
                >
                  {POST_TYPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-4 space-y-3">
              {browseLoading ? (
                <div className="rounded-xl border border-white/20 bg-white/10 p-4 text-sm font-semibold text-white">
                  Loading posts...
                </div>
              ) : null}
              {!browseLoading && browseError ? (
                <div className="rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                  {browseError}
                </div>
              ) : null}
              {!browseLoading && !browseError && browsePosts.length === 0 ? (
                <div className="rounded-xl border border-white/20 bg-white/10 p-4 text-sm text-white">
                  No posts yet. Be the first to create one.
                </div>
              ) : null}
              {!browseLoading && tournamentLoading && !tournamentSummary ? (
                <div className="rounded-xl border border-white/20 bg-white/10 p-4 text-sm font-semibold text-white">
                  Loading tournament...
                </div>
              ) : null}
              {!browseLoading && tournamentError ? (
                <div className="rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                  {tournamentError}
                </div>
              ) : null}
              {!browseLoading && tournamentSummary ? (
                <button
                  type="button"
                  onClick={() => void openTournamentPage()}
                  className="browse-aura-card w-full rounded-xl bg-[#3d0066] p-4 text-left text-white transition-transform hover:-translate-y-[1px]"
                >
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className="space-y-2">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-full bg-[#fdc500] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#3d0066]">
                          Weekly Tournament
                        </span>
                      </div>
                      <h3 className="text-lg font-bold">
                        {tournamentSummary.status === 'completed'
                          ? 'This week’s Fun / Marry / Kill champions are in'
                          : `Round ${tournamentSummary.activeWindow?.stageIndex ?? 1} is live`}
                      </h3>
                      <p className="text-sm text-white/80">
                        {tournamentSummary.status === 'completed'
                          ? 'Tap to see the final category winners and the full bracket path.'
                          : 'Vote through every image matchup in the current 6-picture round before results unlock.'}
                      </p>
                    </div>
                    <div className="rounded-xl bg-black/20 px-4 py-3 text-center sm:min-w-[220px]">
                      <div className="text-[11px] font-semibold uppercase tracking-wide text-[#ffd84a]">
                        {tournamentSummary.status === 'completed'
                          ? 'Next tournament starts in'
                          : 'Tournament ends in'}
                      </div>
                      <div className="mt-1 text-xl font-black text-white">
                        {tournamentCountdown}
                      </div>
                      {tournamentSummary.activeWindow ? (
                        <div className="mt-2 text-xs text-white/75">
                          Current category closes in {tournamentRoundCountdown}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="mt-4 hidden sm:block">
                    <TournamentProgressGraph tournament={tournamentSummary} />
                  </div>
                  {tournamentSummary.finalWinners.length > 0 ? (
                    <div className="mt-4 grid gap-2 sm:grid-cols-3">
                      {tournamentSummary.finalWinners.map((winner) => {
                        const entrant = tournamentEntrantMap[winner.entrantId];
                        return (
                          <div key={winner.category} className="rounded-xl bg-black/20 px-3 py-3">
                            <div className="text-[11px] font-semibold uppercase tracking-wide text-[#ffd84a]">
                              {tournamentCategoryLabels[winner.category]}
                            </div>
                            <div className="mt-2 flex items-center gap-3">
                              {entrant?.kind === 'image' && entrant.value ? (
                                <img
                                  src={entrant.value}
                                  alt={getTournamentEntrantLabel(entrant)}
                                  className="h-20 w-20 rounded-lg object-cover object-top"
                                />
                              ) : (
                                <div className="flex h-20 w-20 items-center justify-center rounded-lg bg-white/10 text-xs font-bold text-white/70">
                                  TXT
                                </div>
                              )}
                              <div className="min-w-0">
                                <div className="truncate text-sm font-semibold text-white">
                                  {entrant ? getTournamentEntrantLabel(entrant) : 'Winner'}
                                </div>
                                <div className="text-xs text-white/70">
                                  {winner.score} final votes
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </button>
              ) : null}
              {!browseLoading && !browseError
                ? browseDisplayItems.map((item) => {
                    if (item.kind === 'ad') {
                      return (
                        <div
                          key={`browse-ad-${browsePage}-${item.slotIndex}`}
                          className="browse-aura-card rounded-xl bg-[#3d0066] p-3 text-white"
                        >
                          <p className="mb-2 text-[10px] font-semibold uppercase tracking-wide text-[#fdc500]/90">
                            Sponsored
                          </p>
                          <div className="aspect-[4/3] min-h-[280px] w-full overflow-hidden rounded-lg border border-white/20 bg-black/20 sm:aspect-[4/1] sm:min-h-0">
                            <iframe
                              key={`browse-ad-frame-${browsePage}-${item.slotIndex}`}
                              title={`Sponsored banner ${item.slotIndex}`}
                              srcDoc={browseAdSrcDoc}
                              className="h-full w-full border-0"
                              loading="lazy"
                              referrerPolicy="no-referrer"
                            />
                          </div>
                        </div>
                      );
                    }

                    const post = item.post;
                    const commentsExpanded = Boolean(browseCommentsExpandedByPost[post.postId]);
                    const comments = browseCommentsByPost[post.postId] ?? [];
                    const commentsLoading = Boolean(browseCommentsLoadingByPost[post.postId]);
                    const commentsError = browseCommentsErrorByPost[post.postId];
                    const commentsHasMore = Boolean(browseCommentsHasMoreByPost[post.postId]);
                    const commentDraft = browseCommentDraftByPost[post.postId] ?? '';
                    const commentSubmitting = Boolean(
                      browseCommentSubmitPendingByPost[post.postId]
                    );
                    const commentCount = Math.max(0, Math.floor(Number(post.commentCount) || 0));
                    return (
                      <div key={post.postId} className="space-y-2">
                        <div
                          role="button"
                          tabIndex={0}
                          className="browse-aura-card browse-aura-post relative cursor-pointer rounded-xl bg-[#3d0066] p-3 pb-16 text-white"
                          onClick={() => {
                            void openPostFromBrowse(post.postId);
                          }}
                          onKeyDown={(event) => {
                            if (event.key !== 'Enter' && event.key !== ' ') return;
                            event.preventDefault();
                            void openPostFromBrowse(post.postId);
                          }}
                        >
                          <div className="flex flex-wrap items-start justify-between gap-2">
                            <div>
                              <h3 className="text-sm font-bold">
                                {post.title?.trim() || 'Untitled FMK'}
                              </h3>
                              {post.authorUsername ? (
                                <p className="text-xs text-white/80">@{post.authorUsername}</p>
                              ) : null}
                              <p className="text-xs text-white/80">
                                {post.totalVotes ?? 0} vote(s) •{' '}
                                {new Date(post.createdAt).toLocaleString()}
                              </p>
                            </div>
                            <button
                              type="button"
                              aria-label="Report post"
                              className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                              disabled={Boolean(browseReportPendingByPost[post.postId])}
                              onClick={(event) => {
                                event.stopPropagation();
                                openReportModal(post.postId);
                              }}
                            >
                              Report
                            </button>
                          </div>
                          <div className="mt-2 rounded-lg bg-black/20 p-1.5 text-xs">
                            <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-3">
                              {(post.previews?.length
                                ? post.previews
                                : [
                                    {
                                      kind: post.previewKind,
                                      value: post.previewValue,
                                      label: post.previewLabel,
                                    },
                                  ]
                              ).map((preview, index) => (
                                <div
                                  key={`${post.postId}-${index}`}
                                  className="rounded-lg border border-white/20 bg-black/20 p-1.5"
                                >
                                  <p className="truncate text-center font-semibold">
                                    {preview.label}
                                  </p>
                                  {preview.kind === 'image' ? (
                                    <img
                                      src={preview.value}
                                      alt={preview.label}
                                      className="mt-1 h-28 w-full rounded-lg bg-black/30 object-contain sm:h-32"
                                    />
                                  ) : (
                                    <p className="mt-1 line-clamp-4 text-white/90">
                                      {preview.value}
                                    </p>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="absolute bottom-3 left-3 flex items-center gap-2">
                            <button
                              type="button"
                              aria-label="Upvote"
                              className={clsx(
                                'rounded-full px-3 py-1 text-xs font-semibold text-white disabled:opacity-60',
                                post.userVote === 1 ? 'btn-3d-gold' : 'btn-3d-purple'
                              )}
                              disabled={Boolean(browseVotePendingByPost[post.postId])}
                              onClick={(event) => {
                                event.stopPropagation();
                                void handleBrowsePostVote(post.postId, 1);
                              }}
                            >
                              <span className="text-base leading-none text-white">▲</span>
                            </button>
                            <button
                              type="button"
                              aria-label="Downvote"
                              className={clsx(
                                'rounded-full px-3 py-1 text-xs font-semibold text-white disabled:opacity-60',
                                post.userVote === -1 ? 'btn-3d-gold' : 'btn-3d-purple'
                              )}
                              disabled={Boolean(browseVotePendingByPost[post.postId])}
                              onClick={(event) => {
                                event.stopPropagation();
                                void handleBrowsePostVote(post.postId, -1);
                              }}
                            >
                              <span className="text-base leading-none text-white">▼</span>
                            </button>
                            <button
                              type="button"
                              aria-label={commentsExpanded ? 'Hide comments' : 'Show comments'}
                              className={clsx(
                                'flex items-center justify-center rounded-full px-3 py-1 text-xs font-semibold text-white disabled:opacity-60',
                                commentsExpanded ? 'btn-3d-gold' : 'btn-3d-purple'
                              )}
                              onClick={(event) => {
                                event.stopPropagation();
                                toggleBrowseComments(post.postId);
                              }}
                            >
                              <img src={chatIcon} alt="" className="h-5 w-5 object-contain" />
                              <span className="ml-1 min-w-[1ch] text-center text-xs font-bold leading-none text-white">
                                {commentCount}
                              </span>
                            </button>
                          </div>
                        </div>
                        {commentsExpanded ? (
                          <div className="browse-aura-card rounded-xl bg-[#2b004a] p-3 text-white">
                            <div className="space-y-2">
                              {commentsError ? (
                                <p className="text-xs font-semibold text-red-200">
                                  {commentsError}
                                </p>
                              ) : null}
                              {comments.length === 0 && !commentsLoading ? (
                                <p className="text-xs text-white/75">
                                  No comments yet. Start the conversation.
                                </p>
                              ) : null}
                              {comments.map((comment) => (
                                <div
                                  key={comment.id}
                                  className="rounded-lg border border-white/15 bg-black/20 p-2"
                                >
                                  <div className="flex items-center justify-between gap-2">
                                    <p className="text-xs font-semibold text-[#fdc500]">
                                      @{comment.authorUsername?.trim() || 'user'}
                                    </p>
                                    <p className="text-[10px] text-white/65">
                                      {new Date(comment.createdAt).toLocaleString()}
                                    </p>
                                  </div>
                                  <p className="mt-1 text-xs text-white/90 whitespace-pre-wrap">
                                    {comment.body}
                                  </p>
                                </div>
                              ))}
                              {commentsLoading ? (
                                <p className="text-xs text-white/75">Loading comments...</p>
                              ) : null}
                              {commentsHasMore && !commentsLoading ? (
                                <div className="flex justify-start">
                                  <button
                                    type="button"
                                    className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                                    onClick={() => loadMoreBrowseComments(post.postId)}
                                  >
                                    Load more
                                  </button>
                                </div>
                              ) : null}
                            </div>
                            <div className="mt-3 border-t border-white/15 pt-3">
                              <textarea
                                rows={2}
                                value={commentDraft}
                                maxLength={POST_COMMENT_MAX_LENGTH}
                                className="browse-aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-xs text-white placeholder-white/70 disabled:opacity-60"
                                placeholder={
                                  canWriteBrowseComments
                                    ? 'Write a comment...'
                                    : 'Sign in and set a username to comment.'
                                }
                                disabled={!canWriteBrowseComments || commentSubmitting}
                                onChange={(event) =>
                                  setBrowseCommentDraftByPost((prev) => ({
                                    ...prev,
                                    [post.postId]: event.target.value,
                                  }))
                                }
                              />
                              <div className="mt-2 flex items-center justify-between gap-2">
                                <p className="text-[10px] text-white/60">
                                  {(commentDraft || '').length}/{POST_COMMENT_MAX_LENGTH}
                                </p>
                                <button
                                  type="button"
                                  className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                                  disabled={
                                    !canWriteBrowseComments ||
                                    commentSubmitting ||
                                    !commentDraft.trim()
                                  }
                                  onClick={() => {
                                    void submitBrowseComment(post.postId);
                                  }}
                                >
                                  {commentSubmitting ? 'Posting...' : 'Post'}
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    );
                  })
                : null}
            </div>

            <div className="mt-4 flex items-center justify-between">
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                disabled={browsePage <= 1 || browseLoading}
                onClick={() =>
                  updateBrowseLocation({
                    sort: browseSort,
                    type: browseType,
                    page: Math.max(1, browsePage - 1),
                  })
                }
              >
                Previous
              </button>
              <span className="text-xs font-semibold text-white/90">Page {browsePage}</span>
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                disabled={!browseHasMore || browseLoading}
                onClick={() =>
                  updateBrowseLocation({
                    sort: browseSort,
                    type: browseType,
                    page: browsePage + 1,
                  })
                }
              >
                Next
              </button>
            </div>
          </div>
        ) : null}

        {!loading && view === 'packs' ? (
          <div className="aura-panel fmk-card-menu-page relative rounded-2xl bg-[#5c0099] p-4 text-white">
            <div className="absolute left-4 right-4 top-4 z-10 flex items-start justify-between gap-3">
              <CardCurrencyWindow currency={packsCurrency} />
              <div className="aura-chip rounded-lg bg-black/20 px-3 py-2 text-center">
                <div className="text-[10px] font-semibold uppercase text-white/65">Packs</div>
                <div className="text-lg font-black text-white">
                  {packsUnopenedPacks.toLocaleString()}
                </div>
              </div>
            </div>
            <section className="fmk-pack-selection-stage">
              <div className="fmk-pack-selection-pack" aria-hidden="true">
                <img src={cardPackTransparent} alt="" />
              </div>
              {cardsError || shopError ? (
                <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                  {cardsError ?? shopError}
                </div>
              ) : null}
              <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
                <button
                  type="button"
                  className="relative inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-black text-white btn-3d-purple disabled:opacity-40"
                  aria-label="Shop"
                  disabled={!isCardTutorialActionAllowed('shop')}
                  onClick={openBattleShop}
                >
                  {shopDailyGiftAvailable ? (
                    <span
                      className="absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full border-2 border-white bg-red-500 shadow"
                      aria-hidden="true"
                    />
                  ) : null}
                  <img
                    src={shopIcon}
                    alt=""
                    aria-hidden="true"
                    className="h-6 w-6 object-contain"
                  />
                  <span>Shop</span>
                </button>
                <button
                  type="button"
                  className="rounded-full px-6 py-3 text-sm font-black text-white btn-3d-gold disabled:opacity-50"
                  data-card-tutorial-target="open-pack"
                  disabled={
                    !isCardTutorialActionAllowed('open-pack') ||
                    cardsOpening ||
                    shopActionLoading === 'gold-pack' ||
                    (packsUnopenedPacks <= 0 && !canBuyGoldPack)
                  }
                  onClick={() =>
                    packsUnopenedPacks > 0
                      ? void handleOpenCardPack({ tutorial: isCardTutorialActive })
                      : void handlePurchaseGoldPack({ tutorial: isCardTutorialActive })
                  }
                >
                  {isCardTutorialActive &&
                  (cardTutorialStep === 'intro_open_first_pack' ||
                    cardTutorialStep === 'open_second_pack')
                    ? cardsOpening || shopActionLoading === 'gold-pack'
                      ? 'Opening...'
                      : 'Open Pack'
                    : packsUnopenedPacks > 0
                      ? cardsOpening
                        ? 'Opening...'
                        : 'Open Pack'
                      : shopActionLoading === 'gold-pack'
                        ? 'Buying...'
                        : `Buy Pack - ${GOLD_PACK_COST} gold`}
                </button>
              </div>
              {packsUnopenedPacks <= 0 && !canBuyGoldPack ? (
                <p className="mt-2 text-xs font-semibold text-white/65">
                  Earn gold from quests or the shop to buy a pack.
                </p>
              ) : null}
            </section>
          </div>
        ) : null}

        {!loading && view === 'pack' ? (
          packInteractionActive ? (
            <section className="fmk-pack-opening-page">
              {packOpeningPhase === 'idle' ? (
                <button
                  type="button"
                  className="fmk-pack-frozen-button"
                  onClick={() => void startPackOpeningAnimation()}
                >
                  <img
                    src={cardPackTransparent}
                    alt="Card pack ready to open"
                    className="fmk-pack-opening-media fmk-pack-idle-image"
                  />
                  <span className="fmk-pack-open-hint">Tap to open</span>
                </button>
              ) : null}

              {packOpeningPhase === 'playing' || packOpeningPhase === 'opening' ? (
                <div className="fmk-pack-video-stage">
                  {!packVideoReady ? (
                    <img
                      src={cardPackTransparent}
                      alt=""
                      className="fmk-pack-transition-image"
                      aria-hidden="true"
                    />
                  ) : null}
                  <div className="fmk-pack-placeholder-stack" aria-hidden="true">
                    <div />
                    <div />
                    <div />
                  </div>
                  <video
                    ref={packVideoRef}
                    className={clsx(
                      'fmk-pack-opening-media',
                      packVideoReady && 'fmk-pack-opening-media-visible'
                    )}
                    src={cardOpeningVideo}
                    muted
                    playsInline
                    preload="auto"
                    onPlaying={() => setPackVideoReady(true)}
                    onEnded={() => void finishPackOpeningAnimation()}
                  />
                  {packOpeningPhase === 'opening' ? (
                    <div className="fmk-pack-opening-status">Revealing cards...</div>
                  ) : null}
                </div>
              ) : null}

              {packOpeningPhase === 'revealing' && packCurrentCard ? (
                <div className="fmk-pack-reveal-stage">
                  <p className="fmk-pack-reveal-count">
                    Card {Math.min(packRevealIndex + 1, pulledCards.length)} of {pulledCards.length}
                  </p>
                  <div
                    className="fmk-pack-reveal-stack"
                    role="button"
                    tabIndex={0}
                    aria-label={`Reveal next card after ${packCurrentCard.displayName}`}
                    onPointerDown={handlePackCardPointerDown}
                    onPointerUp={handlePackCardPointerUp}
                    onClick={handlePackCardClick}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        dismissCurrentPackCard();
                      }
                    }}
                  >
                    {pulledCards.length - packRevealIndex - 1 >= 2 ? (
                      <div className="fmk-pack-card-shadow fmk-pack-card-shadow-back" />
                    ) : null}
                    {pulledCards.length - packRevealIndex - 1 >= 1 ? (
                      <div className="fmk-pack-card-shadow fmk-pack-card-shadow-mid" />
                    ) : null}
                    <div
                      className={clsx(
                        'fmk-pack-reveal-card',
                        packCardFlying && 'fmk-pack-reveal-card-fly'
                      )}
                    >
                      <CollectionCard card={packCurrentCard} highlight />
                    </div>
                  </div>
                  <p className="fmk-pack-reveal-hint">Click or swipe left</p>
                </div>
              ) : null}
            </section>
          ) : (
            <div className="aura-panel rounded-2xl bg-[#5c0099] p-4 text-white">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                    Pack Opening
                  </p>
                  <h2 className="text-xl font-black text-white">
                    {packOpeningPhase === 'error' ? 'Pack could not open' : 'Pack opened'}
                  </h2>
                </div>
                <button
                  type="button"
                  className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
                  data-card-tutorial-target="return-collection"
                  disabled={!isCardTutorialActionAllowed('return-collection')}
                  onClick={returnToCardCollection}
                >
                  Return to Collection
                </button>
              </div>
              {cardsError ? (
                <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                  {cardsError}
                </div>
              ) : null}
              {pulledCards.length > 0 ? (
                <section className="mt-5">
                  <h3 className="mb-3 text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                    New Cards
                  </h3>
                  <div className="grid grid-cols-3 gap-3">
                    {pulledCards.map((card, index) => (
                      <CollectionCard
                        key={`${card.cardId}-${card.updatedAt}-${index}`}
                        card={card}
                        highlight
                        onSelect={setSelectedCard}
                      />
                    ))}
                  </div>
                </section>
              ) : null}
            </div>
          )
        ) : null}

        {!loading && view === 'cards' ? (
          <div className="aura-panel fmk-card-menu-page rounded-2xl bg-[#5c0099] p-4 text-white">
            {!cardDeckEditorOpen ? (
              <div className="flex flex-wrap items-center justify-between gap-3">
                <CardCurrencyWindow currency={shopCurrency} />
                <div className="flex items-center gap-2">
                  <div className="aura-chip rounded-lg bg-black/20 px-3 py-2 text-center">
                    <div className="text-[10px] font-semibold uppercase text-white/65">Packs</div>
                    <div className="text-lg font-black text-[#ffd84a]">{unopenedCardPacks}</div>
                  </div>
                  {moderationToolsOpen && adminToken.trim() ? (
                    <>
                      <button
                        type="button"
                        className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                        disabled={cardsLoading || cardsOpening || cardsGrantingPack}
                        onClick={() => void handleGrantTemporaryCardPack()}
                      >
                        {cardsGrantingPack ? 'Granting...' : 'Temp +1 Pack'}
                      </button>
                      <button
                        type="button"
                        className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                        disabled={cardsLoading || cardsOpening || Boolean(cardsGrantingCurrency)}
                        onClick={() => void handleGrantDebugCurrency({ gold: 1000 })}
                      >
                        {cardsGrantingCurrency === 'gold' ? 'Granting...' : 'Debug +1,000 Gold'}
                      </button>
                      <button
                        type="button"
                        className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                        disabled={cardsLoading || cardsOpening || Boolean(cardsGrantingCurrency)}
                        onClick={() => void handleGrantDebugCurrency({ gems: 100 })}
                      >
                        {cardsGrantingCurrency === 'gems' ? 'Granting...' : 'Debug +100 Gems'}
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            ) : null}

            {cardsLoading ? (
              <div className="mt-4 rounded-xl border border-white/20 bg-black/20 p-6 text-center text-sm font-semibold">
                Loading cards...
              </div>
            ) : null}

            {cardsError ? (
              <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                {cardsError}
              </div>
            ) : null}

            {!cardsLoading && unopenedCardPacks <= 0 && collectionCards.length === 0 ? (
              <div className="mt-4 rounded-xl border border-dashed border-[#ffe27a]/45 bg-black/20 p-6 text-center text-sm font-semibold text-white/85">
                Vote on image polls to earn card packs.
              </div>
            ) : null}

            {!cardDeckEditorOpen && pulledCards.length > 0 ? (
              <section className="mt-5">
                <div className="mb-3 flex items-center justify-between gap-2">
                  <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                    Latest Pull
                  </h3>
                  <button
                    type="button"
                    className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                    onClick={() => setPulledCards([])}
                  >
                    Hide
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
                  {pulledCards.map((card, index) => (
                    <CollectionCard
                      key={`${card.cardId}-${card.updatedAt}-${index}`}
                      card={card}
                      highlight
                      onSelect={setSelectedCard}
                    />
                  ))}
                </div>
              </section>
            ) : null}

            {cardDeckEditorOpen ? (
              <section className="mt-5 rounded-xl border border-white/15 bg-black/20 p-3">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                      Battle Deck
                    </h3>
                    <p className="text-xs font-semibold text-white/70">
                      {deckSelection.length}/6 selected
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                      data-card-tutorial-target="save-deck"
                      disabled={
                        !isCardTutorialActionAllowed('save-deck') ||
                        deckSaving ||
                        deckSelection.length !== 6
                      }
                      onClick={() => void handleSaveCardDeck()}
                    >
                      {deckSaving ? 'Saving...' : 'Save Deck'}
                    </button>
                  </div>
                </div>
                {deckError ? (
                  <div className="mt-3 rounded-lg border border-red-300/40 bg-red-900/20 p-3 text-xs text-red-100">
                    {deckError}
                  </div>
                ) : null}
                {cardDeck?.issues.length ? (
                  <div className="mt-3 rounded-lg border border-[#ffe27a]/35 bg-[#fdc500]/10 p-3 text-xs font-semibold text-[#ffeaa0]">
                    {cardDeck.issues.join(' ')}
                  </div>
                ) : null}
                <div className="mt-3 grid max-w-xs grid-cols-3 gap-2">
                  {Array.from({ length: 6 }, (_, index) => {
                    const cardId = deckSelection[index] ?? null;
                    const card = cardId
                      ? collectionCards.find((item) => item.cardId === cardId)
                      : null;
                    return (
                      <div
                        key={`deck-slot-${index}`}
                        className="flex aspect-[4/3] min-h-16 items-center justify-center overflow-hidden rounded-lg border border-dashed border-white/25 bg-black/25 p-1"
                        aria-label={
                          card
                            ? `Battle deck slot ${index + 1}: ${card.displayName}`
                            : `Empty battle deck slot ${index + 1}`
                        }
                      >
                        {card ? (
                          <img
                            src={card.image}
                            alt=""
                            aria-hidden="true"
                            className="h-full w-full rounded-md object-cover"
                          />
                        ) : (
                          <span className="text-xs font-black text-white/35">{index + 1}</span>
                        )}
                      </div>
                    );
                  })}
                </div>
                {deckSelection.length <= 0 ? (
                  <p className="mt-3 text-xs text-white/65">Pick 6 unique owned cards.</p>
                ) : null}
              </section>
            ) : null}

            <section className="mt-5">
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
                <h3 className="text-sm font-black uppercase tracking-wide text-white">
                  Collection
                </h3>
                <span className="text-xs font-semibold text-white/70">
                  {collectionCards.length} card(s)
                </span>
              </div>
              {collectionCards.length > 0 ? (
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
                  {collectionCards.map((card) => {
                    const inDeck = deckSelection.includes(card.cardId);
                    return (
                      <div key={card.cardId} className="space-y-2">
                        <CollectionCard
                          card={card}
                          selected={cardDeckEditorOpen && inDeck}
                          onSelect={setSelectedCard}
                        />
                        {cardDeckEditorOpen ? (
                          <button
                            type="button"
                            className={clsx(
                              'w-full rounded-full px-3 py-1 text-xs font-semibold text-white disabled:opacity-60',
                              inDeck ? 'btn-3d-gold' : 'btn-3d-purple'
                            )}
                            disabled={
                              !isCardTutorialActionAllowed('select-deck-card') ||
                              (!inDeck && deckSelection.length >= 6)
                            }
                            onClick={() => toggleDeckCard(card.cardId)}
                          >
                            {inDeck ? 'Remove from Deck' : 'Add to Deck'}
                          </button>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              ) : !cardsLoading ? (
                <div className="rounded-xl border border-white/15 bg-black/20 p-6 text-center text-sm text-white/75">
                  No cards yet.
                </div>
              ) : null}
            </section>
          </div>
        ) : null}

        {!loading &&
        (view === 'cards' || view === 'packs' || view === 'pack' || view === 'battle') &&
        selectedCard ? (
          <div
            className="fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-4"
            role="dialog"
            aria-modal="true"
            aria-label={`${selectedCard.displayName} full art`}
            onClick={() => setSelectedCard(null)}
          >
            <div
              className="aura-panel flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-[#2b004a] text-white"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="flex items-center justify-between gap-3 border-b border-white/15 px-4 py-3">
                <div className="min-w-0">
                  <p className="text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                    {CARD_RARITY_LABELS[selectedCard.rarity]} ·{' '}
                    {CARD_ABILITY_LABELS[selectedCard.ability]} · Power {selectedCard.power}
                  </p>
                  <h3 className="truncate text-lg font-black">{selectedCard.displayName}</h3>
                </div>
                <button
                  type="button"
                  className="shrink-0 rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                  onClick={() => setSelectedCard(null)}
                >
                  Close
                </button>
              </div>
              <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 bg-black/35 p-3">
                {selectedCardFullArt ? (
                  <img
                    src={selectedCardFullArt}
                    alt={selectedCard.displayName}
                    className="max-h-[66vh] w-full rounded-lg object-contain"
                  />
                ) : (
                  <div className="rounded-xl border border-white/20 bg-black/30 p-8 text-center text-sm text-white/75">
                    Full art unavailable.
                  </div>
                )}
                <div className="w-full rounded-xl border border-[#ffd84a]/25 bg-[#3d0066]/85 px-4 py-3 text-sm font-semibold text-white shadow-inner">
                  <div className="flex items-center gap-2 text-[#ffd84a]">
                    <CardAbilityIcon ability={selectedCard.ability} />
                    <span>{CARD_ABILITY_LABELS[selectedCard.ability]}</span>
                  </div>
                  <p className="mt-2 text-white/85">
                    {CARD_ABILITY_DESCRIPTIONS[selectedCard.ability]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {!loading && view === 'battle' ? (
          <div
            className={clsx(
              'aura-panel fmk-battle-arena-panel rounded-2xl bg-[#5c0099] p-4 text-white',
              matchmakingActive && pendingBattleStart && 'fmk-battle-arena-panel-matchmaking'
            )}
            style={{ '--fmk-battle-bg': `url(${battleBackground})` } as React.CSSProperties}
          >
            {battleError ? (
              <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                {battleError}
              </div>
            ) : null}

            {battleResult ? (
              <BattleResultScreen result={battleResult} onContinue={handleBattleResultContinue} />
            ) : null}

            {!battleResult && !matchmakingActive && !battleIsActive ? (
              <section className="fmk-battle-lobby">
                {battleDeck && !battleDeck.valid ? (
                  <div className="relative z-10 mb-4 rounded-lg border border-[#ffe27a]/35 bg-[#fdc500]/10 p-3 text-xs font-semibold text-[#ffeaa0]">
                    {battleDeck.issues.join(' ') || 'Save a valid deck from the cards page.'}
                  </div>
                ) : null}
                {leaderboardEnabled ? (
                  <button
                    type="button"
                    className="fmk-battle-action-button fmk-battle-leaderboard-button rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                    aria-label="Leaderboard"
                    onClick={() => {
                      if (!requireReadyUserAction('open the leaderboard')) return;
                      void fetchLeaderboard();
                      setLeaderboardOpen(true);
                    }}
                  >
                    <img
                      src={leaderboardIcon}
                      alt=""
                      aria-hidden="true"
                      className="fmk-battle-action-icon"
                    />
                  </button>
                ) : null}

                <div className="fmk-battle-rank-stage">
                  <BattleRankDisplay rating={arenaRating} animation={battleRankAnimation} />
                </div>

                <div className="fmk-battle-lobby-actions">
                  <button
                    type="button"
                    className="fmk-battle-play-button fmk-battle-play-button-lobby disabled:opacity-50"
                    aria-label={battleStarting ? 'Finding Match' : 'Battle'}
                    data-card-tutorial-target="start-battle"
                    disabled={
                      !isCardTutorialActionAllowed('start-battle') ||
                      battleLoading ||
                      battleStarting ||
                      !battleDeck?.valid
                    }
                    onClick={() => void handleStartBattle()}
                  >
                    <img src={playButtonAsset} alt="" aria-hidden="true" />
                  </button>
                  <div className="fmk-battle-side-actions">
                    <button
                      type="button"
                      className="fmk-battle-action-button rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                      aria-label="Modify Deck"
                      data-card-tutorial-target="modify-deck"
                      disabled={!isCardTutorialActionAllowed('modify-deck')}
                      onClick={openCardDeckEditor}
                    >
                      <img
                        src={modifyDeckIcon}
                        alt=""
                        aria-hidden="true"
                        className="fmk-battle-action-icon"
                      />
                    </button>
                  </div>
                </div>
              </section>
            ) : null}

            {matchmakingActive && pendingBattleStart ? (
              <section
                className={clsx(
                  'fmk-matchmaking-card rounded-xl border border-[#ffe27a]/35 bg-black/25 p-4 text-center',
                  matchmakingLocked && 'fmk-matchmaking-card-locked'
                )}
              >
                <p className="text-xs font-black uppercase tracking-wide text-[#ffd84a]">
                  {matchmakingLocked ? 'Opponent locked' : 'Searching for an opponent...'}
                </p>
                <div className="mt-4 grid items-center gap-3 sm:grid-cols-[1fr_auto_1fr]">
                  <div className="fmk-matchmaking-player-panel rounded-xl border border-white/15 bg-[#2b004a] p-4">
                    <p className="text-[10px] font-semibold uppercase tracking-wide text-white/55">
                      You
                    </p>
                    <p className="mt-1 truncate text-lg font-black text-white">
                      {matchmakingPlayerName}
                    </p>
                  </div>
                  <div className="fmk-matchmaking-vs text-xl font-black text-[#ffd84a]">
                    <span>VS</span>
                  </div>
                  <div className="fmk-matchmaking-opponent-panel rounded-xl border border-[#ffd84a]/35 bg-[#2b004a] p-4 shadow-[0_0_24px_rgba(253,197,0,0.18)]">
                    <p className="text-[10px] font-semibold uppercase tracking-wide text-white/55">
                      Opponent
                    </p>
                    <p
                      key={matchmakingOpponentName}
                      className="fmk-matchmaking-name mt-1 truncate text-lg font-black text-[#ffeaa0]"
                    >
                      {matchmakingOpponentName}
                    </p>
                  </div>
                </div>
              </section>
            ) : battleIsActive && battle ? (
              <section className="mt-4">
                <BattleMotionLayer
                  attackAnimation={battleAttackAnimation}
                  drawAnimation={battleDrawAnimation}
                  healAnimations={battleHealAnimations}
                />

                <div className="space-y-4">
                  <div className="fmk-battle-board-row fmk-battle-board-row-opponent">
                    <BattleDeckStack
                      side="opponent"
                      count={battleDeckCountOverrides.opponent ?? battle.opponent.deck.length}
                      displayName={battle.opponent.displayName}
                      registerBattleDeck={registerBattleDeck}
                    />
                    <div className="fmk-battle-card-grid grid grid-cols-3 gap-3">
                      {battle.opponent.active.map((card, index) => (
                        <BattleCardSlot
                          key={card?.instanceId ?? `opponent-empty-${index}`}
                          card={card}
                          side="opponent"
                          slotIndex={index}
                          attackAnimation={battleAttackAnimation}
                          drawReveal={battleDrawReveal}
                          registerBattleCard={registerBattleCard}
                          registerBattleSlot={registerBattleSlot}
                          onInspect={(card) => setSelectedCard(battleCardToPreviewCard(card))}
                          damageAmount={
                            card && battleAttackAnimation?.targetInstanceId === card.instanceId
                              ? battleAttackAnimation.targetDamage
                              : null
                          }
                          healAmount={
                            card
                              ? (battleHealAnimations.find(
                                  (animation) => animation.targetInstanceId === card.instanceId
                                )?.amount ?? null)
                              : null
                          }
                          disabled={
                            !isCardTutorialActionAllowed('select-target') ||
                            battleActionLoading ||
                            battleAnimating ||
                            battle.status !== 'active' ||
                            battle.turn !== 'player' ||
                            !selectedBattleAttacker
                          }
                          {...(selectedBattleAttacker && battle.status === 'active'
                            ? {
                                onClick: (target: BattleCard) =>
                                  void handleBattleAttack(target.instanceId),
                              }
                            : {})}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="fmk-battle-turn-divider" aria-live="polite">
                    <span>
                      {battle.status === 'active'
                        ? battle.turn === 'player'
                          ? 'Your turn'
                          : "Opponent's turn"
                        : battle.status === 'won'
                          ? 'Victory'
                          : battle.status === 'forfeited'
                            ? 'Forfeited'
                            : 'Defeat'}
                    </span>
                  </div>

                  <div className="fmk-battle-board-row fmk-battle-board-row-player">
                    <div className="fmk-battle-card-grid grid grid-cols-3 gap-3">
                      {battle.player.active.map((card, index) => (
                        <BattleCardSlot
                          key={card?.instanceId ?? `player-empty-${index}`}
                          card={card}
                          side="player"
                          slotIndex={index}
                          selected={Boolean(card && card.instanceId === selectedBattleAttacker)}
                          attackAnimation={battleAttackAnimation}
                          drawReveal={battleDrawReveal}
                          registerBattleCard={registerBattleCard}
                          registerBattleSlot={registerBattleSlot}
                          onInspect={(card) => setSelectedCard(battleCardToPreviewCard(card))}
                          damageAmount={
                            card && battleAttackAnimation?.targetInstanceId === card.instanceId
                              ? battleAttackAnimation.targetDamage
                              : null
                          }
                          healAmount={
                            card
                              ? (battleHealAnimations.find(
                                  (animation) => animation.targetInstanceId === card.instanceId
                                )?.amount ?? null)
                              : null
                          }
                          disabled={
                            !isCardTutorialActionAllowed('select-attacker') ||
                            battleActionLoading ||
                            battleAnimating ||
                            battle.status !== 'active' ||
                            battle.turn !== 'player'
                          }
                          onClick={(attacker) => {
                            if (!isCardTutorialActionAllowed('select-attacker')) return;
                            setSelectedBattleAttacker((prev) =>
                              prev === attacker.instanceId ? null : attacker.instanceId
                            );
                            if (cardTutorialStep === 'select_attacker') {
                              setCardTutorialStep('select_target');
                            }
                          }}
                        />
                      ))}
                    </div>
                    <BattleDeckStack
                      side="player"
                      count={battleDeckCountOverrides.player ?? battle.player.deck.length}
                      displayName={battle.player.displayName}
                      registerBattleDeck={registerBattleDeck}
                    />
                  </div>
                </div>
              </section>
            ) : null}
          </div>
        ) : null}

        {!loading && view === 'quests' ? (
          <div className="aura-panel fmk-card-menu-page rounded-2xl bg-[#5c0099] p-4 text-white">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                  Daily
                </p>
                <h2 className="text-xl font-black text-white">Quests</h2>
              </div>
              <div
                ref={goldBadgeRef}
                className="flex items-center gap-2 rounded-lg bg-black/25 px-3 py-2 text-sm font-black text-[#ffd84a]"
              >
                <img src={coinsIcon} alt="" className="h-6 w-6 object-contain" />
                {(questsState?.currency.gold ?? currency.gold).toLocaleString()}
              </div>
            </div>
            {questsLoading ? (
              <div className="mt-4 rounded-xl border border-white/20 bg-black/20 p-6 text-center text-sm font-semibold">
                Loading quests...
              </div>
            ) : null}
            {questsError ? (
              <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                {questsError}
              </div>
            ) : null}
            <div className="mt-4 grid gap-3">
              {(questsState?.quests ?? []).map((quest) => {
                const claimable = quest.completed && !quest.claimed;
                return (
                  <article key={quest.id} className="aura-card rounded-xl bg-[#4a0079] p-4">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                          {quest.title}
                        </h3>
                        <p className="mt-1 text-xs font-semibold text-white/70">
                          {quest.description}
                        </p>
                      </div>
                      <div className="inline-flex shrink-0 items-center gap-1 rounded-full bg-black/25 px-3 py-1 text-xs font-black text-[#ffd84a]">
                        <span>+{quest.rewardGold}</span>
                        <CurrencyIcon kind="coin" className="h-4 w-4" />
                      </div>
                    </div>
                    <div className="mt-4 flex items-center justify-between gap-3">
                      <span
                        className={clsx(
                          'rounded-full px-3 py-1 text-xs font-black',
                          quest.claimed
                            ? 'bg-white/10 text-white/55'
                            : quest.completed
                              ? 'bg-[#fdc500]/20 text-[#ffeaa0]'
                              : 'bg-black/25 text-white/65'
                        )}
                      >
                        {quest.claimed ? 'Claimed' : quest.completed ? 'Complete' : 'Incomplete'}
                      </span>
                      <button
                        type="button"
                        className="rounded-full px-4 py-2 text-xs font-black text-white btn-3d-gold disabled:opacity-50"
                        disabled={!claimable || Boolean(questActionLoading)}
                        onClick={(event) =>
                          void handleClaimQuest(quest, event.currentTarget.getBoundingClientRect())
                        }
                      >
                        {questActionLoading === quest.id ? 'Claiming...' : 'Claim'}
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
            <div className="mt-5">
              <button
                type="button"
                aria-label="Open F.M.K companions"
                className="aura-card flex w-full items-center justify-center gap-5 rounded-xl bg-[#4a0079] p-6 text-left font-black uppercase tracking-wide text-white btn-3d-purple"
                onClick={() => void openGallery()}
              >
                <img
                  src={fmkGalleryIcon}
                  alt=""
                  className="h-20 w-20 shrink-0 object-contain sm:h-24 sm:w-24"
                />
                <span className="text-xl leading-tight sm:text-2xl">F.M.K Companions</span>
              </button>
            </div>
          </div>
        ) : null}

        {!loading && view === 'shop' ? (
          <div className="aura-panel fmk-card-menu-page relative isolate rounded-2xl bg-[#5c0099] p-4 text-white">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-black text-white">Shop</h2>
              </div>
            </div>

            <div className="sticky top-2 z-[70] mt-4 flex gap-2 overflow-x-auto rounded-xl border border-[#ffe27a]/30 bg-[#3d0066]/95 p-2 shadow-[0_10px_24px_rgba(0,0,0,0.35)] backdrop-blur">
              {SHOP_TABS.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  className="relative shrink-0 rounded-full px-4 py-2 text-xs font-black text-white btn-3d-purple"
                  onClick={() => scrollToShopSection(tab.id)}
                >
                  {tab.id === 'daily-gift' && shopDailyGiftAvailable ? (
                    <span
                      className="absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full border-2 border-white bg-red-500 shadow"
                      aria-hidden="true"
                    />
                  ) : null}
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-2 rounded-xl border border-white/15 bg-black/20 p-3">
              <div className="flex items-center gap-2 rounded-lg bg-black/25 px-3 py-2 text-sm font-black text-[#ffd84a]">
                <img src={coinsIcon} alt="" className="h-6 w-6 object-contain" />
                {shopCurrency.gold.toLocaleString()}
              </div>
              <div className="flex items-center gap-2 rounded-lg bg-black/25 px-3 py-2 text-sm font-black text-[#90f7ff]">
                <img src={gemsIcon} alt="" className="h-6 w-6 object-contain" />
                {shopCurrency.gems.toLocaleString()}
              </div>
              <div className="flex items-center gap-2 rounded-lg bg-black/25 px-3 py-2 text-sm font-black text-white">
                <img src={cardPackTransparent} alt="" className="h-7 w-7 object-contain" />
                {shopUnopenedPacks.toLocaleString()} PACKS
              </div>
            </div>

            {shopLoading ? (
              <div className="mt-4 rounded-xl border border-white/20 bg-black/20 p-6 text-center text-sm font-semibold">
                Loading shop...
              </div>
            ) : null}

            {shopError ? (
              <div className="mt-4 rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                {shopError}
              </div>
            ) : null}

            <div className="mt-5 space-y-5">
              <section
                id="shop-special"
                className="scroll-mt-24 rounded-xl border border-white/15 bg-black/20 p-4"
              >
                <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                  Special
                </h3>
                <div className="mt-3 grid gap-4 lg:grid-cols-2">
                  {SHOP_SPECIAL_BUNDLES.map((bundle, index) => {
                    const ribbon = getShopBundleRibbon(index, SHOP_SPECIAL_BUNDLES.length);
                    const coinArt = getShopCoinBundleArt(bundle.gold);
                    const gemArt = getShopGemBundleArt(bundle.gems);
                    return (
                      <article
                        key={bundle.id}
                        className="aura-card relative overflow-hidden rounded-xl bg-[#4a0079] p-4"
                      >
                        {ribbon ? <ShopOfferRibbon label={ribbon} /> : null}
                        <div className="grid grid-cols-3 items-end gap-2">
                          <ShopCurrencyArt
                            src={coinArt}
                            count={getShopCurrencyArtRepeatCount(
                              SHOP_SPECIAL_BUNDLES,
                              index,
                              (item) => getShopCoinBundleArt(item.gold)
                            )}
                            className="mx-auto h-24 w-full"
                          />
                          <ShopCurrencyArt
                            src={gemArt}
                            count={getShopCurrencyArtRepeatCount(
                              SHOP_SPECIAL_BUNDLES,
                              index,
                              (item) => getShopGemBundleArt(item.gems)
                            )}
                            className="mx-auto h-24 w-full"
                          />
                          <ShopPackStack packs={bundle.packs} className="h-24 w-full" />
                        </div>
                        <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs font-bold text-white/80">
                          <span>{bundle.gold.toLocaleString()} GOLD</span>
                          <span>{bundle.gems.toLocaleString()} GEMS</span>
                          <span>
                            {bundle.packs} {bundle.packs === 1 ? 'PACK' : 'PACKS'}
                          </span>
                        </div>
                        <div className="mt-4 flex justify-center">
                          <button
                            type="button"
                            className="rounded-full px-5 py-2 text-sm font-black text-white btn-3d-gold"
                            onClick={() => void openShopCheckout(buildSpecialPaidOffer(bundle))}
                          >
                            {bundle.price}
                          </button>
                        </div>
                      </article>
                    );
                  })}
                </div>
              </section>

              <section
                id="shop-daily-gift"
                className="scroll-mt-24 rounded-xl border border-white/15 bg-black/20 p-4"
              >
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">
                      Daily Gift
                    </h3>
                    <p className="mt-1 text-xs font-semibold text-white/65">
                      {shopDailyGift?.available
                        ? `${shopDailyGift.rewardGold} GOLD + ${shopDailyGift.rewardGems} GEMS`
                        : shopDailyReadyAt
                          ? `Next gift: ${shopDailyReadyAt}`
                          : 'Daily gift unavailable'}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="relative rounded-full px-4 py-2 text-sm font-black text-white btn-3d-gold disabled:opacity-50"
                    disabled={
                      shopActionLoading === 'daily-gift' || shopLoading || !shopDailyGift?.available
                    }
                    onClick={() => void handleClaimDailyGift()}
                  >
                    {shopDailyGiftAvailable ? (
                      <span
                        className="absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full border-2 border-white bg-red-500 shadow"
                        aria-hidden="true"
                      />
                    ) : null}
                    {shopActionLoading === 'daily-gift' ? 'Claiming...' : 'Claim'}
                  </button>
                </div>
                <div className="mt-3 grid gap-3 sm:grid-cols-2">
                  <div className="aura-card flex items-center justify-between rounded-xl bg-[#4a0079] p-4">
                    <div className="flex items-center gap-3">
                      <img src={coinsIcon} alt="" className="h-8 w-8 object-contain" />
                      <div>
                        <span className="text-sm font-black">WATCH VIDEO FOR COINS</span>
                        <p className="text-xs font-semibold text-white/60">
                          {shopAdGoldReward ? `${shopAdGoldReward.rewardGold} GOLD` : '100 GOLD'}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="rounded-full px-4 py-2 text-xs font-black text-white btn-3d-gold disabled:opacity-50"
                      disabled={
                        shopLoading ||
                        Boolean(shopActionLoading) ||
                        (shopAdGoldReward ? !shopAdGoldReward.available : true)
                      }
                      onClick={() => openShopRewardedAd('gold')}
                    >
                      {getShopAdRewardButtonLabel(
                        'gold',
                        shopAdGoldReward?.available ?? false,
                        shopAdGoldReward?.nextClaimAt ?? 0
                      )}
                    </button>
                  </div>
                  <div className="aura-card flex items-center justify-between rounded-xl bg-[#4a0079] p-4">
                    <div className="flex items-center gap-3">
                      <img src={gemsIcon} alt="" className="h-8 w-8 object-contain" />
                      <div>
                        <span className="text-sm font-black">WATCH VIDEO FOR GEMS</span>
                        <p className="text-xs font-semibold text-white/60">
                          {shopAdGemsReward ? `${shopAdGemsReward.rewardGems} GEMS` : '5 GEMS'}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="rounded-full px-4 py-2 text-xs font-black text-white btn-3d-gold disabled:opacity-50"
                      disabled={
                        shopLoading ||
                        Boolean(shopActionLoading) ||
                        (shopAdGemsReward ? !shopAdGemsReward.available : true)
                      }
                      onClick={() => openShopRewardedAd('gems')}
                    >
                      {getShopAdRewardButtonLabel(
                        'gems',
                        shopAdGemsReward?.available ?? false,
                        shopAdGemsReward?.nextClaimAt ?? 0
                      )}
                    </button>
                  </div>
                </div>
              </section>

              <section
                id="shop-gems"
                className="scroll-mt-24 rounded-xl border border-white/15 bg-black/20 p-4"
              >
                <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">Gems</h3>
                <div className="mt-3 grid gap-4 md:grid-cols-2">
                  {SHOP_GEM_BUNDLES.map((bundle, index) => {
                    const ribbon = getShopBundleRibbon(index, SHOP_GEM_BUNDLES.length);
                    const gemArt = getShopGemBundleArt(bundle.gems);
                    return (
                      <article
                        key={bundle.id}
                        className="aura-card relative overflow-hidden rounded-xl bg-[#4a0079] p-4 text-center"
                      >
                        {ribbon ? <ShopOfferRibbon label={ribbon} /> : null}
                        <ShopCurrencyArt
                          src={gemArt}
                          count={getShopCurrencyArtRepeatCount(SHOP_GEM_BUNDLES, index, (item) =>
                            getShopGemBundleArt(item.gems)
                          )}
                          className="mx-auto h-36 w-full"
                        />
                        <div className="mt-3 flex items-center justify-center gap-2">
                          <img src={gemsIcon} alt="" className="h-6 w-6 shrink-0 object-contain" />
                          <span className="text-xl font-black text-[#90f7ff]">
                            {bundle.gems.toLocaleString()} GEMS
                          </span>
                        </div>
                        <div className="mt-4 flex justify-center">
                          <button
                            type="button"
                            className="rounded-full px-5 py-2 text-sm font-black text-white btn-3d-gold"
                            onClick={() => void openShopCheckout(buildGemPaidOffer(bundle))}
                          >
                            {bundle.price}
                          </button>
                        </div>
                      </article>
                    );
                  })}
                </div>
              </section>

              <section
                id="shop-packs"
                className="scroll-mt-24 rounded-xl border border-white/15 bg-black/20 p-4"
              >
                <h3 className="text-sm font-black uppercase tracking-wide text-[#ffd84a]">Packs</h3>
                <div className="mt-3 grid gap-4 md:grid-cols-2">
                  {SHOP_PACK_BUNDLES.map((bundle, index) => {
                    const canAfford = shopCurrency.gems >= bundle.gems;
                    const loadingBundle = shopActionLoading === bundle.id;
                    const ribbon = getShopBundleRibbon(index, SHOP_PACK_BUNDLES.length);
                    return (
                      <article
                        key={bundle.id}
                        className="aura-card relative overflow-hidden rounded-xl bg-[#4a0079] p-4 text-center"
                      >
                        {ribbon ? <ShopOfferRibbon label={ribbon} /> : null}
                        <ShopPackStack packs={bundle.packs} className="h-40 w-full" />
                        <div className="mt-2 text-xl font-black">
                          {bundle.packs} {bundle.packs === 1 ? 'PACK' : 'PACKS'}
                        </div>
                        <div className="mt-1 flex items-center justify-center gap-2 text-sm font-black text-[#90f7ff]">
                          <img src={gemsIcon} alt="" className="h-5 w-5 object-contain" />
                          {bundle.gems} GEMS
                        </div>
                        <button
                          type="button"
                          className="mt-4 w-full rounded-full px-4 py-2 text-sm font-black text-white btn-3d-purple disabled:opacity-50"
                          disabled={!canAfford || Boolean(shopActionLoading)}
                          onClick={() => void handlePurchaseShopPacks(bundle.packs)}
                        >
                          {loadingBundle ? 'Buying...' : 'Buy'}
                        </button>
                      </article>
                    );
                  })}
                </div>
              </section>
            </div>
          </div>
        ) : null}

        {!loading && view === 'create' ? (
          <div className="aura-panel rounded-2xl bg-[#5c0099] p-4">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-bold text-white">Create a new F.M.K</h2>
              <span className="text-xs font-semibold text-[#fdc500]">Exactly 3 options</span>
            </div>
            <div className="mt-4 flex flex-col gap-3">
              <div className="aura-card rounded-xl bg-[#510087] p-3">
                <label
                  className="mb-1 block text-xs font-semibold uppercase tracking-wide text-white/90"
                  htmlFor="create-post-title"
                >
                  Title post
                </label>
                <input
                  id="create-post-title"
                  type="text"
                  maxLength={120}
                  className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/70"
                  placeholder="Enter a post title"
                  value={createTitle}
                  onChange={(e) => setCreateTitle(e.target.value)}
                  onBlur={() => setCreateTitleTouched(true)}
                />
                {createTitleTouched && createTitleInvalid ? (
                  <p className="mt-2 text-xs font-semibold text-red-200">Title post is required.</p>
                ) : null}
              </div>
              <div className="aura-card rounded-xl bg-[#510087] p-3">
                <label
                  className="mb-1 block text-xs font-semibold uppercase tracking-wide text-white/90"
                  htmlFor="create-post-type"
                >
                  Post type
                </label>
                <select
                  id="create-post-type"
                  className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm font-semibold text-white"
                  value={createPostType}
                  onChange={(event) => setCreatePostType(event.target.value as FMKPostType)}
                >
                  {POST_TYPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-center justify-between text-sm font-semibold text-white">
                <span>
                  Slot {currentCreateSlot + 1} of {slots.length}
                </span>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => setCurrentCreateSlot((prev) => Math.max(0, prev - 1))}
                    disabled={currentCreateSlot === 0}
                    className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white disabled:opacity-50 btn-3d-gold"
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const currentSlot = slots[currentCreateSlot];
                      if (!currentSlot) return;
                      const needsImage = currentSlot.kind === 'image' && !currentSlot.value;
                      const needsFaceCrop =
                        currentSlot.kind === 'image' &&
                        Boolean(currentSlot.value) &&
                        !currentSlot.faceValue;
                      if (needsImage || needsFaceCrop) {
                        setCreateFacePromptOpen(true);
                        return;
                      }
                      setCurrentCreateSlot((prev) => Math.min(slots.length - 1, prev + 1));
                    }}
                    disabled={currentCreateSlot === slots.length - 1}
                    className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white disabled:opacity-50 btn-3d-gold"
                  >
                    Next
                  </button>
                </div>
              </div>
              {slots.map((slot, index) =>
                index === currentCreateSlot ? (
                  <div
                    key={index}
                    className="aura-card flex flex-col gap-2 rounded-xl bg-[#510087] p-3"
                  >
                    {slot.kind === 'image' ? (
                      <input
                        type="text"
                        className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/70"
                        placeholder="Label"
                        value={slot.label}
                        onChange={(e) => updateSlot(index, { label: e.target.value })}
                      />
                    ) : null}
                    <select
                      className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white"
                      value={slot.kind}
                      onChange={(e) =>
                        updateSlot(index, {
                          kind: e.target.value as SlotInput['kind'],
                          faceValue: '',
                        })
                      }
                    >
                      <option value="image">Image</option>
                      <option value="text">Text</option>
                    </select>
                    {slot.kind === 'text' ? (
                      <textarea
                        rows={3}
                        className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/70"
                        placeholder="Enter text"
                        value={slot.value}
                        onChange={(e) =>
                          updateSlot(index, { value: e.target.value, label: e.target.value })
                        }
                      />
                    ) : (
                      <div className="flex flex-col gap-2">
                        <div
                          className="aura-dashed group flex min-h-[140px] w-full flex-col items-center justify-center gap-2 rounded-xl bg-white/5 px-3 py-4 text-center text-sm text-white hover:bg-white/10"
                          onClick={() => triggerFileSelect(index)}
                          onDragOver={(e) => e.preventDefault()}
                          onDragEnter={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault();
                            handleDropFile(index, e.dataTransfer?.files ?? null);
                          }}
                        >
                          {slot.value ? (
                            <img
                              src={slot.value}
                              alt={slot.label}
                              className="aura-frame h-28 w-full rounded-lg object-contain bg-[#3d0066]"
                            />
                          ) : (
                            <>
                              <div className="text-4xl">📤</div>
                              <div className="font-semibold text-white">
                                Drag & drop or click to upload
                              </div>
                              <div className="text-xs text-white/80">
                                Images only. Replaces current image. Large files are compressed
                                automatically.
                              </div>
                            </>
                          )}
                        </div>
                        {slot.value ? (
                          <div className="flex flex-wrap items-center gap-2 text-xs text-white/80">
                            <button
                              type="button"
                              className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
                              onClick={() => openFaceCrop(index)}
                            >
                              Crop face
                            </button>
                            {slot.faceValue ? (
                              <>
                                <img
                                  src={slot.faceValue}
                                  alt={`${slot.label} face`}
                                  className="aura-frame h-10 w-10 rounded-full object-cover bg-[#3d0066]"
                                />
                                <button
                                  type="button"
                                  className="rounded-lg bg-[#510087] px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                                  onClick={() => updateSlot(index, { faceValue: '' })}
                                >
                                  Clear face
                                </button>
                              </>
                            ) : (
                              <span>No face crop yet.</span>
                            )}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                ) : null
              )}
            </div>
            {createFacePromptOpen ? (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
                <div className="aura-panel w-full max-w-sm rounded-2xl bg-[#5c0099] p-4 text-center text-sm font-semibold text-white shadow-2xl">
                  <p>Please upload an image and crop a face before proceeding.</p>
                  <div className="mt-4 flex items-center justify-center gap-3">
                    <button
                      type="button"
                      onClick={() => setCreateFacePromptOpen(false)}
                      className="rounded-lg bg-[#fdc500] px-4 py-2 text-xs font-semibold text-white btn-3d-gold"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
            {!hasUploadedImage ? (
              <p className="mt-3 text-xs text-white/80">
                We publish This F.M.K using your account. Publish, then share the post link so the
                community can vote.
              </p>
            ) : null}
            {postedAs === 'app' ? (
              <div className="mt-2 rounded-lg border border-yellow-300 bg-yellow-100 px-3 py-2 text-xs font-semibold text-yellow-900">
                Couldn't publish as your account, so this one was posted by the app. Check your
                posting permissions in this subreddit.{' '}
                {postedAsReason ? `Reason: ${postedAsReason}` : ''}
              </div>
            ) : null}
            {createBlocked ? (
              <p className="mt-3 text-xs font-semibold text-red-100">Sign in to create posts.</p>
            ) : null}
            <div className="mt-4 flex justify-end">
              <button
                type="button"
                onClick={submitCreate}
                disabled={creating || createTitleInvalid || createBlocked}
                className="rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-60 btn-3d-gold"
              >
                {creating ? 'Saving...' : 'Publish F.M.K'}
              </button>
            </div>
          </div>
        ) : null}

        {!loading && view === 'settings' ? (
          <div className="aura-panel rounded-2xl bg-[#5c0099] p-4">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-bold text-white">Settings</h2>
              <button
                type="button"
                onClick={closeSettings}
                className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
              >
                Return
              </button>
            </div>
            <div className="mt-4 flex flex-col gap-3">
              {battleIsActive ? (
                <div className="aura-card flex items-center justify-between gap-3 rounded-xl bg-[#510087] px-3 py-2">
                  <div>
                    <p className="text-sm font-semibold text-white">Current battle</p>
                    <p className="text-xs text-white/80">Leave this ranked duel</p>
                  </div>
                  <button
                    type="button"
                    className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                    disabled={battleActionLoading || battleAnimating}
                    onClick={() => void handleForfeitBattle()}
                  >
                    Forfeit
                  </button>
                </div>
              ) : null}
              <div className="aura-card flex items-center justify-between rounded-xl bg-[#510087] px-3 py-2">
                <div>
                  <p className="text-sm font-semibold text-white">Page audio</p>
                  <p className="text-xs text-white/80">Mute/unmute all in-app sounds</p>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    const nextMuted = !isMuted;
                    setIsMuted(nextMuted);
                    void updateAudioPreference(nextMuted);
                  }}
                  className="rounded-lg bg-white/10 px-4 py-2 text-sm font-semibold text-white hover:bg-white/20"
                >
                  {isMuted ? 'Unmute' : 'Mute'}
                </button>
              </div>
              <div className="aura-card rounded-xl bg-[#510087] px-3 py-3">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <p className="text-sm font-semibold text-white">Moderator tools</p>
                    <p className="text-xs text-white/80">
                      {moderationToolsOpen
                        ? 'Review reports and remove posts'
                        : 'Open to view moderation actions'}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                    onClick={() => setModerationToolsOpen((prev) => !prev)}
                  >
                    {moderationToolsOpen ? 'Close moderation tools' : 'Moderation tools'}
                  </button>
                </div>
                {moderationToolsOpen ? (
                  <>
                    <div className="mt-2 flex justify-end">
                      <button
                        type="button"
                        className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                        disabled={
                          adminReportsLoading || adminAnalyticsLoading || !adminToken.trim()
                        }
                        onClick={() => {
                          void loadAdminReportedPosts(adminReportsPage);
                          void loadAdminAnalyticsSummary(adminAnalyticsDays);
                        }}
                      >
                        Refresh
                      </button>
                    </div>
                    <div className="mt-2">
                      <label
                        className="mb-1 block text-xs font-semibold text-white/90"
                        htmlFor="admin-token-input"
                      >
                        Admin token
                      </label>
                      <input
                        id="admin-token-input"
                        type="password"
                        value={adminToken}
                        onChange={(event) => {
                          setAdminToken(event.target.value);
                          setAdminReportsPage(1);
                        }}
                        className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-xs text-white placeholder-white/70"
                        placeholder="Enter admin token"
                      />
                    </div>
                    <label className="mt-2 flex items-center gap-2 text-xs font-semibold text-white/90">
                      <input
                        type="checkbox"
                        checked={adminHardDelete}
                        onChange={(event) => setAdminHardDelete(event.target.checked)}
                        className="h-4 w-4 accent-[#fdc500]"
                      />
                      Hard delete data and attempt image cleanup
                    </label>
                    <div className="mt-3 rounded-lg border border-white/15 bg-black/20 p-3">
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <div>
                          <p className="text-sm font-semibold text-white">Analytics</p>
                          <p className="text-xs text-white/75">
                            {adminAnalyticsSummary
                              ? `${adminAnalyticsSummary.days} day summary`
                              : 'No analytics loaded yet'}
                          </p>
                        </div>
                        <div className="flex flex-wrap gap-1">
                          {ANALYTICS_DAY_OPTIONS.map((days) => (
                            <button
                              key={days}
                              type="button"
                              className={clsx(
                                'rounded-lg px-2 py-1 text-[11px] font-semibold text-white disabled:opacity-60',
                                adminAnalyticsDays === days ? 'btn-3d-gold' : 'btn-3d-purple'
                              )}
                              disabled={adminAnalyticsLoading}
                              onClick={() => {
                                setAdminAnalyticsDays(days);
                                void loadAdminAnalyticsSummary(days);
                              }}
                            >
                              {days}d
                            </button>
                          ))}
                        </div>
                      </div>
                      {adminAnalyticsLoading ? (
                        <p className="mt-3 text-xs font-semibold text-white/80">
                          Loading analytics...
                        </p>
                      ) : null}
                      {!adminAnalyticsLoading && adminAnalyticsError ? (
                        <p className="mt-3 text-xs font-semibold text-red-200">
                          {adminAnalyticsError}
                        </p>
                      ) : null}
                      {!adminAnalyticsLoading && adminAnalyticsSummary ? (
                        <div className="mt-3 space-y-3">
                          <div className="grid gap-2 sm:grid-cols-3">
                            {[
                              ['Daily users', adminAnalyticsSummary.totals.uniqueUsers],
                              ['Tracked actions', adminAnalyticsSummary.totals.totalEvents],
                              ['Goo starts', adminAnalyticsSummary.totals.gooStarts],
                              ['Done presses', adminAnalyticsSummary.totals.gooDonePresses],
                              ['Goo rewards', adminAnalyticsSummary.totals.gooRewards],
                              ['Kill win rate', `${adminAnalyticsSummary.totals.killWaveWinRate}%`],
                              ['Tournament plays', adminAnalyticsSummary.totals.tournamentPlays],
                              [
                                'Tournament choices',
                                adminAnalyticsSummary.totals.tournamentChoices,
                              ],
                              ['Marry foot rubs', adminAnalyticsSummary.totals.marryFootRubs],
                              ['Fun back rubs', adminAnalyticsSummary.totals.funBackRubs],
                            ].map(([label, value]) => (
                              <div key={label} className="rounded-lg bg-[#3d0066] px-3 py-2">
                                <p className="text-[11px] font-semibold text-white/70">{label}</p>
                                <p className="mt-1 text-lg font-black text-white">{value}</p>
                              </div>
                            ))}
                          </div>
                          {analyticsRecentDaily.length ? (
                            <div>
                              <p className="text-xs font-semibold text-white/85">Daily trend</p>
                              <div className="mt-2 grid gap-1 sm:grid-cols-2">
                                {analyticsRecentDaily.map((point) => (
                                  <div
                                    key={point.date}
                                    className="flex items-center justify-between rounded-lg bg-[#3d0066] px-2 py-1 text-[11px] font-semibold text-white/85"
                                  >
                                    <span>{point.date}</span>
                                    <span>
                                      {point.uniqueUsers} users / {point.totalEvents} actions
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : null}
                          <div className="grid gap-3 lg:grid-cols-3">
                            {[
                              ['Top actions', analyticsTopEvents],
                              ['Pages', analyticsTopPages],
                              ['Galleries', analyticsTopGalleries],
                            ].map(([title, metrics]) => (
                              <div key={title as string}>
                                <p className="text-xs font-semibold text-white/85">
                                  {title as string}
                                </p>
                                <div className="mt-2 space-y-1">
                                  {(metrics as typeof analyticsTopEvents).length ? (
                                    (metrics as typeof analyticsTopEvents).map((metric) => (
                                      <div
                                        key={metric.name}
                                        className="flex items-center justify-between gap-2 rounded-lg bg-[#3d0066] px-2 py-1 text-[11px] font-semibold text-white/85"
                                      >
                                        <span className="truncate">
                                          {toAnalyticsMetricLabel(metric.name)}
                                        </span>
                                        <span>{metric.count}</span>
                                      </div>
                                    ))
                                  ) : (
                                    <p className="text-[11px] text-white/65">No data</p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-3">
                      {adminReportsLoading ? (
                        <p className="text-xs font-semibold text-white/80">
                          Loading reported posts...
                        </p>
                      ) : null}
                      {!adminReportsLoading && adminReportsError ? (
                        <p className="text-xs font-semibold text-red-200">{adminReportsError}</p>
                      ) : null}
                      {!adminReportsLoading && !adminReportsError && adminReports.length === 0 ? (
                        <p className="text-xs text-white/80">No reported posts right now.</p>
                      ) : null}
                      {!adminReportsLoading && !adminReportsError && adminReports.length > 0 ? (
                        <div className="space-y-2">
                          {adminReports.map((item) => (
                            <div
                              key={item.postId}
                              className="rounded-lg border border-white/20 bg-black/20 p-2"
                            >
                              <div className="flex flex-wrap items-center justify-between gap-2">
                                <div>
                                  <p className="text-xs font-semibold text-white">
                                    {item.title?.trim() || 'Untitled FMK'}
                                  </p>
                                  <p className="text-[11px] text-white/75">
                                    {item.reportCount} report(s) •{' '}
                                    {new Date(item.lastReportedAt).toLocaleString()}
                                  </p>
                                  <p className="text-[11px] font-semibold text-[#fdc500]">
                                    Type: {toPostTypeLabel(item.type)}
                                  </p>
                                  {REPORT_REASONS.some(
                                    (reason) => Number(item.reasonCounts?.[reason] ?? 0) > 0
                                  ) ? (
                                    <div className="mt-2 flex flex-wrap gap-1">
                                      {REPORT_REASONS.filter(
                                        (reason) => Number(item.reasonCounts?.[reason] ?? 0) > 0
                                      ).map((reason) => (
                                        <span
                                          key={reason}
                                          className="rounded-full bg-black/25 px-2 py-0.5 text-[10px] font-semibold text-white/85"
                                        >
                                          {REPORT_REASON_LABELS[reason]}:{' '}
                                          {item.reasonCounts?.[reason]}
                                        </span>
                                      ))}
                                    </div>
                                  ) : null}
                                  {item.recentReports?.length ? (
                                    <div className="mt-2 space-y-1">
                                      {item.recentReports.map((report) => (
                                        <div
                                          key={`${item.postId}-${report.createdAt}-${report.reason}`}
                                          className="rounded-lg bg-black/20 px-2 py-1 text-[11px] text-white/80"
                                        >
                                          <p className="font-semibold text-white/90">
                                            {REPORT_REASON_LABELS[report.reason]} •{' '}
                                            {new Date(report.createdAt).toLocaleString()}
                                          </p>
                                          {report.comment ? (
                                            <p className="mt-0.5 break-words">{report.comment}</p>
                                          ) : null}
                                        </div>
                                      ))}
                                    </div>
                                  ) : null}
                                </div>
                                <div className="flex flex-wrap items-center gap-2">
                                  <select
                                    className="aura-field rounded-lg bg-[#3d0066] px-2 py-1 text-[11px] font-semibold text-white"
                                    value={adminTypeByPost[item.postId] ?? item.type}
                                    disabled={Boolean(adminTypePendingByPost[item.postId])}
                                    onChange={(event) =>
                                      setAdminTypeByPost((prev) => ({
                                        ...prev,
                                        [item.postId]: event.target.value as FMKPostType,
                                      }))
                                    }
                                  >
                                    {POST_TYPE_OPTIONS.map((option) => (
                                      <option key={option.value} value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                  <button
                                    type="button"
                                    className="rounded-lg bg-[#fdc500] px-2 py-1 text-[11px] font-semibold text-white btn-3d-gold disabled:opacity-60"
                                    disabled={Boolean(adminTypePendingByPost[item.postId])}
                                    onClick={() => {
                                      void handleAdminUpdatePostType(item.postId);
                                    }}
                                  >
                                    {adminTypePendingByPost[item.postId]
                                      ? 'Saving...'
                                      : 'Save type'}
                                  </button>
                                  <button
                                    type="button"
                                    className="rounded-lg bg-[#510087] px-2 py-1 text-[11px] font-semibold text-white btn-3d-purple"
                                    onClick={() => {
                                      void openPostFromBrowse(item.postId);
                                    }}
                                  >
                                    Open
                                  </button>
                                  <button
                                    type="button"
                                    className="rounded-lg bg-[#510087] px-2 py-1 text-[11px] font-semibold text-white btn-3d-purple disabled:opacity-60"
                                    disabled={Boolean(adminDismissPendingByPost[item.postId])}
                                    onClick={() => {
                                      void handleAdminDismissReports(item.postId);
                                    }}
                                  >
                                    {adminDismissPendingByPost[item.postId]
                                      ? 'Dismissing...'
                                      : 'Dismiss'}
                                  </button>
                                  <button
                                    type="button"
                                    className="rounded-lg bg-[#fd4b4b] px-2 py-1 text-[11px] font-semibold text-white btn-3d-gold disabled:opacity-60"
                                    disabled={
                                      Boolean(adminRemovePendingByPost[item.postId]) || item.removed
                                    }
                                    onClick={() => {
                                      void handleAdminRemovePost(item.postId);
                                    }}
                                  >
                                    {item.removed ? 'Removed' : 'Remove'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-3 flex items-center justify-between">
                      <button
                        type="button"
                        className="rounded-lg bg-[#510087] px-2 py-1 text-[11px] font-semibold text-white btn-3d-purple disabled:opacity-60"
                        disabled={adminReportsPage <= 1 || adminReportsLoading}
                        onClick={() => setAdminReportsPage((prev) => Math.max(1, prev - 1))}
                      >
                        Previous
                      </button>
                      <span className="text-[11px] font-semibold text-white/80">
                        Page {adminReportsPage}
                      </span>
                      <button
                        type="button"
                        className="rounded-lg bg-[#510087] px-2 py-1 text-[11px] font-semibold text-white btn-3d-purple disabled:opacity-60"
                        disabled={!adminReportsHasMore || adminReportsLoading}
                        onClick={() => setAdminReportsPage((prev) => prev + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </>
                ) : null}
              </div>
              {isAuthenticated ? (
                <div className="aura-card rounded-xl bg-[#510087] px-3 py-3">
                  <p className="text-sm font-semibold text-white">Account</p>
                  <p className="mt-1 text-xs text-white/80">
                    Signed in as @{accountUsername?.trim() || 'user'}. You can sign out here.
                  </p>
                  <div className="mt-3 flex justify-end">
                    <button
                      type="button"
                      className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                      disabled={authSubmitting}
                      onClick={() => void handleAuthSignOut()}
                    >
                      {authSubmitting ? 'Signing out...' : 'Sign out'}
                    </button>
                  </div>
                </div>
              ) : null}
              <p className="pt-2 text-center text-xs font-semibold text-white/85">
                Contact us:{' '}
                <a href="mailto:fmk.game.support@gmail.com">fmk.game.support@gmail.com</a>
              </p>
            </div>
          </div>
        ) : null}

        {!loading && view === 'gallery' ? (
          <>
            {isKillGallery ? (
              <div className="aura-panel rounded-2xl bg-[#5c0099] p-4">
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div
                      ref={goldBadgeRef}
                      className="aura-chip relative flex h-7 items-center gap-2 rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white"
                    >
                      <CurrencyIcon kind="coin" />
                      <span>{galleryDisplayGold}</span>
                    </div>
                    <div className="aura-chip-blue flex h-7 items-center gap-2 rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white">
                      <CurrencyIcon kind="gem" />
                      <span>{galleryDisplayGems}</span>
                      <button
                        type="button"
                        onClick={openGalleryGemShop}
                        className="rounded-full bg-[#fdc500] px-2 py-0.5 text-xs font-semibold text-white"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <img
                    src={killBg}
                    alt="Kill gallery"
                    className="pointer-events-none absolute left-1/2 top-1/2 h-14 -translate-x-1/2 -translate-y-1/2 object-contain"
                  />
                  <button
                    type="button"
                    onClick={closeGallery}
                    className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
                  >
                    Return
                  </button>
                </div>
                <div className="mt-4">
                  <div
                    ref={killGameRef}
                    onClick={handleKillShot}
                    className="relative h-[420px] w-full overflow-hidden rounded-2xl border-2 border-white/20 bg-[#1a001f]"
                    style={{
                      backgroundImage: `url(${killGalleryBg})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  >
                    {!killWaveActive ? (
                      <button
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          trackAnalyticsEvent('gallery_tab_change', {
                            galleryType: 'marry',
                            fromGalleryType: 'kill',
                          });
                          setGalleryType('marry');
                        }}
                        className="absolute left-3 top-1/2 z-[260] -translate-y-1/2 rounded-xl bg-[#fdc500] px-4 py-1.5 text-2xl font-semibold text-white btn-3d-gold"
                      >
                        ←
                      </button>
                    ) : null}
                    <div className="aura-chip absolute left-3 top-3 z-[210] rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white">
                      Survive: {surviveTimerLabel}
                    </div>
                    <div className="aura-chip absolute right-3 top-3 z-[210] rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white">
                      {'❤️'.repeat(killHearts)}
                    </div>
                    {killEnemies.map((enemy) => (
                      <div
                        key={enemy.id}
                        className="absolute"
                        style={{
                          left: `${enemy.x}%`,
                          top: `${enemy.y}%`,
                          transform: 'translate(-50%, 0)',
                        }}
                      >
                        <div className="relative kill-enemy">
                          {enemy.alive ? (
                            <SpriteLoop
                              src={soldierWalkSprite}
                              cols={4}
                              rows={7}
                              frameCount={28}
                              fps={18}
                              width={78}
                              height={110}
                              className="kill-soldier-sprite"
                            />
                          ) : (
                            <img
                              src={soldierDeadSprite}
                              alt="Defeated"
                              className="kill-soldier-dead"
                            />
                          )}
                          {enemy.faceSrc ? (
                            <img
                              src={enemy.faceSrc}
                              alt=""
                              className={clsx(
                                'kill-enemy-face',
                                !enemy.alive && 'kill-enemy-face-dead'
                              )}
                            />
                          ) : null}
                        </div>
                      </div>
                    ))}
                    {killBullets.map((bullet) => (
                      <img
                        key={bullet.id}
                        src={bulletAsset}
                        alt=""
                        className="kill-bullet"
                        style={{
                          left: `${bullet.x}%`,
                          top: `${bullet.y}%`,
                        }}
                      />
                    ))}
                    <img
                      src={gunAsset}
                      alt="Gun"
                      className="kill-gun"
                      style={{ left: `${killGunX}%` }}
                    />
                    {killFlashVisible ? (
                      <div className="kill-muzzle-flash" style={{ left: `${killGunX}%` }}>
                        <SpriteOnce
                          key={`muzzle-${killFlashKey}`}
                          src={muzzleFlashSprite}
                          cols={5}
                          rows={7}
                          frameCount={35}
                          fps={45}
                          width={60}
                          onComplete={() => setKillFlashVisible(false)}
                        />
                      </div>
                    ) : null}
                    {!killWaveActive && killWavePopupOpen ? (
                      <div className="absolute inset-0 z-[230] flex items-center justify-center bg-black/60 px-4 pointer-events-none">
                        <div className="aura-panel w-full max-w-sm rounded-2xl bg-[#5c0099] p-4 text-center text-sm font-semibold text-white shadow-2xl pointer-events-auto">
                          <p className="text-lg font-bold">Kill Gallery</p>
                          <p className="mt-2 text-sm">Wave {killWaveState.waveNumber}</p>
                          <p className="mt-2 text-xs text-white/80">
                            Next wave in: {killCountdownLabel}
                          </p>
                          <button
                            type="button"
                            onClick={(event) => {
                              event.stopPropagation();
                              void startKillWave();
                            }}
                            disabled={!killWaveReady}
                            className={clsx(
                              'mt-4 rounded-lg px-4 py-2 text-sm font-semibold',
                              killWaveReady ? 'btn-3d-gold' : 'bg-white/10 text-white/60'
                            )}
                          >
                            Start fight
                          </button>
                        </div>
                      </div>
                    ) : null}
                    {killRewardOpen ? (
                      <div className="absolute inset-0 z-[240] flex items-center justify-center bg-black/70 px-4">
                        <div
                          ref={killRewardRef}
                          className="aura-panel w-full max-w-sm rounded-2xl bg-[#5c0099] p-4 text-center text-sm font-semibold text-white shadow-2xl"
                        >
                          <CurrencyIcon kind="coin" className="mx-auto h-10 w-10" />
                          <p className="mt-2 text-sm font-bold">
                            Successfully defended against wave!
                          </p>
                          <p className="mt-2 text-xs text-white/80">
                            Reward: {killRewardAmount} coins
                          </p>
                          <button
                            type="button"
                            onClick={(event) => {
                              event.stopPropagation();
                              claimKillReward();
                            }}
                            className="mt-4 rounded-lg px-4 py-2 text-sm font-semibold btn-3d-gold"
                          >
                            Claim
                          </button>
                        </div>
                      </div>
                    ) : null}
                    {!killGalleryItems.length ? (
                      <div className="absolute inset-0 z-[200] flex items-center justify-center rounded-2xl bg-black/50 px-4 text-center text-sm font-semibold text-white/80">
                        No targets yet. Vote in a poll to build your kill gallery.
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            {!isKillGallery ? (
              <div className="aura-panel rounded-2xl bg-[#5c0099] p-4">
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div
                      ref={goldBadgeRef}
                      className="aura-chip relative flex h-7 items-center gap-2 rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white"
                    >
                      <CurrencyIcon kind="coin" />
                      <span>{galleryDisplayGold}</span>
                    </div>
                    <div className="aura-chip-blue flex h-7 items-center gap-2 rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white">
                      <CurrencyIcon kind="gem" />
                      <span>{galleryDisplayGems}</span>
                      <button
                        type="button"
                        onClick={openGalleryGemShop}
                        className="rounded-full bg-[#fdc500] px-2 py-0.5 text-xs font-semibold text-white"
                      >
                        +
                      </button>
                    </div>
                    <div className="aura-chip flex h-7 items-center gap-2 rounded-lg bg-[#4a0079] px-3 py-1 text-xs font-semibold text-white">
                      <span>
                        {galleryItems.length}/{activeAvailableSlots}
                      </span>
                      <img
                        src={isFunGallery ? femaleFunBase : femaleBase}
                        alt="Brides"
                        className="h-4 w-4 object-contain"
                      />
                      <button
                        type="button"
                        onClick={() => setSlotUnlockOpen(true)}
                        className="rounded-full bg-[#fdc500] px-2 py-0.5 text-xs font-semibold text-white"
                      >
                        +
                      </button>
                    </div>
                    <img
                      src={isFunGallery ? fBg : marryBg}
                      alt={isFunGallery ? 'Fun gallery' : 'Marry gallery'}
                      className="pointer-events-none h-10 w-10 object-contain sm:hidden"
                    />
                  </div>
                  <img
                    src={isFunGallery ? fBg : marryBg}
                    alt={isFunGallery ? 'Fun gallery' : 'Marry gallery'}
                    className="pointer-events-none absolute left-1/2 top-1/2 hidden h-16 -translate-x-1/2 -translate-y-1/2 object-contain sm:block"
                  />
                  <button
                    type="button"
                    onClick={closeGallery}
                    className="rounded-lg bg-[#fdc500] px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
                  >
                    Return
                  </button>
                </div>
                <div className="mt-4">
                  <div
                    className="relative h-[420px] w-full overflow-hidden rounded-2xl border-2 border-white/20 bg-[#4a0079]"
                    style={{
                      backgroundImage: `url(${isFunGallery ? funBg : chapelBg})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  >
                    {!isFunGallery ? (
                      <button
                        type="button"
                        onClick={() => {
                          trackAnalyticsEvent('gallery_tab_change', {
                            galleryType: 'fun',
                            fromGalleryType: 'marry',
                          });
                          setGalleryType('fun');
                        }}
                        className="absolute left-3 top-1/2 z-[200] -translate-y-1/2 rounded-xl bg-[#fdc500] px-4 py-1.5 text-2xl font-semibold text-white btn-3d-gold"
                      >
                        ←
                      </button>
                    ) : null}
                    {isFunGallery ? (
                      <button
                        type="button"
                        onClick={() => {
                          trackAnalyticsEvent('gallery_tab_change', {
                            galleryType: 'marry',
                            fromGalleryType: 'fun',
                          });
                          setGalleryType('marry');
                        }}
                        className="absolute right-3 top-1/2 z-[200] -translate-y-1/2 rounded-xl bg-[#fdc500] px-4 py-1.5 text-2xl font-semibold text-white btn-3d-gold"
                      >
                        →
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={() => {
                          trackAnalyticsEvent('gallery_tab_change', {
                            galleryType: 'kill',
                            fromGalleryType: 'marry',
                          });
                          setGalleryType('kill');
                        }}
                        className="absolute right-3 top-1/2 z-[200] -translate-y-1/2 rounded-xl bg-[#fdc500] px-4 py-1.5 text-2xl font-semibold text-white btn-3d-gold"
                      >
                        →
                      </button>
                    )}
                    {galleryItems.map((item) => {
                      const position = galleryPositions[item.id];
                      const faceSrc = item.faceValue || item.image;
                      const outfitId = activeOutfits.selected[item.id] ?? 'default';
                      const bodySrc = activeOutfitSources[outfitId];
                      const faceClass =
                        'absolute left-1/2 -translate-x-1/2 rounded-full object-cover bg-[#3d0066]';
                      const faceFallbackClass =
                        'absolute left-1/2 -translate-x-1/2 rounded-full bg-[#3d0066] p-1 text-center text-[10px] font-semibold text-white/80';
                      const funFaceScale = isFunGallery ? 1.2 : 1;
                      const baseFaceSize = (isFunGallery ? 30 : 37) * funFaceScale;
                      const baseFallbackSize = (isFunGallery ? 34 : 41) * funFaceScale;
                      const width = 120 * (position?.scale ?? 1);
                      const height = 170 * (position?.scale ?? 1);
                      const motion = galleryMotion[item.id];
                      const isSelectable = (
                        isFunGallery ? selectableFunIds : selectableMarryIds
                      ).has(item.id);
                      const showBubble =
                        activeBubbleId === item.id && chatBubbleVisible && chatBubbleText;
                      const depthLayer = Math.round(position?.top ?? 50);
                      return (
                        <div
                          key={item.id}
                          ref={(node) => {
                            if (node) {
                              galleryItemRefs.current[item.id] = node;
                            } else {
                              delete galleryItemRefs.current[item.id];
                            }
                          }}
                          className={clsx(
                            'absolute',
                            motion === 'left' && 'gallery-sway-left',
                            motion === 'right' && 'gallery-sway-right',
                            motion === 'jump' && 'gallery-hop'
                          )}
                          onAnimationEnd={() => {
                            if (!motion) return;
                            setGalleryMotion((prev) => ({ ...prev, [item.id]: null }));
                          }}
                          style={{
                            left: `${position?.left ?? 50}%`,
                            top: `${position?.top ?? 50}%`,
                            width,
                            height,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10 + depthLayer,
                          }}
                          onClick={() => {
                            setSelectedGalleryItem(item);
                          }}
                        >
                          <div className="relative h-full w-full cursor-pointer">
                            {isSelectable ? (
                              <img
                                src={exclamationAsset}
                                alt="Selectable"
                                className="pointer-events-none absolute -top-1 left-1/2 h-15 w-15 -translate-x-1/2 drop-shadow"
                              />
                            ) : null}
                            {showBubble ? (
                              <div className="pointer-events-none absolute -right-26 -top-15 w-40">
                                <div className="relative w-full">
                                  <img
                                    src={chatBubbleAsset}
                                    alt="Chat bubble"
                                    className="h-auto w-full object-contain"
                                  />
                                  <div className="absolute inset-0 px-3 pt-6 pb-2 text-[10px] font-semibold leading-tight text-[#2b1d00]">
                                    {chatBubbleText}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <img
                              src={bodySrc}
                              alt="Gallery base"
                              className="h-full w-full object-contain"
                            />
                            {faceSrc ? (
                              <img
                                src={faceSrc}
                                alt={item.label}
                                className={faceClass}
                                style={{
                                  top: isFunGallery ? '28%' : '30%',
                                  width: `${baseFaceSize * (position?.scale ?? 1)}px`,
                                  height: `${baseFaceSize * (position?.scale ?? 1)}px`,
                                }}
                              />
                            ) : (
                              <div
                                className={faceFallbackClass}
                                style={{
                                  top: isFunGallery ? '16%' : '18%',
                                  width: `${baseFallbackSize * (position?.scale ?? 1)}px`,
                                  height: `${baseFallbackSize * (position?.scale ?? 1)}px`,
                                }}
                              >
                                {item.label || 'No face'}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    {!galleryItems.length ? (
                      <div className="absolute inset-0 flex items-center justify-center rounded-2xl bg-black/30 px-4 text-center text-sm font-semibold text-white/80">
                        No selection yet. Vote in a poll to build your gallery.
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            {!isKillGallery && slotUnlockOpen ? (
              <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 px-4">
                <div className="aura-panel w-full max-w-sm rounded-2xl bg-[#5c0099] p-4 text-center text-sm font-semibold text-white shadow-2xl">
                  <p>
                    -10 ❤️ affection from each {isFunGallery ? 'dancer' : 'bride'} to add a new{' '}
                    {isFunGallery ? 'dancer' : 'bride'}?
                  </p>
                  <p className="mt-1 text-xs text-white/70">
                    This will make {isFunGallery ? 'dancers' : 'brides'} unhappy.
                  </p>
                  {!canUnlockSlot ? (
                    <p className="mt-2 text-xs text-white/70">
                      Not enough ❤️ affection to unlock a new slot.
                    </p>
                  ) : null}
                  <div className="mt-4 flex items-center justify-center gap-3">
                    <button
                      type="button"
                      onClick={() => setSlotUnlockOpen(false)}
                      className="rounded-lg bg-[#510087] px-4 py-2 text-xs font-semibold text-white btn-3d-purple"
                      disabled={galleryActionLoading}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      onClick={handleUnlockSlot}
                      className={clsx(
                        'rounded-lg px-4 py-2 text-xs font-semibold',
                        canUnlockSlot
                          ? 'bg-[#fdc500] text-white btn-3d-gold'
                          : 'bg-white/10 text-white/50'
                      )}
                      disabled={!canUnlockSlot || galleryActionLoading}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
            {!isKillGallery && selectedGalleryItem ? (
              <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 px-4">
                <div className="flex w-full max-w-2xl items-start justify-center gap-3">
                  <div className="aura-panel relative w-full max-w-sm rounded-2xl bg-[#5c0099] p-4 shadow-2xl">
                    <button
                      type="button"
                      onClick={() => {
                        if (footRubUsed) {
                          spawnCoinParticles();
                          startGoldIncrement();
                          window.setTimeout(() => closeSelectableModal(), 650);
                        } else {
                          closeSelectableModal();
                        }
                      }}
                      className="absolute right-2 top-2 rounded-full bg-white/10 px-2 py-1 text-xs font-semibold text-white hover:bg-white/20"
                    >
                      X
                    </button>
                    <div className="absolute left-3 top-3 flex flex-col gap-2">
                      <div className="aura-chip rounded-lg bg-[#4a0079] px-3 py-1 text-sm font-semibold text-white">
                        <div className="flex items-center gap-2">
                          <span className="text-base">❤️</span>
                          <span>{selectedAffection}</span>
                        </div>
                      </div>
                      <div className="aura-chip rounded-lg bg-[#4a0079] px-3 py-1 text-sm font-semibold text-white/90">
                        <span>Status: </span>
                        <span className="text-base">{footRubUsed ? '😊' : '😠'}</span>
                      </div>
                    </div>
                    <div className="flex flex-col items-center gap-4 pt-4">
                      <div className="relative h-44 w-32">
                        <img
                          src={selectedBodySrc}
                          alt="Selected character"
                          className="h-full w-full object-contain"
                        />
                        {selectedGalleryFaceSrc ? (
                          <img
                            src={selectedGalleryFaceSrc}
                            alt={selectedGalleryItem.label}
                            className={selectedFaceClass}
                          />
                        ) : (
                          <div className={selectedFaceFallbackClass}>
                            {selectedGalleryItem.label || 'No face'}
                          </div>
                        )}
                        <div className="pointer-events-none absolute inset-0 z-20">
                          {heartParticles.map((particle) => (
                            <span
                              key={particle.id}
                              className="gallery-heart-particle"
                              style={{
                                left: `calc(50% + ${particle.x}px)`,
                                top: `calc(40% + ${particle.y}px)`,
                                animationDuration: `${particle.duration}ms`,
                                animationDelay: `${particle.delay}ms`,
                              }}
                            >
                              ❤️
                            </span>
                          ))}
                        </div>
                      </div>
                      {divorceConfirmOpen ? (
                        <div className="aura-card w-full rounded-xl bg-[#4a0079] px-3 py-3 text-center text-xs font-semibold text-white">
                          <p>Are you sure you want to divorce this character?</p>
                          <div className="mt-3 flex items-center justify-center gap-2">
                            <button
                              type="button"
                              onClick={() => setDivorceConfirmOpen(false)}
                              className="rounded-lg bg-[#510087] px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                              disabled={galleryActionLoading}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              onClick={handleDivorce}
                              className="rounded-lg bg-[#fd4b4b] px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
                              disabled={galleryActionLoading || !canAffordDivorce}
                            >
                              <span className="inline-flex items-center justify-center gap-1">
                                Confirm (-300 <CurrencyIcon kind="coin" className="h-3.5 w-3.5" />)
                              </span>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="flex w-full flex-col items-center gap-2">
                          <div className="flex w-full items-center gap-2">
                            <button
                              type="button"
                              onClick={handleFootRub}
                              className={clsx(
                                'flex-1 rounded-lg px-4 py-2 text-xs font-semibold',
                                galleryActionLoading || footRubUsed || !selectedIsSelectable
                                  ? 'bg-white/10 text-white/80'
                                  : 'bg-[#ff9ad5] text-white btn-3d-gold'
                              )}
                              disabled={
                                galleryActionLoading || footRubUsed || !selectedIsSelectable
                              }
                            >
                              {isFunGallery ? 'Dance (+2 ❤️)' : 'Foot rub (+2 ❤️)'}
                            </button>
                            <button
                              type="button"
                              onClick={handleGift}
                              className={clsx(
                                'flex-1 rounded-lg px-4 py-2 text-xs font-semibold',
                                galleryActionLoading || !canAffordGift || !selectedIsSelectable
                                  ? 'bg-white/10 text-white/80'
                                  : 'bg-[#fdc500] text-white btn-3d-gold'
                              )}
                              disabled={
                                galleryActionLoading || !canAffordGift || !selectedIsSelectable
                              }
                            >
                              <span className="inline-flex items-center justify-center gap-1">
                                Gift (-75 <CurrencyIcon kind="coin" className="h-3.5 w-3.5" />)
                              </span>
                            </button>
                          </div>
                          <div className="flex w-full items-center gap-2">
                            <button
                              type="button"
                              onClick={() => setDivorceConfirmOpen(true)}
                              className="flex-1 rounded-lg bg-[#fd4b4b] px-4 py-2 text-xs font-semibold text-white btn-3d-purple"
                              disabled={galleryActionLoading || !canAffordDivorce}
                            >
                              <span className="inline-flex items-center justify-center gap-1">
                                {isFunGallery ? 'Fire' : 'Divorce'} (-300{' '}
                                <CurrencyIcon kind="coin" className="h-3.5 w-3.5" />)
                              </span>
                            </button>
                            <button
                              type="button"
                              onClick={() => setShopOpen((prev) => !prev)}
                              className={clsx(
                                'flex-1 rounded-lg px-4 py-2 text-xs font-semibold',
                                shopOpen
                                  ? 'bg-white/20 text-white'
                                  : 'bg-[#510087] text-white btn-3d-purple'
                              )}
                            >
                              Customize
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {shopOpen ? (
                    <div className="aura-card w-44 rounded-2xl bg-[#4a0079] p-3 text-white shadow-lg">
                      <div className="flex items-center justify-between text-xs font-semibold">
                        <span>Outfits</span>
                        <span>
                          {shopPage + 1}/{shopTotalPages}
                        </span>
                      </div>
                      <div className="mt-2 flex flex-col gap-2">
                        {shopItems.map((outfit) => {
                          const isUnlocked = unlockedOutfits.has(outfit.id);
                          const isSelected = selectedOutfitId === outfit.id;
                          return (
                            <button
                              key={outfit.id}
                              type="button"
                              onClick={() => {
                                if (isUnlocked) {
                                  void handleSelectOutfit(outfit.id);
                                } else {
                                  setOutfitConfirm({ open: true, outfitId: outfit.id });
                                }
                              }}
                              className={clsx(
                                'relative rounded-lg border-2 bg-[#5c0099] p-1',
                                isSelected ? 'aura-selected' : 'border-white/30',
                                !isUnlocked && 'opacity-80'
                              )}
                            >
                              <img
                                src={outfit.src}
                                alt={`${outfit.id} outfit`}
                                className="h-16 w-full object-contain"
                              />
                              {!isUnlocked ? (
                                <div className="absolute bottom-1 right-1 rounded bg-black/60 px-1 text-[10px] font-semibold text-white">
                                  <span className="inline-flex items-center gap-1">
                                    {outfit.price}
                                    <CurrencyIcon kind="coin" className="h-3 w-3" />
                                  </span>
                                </div>
                              ) : null}
                            </button>
                          );
                        })}
                      </div>
                      <div className="mt-2 flex items-center justify-between">
                        <button
                          type="button"
                          onClick={() => setShopPage((prev) => Math.max(0, prev - 1))}
                          className="rounded-lg bg-white/10 px-2 py-1 text-[10px] font-semibold text-white/80"
                          disabled={shopPage === 0}
                        >
                          Up
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setShopPage((prev) => Math.min(shopTotalPages - 1, prev + 1))
                          }
                          className="rounded-lg bg-white/10 px-2 py-1 text-[10px] font-semibold text-white/80"
                          disabled={shopPage >= shopTotalPages - 1}
                        >
                          Down
                        </button>
                      </div>
                      {confirmOutfit ? (
                        <div className="mt-3 rounded-lg border border-white/20 bg-[#5c0099] px-2 py-2 text-[10px] font-semibold">
                          <p className="inline-flex items-center justify-center gap-1">
                            Unlock for {confirmOutfit.price}
                            <CurrencyIcon kind="coin" className="h-3 w-3" />?
                          </p>
                          <div className="mt-2 flex items-center justify-between gap-2">
                            <button
                              type="button"
                              onClick={() => setOutfitConfirm({ open: false, outfitId: null })}
                              className="rounded bg-white/10 px-2 py-1 text-[10px] text-white/80"
                              disabled={galleryActionLoading}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              onClick={() => handleUnlockOutfit(confirmOutfit.id)}
                              className="rounded bg-[#fdc500] px-2 py-1 text-[10px] font-semibold text-white"
                              disabled={galleryActionLoading || currency.gold < confirmOutfit.price}
                            >
                              Confirm
                            </button>
                          </div>
                          {currency.gold < confirmOutfit.price ? (
                            <p className="mt-1 text-[10px] text-white/60">Not enough gold.</p>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </>
        ) : null}

        {!loading && view === 'poll' ? (
          <div className="aura-panel rounded-2xl bg-[#5c0099] p-3 sm:p-4">
            {entry ? (
              <>
                {postedAs === 'app' ? (
                  <div className="mb-3 rounded-lg border border-yellow-300 bg-yellow-100 px-3 py-2 text-xs font-semibold text-yellow-900">
                    Couldn't publish as your account, so this post was published by the app. Check
                    your posting permissions in this subreddit.{' '}
                    {postedAsReason ? `Reason: ${postedAsReason}` : ''}
                  </div>
                ) : null}
                {canViewPollResults ? (
                  showReveal ? (
                    <div
                      className="aura-panel rounded-2xl bg-[#5c0099] p-4 sm:p-5"
                      onClick={advanceReveal}
                    >
                      <div className="grid grid-cols-1 gap-4 md:grid-cols-[0.9fr_1.1fr]">
                        <div
                          className="aura-frame relative w-full max-h-[220px] md:max-h-[280px] overflow-hidden rounded-2xl bg-black"
                          ref={revealImageContainerRef}
                        >
                          <div
                            className={clsx(
                              'absolute inset-0 z-10 bg-black transition-opacity duration-500 ease-out',
                              revealImageVisible ? 'opacity-0' : 'opacity-100'
                            )}
                          />
                          {curtainPlaying && !simplifyRevealAnimation ? (
                            <div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none">
                              <CurtainReveal
                                key={`curtain-${revealStep}-${currentRevealRole}`}
                                videoSrc={curtainVideo}
                                fallbackSrc={curtainSprite}
                                width={curtainWidth}
                                height={curtainHeight}
                                onComplete={handleCurtainComplete}
                              />
                            </div>
                          ) : null}
                          {currentWinnerImage ? (
                            <img
                              src={currentWinnerImage}
                              alt={currentWinnerLabel}
                              className={clsx(
                                'relative z-0 h-full w-full object-contain transition-all duration-700 ease-out',
                                revealImageVisible
                                  ? 'brightness-100 opacity-100'
                                  : 'brightness-0 opacity-40'
                              )}
                            />
                          ) : (
                            <div className="relative z-0 flex h-full w-full items-center justify-center bg-[#31004f] p-4 text-center text-white/80">
                              {currentWinnerLabel}
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col gap-3">
                          <div
                            className={clsx(
                              'text-5xl font-black uppercase leading-tight tracking-tight text-[#fdc500] transition-all duration-500',
                              revealTextVisible
                                ? 'opacity-100 translate-y-0 scale-100'
                                : 'opacity-0 translate-y-2 scale-95'
                            )}
                          >
                            {roleLabels[currentRevealRole]}
                          </div>
                          <div
                            className={clsx(
                              'text-xl font-semibold text-white transition-all duration-500',
                              revealTextVisible
                                ? 'opacity-100 translate-y-0'
                                : 'opacity-0 translate-y-2'
                            )}
                          >
                            {currentPhrase || 'Ready for the reveal?'}
                          </div>
                          <div
                            className={clsx(
                              'rounded-xl border-2 border-white/20 bg-white/10 px-3 py-3 text-lg font-semibold text-white transition-all duration-500',
                              revealTextVisible
                                ? 'opacity-100 translate-y-0'
                                : 'opacity-0 translate-y-2'
                            )}
                          >
                            {currentWinnerSlot
                              ? `${currentWinnerPercent}% of players chose ${currentWinnerLabel}.`
                              : 'Gathering results...'}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="rounded-2xl bg-[#5c0099] px-1 py-3 sm:p-4 shadow-sm">
                      <div className="mb-3 flex flex-wrap items-center gap-1 sm:gap-2 rounded-2xl bg-[#5c0099] px-0 py-1 sm:px-0 sm:py-3">
                        <div className="flex flex-1 flex-wrap items-center gap-1 sm:gap-2 rounded-full bg-[#5c0099] px-0 py-1 sm:px-0 sm:py-2">
                          <button
                            type="button"
                            className="flex h-11 items-center rounded-full px-4 py-2 text-sm font-semibold transition-colors bg-[#510087] text-white btn-3d-purple disabled:opacity-60"
                            onClick={() => void handleGenerateShareImage()}
                            disabled={shareGenerating}
                          >
                            {shareGenerating ? 'Sharing...' : 'Share'}
                          </button>
                          <button
                            type="button"
                            className="flex h-11 items-center rounded-full px-4 py-2 text-sm font-semibold transition-colors bg-[#510087] text-white btn-3d-purple disabled:opacity-60"
                            onClick={handleReportCurrentPost}
                            disabled={
                              !entry?.id ||
                              Boolean(browseReportPendingByPost[entry?.id ?? selectedGameId ?? ''])
                            }
                          >
                            {browseReportPendingByPost[entry?.id ?? selectedGameId ?? '']
                              ? 'Reporting...'
                              : 'Report'}
                          </button>
                        </div>
                      </div>
                      {shareError ? (
                        <p className="mt-2 text-xs font-semibold text-red-200">{shareError}</p>
                      ) : null}
                      <div className="aura-card rounded-xl bg-[#5c0099] p-3 sm:p-4 text-sm text-white">
                        <span>Thanks for voting! Here are the live results. Press </span>
                        <a
                          href={browseHref}
                          data-fmk-browse-nav="1"
                          className={clsx(
                            'mx-1 inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold-pulse sm:hidden',
                            isMobileBrowseAdEligible ? 'fmk-popunder-trigger-browse-mobile' : null
                          )}
                          onPointerDownCapture={primeMobileBrowseAfterAd}
                          onTouchStartCapture={primeMobileBrowseAfterAd}
                          onMouseDownCapture={primeMobileBrowseAfterAd}
                          onPointerUp={() => {
                            window.setTimeout(() => openBrowseView('results-mobile-pointerup'), 0);
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            if (POPUNDER_DEBUG)
                              console.info('[POPUNDER DEBUG] Mobile results Browse clicked');
                            openBrowseView('results-mobile-click');
                          }}
                          aria-label="Browse"
                        >
                          Browse
                        </a>
                        <a
                          href={browseHref}
                          data-fmk-browse-nav="1"
                          className={clsx(
                            'mx-1 hidden items-center rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold-pulse sm:inline-flex',
                            BROWSE_POPUNDER_ADS_ENABLED
                              ? 'fmk-popunder-trigger-browse-desktop'
                              : null
                          )}
                          onPointerDownCapture={primeDesktopBrowseAfterAd}
                          onTouchStartCapture={primeDesktopBrowseAfterAd}
                          onMouseDownCapture={primeDesktopBrowseAfterAd}
                          onPointerUp={() => {
                            window.setTimeout(() => openBrowseView('results-desktop-pointerup'), 0);
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            if (POPUNDER_DEBUG)
                              console.info('[POPUNDER DEBUG] Desktop results Browse clicked');
                            openBrowseView('results-desktop-click');
                          }}
                          aria-label="Browse"
                        >
                          Browse
                        </a>
                        <span> to check out more fmk-game.com!</span>
                      </div>
                      <div className="aura-card mt-3 rounded-xl bg-[#5c0099] p-3 sm:p-4">
                        <div className="flex flex-wrap items-center justify-between gap-3">
                          <div>
                            <p className="text-xs font-semibold text-white/80">Role</p>
                            <p className="text-lg font-bold text-white">
                              {roleLabels[currentResultRole]}
                            </p>
                            <p className="text-xs text-white/80">{totalVotes} vote(s)</p>
                          </div>
                          <div className="flex items-center gap-2">
                            <button
                              type="button"
                              onClick={goToPreviousRole}
                              disabled={currentResultRole === 'f'}
                              className="rounded-lg px-3 py-2 text-sm font-semibold text-white btn-3d-gold disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500"
                            >
                              Previous
                            </button>
                            {currentResultRole === 'k' ? (
                              <button
                                type="button"
                                onClick={() => {
                                  setGalleryType('marry');
                                  void openGallery();
                                }}
                                className="rounded-lg px-3 py-2 text-sm font-semibold text-white btn-3d-gold"
                              >
                                <img src={homeIcon} alt="" className="h-7 w-7 object-contain" />
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={goToNextRole}
                                className="rounded-lg px-3 py-2 text-sm font-semibold text-white btn-3d-gold"
                              >
                                Next
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="mt-3 space-y-3">
                          {entry.slots.map((slot) => (
                            <PercentBar
                              key={`${currentResultRole}-${slot.id}`}
                              slot={slot}
                              percent={percentFor(percentages, currentResultRole, slot.id)}
                              highlight={assignment[currentResultRole] === slot.id}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <>
                    <div className="flex flex-wrap items-center gap-1 sm:gap-2">
                      <button
                        type="button"
                        className="flex h-11 items-center rounded-full px-4 py-2 text-sm font-semibold transition-colors bg-[#510087] text-white btn-3d-purple disabled:opacity-60"
                        onClick={() => void handleGenerateShareImage()}
                        disabled={shareGenerating}
                      >
                        {shareGenerating ? 'Sharing...' : 'Share'}
                      </button>
                      <button
                        type="button"
                        className="flex h-11 items-center rounded-full px-4 py-2 text-sm font-semibold transition-colors bg-[#510087] text-white btn-3d-purple disabled:opacity-60"
                        onClick={handleReportCurrentPost}
                        disabled={
                          !entry?.id ||
                          Boolean(browseReportPendingByPost[entry?.id ?? selectedGameId ?? ''])
                        }
                      >
                        {browseReportPendingByPost[entry?.id ?? selectedGameId ?? '']
                          ? 'Reporting...'
                          : 'Report'}
                      </button>
                      {award !== null ? (
                        <div
                          className={clsx(
                            'rounded-full px-4 py-2 text-sm font-semibold',
                            award ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'
                          )}
                        >
                          {award ? 'You matched the majority! +10 pts' : 'Submitted'}
                        </div>
                      ) : null}
                    </div>
                    {shareError ? (
                      <p className="mt-2 text-xs font-semibold text-red-200">{shareError}</p>
                    ) : null}
                    {!isAuthenticated ? (
                      <div className="aura-card mt-3 rounded-xl bg-[#510087] p-3 text-sm text-white">
                        <p>Sign in to create posts and access the leaderboard.</p>
                        <button
                          type="button"
                          className="mt-2 rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold"
                          onClick={() => {
                            setAuthMode('sign_in');
                            setAuthOpen(true);
                            setAuthError(null);
                            setAuthMessage(null);
                          }}
                        >
                          Open Login
                        </button>
                      </div>
                    ) : null}

                    <div className="fmk-poll-vote-board mt-3 flex flex-col gap-3 rounded-2xl bg-[#5c0099] p-4">
                      <div className="fmk-poll-drop-grid grid grid-cols-3 gap-2 sm:justify-items-center sm:gap-3">
                        {(Object.keys(roleLabels) as Array<keyof FMKAssignment>).map((role) => (
                          <div
                            key={role}
                            className="fmk-poll-drop-column w-full max-w-[220px]"
                            onDragOver={(e) => {
                              e.preventDefault();
                              setDragOverRole(role);
                            }}
                            onDragEnter={(e) => {
                              e.preventDefault();
                              setDragOverRole(role);
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              handleDrop(role, dragging);
                              setDragging(null);
                              setDragOverRole(null);
                            }}
                            onDragLeave={() =>
                              setDragOverRole((prev) => (prev === role ? null : prev))
                            }
                          >
                            <DropZone
                              role={role}
                              entry={entry}
                              assignment={assignment}
                              isActive={dragOverRole === role}
                              onUnassign={unassignRole}
                              isDragInProgress={Boolean(dragging)}
                              onClickEmpty={(r) => handleDrop(r, selectedSlotId)}
                              particles={slotParticles[role]}
                            />
                          </div>
                        ))}
                      </div>
                      <div className="fmk-poll-slot-grid grid grid-cols-3 gap-2 sm:justify-items-center sm:gap-3">
                        {entry.slots.map((slot) => {
                          const isAssigned = Object.values(assignment).includes(slot.id);
                          return (
                            <SlotCard
                              key={slot.id}
                              slot={slot}
                              isDragging={dragging === slot.id}
                              isAssigned={isAssigned}
                              isSelected={selectedSlotId === slot.id}
                              onSelect={(s) =>
                                setSelectedSlotId((prev) => (prev === s.id ? null : s.id))
                              }
                              onDragStart={(s, e) => {
                                setDragging(s.id);
                                createDragImage(s, e);
                              }}
                              onDragEnd={() => setDragging(null)}
                            />
                          );
                        })}
                      </div>
                      <button
                        type="button"
                        onClick={handleVote}
                        disabled={voting || hasVoted}
                        className={clsx(
                          'mt-2 self-start rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-60',
                          hasVoted ? 'btn-3d-gold-deep' : 'btn-3d-gold-pulse'
                        )}
                      >
                        {hasVoted ? 'Already voted' : voting ? 'Submitting...' : 'Vote'}
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="rounded-xl border border-dashed border-gray-200 p-6 text-center text-gray-600">
                No F.M.K created yet. Switch to Create to publish one for this post.
              </div>
            )}
          </div>
        ) : null}

        {!loading && view === 'gooGame' ? (
          gooGameSlot ? (
            <GooMiniGame
              imageSrc={gooGameSlot.value}
              label={gooGameSlot.label ?? 'your Fun pick'}
              onBackToResults={backToPollResults}
              backButtonClassName={clsx(
                BROWSE_POPUNDER_ADS_ENABLED
                  ? window.matchMedia('(max-width: 639px)').matches
                    ? isMobileBrowseAdEligible
                      ? 'fmk-popunder-trigger-browse-mobile'
                      : null
                    : 'fmk-popunder-trigger-browse-desktop'
                  : null
              )}
              onBackPointerDownCapture={() => {
                if (window.matchMedia('(max-width: 639px)').matches) {
                  primeMobileGooExitAfterAd();
                } else {
                  primeDesktopGooExitAfterAd();
                }
              }}
              onBackTouchStartCapture={() => {
                if (window.matchMedia('(max-width: 639px)').matches) {
                  primeMobileGooExitAfterAd();
                } else {
                  primeDesktopGooExitAfterAd();
                }
              }}
              onBackMouseDownCapture={() => {
                if (window.matchMedia('(max-width: 639px)').matches) {
                  primeMobileGooExitAfterAd();
                } else {
                  primeDesktopGooExitAfterAd();
                }
              }}
            />
          ) : (
            <div className="aura-panel rounded-2xl bg-[#5c0099] p-6 text-center text-white">
              <h2 className="text-xl font-black">No Fun image selected</h2>
              <p className="mt-2 text-sm text-white/80">
                Return to the results screen and choose the mini game from a poll where your Fun
                pick is an image.
              </p>
              <button
                type="button"
                className="mt-4 rounded-full px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
                onClick={backToPollResults}
              >
                Back to results
              </button>
            </div>
          )
        ) : null}

        {!loading && view === 'tournament' ? (
          <div className="aura-panel rounded-2xl bg-[#5c0099] p-3 sm:p-4">
            {tournamentPageLoading ? (
              <div className="rounded-xl border border-white/20 bg-white/10 p-6 text-center text-sm font-semibold text-white">
                Loading tournament...
              </div>
            ) : tournamentSummary ? (
              <div className="space-y-4">
                <div className="flex flex-nowrap items-start justify-between gap-2 sm:gap-3">
                  <div className="min-w-0 flex-1">
                    <p className="text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                      Weekly Tournament
                    </p>
                    <h2 className="text-lg font-black text-white sm:text-xl">
                      {tournamentSummary.activeWindow?.groupLabel ?? 'Tournament Results'}
                    </h2>
                    <p className="text-[10px] leading-snug text-white/80 sm:text-sm sm:leading-normal">
                      {tournamentSummary.activeWindow
                        ? `${tournamentCategoryLabels[tournamentSummary.activeWindow.activeCategory ?? 'f']} closes in ${tournamentRoundCountdown}. Tournament ends in ${tournamentCountdown}.`
                        : `Tournament ends in ${tournamentCountdown}.`}
                    </p>
                  </div>
                  {!tournamentHasVoted && currentTournamentDecision && tournamentRound ? (
                    <div className="w-[128px] shrink-0 rounded-xl bg-black/20 px-2 py-2 sm:w-auto sm:px-4 sm:py-3">
                      <div className="text-center text-[10px] font-semibold uppercase tracking-wide text-[#ffd84a] sm:text-xs">
                        Current Category
                      </div>
                      <p className="text-center text-base font-black text-white sm:text-lg">
                        {tournamentCategoryLabels[currentTournamentDecision.category]}
                      </p>
                      <h3 className="text-center text-xs font-bold text-white sm:text-lg">
                        Matchup {currentTournamentDecision.pairIndex + 1} of{' '}
                        {tournamentRound.pairs.length}
                      </h3>
                    </div>
                  ) : null}
                </div>

                {tournamentError ? (
                  <div className="rounded-xl border border-red-300/40 bg-red-900/20 p-4 text-sm text-red-100">
                    {tournamentError}
                  </div>
                ) : null}

                {!tournamentHasVoted && currentTournamentDecision && tournamentRound
                  ? (() => {
                      const left =
                        tournamentEntrantMap[currentTournamentDecision.pair.leftEntrantId];
                      const right =
                        tournamentEntrantMap[currentTournamentDecision.pair.rightEntrantId];
                      if (!left || !right) return null;
                      return (
                        <div className="space-y-4">
                          <div className="rounded-xl bg-[#3d0066] p-4">
                            <div className="text-center text-3xl font-black text-[#ffd84a] sm:text-4xl">
                              {tournamentCategoryLabels[currentTournamentDecision.category]}
                            </div>
                          </div>

                          <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 sm:gap-4">
                            <button
                              type="button"
                              className="aura-card min-w-0 overflow-hidden rounded-2xl bg-[#3d0066] p-2 text-left transition hover:-translate-y-[1px] disabled:cursor-not-allowed disabled:opacity-70 sm:p-3"
                              disabled={tournamentChoiceInProgress}
                              onClick={() =>
                                handleTournamentChoice(
                                  currentTournamentDecision.pair.pairKey,
                                  left.entrantId
                                )
                              }
                            >
                              <div className="relative h-[34vh] min-h-[220px] overflow-hidden rounded-xl bg-black sm:h-[46vh] sm:min-h-[320px]">
                                {left.kind === 'image' && left.value ? (
                                  <img
                                    src={left.value}
                                    alt={getTournamentEntrantLabel(left)}
                                    className="h-full w-full object-cover object-top"
                                  />
                                ) : (
                                  <div className="flex h-full items-center justify-center p-6 text-center text-white">
                                    {getTournamentEntrantLabel(left)}
                                  </div>
                                )}
                                {tournamentPendingChoice?.pairKey ===
                                  currentTournamentDecision.pair.pairKey &&
                                tournamentPendingChoice.entrantId === left.entrantId ? (
                                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/20">
                                    <img
                                      src={roleParticles[currentTournamentDecision.category]}
                                      alt={
                                        tournamentCategoryLabels[currentTournamentDecision.category]
                                      }
                                      className="tournament-choice-icon"
                                    />
                                  </div>
                                ) : null}
                              </div>
                              <div className="mt-2 text-center text-xs font-bold text-white sm:mt-3 sm:text-base">
                                {getTournamentEntrantLabel(left)}
                              </div>
                            </button>
                            <div className="text-center text-sm font-black uppercase tracking-[0.16em] text-[#ffd84a] sm:text-2xl sm:tracking-[0.24em]">
                              VS
                            </div>
                            <button
                              type="button"
                              className="aura-card min-w-0 overflow-hidden rounded-2xl bg-[#3d0066] p-2 text-left transition hover:-translate-y-[1px] disabled:cursor-not-allowed disabled:opacity-70 sm:p-3"
                              disabled={tournamentChoiceInProgress}
                              onClick={() =>
                                handleTournamentChoice(
                                  currentTournamentDecision.pair.pairKey,
                                  right.entrantId
                                )
                              }
                            >
                              <div className="relative h-[34vh] min-h-[220px] overflow-hidden rounded-xl bg-black sm:h-[46vh] sm:min-h-[320px]">
                                {right.kind === 'image' && right.value ? (
                                  <img
                                    src={right.value}
                                    alt={getTournamentEntrantLabel(right)}
                                    className="h-full w-full object-cover object-top"
                                  />
                                ) : (
                                  <div className="flex h-full items-center justify-center p-6 text-center text-white">
                                    {getTournamentEntrantLabel(right)}
                                  </div>
                                )}
                                {tournamentPendingChoice?.pairKey ===
                                  currentTournamentDecision.pair.pairKey &&
                                tournamentPendingChoice.entrantId === right.entrantId ? (
                                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/20">
                                    <img
                                      src={roleParticles[currentTournamentDecision.category]}
                                      alt={
                                        tournamentCategoryLabels[currentTournamentDecision.category]
                                      }
                                      className="tournament-choice-icon"
                                    />
                                  </div>
                                ) : null}
                              </div>
                              <div className="mt-2 text-center text-xs font-bold text-white sm:mt-3 sm:text-base">
                                {getTournamentEntrantLabel(right)}
                              </div>
                            </button>
                          </div>

                          <div className="hidden items-center gap-3 sm:grid sm:grid-cols-[1fr_auto_1fr]">
                            <button
                              type="button"
                              className="rounded-xl px-5 py-3 text-sm font-bold text-white btn-3d-gold"
                              disabled={tournamentChoiceInProgress}
                              onClick={() =>
                                handleTournamentChoice(
                                  currentTournamentDecision.pair.pairKey,
                                  left.entrantId
                                )
                              }
                            >
                              Choose {getTournamentEntrantLabel(left)}
                            </button>
                            <div className="text-center text-sm font-black uppercase tracking-[0.24em] text-white/80">
                              OR
                            </div>
                            <button
                              type="button"
                              className="rounded-xl px-5 py-3 text-sm font-bold text-white btn-3d-gold"
                              disabled={tournamentChoiceInProgress}
                              onClick={() =>
                                handleTournamentChoice(
                                  currentTournamentDecision.pair.pairKey,
                                  right.entrantId
                                )
                              }
                            >
                              Choose {getTournamentEntrantLabel(right)}
                            </button>
                          </div>
                        </div>
                      );
                    })()
                  : null}

                {!tournamentHasVoted && tournamentSelectionsComplete && tournamentRound ? (
                  <div className="rounded-xl bg-[#3d0066] p-4">
                    <h3 className="text-lg font-bold text-white">Phase complete</h3>
                    <p className="mt-1 text-sm text-white/80">
                      You finished every {tournamentCategoryLabels[tournamentRound.category]}{' '}
                      matchup in this phase. Results are being submitted automatically.
                    </p>
                  </div>
                ) : null}

                {tournamentHasVoted && tournamentRoundResults ? (
                  <div className="space-y-4">
                    <div className="rounded-xl bg-[#3d0066] p-4">
                      <div className="flex flex-wrap items-center justify-between gap-3">
                        <div>
                          <h3 className="text-lg font-bold text-white">Round Results</h3>
                          <p className="text-sm text-white/80">
                            Category winners from this round are shown below.
                          </p>
                        </div>
                      </div>
                    </div>
                    <TournamentStandings
                      result={tournamentRoundResults}
                      entrantMap={tournamentEntrantMap}
                    />
                  </div>
                ) : null}

                {tournamentFinalWinners.length > 0 ? (
                  <div className="rounded-xl bg-[#3d0066] p-4">
                    <h3 className="text-lg font-bold text-white">Final Winners</h3>
                    <div className="mt-3 grid gap-3 md:grid-cols-3">
                      {tournamentFinalWinners.map((winner) => {
                        const entrant = tournamentEntrantMap[winner.entrantId];
                        if (!entrant) return null;
                        return (
                          <div
                            key={winner.category}
                            className="aura-card rounded-xl bg-[#4a0079] p-3"
                          >
                            <p className="text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                              {tournamentCategoryLabels[winner.category]}
                            </p>
                            <div className="mt-2 relative h-56 overflow-hidden rounded-xl bg-black">
                              {entrant.kind === 'image' && entrant.value ? (
                                <img
                                  src={entrant.value}
                                  alt={getTournamentEntrantLabel(entrant)}
                                  className="h-full w-full object-cover object-top"
                                />
                              ) : (
                                <div className="flex h-full items-center justify-center p-6 text-center text-white">
                                  {getTournamentEntrantLabel(entrant)}
                                </div>
                              )}
                            </div>
                            <p className="mt-2 text-base font-bold text-white">
                              {getTournamentEntrantLabel(entrant)}
                            </p>
                            <p className="text-xs text-white/75">{winner.score} final votes</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}

                {(!currentTournamentDecision || tournamentHasVoted) &&
                !tournamentChoiceInProgress &&
                tournamentBracket ? (
                  <div className="rounded-xl bg-[#3d0066] p-4">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                      <div>
                        <h3 className="text-lg font-bold text-white">Tournament Progress</h3>
                        {tournamentShareError ? (
                          <p className="mt-1 text-xs font-semibold text-red-200">
                            {tournamentShareError}
                          </p>
                        ) : null}
                      </div>
                      <button
                        type="button"
                        className="rounded-full bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                        disabled={tournamentShareGenerating}
                        onClick={() => void handleGenerateTournamentShareImage()}
                      >
                        {tournamentShareGenerating ? 'Generating...' : 'Share'}
                      </button>
                    </div>
                    <div className="mt-4">
                      <TournamentBracketGraph
                        bracket={tournamentBracket}
                        entrantMap={tournamentEntrantMap}
                        onPreview={setTournamentPreviewEntrant}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="rounded-xl border border-white/20 bg-white/10 p-6 text-center text-sm text-white/80">
                No weekly tournament is live yet.
              </div>
            )}
          </div>
        ) : null}
      </div>

      {showCardEconomyMenu ? (
        <nav className="fmk-card-floating-menu" aria-label="Card menu">
          {CARD_ECONOMY_MENU_ITEMS.map((item, index) => {
            const active = (view as GameView) === item.view;
            return (
              <button
                key={item.view}
                type="button"
                className={clsx(
                  'fmk-card-floating-menu-button',
                  active && 'fmk-card-floating-menu-button-active'
                )}
                style={{ '--fmk-card-menu-index': index } as React.CSSProperties}
                aria-label={item.label}
                aria-current={active ? 'page' : undefined}
                data-card-tutorial-target={`menu-${item.view}`}
                disabled={!isCardTutorialActionAllowed(`menu-${item.view}` as CardTutorialAction)}
                onClick={() => openCardEconomyView(item.view)}
              >
                <img src={item.icon} alt="" aria-hidden="true" />
                {item.view === 'shop' && shopDailyGiftAvailable ? (
                  <span className="fmk-card-floating-menu-notification" aria-hidden="true" />
                ) : null}
                {item.view === 'quests' && questRewardAvailable ? (
                  <span className="fmk-card-floating-menu-notification" aria-hidden="true" />
                ) : null}
                {active ? <span>{item.label}</span> : null}
              </button>
            );
          })}
        </nav>
      ) : null}

      {cardTutorialOverlay ? (
        <CardTutorialOverlay
          message={cardTutorialOverlay.message}
          targetSelector={cardTutorialOverlay.targetSelector}
          showContinue={cardTutorialOverlay.showContinue}
          onContinue={continueCardTutorial}
        />
      ) : null}

      {(view === 'poll' && !revealActive) || view === 'tournament' ? (
        <LevelUpModal event={levelEvent} isMuted={isMuted} onClose={handleLevelModalClose} />
      ) : null}

      {cardPackUnlockPrompt ? (
        <CardPackUnlockModal
          onOpen={handleOpenFreeCardPack}
          onClose={() => {
            setCardPackUnlockPrompt(null);
            setPendingCardPackUnlockPrompt(null);
          }}
        />
      ) : null}

      {completedTutorialNoticeOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4">
          <div className="aura-panel w-full max-w-sm rounded-2xl bg-[#5c0099] p-5 text-center text-white shadow-2xl">
            <h3 className="text-xl font-black leading-tight">Tutorial already completed</h3>
            <p className="mt-3 text-sm font-semibold text-white/80">
              This account has already completed the card tutorial, so tutorial packs are no longer
              awarded.
            </p>
            <button
              type="button"
              className="mt-5 w-full rounded-full px-5 py-3 text-sm font-black text-white btn-3d-gold"
              onClick={() => setCompletedTutorialNoticeOpen(false)}
            >
              Got it
            </button>
          </div>
        </div>
      ) : null}

      {funPromptOpen && pendingFunSlot && !cardPackUnlockPrompt ? (
        <FunPromptModal
          slot={pendingFunSlot}
          onAccept={acceptFunPrompt}
          onDecline={declineFunPrompt}
        />
      ) : null}

      {tournamentPreviewEntrant ? (
        <div
          className="fixed inset-0 z-40 flex items-center justify-center bg-black/70 px-4"
          onClick={() => setTournamentPreviewEntrant(null)}
        >
          <div
            className="aura-panel w-full max-w-lg rounded-2xl bg-[#5c0099] p-4 text-white shadow-lg"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between gap-3">
              <div>
                <h3 className="text-lg font-bold">
                  {getTournamentEntrantLabel(tournamentPreviewEntrant)}
                </h3>
                <p className="text-xs text-white/70">
                  {tournamentPreviewEntrant.sourcePostTitle?.trim() || 'Tournament entrant preview'}
                </p>
              </div>
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                onClick={() => setTournamentPreviewEntrant(null)}
              >
                Close
              </button>
            </div>
            <div className="mt-4 overflow-hidden rounded-2xl bg-black">
              {tournamentPreviewEntrant.kind === 'image' && tournamentPreviewEntrant.value ? (
                <img
                  src={tournamentPreviewEntrant.value}
                  alt={getTournamentEntrantLabel(tournamentPreviewEntrant)}
                  className="max-h-[70vh] w-full object-contain"
                />
              ) : (
                <div className="flex min-h-64 items-center justify-center p-8 text-center text-white/80">
                  {getTournamentEntrantLabel(tournamentPreviewEntrant)}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}

      {authOpen ? (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/70 px-4">
          <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-4 text-white shadow-lg">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-bold">Account</h3>
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple"
                onClick={() => setAuthOpen(false)}
              >
                Close
              </button>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                type="button"
                className={clsx(
                  'rounded-full px-3 py-1 text-xs font-semibold text-white',
                  authMode === 'sign_in' ? 'btn-3d-gold' : 'btn-3d-purple'
                )}
                onClick={() => setAuthMode('sign_in')}
              >
                Sign in
              </button>
              <button
                type="button"
                className={clsx(
                  'rounded-full px-3 py-1 text-xs font-semibold text-white',
                  authMode === 'register' ? 'btn-3d-gold' : 'btn-3d-purple'
                )}
                onClick={() => setAuthMode('register')}
              >
                Register
              </button>
              <button
                type="button"
                className={clsx(
                  'rounded-full px-3 py-1 text-xs font-semibold text-white',
                  authMode === 'reset' ? 'btn-3d-gold' : 'btn-3d-purple'
                )}
                onClick={() => setAuthMode('reset')}
              >
                Reset password
              </button>
            </div>
            <div className="mt-3 flex flex-col gap-2">
              <input
                type="email"
                className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/60"
                placeholder="Email"
                value={authEmail}
                onChange={(event) => setAuthEmail(event.target.value)}
              />
              {authMode !== 'reset' ? (
                <input
                  type="password"
                  className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/60"
                  placeholder="Password"
                  value={authPassword}
                  onChange={(event) => setAuthPassword(event.target.value)}
                />
              ) : null}
              {authMode === 'register' ? (
                <input
                  type="text"
                  className="aura-field w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/60"
                  placeholder="Username (letters, numbers, underscores)"
                  value={authUsername}
                  onChange={(event) => setAuthUsername(event.target.value)}
                />
              ) : null}
              <div className="mt-1 flex flex-wrap gap-2">
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                  disabled={authSubmitting}
                  onClick={() => void handleAuthSubmit()}
                >
                  {authSubmitting
                    ? 'Working...'
                    : authMode === 'register'
                      ? 'Create account'
                      : authMode === 'reset'
                        ? 'Send reset email'
                        : 'Sign in'}
                </button>
              </div>
              {authMode !== 'reset' ? (
                <div className="mt-2 flex flex-col gap-2">
                  <div ref={googleButtonRef} className="min-h-[44px]" />
                  {!googleButtonReady ? (
                    <button
                      type="button"
                      className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                      disabled={authSubmitting || !googleIdentityConfigured}
                      onClick={() => void handleGoogleSignIn()}
                    >
                      Continue with Google
                    </button>
                  ) : null}
                </div>
              ) : null}
              {authError ? <p className="text-xs font-semibold text-red-200">{authError}</p> : null}
              {authMessage ? (
                <p className="text-xs font-semibold text-green-200">{authMessage}</p>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

      {usernameClaimOpen && isAuthenticated ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4">
          <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-4 text-white shadow-lg">
            <h3 className="text-base font-bold">Choose your username</h3>
            <p className="mt-2 text-xs text-white/80">
              A username is required once and cannot be changed later.
            </p>
            <input
              type="text"
              className="aura-field mt-3 w-full rounded-lg bg-[#3d0066] px-3 py-2 text-sm text-white placeholder-white/60"
              placeholder="Username (3-20 chars, letters/numbers/_)"
              value={authUsername}
              onChange={(event) => setAuthUsername(event.target.value)}
            />
            <div className="mt-3 flex items-center gap-2">
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-gold disabled:opacity-60"
                disabled={usernameClaimSubmitting}
                onClick={() => void handleClaimUsernameSubmit()}
              >
                {usernameClaimSubmitting ? 'Saving...' : 'Save username'}
              </button>
              <button
                type="button"
                className="rounded-full px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                disabled={usernameClaimSubmitting}
                onClick={() => void handleAuthSignOut()}
              >
                Sign out
              </button>
            </div>
            {usernameClaimError ? (
              <p className="mt-2 text-xs font-semibold text-red-200">{usernameClaimError}</p>
            ) : null}
          </div>
        </div>
      ) : null}

      {ageGateOpen ? (
        <AgeGateModal
          onConfirm={() => {
            setAgeGateVerification();
            setAgeGateOpen(false);
          }}
          onLeave={() => navigateTo(AGE_GATE_LEAVE_URL)}
        />
      ) : null}

      {tournamentShareImage ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/70 px-4">
          <div className="aura-panel w-full max-w-5xl rounded-2xl bg-[#5c0099] p-4 shadow-lg">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-lg font-bold text-white">Tournament Bracket Share</h3>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-3 py-1 text-sm font-semibold text-white btn-3d-purple"
                onClick={closeTournamentSharePreview}
              >
                Close
              </button>
            </div>
            <img
              src={tournamentShareImage}
              alt="Tournament bracket share preview"
              className="aura-frame mt-3 max-h-[70vh] w-full rounded-xl bg-[#2a0045] object-contain"
            />
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <a
                href={tournamentShareImage}
                download="fmk-tournament-bracket.jpg"
                className="rounded-full bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
              >
                Download Image
              </a>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
                onClick={() => void handleCopyTournamentLink()}
              >
                Copy Tournament Link
              </button>
            </div>
            {tournamentShareError ? (
              <p className="mt-2 text-xs font-semibold text-red-200">{tournamentShareError}</p>
            ) : null}
            <p className="mt-2 text-xs text-white/80">
              The link opens the current weekly tournament page. The image is generated locally for
              download.
            </p>
          </div>
        </div>
      ) : null}

      {sharePreviewImage ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/70 px-4">
          <div className="aura-panel w-full max-w-4xl rounded-2xl bg-[#5c0099] p-4 shadow-lg">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-lg font-bold text-white">Share Preview</h3>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-3 py-1 text-sm font-semibold text-white btn-3d-purple"
                onClick={closeSharePreview}
              >
                Close
              </button>
            </div>
            <img
              src={sharePreviewImage}
              alt="FMK share preview"
              className="aura-frame mt-3 w-full rounded-xl bg-[#2a0045]"
            />
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <button
                type="button"
                className="rounded-full bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                onClick={() => void handleShareToReddit()}
                disabled={sharePosting}
              >
                {sharePosting ? 'Posting...' : 'Share to Reddit'}
              </button>
              <a
                href={sharePreviewImage}
                download="fmk-share.png"
                className="rounded-full bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
              >
                Download Image
              </a>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                onClick={() => void handleCopySourceLink()}
              >
                Copy Share Link
              </button>
            </div>
            <p className="mt-2 text-xs text-white/80">
              Reddit opens as a link post. The short share link shows your preview image and then
              redirects to the original FMK post.
            </p>
          </div>
        </div>
      ) : null}

      {showPollBannerAds ? (
        <div className="mx-auto w-full max-w-5xl px-2 pt-3 sm:px-4">
          <div className="flex justify-center sm:hidden">
            <ins
              className={POLL_BANNER_MOBILE_CLASS}
              data-zoneid={POLL_BANNER_MOBILE_ZONE_ID}
            ></ins>
          </div>
          <div className="hidden items-center justify-center gap-3 sm:flex">
            <ins
              className={POLL_BANNER_DESKTOP_CLASS}
              data-zoneid={POLL_BANNER_DESKTOP_ZONE_ID}
            ></ins>
            <ins
              className={POLL_BANNER_DESKTOP_CLASS}
              data-zoneid={POLL_BANNER_DESKTOP_ZONE_ID}
            ></ins>
            <ins
              className={POLL_BANNER_DESKTOP_CLASS}
              data-zoneid={POLL_BANNER_DESKTOP_ZONE_ID}
            ></ins>
          </div>
        </div>
      ) : null}

      {showSlidingVideoAd ? <SlidingVideoAd blockedAdTypes={slidingVideoAdBlockedTypes} /> : null}

      <LegalFooter className="mx-auto w-full max-w-5xl px-2 pb-4 sm:px-4" />

      {battleLegendaryDealExpiresAt && view === 'battle' && !shopCheckout ? (
        <BattleLegendaryDealModal
          offer={BATTLE_LEGENDARY_DEAL_OFFER}
          expiresAt={battleLegendaryDealExpiresAt}
          onClose={() => setBattleLegendaryDealExpiresAt(null)}
          onPurchase={() => {
            setBattleLegendaryDealExpiresAt(null);
            void openShopCheckout(BATTLE_LEGENDARY_DEAL_OFFER);
          }}
        />
      ) : null}

      {shopCheckout ? (
        <div
          className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 px-4"
          role="dialog"
          aria-modal="true"
        >
          <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-4 text-white shadow-lg">
            <div className="flex items-center justify-between gap-3">
              <div>
                <h3 className="text-lg font-black text-white">Checkout</h3>
                {shopCheckout.offer ? (
                  <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#ffd84a]">
                    {formatShopPaidPrice(shopCheckout.offer)}
                  </p>
                ) : null}
              </div>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-3 py-1 text-sm font-semibold text-white btn-3d-purple"
                onClick={() => setShopCheckout(null)}
              >
                Close
              </button>
            </div>

            {shopCheckout.offer ? (
              <div className="mt-4 rounded-xl border border-white/15 bg-black/25 p-4">
                <p className="text-sm font-black">{shopCheckout.offer.label}</p>
                <div
                  className={clsx(
                    'mt-3 grid gap-2 text-center text-xs font-black',
                    shopCheckout.offer.reward.guaranteedLegendaryCards
                      ? 'grid-cols-2 sm:grid-cols-4'
                      : 'grid-cols-3'
                  )}
                >
                  <div className="rounded-lg bg-black/25 p-2 text-[#ffd84a]">
                    <img src={coinsIcon} alt="" className="mx-auto h-7 w-7 object-contain" />
                    {shopCheckout.offer.reward.gold.toLocaleString()} GOLD
                  </div>
                  <div className="rounded-lg bg-black/25 p-2 text-[#90f7ff]">
                    <img src={gemsIcon} alt="" className="mx-auto h-7 w-7 object-contain" />
                    {shopCheckout.offer.reward.gems.toLocaleString()} GEMS
                  </div>
                  <div className="rounded-lg bg-black/25 p-2 text-white">
                    <img
                      src={cardPackTransparent}
                      alt=""
                      className="mx-auto h-7 w-7 object-contain"
                    />
                    {shopCheckout.offer.reward.packs.toLocaleString()} PACKS
                  </div>
                  {shopCheckout.offer.reward.guaranteedLegendaryCards ? (
                    <div className="rounded-lg bg-black/25 p-2 text-[#ffd84a]">
                      <img
                        src={legendaryRarityIcon}
                        alt=""
                        className="mx-auto h-7 w-7 object-contain"
                      />
                      {shopCheckout.offer.reward.guaranteedLegendaryCards.toLocaleString()}{' '}
                      LEGENDARY
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}

            <div className="mt-4 rounded-xl border border-white/15 bg-black/20 p-4 text-center">
              {shopCheckout.loading ? (
                <p className="text-sm font-semibold text-white/80">Creating checkout...</p>
              ) : shopCheckout.error ? (
                <p className="text-sm font-semibold text-red-100">{shopCheckout.error}</p>
              ) : shopCheckout.orderStatus === 'paid' ? (
                <p className="text-sm font-semibold text-green-100">
                  Payment complete. Your purchase has been added.
                </p>
              ) : shopCheckout.orderStatus === 'failed' ? (
                <p className="text-sm font-semibold text-red-100">
                  This checkout failed or expired.
                </p>
              ) : shopCheckout.orderStatus === 'partially_paid' ? (
                <p className="text-sm font-semibold text-yellow-100">
                  Payment is partially paid and needs manual review.
                </p>
              ) : shopCheckout.paymentStarted ? (
                <div className="flex flex-col items-center gap-3">
                  <div
                    className="h-9 w-9 animate-spin rounded-full border-4 border-white/20 border-t-[#ffd84a]"
                    aria-hidden="true"
                  />
                  <p className="text-sm font-semibold text-white/80">
                    Waiting for NOWPayments confirmation...
                  </p>
                </div>
              ) : (
                <p className="text-sm font-semibold text-white/80">
                  Complete payment with NOWPayments. This page will update automatically.
                </p>
              )}

              {shopCheckout.invoiceUrl &&
              shopCheckout.orderStatus !== 'paid' &&
              !shopCheckout.paymentStarted ? (
                <a
                  href={shopCheckout.invoiceUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="mt-4 inline-flex justify-center"
                  onClick={() =>
                    setShopCheckout((prev) =>
                      prev ? { ...prev, paymentStarted: true, error: null } : prev
                    )
                  }
                >
                  <img
                    src={NOWPAYMENTS_BUTTON_SRC}
                    alt="Crypto payment button by NOWPayments"
                    className="h-12 w-auto"
                  />
                </a>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

      {shopRewardedAdKind ? (
        <ShopRewardedAd
          rewardKind={shopRewardedAdKind}
          vastSrc={shopRewardedAdVastSrc}
          blockedAdTypes={shopRewardedAdBlockedTypes}
          claimLoading={shopActionLoading === `ad-${shopRewardedAdKind}`}
          claimError={shopRewardedAdError}
          onClaim={(rewardKind) => void handleClaimShopAdReward(rewardKind)}
          onClose={closeShopRewardedAd}
        />
      ) : null}

      {shopAdRewardCelebration ? (
        <ShopAdRewardCelebration
          reward={shopAdRewardCelebration}
          onClose={closeShopAdRewardCelebration}
        />
      ) : null}

      {shopDailyGiftCelebration ? (
        <ShopAdRewardCelebration
          reward={shopDailyGiftCelebration}
          onClose={closeShopDailyGiftCelebration}
        />
      ) : null}

      {leaderboardOpen ? (
        <div className="fixed inset-0 z-20 flex items-start justify-center bg-black/40 px-4 pb-28 pt-10 sm:pt-14">
          <div className="aura-panel max-h-[calc(100vh-9rem)] w-full max-w-lg overflow-hidden rounded-2xl bg-[#5c0099] p-4 shadow-lg">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">Leaderboard</h3>
              <button
                type="button"
                className="text-sm text-white/80 hover:text-white"
                onClick={() => setLeaderboardOpen(false)}
              >
                Close
              </button>
            </div>
            <div className="mt-3 max-h-[calc(100vh-14rem)] space-y-2 overflow-y-auto pr-1">
              {leaderboard.length === 0 ? (
                <p className="text-sm text-white/80">No battle ratings yet. Be the first to play!</p>
              ) : (
                leaderboard.map((entry) => {
                  const rating = entry.battleRating ?? entry.points;
                  const battleRankDisplay = getBattleRankDisplay(rating);
                  const battleRankIcon =
                    BATTLE_RANK_ICONS[battleRankDisplay.rankNumber - 1] ?? rank1Icon;
                  return (
                    <div
                      key={entry.userId}
                      className={clsx(
                        'flex min-h-16 items-center justify-between rounded-lg border px-3 py-3',
                        entry.userId === leaderboardUserId
                          ? 'border-2 border-[#ffd54f] bg-[#5b13a4]'
                          : 'aura-card bg-[#510087]'
                      )}
                    >
                      <div className="flex min-w-0 items-center gap-3">
                        <span className="w-6 shrink-0 text-right text-xs font-black text-white/80">
                          {entry.rank}.
                        </span>
                        <img
                          src={battleRankIcon}
                          alt={`Battle rank ${battleRankDisplay.rankNumber}`}
                          className="h-11 w-11 shrink-0 object-contain drop-shadow"
                        />
                        <div className="min-w-0">
                          <span className="block truncate text-sm font-semibold text-white">
                            {entry.username || entry.userId}
                          </span>
                          <span className="block text-[11px] font-black uppercase text-[#ffd84a]">
                            Rank {battleRankDisplay.rankNumber}
                          </span>
                        </div>
                      </div>
                      <span className="shrink-0 text-sm font-semibold text-white">
                        {rating} rating
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      ) : null}

      {faceCropSrc && faceCropSlotIndex !== null ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/70 px-4">
          <div className="aura-panel w-full max-w-lg rounded-2xl bg-[#5c0099] p-5 shadow-lg">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">Face Crop</h3>
              <button
                type="button"
                className="text-sm text-white/80 hover:text-white"
                onClick={closeFaceCrop}
              >
                Close
              </button>
            </div>
            <p className="mt-2 text-xs font-semibold text-white/80">
              Drag the image to position the face inside the circle.
            </p>
            <div className="mt-4 flex flex-col items-center gap-4">
              <div
                className="aura-frame relative h-[220px] w-[220px] overflow-hidden rounded-full bg-[#3d0066] touch-none"
                onPointerDown={handleCropPointerDown}
                onPointerMove={handleCropPointerMove}
                onPointerUp={handleCropPointerUp}
                onPointerLeave={handleCropPointerUp}
              >
                {faceCropImage && cropMetrics ? (
                  <img
                    src={faceCropSrc}
                    alt="Face crop"
                    className="absolute left-1/2 top-1/2 select-none"
                    style={{
                      width: faceCropImage.width,
                      height: faceCropImage.height,
                      transform: `translate(-50%, -50%) translate(${faceCropOffset.x}px, ${faceCropOffset.y}px) scale(${cropMetrics.displayScale})`,
                      transformOrigin: 'center',
                    }}
                    draggable={false}
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-xs font-semibold text-white/80">
                    Loading image...
                  </div>
                )}
              </div>
              <div className="flex w-full items-center gap-3">
                <span className="text-xs font-semibold text-white/80">Zoom</span>
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.01}
                  value={faceCropScale}
                  onChange={(e) => setFaceCropScale(Number(e.target.value))}
                  className="w-full accent-[#fdc500]"
                />
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
                  onClick={saveFaceCrop}
                >
                  Save face
                </button>
                <button
                  type="button"
                  className="rounded-lg bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
                  onClick={closeFaceCrop}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {reportModalPostId ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/60 px-4">
          <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-4 shadow-lg">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-base font-bold text-white">Report post</h3>
                <p className="mt-1 text-sm font-semibold text-white/85">
                  Tell moderators what needs attention.
                </p>
              </div>
              <button
                type="button"
                className="rounded-full bg-[#510087] px-3 py-1 text-xs font-semibold text-white btn-3d-purple disabled:opacity-60"
                disabled={Boolean(browseReportPendingByPost[reportModalPostId])}
                onClick={closeReportModal}
              >
                Close
              </button>
            </div>
            <div className="mt-4 space-y-2">
              {REPORT_REASONS.map((reason) => (
                <label
                  key={reason}
                  className={clsx(
                    'flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold text-white',
                    reportReason === reason
                      ? 'border-[#fdc500] bg-black/25'
                      : 'border-white/20 bg-black/10'
                  )}
                >
                  <input
                    type="radio"
                    name="report-reason"
                    value={reason}
                    checked={reportReason === reason}
                    disabled={Boolean(browseReportPendingByPost[reportModalPostId])}
                    onChange={() => setReportReason(reason)}
                    className="accent-[#fdc500]"
                  />
                  <span>{REPORT_REASON_LABELS[reason]}</span>
                </label>
              ))}
            </div>
            <label
              className="mt-4 block text-xs font-semibold text-white/90"
              htmlFor="report-comment-input"
            >
              Additional information
            </label>
            <textarea
              id="report-comment-input"
              className="aura-field mt-1 min-h-24 w-full resize-y rounded-lg bg-[#3d0066] px-3 py-2 text-sm font-semibold text-white placeholder:text-white/45"
              value={reportComment}
              maxLength={REPORT_COMMENT_MAX_LENGTH}
              disabled={Boolean(browseReportPendingByPost[reportModalPostId])}
              placeholder="Optional"
              onChange={(event) => setReportComment(event.target.value)}
            />
            <div className="mt-1 flex items-center justify-between gap-2">
              <span className="text-[11px] font-semibold text-white/65">
                {reportComment.trim().length}/{REPORT_COMMENT_MAX_LENGTH}
              </span>
              {reportModalError ? (
                <span className="text-right text-[11px] font-semibold text-red-200">
                  {reportModalError}
                </span>
              ) : null}
            </div>
            <div className="mt-4 flex flex-wrap justify-end gap-2">
              <button
                type="button"
                className="rounded-lg bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple disabled:opacity-60"
                disabled={Boolean(browseReportPendingByPost[reportModalPostId])}
                onClick={closeReportModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold disabled:opacity-60"
                disabled={Boolean(browseReportPendingByPost[reportModalPostId])}
                onClick={() => {
                  void submitReport();
                }}
              >
                {browseReportPendingByPost[reportModalPostId] ? 'Submitting...' : 'Submit report'}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {reportThanksModalOpen ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/60 px-4">
          <div className="aura-panel w-full max-w-md rounded-2xl bg-[#5c0099] p-4 text-center shadow-lg">
            <h3 className="text-base font-bold text-white">Report received</h3>
            <p className="mt-2 text-sm font-semibold text-white/90">{reportThanksMessage}</p>
            <div className="mt-4 flex justify-center">
              <button
                type="button"
                onClick={() => setReportThanksModalOpen(false)}
                className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {error ? (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/60 px-4">
          <div className="w-full max-w-md rounded-2xl border-2 border-red-300 bg-white p-4 shadow-lg">
            <p className="text-sm font-semibold text-red-700 text-center">{error}</p>
            <div className="mt-3 flex justify-center">
              <button
                type="button"
                onClick={() => setError(null)}
                className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white shadow-sm btn-3d-gold"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
